import { jsx, jsxs, Fragment } from 'theme-ui/jsx-runtime';
import { Global, css, keyframes } from '@emotion/react';
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback, useMemo, Fragment as Fragment$1 } from 'react';
import { get, ThemeProvider, Grid, AspectRatio, createElement } from 'theme-ui';
import { css as css$1 } from '@emotion/css';
import factory from 'codemirror-ssr';
import useClike from 'codemirror-ssr/mode/clike/clike.js';
import useCSS from 'codemirror-ssr/mode/css/css.js';
import useGo from 'codemirror-ssr/mode/go/go.js';
import useHtml from 'codemirror-ssr/mode/htmlmixed/htmlmixed.js';
import useJavascript from 'codemirror-ssr/mode/javascript/javascript.js';
import useJSX from 'codemirror-ssr/mode/jsx/jsx.js';
import useMarkdown from 'codemirror-ssr/mode/markdown/markdown.js';
import usePHP from 'codemirror-ssr/mode/php/php.js';
import usePython from 'codemirror-ssr/mode/python/python.js';
import useRuby from 'codemirror-ssr/mode/ruby/ruby.js';
import useShell from 'codemirror-ssr/mode/shell/shell.js';
import useSwift from 'codemirror-ssr/mode/swift/swift.js';
import useXML from 'codemirror-ssr/mode/xml/xml.js';
import useDart from 'codemirror-ssr/mode/dart/dart.js';
import useSimpleScrollbars from 'codemirror-ssr/addon/scroll/simplescrollbars.js';
import ImgixClient from '@imgix/js-core';
import require$$0 from 'lazysizes';
import styled from '@emotion/styled';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
// ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN
const colors$1 = {},
  fontFamilies$1 = {},
  lineHeights$1 = {},
  fontWeights$1 = {},
  fontSizes$1 = {},
  spacing$1 = {},
  sizing$1 = {},
  borderRadius$1 = {},
  boxShadow$1 = {},
  borderWidth$1 = {},
  motion$1 = {},
  opacity$1 = {},
  icons$1 = {},
  navigation = {},
  letterSpacings = {};

colors$1.black10 = '#fafbfc';
colors$1.black15 = '#f5f7fA';
colors$1.black20 = '#e7eeec';
colors$1.black30 = '#b8c4c2';
colors$1.black40 = '#9fa1a2';
colors$1.black50 = '#5d6c74';
colors$1.black60 = '#3d4f58';
colors$1.black70 = '#21313c';
colors$1.black80 = '#061621';
colors$1.black00 = '#ffffff';
colors$1.blue05 = '#EEFDFA';
colors$1.blue10 = '#E3FCF7';
colors$1.blue20 = '#A6FFEC';
colors$1.blue30 = '#53E9F6';
colors$1.blue40 = '#00D2FF';
colors$1.blue50 = '#009FFD';
colors$1.blue60 = '#006CFA';
colors$1.blue70 = '#0D427C';
colors$1.blue80 = '#001E2B';
colors$1.purple05 = '#FBF3FF';
colors$1.purple10 = '#F9EBFF';
colors$1.purple20 = '#F2C5EE';
colors$1.purple30 = '#D38FF0';
colors$1.purple40 = '#B45AF2';
colors$1.purple50 = '#983FF9';
colors$1.purple60 = '#7C25FF';
colors$1.purple70 = '#5400F8';
colors$1.purple80 = '#2A0F91';
colors$1.green05 = '#F8FFEA';
colors$1.green10 = '#F4FFDC';
colors$1.green20 = '#E9FF99';
colors$1.green30 = '#B1FF05';
colors$1.green40 = '#00ED64';
colors$1.green50 = '#00AA57';
colors$1.green60 = '#00684A';
colors$1.green70 = '#014E3D';
colors$1.green80 = '#023430';
colors$1.yellow05 = '#FEFAE9';
colors$1.yellow10 = '#FEF7DB';
colors$1.yellow20 = '#FFEC9E';
colors$1.yellow30 = '#FBDB5A';
colors$1.yellow40 = '#FFC010';
colors$1.yellow50 = '#F28900';
colors$1.yellow60 = '#944F01';
colors$1.yellow70 = '#4C2100';
colors$1.yellow80 = '#2F1400';
colors$1.red05 = '#FFF2EF';
colors$1.red10 = '#FFEAE5';
colors$1.red20 = '#FFCDC7';
colors$1.red30 = '#FF6960';
colors$1.red40 = '#F3461F';
colors$1.red50 = '#DB3030';
colors$1.red60 = '#970606';
colors$1.red70 = '#5B0000';
colors$1.red80 = '#430404';
colors$1.text = {
  default: colors$1.blue80,
  secondary: colors$1.black50,
  inverse: colors$1.black00,
  inverseSecondary: colors$1.black30,
  error: colors$1.red50,
  errorInverse: colors$1.red30,
  neutral: colors$1.black50,
  selected: colors$1.green70,
  inverseSelected: colors$1.green40,
  mark: colors$1.green60,
  inverseMark: colors$1.green40,
  eyebrowDefault: colors$1.green60,
  eyebrowInverse: colors$1.green40,
  eyebrowInverseSecondary: colors$1.black00,
  checkbox: colors$1.green40
};
colors$1.border = {
  default: colors$1.black30,
  inverse: colors$1.black50,
  inverseDarker: colors$1.black60
};
colors$1.icon = {
  error: colors$1.red50,
  errorInverse: colors$1.red30,
  warning: colors$1.yellow40,
  branded: {
    primary: colors$1.blue80,
    secondary: colors$1.green40,
    inversePrimary: colors$1.black00,
    inverseSecondary: colors$1.green40
  },
  system: {
    default: colors$1.black60,
    defaultNeutral: colors$1.black50,
    inverse: colors$1.black00,
    inverseNeutral: colors$1.black30,
    success: colors$1.green60,
    successInverse: colors$1.green40
  }
};
colors$1.background = {
  body: colors$1.black00,
  container: colors$1.black10,
  containerLight: colors$1.black15,
  containerLighter: colors$1.black00,
  containerInverse: colors$1.blue80,
  containerInverseDarker: colors$1.black80,
  selected: colors$1.green40,
  selectedLighter: colors$1.green10,
  panel: colors$1.black00,
  selectedInverseLighter: colors$1.black60
};
colors$1.button = {
  primary: {
    bg: colors$1.green40,
    bgDisabled: colors$1.black30,
    text: colors$1.blue80,
    textDisabled: colors$1.black50,
    border: colors$1.green60,
    borderDisabled: colors$1.black70
  },
  secondary: { bg: colors$1.blue80, text: colors$1.black00 },
  inversePrimary: {
    bg: colors$1.green40,
    bgDisabled: colors$1.black60,
    text: colors$1.blue80,
    textDisabled: colors$1.black30,
    border: colors$1.green60,
    borderDisabled: colors$1.black70
  },
  inverseSecondary: { bg: colors$1.black00, text: colors$1.blue80 },
  utility: {
    bg: colors$1.green40,
    border: colors$1.green60,
    icon: colors$1.green80,
    iconInverse: colors$1.black00,
    borderInverse: colors$1.green40,
    bgHover: colors$1.green80,
    bgHoverInverse: colors$1.black00
  }
};
colors$1.forms = {
  textInput: {
    default: {
      bg: colors$1.black10,
      bgDisabled: colors$1.black10,
      border: colors$1.blue80,
      text: colors$1.blue80,
      label: colors$1.black50,
      labelFilled: colors$1.black60,
      icon: colors$1.blue80,
      helpText: colors$1.blue80,
      focus: { border: colors$1.blue60, label: colors$1.blue60 },
      error: {
        label: colors$1.red50,
        border: colors$1.red50,
        icon: colors$1.red50,
        labelFocus: colors$1.red60,
        borderFocus: colors$1.red60,
        iconFocus: colors$1.red60
      }
    },
    inverse: {
      bg: colors$1.black70,
      bgDisabled: colors$1.black70,
      border: colors$1.black00,
      text: colors$1.black00,
      label: colors$1.black30,
      labelFilled: colors$1.black10,
      icon: colors$1.black00,
      helpText: colors$1.black10,
      focus: { border: colors$1.blue40, label: colors$1.blue40 },
      error: {
        label: colors$1.red30,
        border: colors$1.red30,
        icon: colors$1.red30,
        labelFocus: colors$1.red50,
        borderFocus: colors$1.red50,
        iconFocus: colors$1.red50
      }
    }
  },
  checkbox: {
    bgSelected: colors$1.green60,
    icon: colors$1.black00,
    boxBorder: colors$1.blue80,
    bg: colors$1.black00,
    bgDisabled: colors$1.black20,
    iconDisabled: colors$1.black00,
    focusBorder: colors$1.blue60,
    bgSelectedDisabled: colors$1.black50,
    boxBorderDisabled: colors$1.black50
  },
  checkboxInverse: {
    bgSelected: colors$1.green40,
    icon: colors$1.blue80,
    boxBorder: colors$1.black00,
    bg: colors$1.blue80,
    bgDisabled: colors$1.black70,
    iconDisabled: colors$1.black00,
    focusBorder: colors$1.blue40,
    bgSelectedDisabled: colors$1.black50,
    boxBorderDisabled: colors$1.black50
  },
  radioButton: {
    bg: colors$1.black00,
    boxBorder: colors$1.blue80,
    focusBorder: colors$1.blue60,
    icon: colors$1.green60,
    boxBorderDisabled: colors$1.black50,
    bgDisabled: colors$1.black20,
    iconDisabled: colors$1.black40
  },
  radioButtonInverse: {
    bg: colors$1.blue80,
    boxBorder: colors$1.black00,
    focusBorder: colors$1.blue40,
    icon: colors$1.green40,
    boxBorderDisabled: colors$1.black50,
    bgDisabled: colors$1.black70,
    iconDisabled: colors$1.black50
  }
};
colors$1.link = {
  cta: {
    default: {
      text: colors$1.blue80,
      icon: colors$1.green60,
      textDisabled: colors$1.black50,
      iconDisabled: colors$1.black50,
      textHover: colors$1.green60
    },
    inverse: {
      text: colors$1.black00,
      icon: colors$1.green40,
      textHover: colors$1.green40
    }
  },
  navigation: { text: colors$1.black70, textSelected: colors$1.green50 },
  footer: { text: colors$1.black00, textSelected: colors$1.green40 },
  inline: {
    default: { text: colors$1.blue60, underline: colors$1.black80 },
    inverse: { text: colors$1.green40, underline: colors$1.black00 }
  }
};
colors$1.pill = {
  identifier: {
    primary: { text: colors$1.blue80, bgInformational: colors$1.blue10 },
    secondary: {
      textInformational: colors$1.black00,
      bgInformational: colors$1.blue60
    },
    inverse: { borderInformational: colors$1.blue10, inverseText: colors$1.blue10 }
  },
  badge: {
    default: { bg: colors$1.green30, text: colors$1.green70 },
    inverse: { bg: colors$1.green30, text: colors$1.green70 }
  }
};
colors$1.tag = {
  border: colors$1.blue60,
  text: colors$1.blue60,
  bg: colors$1.blue10,
  inverseBorder: colors$1.blue40,
  inverseText: colors$1.blue40,
  inverseBG: colors$1.blue80
};
colors$1.panels = {
  default: {
    bg: colors$1.black10,
    bgLighter: colors$1.black00,
    border: colors$1.black30
  },
  inverse: {
    bg: colors$1.black70,
    bgDarker: colors$1.black80,
    border: colors$1.black50
  },
  navigation: { bg: colors$1.black00, border: colors$1.black30 },
  card: {
    bg: colors$1.black00,
    bgDarker: colors$1.black10,
    border: colors$1.black30
  },
  modal: {
    bg: colors$1.black00,
    bgDarker: colors$1.black10,
    border: colors$1.black30
  },
  notification: {
    bgSuccess: colors$1.green10,
    borderSuccess: colors$1.green20,
    bgAlert: colors$1.yellow10,
    borderAlert: colors$1.yellow40,
    bgNote: colors$1.blue10,
    borderNote: colors$1.blue20,
    bgDanger: colors$1.yellow20,
    borderDanger: colors$1.yellow60,
    innerSuccess: colors$1.green80,
    innerNote: colors$1.blue80,
    innerDanger: colors$1.yellow50,
    innerAlert: colors$1.yellow30
  },
  tooltip: {
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50,
    bg: colors$1.black00,
    border: colors$1.black30
  },
  popover: {
    bg: colors$1.black00,
    border: colors$1.black30,
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50
  },
  select: {
    bg: colors$1.black00,
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50,
    border: colors$1.black30
  }
};
colors$1.tabs = {
  tertiary: {
    inverse: {
      borderHover: colors$1.blue60,
      bgActive: colors$1.blue60,
      bg: colors$1.black60,
      textActive: colors$1.black00,
      textInactive: colors$1.black00
    },
    default: {
      borderHover: colors$1.blue60,
      bgActive: colors$1.blue60,
      bg: colors$1.black20,
      textActive: colors$1.black00,
      textInactive: colors$1.black80
    }
  }
};
colors$1.code = {
  bg: colors$1.black80,
  bgLines: colors$1.black70,
  lines: colors$1.blue10,
  copyBG: colors$1.black70,
  operators: colors$1.black10,
  comments: colors$1.black40,
  definitions: colors$1.yellow20,
  numbers: colors$1.purple20,
  keywords: '#FFA1A1',
  variables: colors$1.blue20,
  type: colors$1.blue20,
  strings: colors$1.yellow20,
  attributes: colors$1.green20
};
colors$1.card = {
  default: {
    bg: colors$1.black00,
    border: colors$1.black20,
    textSub: colors$1.green60,
    borderDarker: colors$1.green80
  },
  inverse: {
    bg: colors$1.blue80,
    border: colors$1.black70,
    textSub: colors$1.green40,
    borderLighter: colors$1.green40
  }
};
colors$1.header = {
  default: {
    title: colors$1.blue80,
    text: colors$1.blue80,
    eyebrow: colors$1.green60,
    bg: colors$1.black00,
    bgDarker: colors$1.black10
  },
  inverse: {
    title: colors$1.black00,
    text: colors$1.black00,
    eyebrow: colors$1.green40,
    bg: colors$1.blue80,
    bgLighter: colors$1.green80
  }
};
colors$1.list = {
  default: {
    text: colors$1.blue80,
    bullet: colors$1.blue60,
    checkmark: colors$1.green40
  },
  inverse: {
    text: colors$1.black00,
    bullet: colors$1.green40,
    checkmark: colors$1.green40
  }
};

fontFamilies$1.menlo = 'Menlo';
fontFamilies$1['akzidenz-grotesk-std'] = 'Akzidenz-Grotesk Std';
fontFamilies$1['euclid-circular-a'] = 'Euclid Circular A';
fontFamilies$1['source-code-pro'] = 'Source Code Pro';
fontFamilies$1['mongodb-value-serif'] = 'MongoDB Value Serif';
fontFamilies$1.heading = fontFamilies$1['mongodb-value-serif'];
fontFamilies$1.body = fontFamilies$1['euclid-circular-a'];
fontFamilies$1.mono = fontFamilies$1['source-code-pro'];

lineHeights$1.inc00 = 16;
lineHeights$1.inc10 = 18;
lineHeights$1.inc20 = 24;
lineHeights$1.inc30 = 32;
lineHeights$1.inc40 = 40;
lineHeights$1.inc50 = 48;
lineHeights$1.inc60 = 56;
lineHeights$1.inc70 = 64;
lineHeights$1.inc80 = 72;
lineHeights$1.inc90 = 112;
lineHeights$1.leadingNone = 1;
lineHeights$1.leadingTight = 1.25;
lineHeights$1.leadingNormal = 1.5;
lineHeights$1.leadingRelaxed = 1.75;
lineHeights$1.leadingLoose = 2;
lineHeights$1.headingXXL = lineHeights$1.inc90;
lineHeights$1.headingXL = lineHeights$1.inc80;
lineHeights$1.headingL = lineHeights$1.inc70;
lineHeights$1.headingM = lineHeights$1.inc60;
lineHeights$1.headingS = lineHeights$1.inc50;
lineHeights$1.headingXS = lineHeights$1.inc30;
lineHeights$1.headingXXLResponsive = lineHeights$1.inc60;
lineHeights$1.headingXLResponsive = lineHeights$1.inc50;
lineHeights$1.headingLResponsive = lineHeights$1.inc40;
lineHeights$1.headingMResponsive = lineHeights$1.inc30;
lineHeights$1.headingSResponsive = lineHeights$1.inc30;
lineHeights$1.headingXSResponsive = lineHeights$1.inc20;
lineHeights$1.bodyL = lineHeights$1.inc30;
lineHeights$1.bodyM = lineHeights$1.inc30;
lineHeights$1.bodyS = lineHeights$1.inc20;
lineHeights$1.bodyXS = lineHeights$1.inc00;
lineHeights$1.bodyLResponsive = lineHeights$1.inc30;
lineHeights$1.bodyMResponsive = lineHeights$1.inc30;
lineHeights$1.bodySResponsive = lineHeights$1.inc20;
lineHeights$1.bodyXSResponsive = lineHeights$1.inc00;
lineHeights$1.monoL = lineHeights$1.inc30;
lineHeights$1.monoM = lineHeights$1.inc20;
lineHeights$1.monoS = lineHeights$1.inc00;
lineHeights$1.monoLResponsive = lineHeights$1.inc30;
lineHeights$1.monoMResponsive = lineHeights$1.inc20;
lineHeights$1.monoSResponsive = lineHeights$1.inc00;

fontWeights$1.medium = 'Medium';
fontWeights$1.light = 'Light';
fontWeights$1.regular = 'Regular';
fontWeights$1.bold = 'Bold';
fontWeights$1.semibold = 'Semibold';

fontSizes$1.inc00 = 12;
fontSizes$1.inc10 = 14;
fontSizes$1.inc20 = 16;
fontSizes$1.inc30 = 18;
fontSizes$1.inc40 = 20;
fontSizes$1.inc50 = 24;
fontSizes$1.inc60 = 28;
fontSizes$1.inc70 = 32;
fontSizes$1.inc80 = 36;
fontSizes$1.inc90 = 40;
fontSizes$1.inc100 = 44;
fontSizes$1.inc110 = 48;
fontSizes$1.inc120 = 56;
fontSizes$1.inc130 = 64;
fontSizes$1.inc140 = 96;
fontSizes$1.headingXXL = fontSizes$1.inc140;
fontSizes$1.headingXL = fontSizes$1.inc130;
fontSizes$1.headingL = fontSizes$1.inc120;
fontSizes$1.headingM = fontSizes$1.inc100;
fontSizes$1.headingS = fontSizes$1.inc80;
fontSizes$1.headingXS = fontSizes$1.inc50;
fontSizes$1.headingXXLResponsive = fontSizes$1.inc110;
fontSizes$1.headingXLResponsive = fontSizes$1.inc90;
fontSizes$1.headingLResponsive = fontSizes$1.inc70;
fontSizes$1.headingMResponsive = fontSizes$1.inc60;
fontSizes$1.headingSResponsive = fontSizes$1.inc50;
fontSizes$1.headingXSResponsive = fontSizes$1.inc30;
fontSizes$1.bodyL = fontSizes$1.inc40;
fontSizes$1.bodyM = fontSizes$1.inc30;
fontSizes$1.bodyS = fontSizes$1.inc20;
fontSizes$1.bodyXS = fontSizes$1.inc10;
fontSizes$1.bodyLResponsive = fontSizes$1.inc30;
fontSizes$1.bodyMResponsive = fontSizes$1.inc20;
fontSizes$1.bodySResponsive = fontSizes$1.inc10;
fontSizes$1.bodyXSResponsive = fontSizes$1.inc10;
fontSizes$1.monoL = fontSizes$1.inc20;
fontSizes$1.monoM = fontSizes$1.inc10;
fontSizes$1.monoS = fontSizes$1.inc00;
fontSizes$1.monoLResponsive = fontSizes$1.inc20;
fontSizes$1.monoMResponsive = fontSizes$1.inc10;
fontSizes$1.monoSResponsive = fontSizes$1.inc00;

spacing$1.base = 8;
spacing$1.inc00 = 0;
spacing$1.neg00 = 0;
spacing$1.section00 = spacing$1.base;
spacing$1.section10 = spacing$1.base * 2;
spacing$1.section20 = spacing$1.base * 3;
spacing$1.section30 = spacing$1.base * 6;
spacing$1.section40 = spacing$1.base * 8;
spacing$1.section50 = spacing$1.base * 12;
spacing$1.section60 = spacing$1.base * 14;
spacing$1.inc10 = spacing$1.base * 0.5;
spacing$1.inc20 = spacing$1.base * 1;
spacing$1.inc25 = spacing$1.base * 1.5;
spacing$1.inc30 = spacing$1.base * 2;
spacing$1.inc40 = spacing$1.base * 3;
spacing$1.inc50 = spacing$1.base * 4;
spacing$1.inc60 = spacing$1.base * 5;
spacing$1.inc70 = spacing$1.base * 6;
spacing$1.inc80 = spacing$1.base * 7;
spacing$1.inc90 = spacing$1.base * 8;
spacing$1.inc100 = spacing$1.base * 9;
spacing$1.inc110 = spacing$1.base * 10;
spacing$1.inc120 = spacing$1.base * 11;
spacing$1.inc130 = spacing$1.base * 12;
spacing$1.inc140 = spacing$1.base * 13;
spacing$1.inc150 = spacing$1.base * 14;
spacing$1.inc160 = spacing$1.base * 15;
spacing$1.neg10 = spacing$1.base * -0.5;
spacing$1.neg20 = spacing$1.base * -1;
spacing$1.neg30 = spacing$1.base * -2;
spacing$1.neg40 = spacing$1.base * -3;
spacing$1.neg50 = spacing$1.base * -4;
spacing$1.neg60 = spacing$1.base * -5;
spacing$1.neg70 = spacing$1.base * -6;
spacing$1.neg80 = spacing$1.base * -7;
spacing$1.neg90 = spacing$1.base * -8;
spacing$1.sectionGapZero = spacing$1.inc00;
spacing$1.sectionGapXXSmall = spacing$1.section00;
spacing$1.sectionGapXSmall = spacing$1.section10;
spacing$1.sectionGapSmall = spacing$1.section20;
spacing$1.sectionGapMedium = spacing$1.section30;
spacing$1.sectionGapLarge = spacing$1.section40;
spacing$1.sectionGapXLarge = spacing$1.section50;
spacing$1.sectionGapXXLarge = spacing$1.section60;
spacing$1.elementZero = spacing$1.inc00;
spacing$1.elementXSmall = spacing$1.inc30;
spacing$1.elementSmall = spacing$1.inc40;
spacing$1.elementMedium = spacing$1.inc50;
spacing$1.elementLarge = spacing$1.inc60;
spacing$1.elementXLarge = spacing$1.inc70;
spacing$1.colGapSmall = spacing$1.inc30;
spacing$1.colGapMedium = spacing$1.inc40;
spacing$1.outsideGutterSmall = spacing$1.inc40;
spacing$1.outsideGutterMedium = spacing$1.inc50;
spacing$1.outsideGutterLarge = spacing$1.inc70;
spacing$1.cards = {
  paddingXXS: spacing$1.inc40,
  paddingXS: spacing$1.inc50,
  paddingS: spacing$1.inc60,
  paddingM: spacing$1.inc70,
  paddingL: spacing$1.inc80,
  paddingXL: spacing$1.inc110,
  paddingXXL: spacing$1.inc160
};
spacing$1.responsive = {
  verticalGap: {
    sectionZero: { small: 0, medium: 0, large: 0, xlarge: 0, xxlarge: 0 },
    sectionXXSmall: {
      small: spacing$1.section00,
      medium: spacing$1.section00,
      large: spacing$1.section00,
      xlarge: spacing$1.section00,
      xxlarge: spacing$1.section00
    },
    sectionXSmall: {
      small: spacing$1.section10,
      medium: spacing$1.section10,
      large: spacing$1.section10,
      xlarge: spacing$1.section10,
      xxlarge: spacing$1.section10
    },
    sectionSmall: {
      small: spacing$1.section20,
      medium: spacing$1.section20,
      large: spacing$1.section20,
      xlarge: spacing$1.section20,
      xxlarge: spacing$1.section20
    },
    sectionMedium: {
      small: spacing$1.section30,
      medium: spacing$1.section30,
      large: spacing$1.section30,
      xlarge: spacing$1.section30,
      xxlarge: spacing$1.section30
    },
    sectionLarge: {
      small: spacing$1.sectionGapMedium,
      medium: spacing$1.sectionGapMedium,
      large: spacing$1.section40,
      xlarge: spacing$1.section40,
      xxlarge: spacing$1.section40
    },
    sectionXLarge: {
      small: spacing$1.inc80,
      medium: spacing$1.inc80,
      large: spacing$1.section50,
      xlarge: spacing$1.section50,
      xxlarge: spacing$1.section50
    },
    sectionXXLarge: {
      small: spacing$1.sectionGapLarge,
      medium: spacing$1.sectionGapLarge,
      large: spacing$1.section60,
      xlarge: spacing$1.section60,
      xxlarge: spacing$1.section60
    }
  },
  columnGap: {
    tight: {
      small: spacing$1.inc20,
      medium: spacing$1.inc30,
      large: spacing$1.inc40,
      xlarge: spacing$1.inc40,
      xxlarge: spacing$1.inc40
    },
    normal: {
      small: spacing$1.inc30,
      medium: spacing$1.inc50,
      large: spacing$1.inc70,
      xlarge: spacing$1.inc70,
      xxlarge: spacing$1.inc70
    },
    loose: {
      small: spacing$1.inc40,
      medium: spacing$1.inc60,
      large: spacing$1.inc90,
      xlarge: spacing$1.inc90,
      xxlarge: spacing$1.inc90
    },
    huge: {
      small: spacing$1.inc60,
      medium: spacing$1.inc80,
      large: spacing$1.inc130,
      xlarge: spacing$1.inc130,
      xxlarge: spacing$1.inc130
    }
  },
  cells: {
    normal: {
      vertical: {
        small: spacing$1.inc40,
        medium: spacing$1.inc50,
        large: spacing$1.inc70,
        xlarge: spacing$1.inc70
      },
      left: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      },
      right: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      }
    },
    tight: {
      vertical: {
        small: spacing$1.inc20,
        medium: spacing$1.inc40,
        large: spacing$1.inc40,
        xlarge: spacing$1.inc40,
        xxlarge: spacing$1.inc40
      },
      left: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      },
      right: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      }
    }
  }
};

sizing$1.base = 8;
sizing$1.maxWidthDesktop = 1416;
sizing$1.inc00 = sizing$1.base * 0.5;
sizing$1.inc10 = sizing$1.base * 2;
sizing$1.inc20 = sizing$1.base * 3;
sizing$1.inc30 = sizing$1.base * 4;
sizing$1.inc40 = sizing$1.base * 5;
sizing$1.inc50 = sizing$1.base * 6;
sizing$1.inc60 = sizing$1.base * 7;
sizing$1.inc70 = sizing$1.base * 8;
sizing$1.inc80 = sizing$1.base * 9;
sizing$1.inc90 = sizing$1.base * 10;
sizing$1.inc100 = sizing$1.base * 11;
sizing$1.systemIconLarge = sizing$1.inc30;
sizing$1.systemIconMedium = sizing$1.inc20;
sizing$1.systemIconSmall = sizing$1.inc10;
sizing$1.systemIconXSmall = sizing$1.inc00 * 3;
sizing$1.codeSnippetSmall = sizing$1.base * 35;
sizing$1.codeSnippetMedium = sizing$1.base * 60;
sizing$1.codeSnippetLarge = sizing$1.base * 90;
sizing$1.brandedIconSmall = sizing$1.inc50;
sizing$1.brandedIconMedium = sizing$1.inc70;
sizing$1.brandedIconLarge = sizing$1.inc90;
sizing$1.breakpoint = {
  small: 460,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440
};

borderRadius$1.circle = 999;
borderRadius$1.inc00 = 0;
borderRadius$1.inc10 = 2;
borderRadius$1.inc20 = 4;
borderRadius$1.inc30 = 8;
borderRadius$1.inc40 = 16;
borderRadius$1.inc50 = 24;
borderRadius$1.inc60 = 32;
borderRadius$1.inc70 = 40;
borderRadius$1.inc80 = 56;
borderRadius$1.inc90 = 72;
borderRadius$1.inc100 = 88;
borderRadius$1.inc110 = 104;
borderRadius$1.buttons = borderRadius$1.inc20;
borderRadius$1.input = borderRadius$1.inc20;
borderRadius$1.modal = borderRadius$1.inc20;
borderRadius$1.tooltips = borderRadius$1.inc20;
borderRadius$1.notification = borderRadius$1.inc20;
borderRadius$1.card = borderRadius$1.inc70;
borderRadius$1.cardResponsive = borderRadius$1.inc50;
borderRadius$1.codePanel = borderRadius$1.inc60;
borderRadius$1.buttonHover = borderRadius$1.inc70;
borderRadius$1.scrollyStoryCard = borderRadius$1.inc50;
borderRadius$1.scrollyStoryCardResponsive = borderRadius$1.inc40;

boxShadow$1.level00 = { x: 0, y: 0, spread: 0, color: '#000000', blur: 0 };
boxShadow$1.level01 = { x: 0, y: 2, spread: 0, color: 'rgba(0,0,0,.1)', blur: 4 };
boxShadow$1.level02 = { x: 0, y: 3, spread: 0, color: 'rgba(0,0,0,.15)', blur: 9 };
boxShadow$1.level03 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 20
};
boxShadow$1.level04 = {
  x: 0,
  y: 6,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 30
};
boxShadow$1.buttonHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(242, 197, 238, 1)'
};
boxShadow$1.buttonHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(244, 255, 220, .4)',
  blur: 0
};
boxShadow$1.tagHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(0, 108, 250, .4)'
};
boxShadow$1.tagHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(166, 225, 236, .4)',
  blur: 0
};

borderWidth$1.inc00 = 0;
borderWidth$1.inc10 = 1;
borderWidth$1.inc20 = 2;
borderWidth$1.inc30 = 3;
borderWidth$1.ruleBreak = borderWidth$1.inc10;
borderWidth$1.inputs = borderWidth$1.inc10;
borderWidth$1.systemIconSmall = borderWidth$1.inc10;
borderWidth$1.systemIconMedium = borderWidth$1.inc20;
borderWidth$1.systemIconLarge = borderWidth$1.inc20;

motion$1.inc00 = 100;
motion$1.inc10 = 200;
motion$1.inc20 = 250;
motion$1.inc30 = 300;
motion$1.inc40 = 350;
motion$1.linkAnimation = motion$1.inc30;
motion$1.mobileNavPanel = motion$1.inc30;
motion$1.mobileNavItemExpand = motion$1.inc30;
motion$1.tag = motion$1.inc00;
motion$1.codeSnippetCopyFade = motion$1.inc30 * 10;
motion$1.accordion = motion$1.inc40;

opacity$1.inc00 = '0%';
opacity$1.inc10 = '8%';
opacity$1.inc20 = '20%';
opacity$1.inc30 = '30%';
opacity$1.inc40 = '40%';
opacity$1.inc50 = '50%';
opacity$1.inc60 = '60%';
opacity$1.inc70 = '70%';
opacity$1.inc80 = '80%';
opacity$1.inc90 = '90%';
opacity$1.inc100 = '100%';
opacity$1.modalScrim = opacity$1.inc50;

icons$1.branded = {
  thin: borderWidth$1.inc10,
  medium: borderWidth$1.inc20,
  thick: borderWidth$1.inc30
};

navigation.default = {
  activeIndicator: colors$1.green40,
  bgPanel: '#F5F7FA',
  rule: colors$1.green70,
  l1: {
    text: colors$1.blue80,
    textHover: colors$1.green60,
    bgHover: colors$1.green80,
    mobile: { icon: colors$1.green60, seperator: colors$1.black20 }
  },
  l2: {
    link: colors$1.blue80,
    linkHover: colors$1.green60,
    icon: colors$1.green60,
    description: colors$1.green60,
    mobile: { link: colors$1.green60 }
  },
  l3: { link: colors$1.blue80, linkHover: colors$1.green60, icon: colors$1.green60 }
};
navigation.inverse = {
  activeIndicator: colors$1.green40,
  bgPanel: colors$1.black60,
  rule: colors$1.black00,
  l1: {
    text: colors$1.black00,
    textHover: colors$1.green40,
    bgHover: colors$1.black00,
    mobile: { icon: colors$1.green40, seperator: colors$1.black60 }
  },
  l2: {
    link: colors$1.black00,
    linkHover: colors$1.green40,
    icon: colors$1.green40,
    description: colors$1.black30,
    mobile: { link: colors$1.green40 }
  },
  l3: { link: colors$1.black00, linkHover: colors$1.green40, icon: colors$1.green40 }
};

letterSpacings.eyebrow = 3;

var defaultTokens = /*#__PURE__*/Object.freeze({
    __proto__: null,
    colors: colors$1,
    fontFamilies: fontFamilies$1,
    lineHeights: lineHeights$1,
    fontWeights: fontWeights$1,
    fontSizes: fontSizes$1,
    spacing: spacing$1,
    sizing: sizing$1,
    borderRadius: borderRadius$1,
    boxShadow: boxShadow$1,
    borderWidth: borderWidth$1,
    motion: motion$1,
    opacity: opacity$1,
    icons: icons$1,
    navigation: navigation,
    letterSpacings: letterSpacings
});

const transformToUnit = (token, unit) => {
  return Object.entries(token).reduce((acc, [name, value]) => {
    return {
      ...acc,
      [name]:
        typeof value === 'object'
          ? transformToUnit(value, unit)
          : `${value}${unit}`
    }
  }, {})
};

const transformToArrays = (token) => {
  return Object.entries(token).reduce((acc, [name, value]) => {
    const values = Object.values(value);
    return {
      ...acc,
      [name]:
        values.length > 0 && typeof values[0] === 'number'
          ? Object.values(value)
          : typeof value === 'object'
          ? transformToArrays(value)
          : []
    }
  }, {})
};

// format box shadow tokens to box shadow css shorthand
const formatToBoxShadow = (boxShadow) => {
  return Object.entries(boxShadow).reduce(
    (acc, [name, { x, y, spread, color, blur }]) => {
      /* offset-x | offset-y | blur-radius | spread-radius | color */
      acc[name] = `${x}px ${y}px ${blur}px ${spread}px ${color}`;
      return acc
    },
    {}
  )
};

const convertToPx = (token) => transformToUnit(token, 'px');

const convertToMs = (token) => transformToUnit(token, 'ms');

const shadows$1 = formatToBoxShadow(boxShadow$1);
const borders$1 = convertToPx(borderWidth$1);

var defaultTheme = {
  colors: colors$1,
  shadows: shadows$1,
  borders: borders$1,
  fonts: fontFamilies$1,
  fontWeights: fontWeights$1,
  sizes: convertToPx(sizing$1),
  radii: convertToPx(borderRadius$1),
  lineHeights: convertToPx(lineHeights$1),
  fontSizes: convertToPx(fontSizes$1),
  space: convertToPx(spacing$1),
  responsive: transformToArrays(spacing$1.responsive),
  borderWidths: borders$1,
  breakpoints: Object.values(convertToPx(sizing$1.breakpoint)),
  motion: convertToMs(motion$1),
  opacity: opacity$1,
  letterSpacings: convertToPx(letterSpacings)
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
// ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN
const colors = {},
  fontFamilies = {},
  lineHeights = {},
  fontWeights = {},
  fontSizes = {},
  spacing = {},
  sizing = {},
  borderRadius = {},
  boxShadow = {},
  borderWidth = {},
  motion = {},
  opacity = {},
  icons = {};

colors.black10 = '#fafafa';
colors.black20 = '#e7eeec';
colors.black30 = '#b8c4c2';
colors.black40 = '#9fa1a2';
colors.black50 = '#5d6c74';
colors.black70 = '#3d4f58';
colors.black80 = '#21313c';
colors.black90 = '#061621';
colors.black00 = '#ffffff';
colors.blue10 = '#e1f2f6';
colors.blue20 = '#cfe4f2';
colors.blue40 = '#7acfdd';
colors.blue50 = '#2f9fc5';
colors.blue70 = '#007cad';
colors.blue80 = '#1a567e';
colors.blue90 = '#0d324f';
colors.purple10 = '#f1f0fc';
colors.purple20 = '#d5d4f9';
colors.purple40 = '#9795f9';
colors.purple50 = '#6e60f9';
colors.purple70 = '#4f4fbf';
colors.purple80 = '#36367f';
colors.purple90 = '#273359';
colors.green10 = '#e7f2eb';
colors.green20 = '#b9eacd';
colors.green30 = '#83dba7';
colors.green40 = '#0ad05b';
colors.green50 = '#13AA52';
colors.green70 = '#09804c';
colors.green80 = '#116149';
colors.green90 = '#0b3b35';
colors.red10 = '#ffe1ea';
colors.red20 = '#f4bdca';
colors.red40 = '#ef8f9d';
colors.red50 = '#ea5c76';
colors.red70 = '#d83a6c';
colors.red80 = '#a53060';
colors.red90 = '#70234a';
colors.orange10 = '#fcebe2';
colors.orange20 = '#f9d3c5';
colors.orange40 = '#f7a765';
colors.orange50 = '#f97216';
colors.orange70 = '#cf4a22';
colors.orange80 = '#8f221b';
colors.orange90 = '#570b08';
colors.yellow10 = '#fef7e3';
colors.yellow20 = '#fef2c8';
colors.yellow40 = '#ffeb99';
colors.yellow50 = '#ffdd49';
colors.yellow70 = '#a49437';
colors.yellow80 = '#86681d';
colors.yellow90 = '#543e07';
colors.magenta10 = '#f9edf3';
colors.magenta20 = '#f4bde5';
colors.magenta40 = '#dd85bb';
colors.magenta50 = '#d4459c';
colors.magenta70 = '#b2478e';
colors.magenta80 = '#7f336a';
colors.magenta90 = '#592446';
colors.text = {
  default: colors.black80,
  secondary: colors.black50,
  inverse: colors.black00,
  inverseSecondary: colors.black30,
  error: colors.red70,
  errorInverse: colors.red50,
  neutral: colors.black50,
  selected: colors.green70,
  inverseSelected: colors.green40,
  mark: colors.green70,
  inverseMark: colors.green40
};
colors.border = {
  default: colors.black30,
  inverse: colors.black50,
  inverseDarker: colors.black70
};
colors.icon = {
  error: colors.red70,
  errorInverse: colors.red50,
  warning: colors.yellow50,
  branded: {
    primary: colors.green50,
    secondary: colors.green80,
    tertiary: colors.purple50,
    inversePrimary: colors.green40,
    inverseSecondary: colors.black00
  },
  system: {
    default: colors.black70,
    defaultNeutral: colors.black50,
    inverse: colors.black00,
    inverseNeutral: colors.black30,
    success: colors.green50,
    successInverse: colors.green40
  }
};
colors.background = {
  body: colors.black00,
  container: colors.black10,
  containerLighter: colors.black00,
  containerInverse: colors.black80,
  containerInverseDarker: colors.black90,
  selected: colors.green50,
  selectedLighter: colors.green10,
  panel: colors.black00,
  selectedInverseLighter: colors.black70
};
colors.button = {
  primary: {
    bg: colors.green50,
    bgLighter: colors.green40,
    bgDarker: colors.green70,
    bgDisabled: colors.black30,
    text: colors.black00,
    textDisabled: colors.black50
  },
  secondary: {
    bg: colors.black00,
    bgDarker: colors.black10,
    bgDisabled: colors.black30,
    text: colors.green50,
    border: colors.green50
  },
  inversePrimary: {
    bg: colors.green40,
    bgDarker: colors.black10,
    bgDisabled: colors.black70,
    text: colors.black90,
    textDisabled: colors.black30,
    bgLighter: colors.green30
  },
  inverseSecondary: {
    bg: colors.black80,
    bgLighter: colors.black70,
    bgDisabled: colors.black70,
    text: colors.green40,
    textDisabled: colors.black30,
    border: colors.green40
  },
  faux: { text: colors.green50, textActive: colors.green80 },
  inversefaux: { text: colors.green40, textActive: colors.green30 }
};
colors.input = {
  default: {
    bg: colors.black00,
    bgDisabled: colors.black10,
    border: colors.black30,
    borderError: colors.red70,
    text: colors.text.default,
    textSecondary: colors.text.secondary,
    textError: colors.text.error
  },
  inverse: {
    bg: colors.black80,
    bgDisabled: colors.black70,
    border: colors.black50,
    borderError: colors.red50,
    text: colors.text.inverse,
    textSecondary: colors.text.inverseSecondary,
    textError: colors.text.errorInverse
  }
};
colors.link = {
  cta: {
    default: {
      text: colors.black80,
      icon: colors.green50,
      textDisabled: colors.black50,
      iconDisabled: colors.black50
    },
    inverse: { text: colors.black00, icon: colors.green40 }
  },
  navigation: { text: colors.black80, textSelected: colors.green50 },
  footer: { text: colors.black00, textSelected: colors.green40 },
  inline: {
    default: { text: colors.green50, underline: colors.green50 },
    inverse: { text: colors.green40, underline: colors.black00 }
  }
};
colors.pill = {
  identifier: {
    primary: {
      text: colors.black90,
      bgInformational: colors.blue20,
      bgCritical: colors.red10
    },
    secondary: {
      textInformational: colors.black00,
      bgInformational: colors.blue70,
      bgCritical: colors.red70
    },
    inverse: { borderInformational: colors.blue20, inverseText: colors.blue20 }
  },
  badge: {
    default: { bg: colors.green40, text: colors.green90 },
    inverse: { bg: colors.green40, text: colors.black90 }
  }
};
colors.tag = {
  border: colors.blue50,
  text: colors.blue50,
  bg: colors.blue20,
  inverseBorder: colors.blue20,
  inverseText: colors.blue20,
  inverseBG: colors.blue90
};
colors.panels = {
  default: {
    bg: colors.black10,
    bgLighter: colors.black00,
    border: colors.black30
  },
  inverse: {
    bg: colors.black80,
    bgDarker: colors.black90,
    border: colors.black50
  },
  navigation: { bg: colors.black00, border: colors.black30 },
  card: {
    bg: colors.black00,
    bgDarker: colors.black10,
    border: colors.black30
  },
  modal: {
    bg: colors.black00,
    bgDarker: colors.black10,
    border: colors.black30
  },
  notification: {
    bgSuccess: colors.green10,
    borderSuccess: colors.green20,
    bgAlert: colors.yellow10,
    borderAlert: colors.yellow40,
    bgNote: colors.blue10,
    borderNote: colors.blue20,
    bgDanger: colors.orange10,
    borderDanger: colors.orange20,
    innerSuccess: colors.green80,
    innerNote: colors.blue80,
    innerDanger: colors.orange80,
    innerAlert: colors.yellow90
  },
  tooltip: {
    bgInverse: colors.black80,
    borderInverse: colors.black50,
    bg: colors.black00,
    border: colors.black30
  },
  popover: {
    bg: colors.black00,
    border: colors.black30,
    bgInverse: colors.black80,
    borderInverse: colors.black50
  },
  select: {
    bg: colors.black00,
    bgInverse: colors.black80,
    borderInverse: colors.black50,
    border: colors.black30
  }
};
colors.tabs = {
  tertiary: {
    borderHover: colors.blue70,
    bgActive: colors.blue70,
    bg: colors.black20,
    bgInverse: colors.black70
  }
};
colors.code = { bg: colors.black80, bgLines: colors.black90 };
colors.card = {
  default: {
    bg: colors.black00,
    border: colors.black30,
    textSub: colors.green70,
    borderDarker: colors.green90
  },
  inverse: {
    bg: colors.black80,
    border: colors.black70,
    textSub: colors.green40,
    borderLighter: colors.green40
  }
};

fontFamilies.menlo = 'Menlo';
fontFamilies['akzidenz-grotesk-std'] = 'Akzidenz-Grotesk Std';
fontFamilies['euclid-circular-a'] = 'Euclid Circular A';
fontFamilies['source-code-pro'] = 'Source Code Pro';
fontFamilies['mongodb-value-serif'] = 'MongoDB Value Serif';
fontFamilies.heading = fontFamilies['akzidenz-grotesk-std'];
fontFamilies.body = fontFamilies['akzidenz-grotesk-std'];
fontFamilies.mono = fontFamilies['source-code-pro'];

lineHeights.inc00 = 16;
lineHeights.inc10 = 18;
lineHeights.inc20 = 24;
lineHeights.inc30 = 32;
lineHeights.inc40 = 40;
lineHeights.inc50 = 48;
lineHeights.inc60 = 56;
lineHeights.inc70 = 64;
lineHeights.inc80 = 72;
lineHeights.inc90 = 112;
lineHeights.headingXXL = lineHeights.inc90;
lineHeights.headingXL = lineHeights.inc80;
lineHeights.headingL = lineHeights.inc70;
lineHeights.headingM = lineHeights.inc60;
lineHeights.headingS = lineHeights.inc50;
lineHeights.headingXS = lineHeights.inc30;
lineHeights.headingXXLResponsive = lineHeights.inc60;
lineHeights.headingXLResponsive = lineHeights.inc50;
lineHeights.headingLResponsive = lineHeights.inc40;
lineHeights.headingMResponsive = lineHeights.inc30;
lineHeights.headingSResponsive = lineHeights.inc30;
lineHeights.headingXSResponsive = lineHeights.inc20;
lineHeights.bodyL = lineHeights.inc30;
lineHeights.bodyM = lineHeights.inc30;
lineHeights.bodyS = lineHeights.inc20;
lineHeights.bodyXS = lineHeights.inc00;
lineHeights.bodyLResponsive = lineHeights.inc30;
lineHeights.bodyMResponsive = lineHeights.inc30;
lineHeights.bodySResponsive = lineHeights.inc20;
lineHeights.bodyXSResponsive = lineHeights.inc00;
lineHeights.monoL = lineHeights.inc30;
lineHeights.monoM = lineHeights.inc20;
lineHeights.monoS = lineHeights.inc00;
lineHeights.monoLResponsive = lineHeights.inc30;
lineHeights.monoMResponsive = lineHeights.inc20;
lineHeights.monoSResponsive = lineHeights.inc00;

fontWeights.medium = 'Medium';
fontWeights.light = 'Light';
fontWeights.regular = 'Regular';
fontWeights.bold = 'Bold';
fontWeights.semibold = 'Semibold';

fontSizes.inc00 = 12;
fontSizes.inc10 = 14;
fontSizes.inc20 = 16;
fontSizes.inc30 = 18;
fontSizes.inc40 = 20;
fontSizes.inc50 = 24;
fontSizes.inc60 = 28;
fontSizes.inc70 = 32;
fontSizes.inc80 = 36;
fontSizes.inc90 = 40;
fontSizes.inc100 = 44;
fontSizes.inc110 = 48;
fontSizes.inc120 = 56;
fontSizes.inc130 = 64;
fontSizes.inc140 = 96;
fontSizes.headingXXL = fontSizes.inc140;
fontSizes.headingXL = fontSizes.inc130;
fontSizes.headingL = fontSizes.inc120;
fontSizes.headingM = fontSizes.inc100;
fontSizes.headingS = fontSizes.inc80;
fontSizes.headingXS = fontSizes.inc50;
fontSizes.headingXXLResponsive = fontSizes.inc110;
fontSizes.headingXLResponsive = fontSizes.inc90;
fontSizes.headingLResponsive = fontSizes.inc70;
fontSizes.headingMResponsive = fontSizes.inc60;
fontSizes.headingSResponsive = fontSizes.inc50;
fontSizes.headingXSResponsive = fontSizes.inc30;
fontSizes.bodyL = fontSizes.inc40;
fontSizes.bodyM = fontSizes.inc30;
fontSizes.bodyS = fontSizes.inc20;
fontSizes.bodyXS = fontSizes.inc10;
fontSizes.bodyLResponsive = fontSizes.inc30;
fontSizes.bodyMResponsive = fontSizes.inc20;
fontSizes.bodySResponsive = fontSizes.inc10;
fontSizes.bodyXSResponsive = fontSizes.inc10;
fontSizes.monoL = fontSizes.inc20;
fontSizes.monoM = fontSizes.inc10;
fontSizes.monoS = fontSizes.inc00;
fontSizes.monoLResponsive = fontSizes.inc20;
fontSizes.monoMResponsive = fontSizes.inc10;
fontSizes.monoSResponsive = fontSizes.inc00;

spacing.base = 8;
spacing.inc00 = 0;
spacing.neg00 = 0;
spacing.section00 = spacing.base;
spacing.section10 = spacing.base * 2;
spacing.section20 = spacing.base * 3;
spacing.section30 = spacing.base * 6;
spacing.section40 = spacing.base * 8;
spacing.section50 = spacing.base * 12;
spacing.section60 = spacing.base * 14;
spacing.inc10 = spacing.base * 0.5;
spacing.inc20 = spacing.base * 1;
spacing.inc30 = spacing.base * 2;
spacing.inc40 = spacing.base * 3;
spacing.inc50 = spacing.base * 4;
spacing.inc60 = spacing.base * 5;
spacing.inc70 = spacing.base * 6;
spacing.inc80 = spacing.base * 7;
spacing.inc90 = spacing.base * 8;
spacing.inc100 = spacing.base * 9;
spacing.inc110 = spacing.base * 10;
spacing.inc120 = spacing.base * 11;
spacing.inc130 = spacing.base * 12;
spacing.inc140 = spacing.base * 13;
spacing.inc150 = spacing.base * 14;
spacing.inc160 = spacing.base * 15;
spacing.neg10 = spacing.base * -0.5;
spacing.neg20 = spacing.base * -1;
spacing.neg30 = spacing.base * -2;
spacing.neg40 = spacing.base * -3;
spacing.neg50 = spacing.base * -4;
spacing.neg60 = spacing.base * -5;
spacing.neg70 = spacing.base * -6;
spacing.neg80 = spacing.base * -7;
spacing.neg90 = spacing.base * -8;
spacing.sectionGapZero = spacing.inc00;
spacing.sectionGapXXSmall = spacing.section00;
spacing.sectionGapXSmall = spacing.section10;
spacing.sectionGapSmall = spacing.section20;
spacing.sectionGapMedium = spacing.section30;
spacing.sectionGapLarge = spacing.section40;
spacing.sectionGapXLarge = spacing.section50;
spacing.sectionGapXXLarge = spacing.section60;
spacing.elementZero = spacing.inc00;
spacing.elementXSmall = spacing.inc30;
spacing.elementSmall = spacing.inc40;
spacing.elementMedium = spacing.inc50;
spacing.elementLarge = spacing.inc60;
spacing.elementXLarge = spacing.inc70;
spacing.colGapSmall = spacing.inc30;
spacing.colGapMedium = spacing.inc40;
spacing.outsideGutterSmall = spacing.inc40;
spacing.outsideGutterMedium = spacing.inc50;
spacing.outsideGutterLarge = spacing.inc70;
spacing.cards = {
  paddingXXS: spacing.inc40,
  paddingXS: spacing.inc50,
  paddingS: spacing.inc60,
  paddingM: spacing.inc70,
  paddingL: spacing.inc80,
  paddingXL: spacing.inc110,
  paddingXXL: spacing.inc160
};
spacing.responsive = {
  verticalGap: {
    sectionZero: { small: 0, medium: 0, large: 0, xlarge: 0, xxlarge: 0 },
    sectionXXSmall: {
      small: spacing.section00,
      medium: spacing.section00,
      large: spacing.section00,
      xlarge: spacing.section00,
      xxlarge: spacing.section00
    },
    sectionXSmall: {
      small: spacing.section10,
      medium: spacing.section10,
      large: spacing.section10,
      xlarge: spacing.section10,
      xxlarge: spacing.section10
    },
    sectionSmall: {
      small: spacing.section20,
      medium: spacing.section20,
      large: spacing.section20,
      xlarge: spacing.section20,
      xxlarge: spacing.section20
    },
    sectionMedium: {
      small: spacing.section30,
      medium: spacing.section30,
      large: spacing.section30,
      xlarge: spacing.section30,
      xxlarge: spacing.section30
    },
    sectionLarge: {
      small: spacing.sectionGapMedium,
      medium: spacing.sectionGapMedium,
      large: spacing.section40,
      xlarge: spacing.section40,
      xxlarge: spacing.section40
    },
    sectionXLarge: {
      small: spacing.inc80,
      medium: spacing.inc80,
      large: spacing.section50,
      xlarge: spacing.section50,
      xxlarge: spacing.section50
    },
    sectionXXLarge: {
      small: spacing.sectionGapLarge,
      medium: spacing.sectionGapLarge,
      large: spacing.section60,
      xlarge: spacing.section60,
      xxlarge: spacing.section60
    }
  },
  columnGap: {
    tight: {
      small: spacing.inc20,
      medium: spacing.inc30,
      large: spacing.inc40,
      xlarge: spacing.inc40,
      xxlarge: spacing.inc40
    },
    normal: {
      small: spacing.inc30,
      medium: spacing.inc50,
      large: spacing.inc70,
      xlarge: spacing.inc70,
      xxlarge: spacing.inc70
    },
    loose: {
      small: spacing.inc40,
      medium: spacing.inc60,
      large: spacing.inc90,
      xlarge: spacing.inc90,
      xxlarge: spacing.inc90
    },
    huge: {
      small: spacing.inc60,
      medium: spacing.inc80,
      large: spacing.inc130,
      xlarge: spacing.inc130,
      xxlarge: spacing.inc130
    }
  }
};

sizing.base = 8;
sizing.maxWidthDesktop = 1416;
sizing.inc00 = sizing.base * 0.5;
sizing.inc10 = sizing.base * 2;
sizing.inc20 = sizing.base * 3;
sizing.inc30 = sizing.base * 4;
sizing.inc40 = sizing.base * 5;
sizing.inc50 = sizing.base * 6;
sizing.inc60 = sizing.base * 7;
sizing.inc70 = sizing.base * 8;
sizing.inc80 = sizing.base * 9;
sizing.inc90 = sizing.base * 10;
sizing.inc100 = sizing.base * 11;
sizing.systemIconLarge = sizing.inc30;
sizing.systemIconMedium = sizing.inc20;
sizing.systemIconSmall = sizing.inc10;
sizing.codeSnippetSmall = sizing.base * 35;
sizing.codeSnippetMedium = sizing.base * 60;
sizing.codeSnippetLarge = sizing.base * 90;
sizing.brandedIconSmall = sizing.inc50;
sizing.brandedIconMedium = sizing.inc70;
sizing.brandedIconLarge = sizing.inc90;
sizing.breakpoint = {
  small: 460,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440
};

borderRadius.circle = 999;
borderRadius.inc00 = 0;
borderRadius.inc10 = 2;
borderRadius.inc20 = 4;
borderRadius.inc30 = 8;
borderRadius.inc40 = 16;
borderRadius.inc50 = 24;
borderRadius.inc60 = 32;
borderRadius.inc70 = 40;
borderRadius.inc80 = 56;
borderRadius.inc90 = 72;
borderRadius.inc100 = 88;
borderRadius.inc110 = 104;
borderRadius.buttons = borderRadius.inc20;
borderRadius.input = borderRadius.inc20;
borderRadius.modal = borderRadius.inc20;
borderRadius.tooltips = borderRadius.inc20;
borderRadius.notification = borderRadius.inc20;
borderRadius.card = borderRadius.inc70;
borderRadius.cardResponsive = borderRadius.inc50;
borderRadius.codePanel = borderRadius.inc60;
borderRadius.buttonHover = borderRadius.inc70;
borderRadius.scrollyStoryCard = borderRadius.inc50;
borderRadius.scrollyStoryCardResponsive = borderRadius.inc40;

boxShadow.level00 = { x: 0, y: 0, spread: 0, color: '#000000', blur: 0 };
boxShadow.level01 = { x: 0, y: 2, spread: 0, color: 'rgba(0,0,0,.1)', blur: 4 };
boxShadow.level02 = { x: 0, y: 3, spread: 0, color: 'rgba(0,0,0,.15)', blur: 9 };
boxShadow.level03 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 20
};
boxShadow.level04 = {
  x: 0,
  y: 6,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 30
};
boxShadow.buttonHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(185, 234, 205, 1)'
};
boxShadow.buttonHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(244, 255, 220, .4)',
  blur: 0
};
boxShadow.tagHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(0, 108, 250, .4)'
};
boxShadow.tagHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(166, 225, 236, .4)',
  blur: 0
};

borderWidth.inc00 = 0;
borderWidth.inc10 = 1;
borderWidth.inc20 = 2;
borderWidth.inc30 = 3;
borderWidth.ruleBreak = borderWidth.inc10;
borderWidth.inputs = borderWidth.inc10;
borderWidth.systemIconSmall = borderWidth.inc10;
borderWidth.systemIconMedium = borderWidth.inc20;
borderWidth.systemIconLarge = borderWidth.inc20;

motion.inc00 = 100;
motion.inc10 = 200;
motion.inc20 = 250;
motion.inc30 = 300;
motion.inc40 = 350;
motion.linkAnimation = motion.inc30;
motion.mobileNavPanel = motion.inc30;
motion.mobileNavItemExpand = motion.inc30;
motion.tag = motion.inc00;
motion.codeSnippetCopyFade = motion.inc30 * 10;
motion.accordion = motion.inc40;

opacity.inc00 = '0%';
opacity.inc10 = '10%';
opacity.inc20 = '20%';
opacity.inc30 = '30%';
opacity.inc40 = '40%';
opacity.inc50 = '50%';
opacity.inc60 = '60%';
opacity.inc70 = '70%';
opacity.inc80 = '80%';
opacity.inc90 = '90%';
opacity.inc100 = '100%';
opacity.modalScrim = opacity.inc50;

icons.branded = {
  thin: borderWidth.inc10,
  medium: borderWidth.inc20,
  thick: borderWidth.inc30
};

var legacyTokens = /*#__PURE__*/Object.freeze({
    __proto__: null,
    colors: colors,
    fontFamilies: fontFamilies,
    lineHeights: lineHeights,
    fontWeights: fontWeights,
    fontSizes: fontSizes,
    spacing: spacing,
    sizing: sizing,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    borderWidth: borderWidth,
    motion: motion,
    opacity: opacity,
    icons: icons
});

const shadows = formatToBoxShadow(boxShadow);
const borders = convertToPx(borderWidth);

var legacyTheme = {
  colors,
  shadows,
  borders,
  fonts: fontFamilies,
  fontWeights,
  sizes: convertToPx(sizing),
  radii: convertToPx(borderRadius),
  lineHeights: convertToPx(lineHeights),
  fontSizes: convertToPx(fontSizes),
  space: convertToPx(spacing),
  responsive: transformToArrays(spacing.responsive),
  borderWidths: borders,
  breakpoints: Object.values(convertToPx(sizing.breakpoint)),
  motion: convertToMs(motion),
  opacity,
  config: {
    useRootStyles: false
  }
};

var ELinkVariant;
(function (ELinkVariant) {
    ELinkVariant["LARGE"] = "large";
    ELinkVariant["MEDIUM"] = "medium";
    ELinkVariant["SMALL"] = "small";
})(ELinkVariant || (ELinkVariant = {}));

var getVariantStyles$4 = function (props) {
    var _a = props.variant, variant = _a === void 0 ? ELinkVariant.SMALL : _a, inverse = props.inverse, navItem = props.navItem, navTitle = props.navTitle, arrowOnly = props.arrowOnly, href = props.href, theme = props.theme, linkIcon = props.linkIcon;
    var isNav = navItem || navTitle;
    var defaultTheme = theme === 'default';
    var getColor = function (navItem, navTitle, inverse, defaultTheme) {
        if (navItem === void 0) { navItem = false; }
        if (navTitle === void 0) { navTitle = false; }
        if (inverse === void 0) { inverse = false; }
        if (navItem || navTitle || !defaultTheme) {
            return inverse ? 'black00' : 'link.navigation.text';
        }
        return inverse ? 'link.inline.inverse.text' : 'link.inline.default.text';
    };
    var color = getColor(navItem, navTitle, inverse, defaultTheme);
    switch (variant) {
        case ELinkVariant.LARGE: {
            return {
                fontSize: 'inc40',
                lineHeight: 'inc60',
                color: color,
                '&:hover': {
                    color: linkIcon && 'link.cta.default.textHover',
                    textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
                }
            };
        }
        case ELinkVariant.MEDIUM: {
            return {
                fontSize: navTitle ? 'inc20' : 'inc30',
                lineHeight: navTitle ? 'inc30' : 'inc50',
                color: color,
                '&:hover': {
                    color: linkIcon && 'link.cta.default.textHover',
                    textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
                },
                '&:active': {
                    color: navItem || (navTitle && 'link.navigation.textSelected')
                }
            };
        }
        case ELinkVariant.SMALL: {
            return {
                fontSize: 'inc20',
                lineHeight: 'inc30',
                color: color,
                '&:hover': {
                    color: linkIcon && 'link.cta.default.textHover',
                    textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
                },
                '&:active': {
                    color: navItem || (navTitle && 'link.navigation.textSelected')
                }
            };
        }
    }
};
var getIconColor$1 = function (linkIconColor, inverse, theme) {
    if (linkIconColor) {
        return linkIconColor;
    }
    else if (inverse) {
        return theme.colors.link.cta.inverse.icon;
    }
    return theme.colors.link.cta.default.icon;
};
var fixHref = function (hrefToBeFixed) {
    if (!hrefToBeFixed)
        return hrefToBeFixed;
    var hasHashTag = hrefToBeFixed.includes('#');
    if (!hasHashTag)
        return hrefToBeFixed;
    var isInvalid = hrefToBeFixed.indexOf('#') < hrefToBeFixed.indexOf('?');
    if (!isInvalid)
        return hrefToBeFixed;
    var _a = hrefToBeFixed.split('#'), beforeQuery = _a[0], afterQuery = _a[1];
    var _b = afterQuery.split('?'), query = _b[0], rest = _b[1];
    return beforeQuery + '?' + rest + '#' + query;
};

var getVariantStyles$3 = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, selectedTheme = _a.selectedTheme, theme = _a.theme;
    var primaryToken = inverse ? 'inversePrimary' : 'primary';
    var secondaryToken = inverse ? 'inverseSecondary' : 'secondary';
    if (variant === 'primary') {
        var color_1 = selectedTheme.colors.button[primaryToken].text;
        var disabledColor_1 = selectedTheme.colors.button[primaryToken].textDisabled;
        return {
            color: color_1,
            stroke: color_1,
            fill: color_1,
            borderColor: selectedTheme.colors.button[primaryToken].border,
            bg: selectedTheme.colors.button[primaryToken].bg,
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'none',
                borderRadius: 'buttonHover'
            },
            '&:active, &:focus': {
                bg: selectedTheme.colors.button[primaryToken].bgDarker,
                borderRadius: theme !== 'legacy' && 'circle',
                boxShadow: inverse
                    ? selectedTheme.shadows.buttonHoverInverse
                    : selectedTheme.shadows.buttonHover,
                transition: '.1s' // Need a token for this
            },
            '&:disabled, &disabled:hover': {
                bg: selectedTheme.colors.button[primaryToken].bgDisabled,
                cursor: 'not-allowed',
                color: disabledColor_1,
                stroke: disabledColor_1,
                fill: disabledColor_1,
                boxShadow: 'level00'
            }
        };
    }
    var color = selectedTheme.colors.button[secondaryToken].text;
    var disabledColor = selectedTheme.colors.button[primaryToken].textDisabled;
    return {
        color: color,
        stroke: color,
        fill: color,
        bg: selectedTheme.colors.button[secondaryToken].bg,
        borderWidth: 'inc10',
        borderStyle: 'solid',
        borderColor: inverse
            ? selectedTheme.colors.button.inverseSecondary.bg
            : selectedTheme.colors.button.secondary.border,
        '&:hover': {
            cursor: 'pointer',
            bg: inverse ? null : selectedTheme.colors.button.secondary.background,
            textDecoration: 'none',
            transition: '.1s' // Need a token for this
        },
        '&:active': {
            bg: inverse
                ? selectedTheme.colors.button.inverseSecondary.bgLighter
                : selectedTheme.colors.button.secondary.bgDarker,
            boxShadow: selectedTheme.shadows.buttonHover,
            transition: '.1s' // Need a token for this
        },
        '&:disabled, &disabled:hover': {
            bg: selectedTheme.colors.button[secondaryToken].bgDisabled,
            color: disabledColor,
            stroke: disabledColor,
            fill: disabledColor,
            borderColor: selectedTheme.colors.button[primaryToken].borderDisabled,
            borderWidth: 'inc10',
            borderRadius: selectedTheme.radii.buttons,
            cursor: 'not-allowed'
        }
    };
};
var Button = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.onMouseEnter, onMouseEnter = _d === void 0 ? function () { } : _d, href = _a.href, target = _a.target, disabled = _a.disabled, _e = _a.hasIcon, hasIcon = _e === void 0 ? false : _e, _f = _a.iconPosition, iconPosition = _f === void 0 ? 'left' : _f, _g = _a.iconName, iconName = _g === void 0 ? ESystemIconNames.CHEVRON_RIGHT : _g, _h = _a.iconStrokeWeight, iconStrokeWeight = _h === void 0 ? 'small' : _h, _j = _a.theme, theme = _j === void 0 ? 'default' : _j, children = _a.children, _k = _a.inverse, inverse = _k === void 0 ? false : _k, variant = _a.variant, _l = _a.size, size = _l === void 0 ? 'small' : _l, _m = _a.type, type = _m === void 0 ? 'button' : _m, _o = _a.tabIndex, tabIndex = _o === void 0 ? 0 : _o, _p = _a.trackClick, trackClick = _p === void 0 ? true : _p, _q = _a.trackCategory, trackCategory = _q === void 0 ? '' : _q, customStyles = _a.customStyles, customWrapperStyles = _a.customWrapperStyles, hideIconTitle = _a.hideIconTitle, _r = _a.disableAnchor, disableAnchor = _r === void 0 ? false : _r;
    var ButtonElement = href && !disableAnchor ? 'a' : 'button';
    var buttonType = href ? undefined : type;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var icon = (jsx(SystemIcon, { hideTitle: hideIconTitle, strokeWeight: iconStrokeWeight, name: iconName, inheritColor: true }, void 0));
    return (jsx("div", __assign({ sx: __assign({ display: 'inline-block', '&:hover > button, &:hover > a': {
                borderRadius: 'buttonHover'
            } }, customWrapperStyles) }, { children: jsxs(ButtonElement, __assign({ type: buttonType, tabIndex: tabIndex, className: className, href: fixHref(href), target: target, disabled: disabled, onClick: onClick, onMouseEnter: onMouseEnter, sx: __assign(__assign({ width: ['100%', null, 'unset'], paddingY: 'inc30', paddingX: size === 'small' ? 'inc50' : 'inc70', fontFamily: 'body', fontSize: 'inc20', fontWeight: theme === 'legacy' ? '300' : '500', borderRadius: 'buttons', lineHeight: 'inc00', border: 'solid', borderWidth: 'inc10', textDecoration: 'none', display: hasIcon ? 'flex' : 'inline-block', gap: 'inc20', transition: 'border-radius .15s' }, getVariantStyles$3({ inverse: inverse, variant: variant, selectedTheme: selectedTheme, theme: theme })), customStyles), "data-track": trackClick ? trackClick.toString() : '', "data-track-category": trackCategory === '' ? undefined : trackCategory }, { children: [hasIcon && iconPosition === 'left' && icon, children, hasIcon && iconPosition === 'right' && icon] }), void 0) }), void 0));
};

var getVariantStyles$2 = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, _d = _a.keepMobileOutline, keepMobileOutline = _d === void 0 ? false : _d, selectedTheme = _a.selectedTheme;
    var primaryToken = inverse ? 'inversePrimary' : 'primary';
    var secondaryToken = inverse ? 'inverseSecondary' : 'secondary';
    if (variant === 'primary') {
        var normalColor_1 = selectedTheme.colors.button.utility.icon;
        var hoverColor = inverse
            ? null
            : selectedTheme.colors.button.utility.iconInverse;
        var disabledColor_1 = selectedTheme.colors.button[primaryToken].textDisabled;
        return {
            bg: selectedTheme.colors.button.utility.bg,
            stroke: normalColor_1,
            fill: normalColor_1,
            borderColor: inverse
                ? selectedTheme.colors.button.utility.borderInverse
                : selectedTheme.colors.button.utility.border,
            '&:hover': {
                cursor: 'pointer',
                bg: inverse
                    ? selectedTheme.colors.button.utility.bgHoverInverse
                    : selectedTheme.colors.button.utility.bgHover,
                stroke: hoverColor,
                fill: hoverColor
            },
            '&:active': {
                boxShadow: inverse
                    ? selectedTheme.shadows.buttonHoverInverse
                    : selectedTheme.shadows.buttonHover,
                transition: '.1s' // Need a token for this
            },
            '&:disabled, &disabled:hover': {
                cursor: 'not-allowed',
                bg: selectedTheme.colors.button[primaryToken].bgDisabled,
                stroke: disabledColor_1,
                fill: disabledColor_1,
                boxShadow: 'level00',
                borderColor: selectedTheme.colors.button[primaryToken].borderDisabled
            }
        };
    }
    if (variant === 'outline') {
        var normalColor_2 = inverse
            ? selectedTheme.colors.black10
            : selectedTheme.colors.button.primary.border;
        var hoverColor = inverse
            ? [selectedTheme.colors.black10, null, null, selectedTheme.colors.black70]
            : [
                selectedTheme.colors.button.utility.icon,
                null,
                null,
                selectedTheme.colors.button.utility.iconInverse
            ];
        var disabledColor_2 = inverse
            ? selectedTheme.colors.black10
            : selectedTheme.colors.button.primary.border;
        var mobileBorderStyle = 'none';
        var mobileHoverBg = null;
        var mobileHoverBgInverse = null;
        if (keepMobileOutline) {
            mobileBorderStyle = 'solid';
            mobileHoverBg = selectedTheme.colors.button.primary.bg;
            mobileHoverBgInverse = selectedTheme.colors.button.primary.border;
        }
        return {
            bg: 'transparent',
            stroke: normalColor_2,
            fill: normalColor_2,
            borderStyle: [mobileBorderStyle, null, null, 'solid'],
            borderWidth: 'inc20',
            borderColor: inverse
                ? selectedTheme.colors.button.utility.borderInverse
                : selectedTheme.colors.button.primary.border,
            '&:hover': {
                cursor: 'pointer',
                bg: inverse
                    ? [mobileHoverBg, null, null, selectedTheme.colors.button.primary.bg]
                    : [
                        mobileHoverBgInverse,
                        null,
                        null,
                        selectedTheme.colors.button.primary.border
                    ],
                stroke: hoverColor,
                fill: hoverColor,
                opacity: [
                    selectedTheme.colors.button.primary.border ? 1 : 0.5,
                    null,
                    null,
                    1
                ]
            },
            '&:active': {
                bg: selectedTheme.colors.button[primaryToken].bgDarker,
                boxShadow: inverse
                    ? selectedTheme.shadows.buttonHoverInverse
                    : selectedTheme.shadows.buttonHover,
                transition: '.1s' // Need a token for this
            },
            '&:disabled, &disabled:hover': {
                cursor: 'not-allowed',
                bg: 'transparent',
                stroke: disabledColor_2,
                fill: disabledColor_2,
                boxShadow: 'level00',
                opacity: 0.5
            }
        };
    }
    var normalColor = selectedTheme.colors.button[secondaryToken].text;
    var disabledColor = inverse
        ? selectedTheme.colors.black70
        : selectedTheme.colors.button.primary.textDisabled;
    return {
        bg: inverse
            ? selectedTheme.colors.button.inverseSecondary.bg
            : selectedTheme.colors.black70,
        stroke: normalColor,
        fill: normalColor,
        borderStyle: 'solid',
        borderWidth: 'inc10',
        borderColor: inverse
            ? selectedTheme.colors.button.inverseSecondary.bg
            : selectedTheme.colors.black70,
        '&:hover': {
            cursor: 'pointer',
            bg: inverse
                ? selectedTheme.colors.black20
                : selectedTheme.colors.button.secondary.bg,
            transition: '.1s' // Need a token for this
        },
        '&:active': {
            bg: inverse
                ? selectedTheme.colors.button.inverseSecondary.bgLighter
                : selectedTheme.colors.button.secondary.bgDarker,
            boxShadow: inverse
                ? selectedTheme.shadows.buttonHoverInverse
                : selectedTheme.shadows.buttonHover,
            transition: '.1s' // Need a token for this
        },
        '&:disabled, &disabled:hover': {
            cursor: 'not-allowed',
            bg: inverse
                ? selectedTheme.colors.black40
                : selectedTheme.colors.button.primary.bgDisabled,
            stroke: disabledColor,
            fill: disabledColor,
            borderColor: selectedTheme.colors.button[primaryToken].borderDisabled,
            boxShadow: 'level00'
        }
    };
};
var getSizeStyles$2 = function (variant, size) {
    var outline = variant === 'outline';
    var Styles = {
        small: {
            width: '48px',
            height: '48px'
        },
        large: {
            width: outline ? ['48px', null, null, '56px'] : '56px',
            height: outline ? ['48px', null, null, '56px'] : '56px'
        },
        extraLarge: {
            width: outline ? ['48px', null, null, '88px'] : '88px',
            height: outline ? ['48px', null, null, '88px'] : '88px'
        }
    };
    return Styles[size];
};

var ButtonIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.onMouseEnter, onMouseEnter = _d === void 0 ? function () { } : _d, href = _a.href, target = _a.target, disabled = _a.disabled, _e = _a.iconName, iconName = _e === void 0 ? ESystemIconNames.CHEVRON_RIGHT : _e, _f = _a.iconStrokeWeight, iconStrokeWeight = _f === void 0 ? 'medium' : _f, _g = _a.theme, theme = _g === void 0 ? 'default' : _g, _h = _a.inverse, inverse = _h === void 0 ? false : _h, _j = _a.variant, variant = _j === void 0 ? 'primary' : _j, _k = _a.size, size = _k === void 0 ? 'small' : _k, _l = _a.tabIndex, tabIndex = _l === void 0 ? 0 : _l, _m = _a.trackClick, trackClick = _m === void 0 ? true : _m, _o = _a.trackCategory, trackCategory = _o === void 0 ? '' : _o, customStyles = _a.customStyles, customWrapperStyles = _a.customWrapperStyles, _p = _a.keepMobileOutline, keepMobileOutline = _p === void 0 ? false : _p, ariaLabel = _a.ariaLabel;
    var ButtonElement = href ? 'a' : 'button';
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx("div", __assign({ sx: __assign({ display: 'inline-block' }, customWrapperStyles) }, { children: jsx(ButtonElement, __assign({ "aria-label": ariaLabel, tabIndex: tabIndex, className: className, href: href, target: target, disabled: disabled, onClick: function (e) {
                e.stopPropagation();
                onClick();
            }, onMouseEnter: onMouseEnter, sx: __assign(__assign(__assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'solid', borderWidth: 'inc10', borderRadius: '50%', transition: '.15s' }, getVariantStyles$2({
                inverse: inverse,
                variant: variant,
                selectedTheme: selectedTheme,
                keepMobileOutline: keepMobileOutline
            })), getSizeStyles$2(variant, size)), customStyles), "data-track": trackClick ? trackClick.toString() : '', "data-track-category": trackCategory === '' ? undefined : trackCategory }, { children: jsx(SystemIcon, { strokeWeight: iconStrokeWeight, name: iconName, inheritColor: true }, void 0) }), void 0) }), void 0));
};

var _a$5;
var AKZIDENZ_FAMILY = 'Akzidenz-Grotesk Std';
var EUCLID_CIRCULAR_FAMILY = 'Euclid Circular A';
var MONGODB_VALUE_SERIF_FAMILY = 'MongoDB Value Serif';
var SOURCE_CODE_PRO_FAMILY = 'Source Code Pro';
var FONT_SRCS = (_a$5 = {},
    _a$5[AKZIDENZ_FAMILY] = {
        light: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Regular-WebXL.woff2',
        medium: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Medium-WebXL.woff2'
    },
    _a$5[EUCLID_CIRCULAR_FAMILY] = {
        regular: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Regular-WebXL.woff2',
        medium: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Medium-WebXL.woff2'
    },
    _a$5[MONGODB_VALUE_SERIF_FAMILY] = {
        regular: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Regular.woff2',
        medium: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Medium.woff2',
        bold: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Bold.woff2'
    },
    _a$5[SOURCE_CODE_PRO_FAMILY] = {
        regular: 'https://static.mongodb.com/com/fonts/SourceCodePro-Regular.ttf',
        medium: 'https://static.mongodb.com/com/fonts/SourceCodePro-Medium.ttf'
    },
    _a$5);

var Globals = function (_a) {
    var legacy = _a.legacy;
    if (legacy) {
        return (jsx(Global, { styles: css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n            @font-face {\n              font-family: ", ";\n              src: url(", ") format('woff2');\n              font-weight: 300;\n              font-style: normal;\n              font-display: swap;\n            }\n\n            @font-face {\n              font-family: ", ";\n              src: url(", ") format('woff2');\n              font-weight: 500;\n              font-style: normal;\n              font-display: swap;\n            }\n          "], ["\n            @font-face {\n              font-family: ", ";\n              src: url(", ") format('woff2');\n              font-weight: 300;\n              font-style: normal;\n              font-display: swap;\n            }\n\n            @font-face {\n              font-family: ", ";\n              src: url(", ") format('woff2');\n              font-weight: 500;\n              font-style: normal;\n              font-display: swap;\n            }\n          "])), AKZIDENZ_FAMILY, FONT_SRCS[AKZIDENZ_FAMILY].light, AKZIDENZ_FAMILY, FONT_SRCS[AKZIDENZ_FAMILY].medium) }, void 0));
    }
    return (jsx(Global, { styles: css(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: 500;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: 500;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: bold;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('truetype');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('truetype');\n            font-weight: 500;\n            font-display: swap;\n          }\n        "], ["\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: 500;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: 500;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('woff2');\n            font-weight: bold;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('truetype');\n            font-weight: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ")\n              format('truetype');\n            font-weight: 500;\n            font-display: swap;\n          }\n        "])), EUCLID_CIRCULAR_FAMILY, FONT_SRCS[EUCLID_CIRCULAR_FAMILY].regular, EUCLID_CIRCULAR_FAMILY, FONT_SRCS[EUCLID_CIRCULAR_FAMILY].medium, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].regular, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].medium, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].bold, SOURCE_CODE_PRO_FAMILY, FONT_SRCS[SOURCE_CODE_PRO_FAMILY].regular, SOURCE_CODE_PRO_FAMILY, FONT_SRCS[SOURCE_CODE_PRO_FAMILY].medium) }, void 0));
};
var templateObject_1$4, templateObject_2$3;

var getSpacingStyles = function (spacing) {
    switch (spacing) {
        case 'none':
            return {
                marginTop: 'inc00',
                marginBottom: 'inc00'
            };
        case 'small':
            return {
                marginTop: 'section10',
                marginBottom: 'section10'
            };
        case 'medium':
            return {
                marginTop: 'section20',
                marginBottom: 'section20'
            };
        case 'large':
            return {
                marginTop: 'section30',
                marginBottom: 'section30'
            };
        case 'xlarge':
            return {
                marginTop: 'section40',
                marginBottom: 'section40'
            };
        case 'xxlarge':
            return {
                marginTop: 'section50',
                marginBottom: 'section50'
            };
        default:
            return {
                marginTop: 'section00',
                marginBottom: 'section00'
            };
    }
};
var getBorderWidthStyles = function (strokeWeight) {
    switch (strokeWeight) {
        case 'medium':
            return {
                borderTopWidth: 'inc20',
                borderBottomWidth: 'inc00',
                borderLeftWidth: 'inc00',
                borderRightWidth: 'inc00'
            };
        case 'large':
            return {
                borderTopWidth: 'inc30',
                borderBottomWidth: 'inc00',
                borderLeftWidth: 'inc00',
                borderRightWidth: 'inc00'
            };
        default:
            return {
                borderTopWidth: 'inc10',
                borderBottomWidth: 'inc00',
                borderLeftWidth: 'inc00',
                borderRightWidth: 'inc00'
            };
    }
};

var HorizontalRule = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b; _a.theme; var _d = _a.inverse, inverse = _d === void 0 ? false : _d, _e = _a.spacing, spacing = _e === void 0 ? 'xsmall' : _e, _f = _a.strokeWeight, strokeWeight = _f === void 0 ? 'small' : _f, customStyles = _a.customStyles;
    return (jsx("hr", { className: className, sx: __assign(__assign(__assign(__assign({ width: '100%' }, getSpacingStyles(spacing)), getBorderWidthStyles(strokeWeight)), { borderColor: inverse ? 'border.inverse' : 'border.default', borderStyle: 'solid' }), customStyles) }, void 0));
};

var getArrowHeightVariants = function (props, theme) {
    var variant = props.variant, navTitle = props.navTitle;
    switch (variant) {
        case ELinkVariant.LARGE: {
            return {
                minHeight: theme.lineHeights.inc60
            };
        }
        case ELinkVariant.MEDIUM: {
            return {
                minHeight: navTitle ? theme.lineHeights.inc30 : theme.lineHeights.inc50
            };
        }
        case ELinkVariant.SMALL: {
            return {
                minHeight: theme.lineHeights.inc30
            };
        }
    }
};
var Arrow$2 = function (_a) {
    var isNav = _a.isNav, className = _a.className, inverse = _a.inverse, theme = _a.theme, props = __rest(_a, ["isNav", "className", "inverse", "theme"]);
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx("span", __assign({ sx: __assign(__assign({ minWidth: '24px' }, getArrowHeightVariants(props, selectedTheme)), { overflow: 'hidden', position: 'relative', display: 'inline-block', marginLeft: 'inc30', color: inverse ? 'link.cta.inverse.icon' : 'link.cta.default.icon' }) }, { children: jsx("span", __assign({ "aria-hidden": 'true', className: className, sx: __assign(__assign({ display: 'inline-block', position: 'absolute', fontFamily: theme === 'legacy' ? 'Arial, sans-serif' : selectedTheme.fonts.body, left: props.navItem ? '-100px' : '0' }, getVariantStyles$4(__assign({}, props))), { color: isNav && 'green50' }) }, { children: "\u2192" }), void 0) }), void 0));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var AcademicCap = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M9.48164 29.2421V16.7849L16.0002 13.0942M16.0002 19.2763L30.6668 10.9715L16.0002 2.66675L1.3335 10.9715L16.0002 19.2763ZM16.0002 19.2763L26.0387 13.5925C27.3595 17.0109 27.7344 20.7333 27.1224 24.3539C22.9889 24.7628 19.0919 26.5075 16.0002 29.3334C12.9088 26.5078 9.01245 24.7631 4.87957 24.3539C4.26716 20.7333 4.64202 17.0108 5.96327 13.5925L16.0002 19.2763Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var AppWindow = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M2 14.6667H30', strokeWidth: '2' }),
        React.createElement("path", { d: 'M5.3335 2.33325H26.6668C28.3237 2.33325 29.6668 3.6764 29.6668 5.33325V26.6666C29.6668 28.3234 28.3237 29.6666 26.6668 29.6666H5.3335C3.67664 29.6666 2.3335 28.3234 2.3335 26.6666V5.33326C2.3335 3.6764 3.67664 2.33325 5.3335 2.33325Z', strokeWidth: '2' }),
        React.createElement("circle", { cx: '8.6665', cy: '8.66675', r: '2', strokeWidth: '2' }),
        React.createElement("circle", { cx: '16.6665', cy: '8.66675', r: '2', strokeWidth: '2' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ArrowDown$1 = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M15.9955 26.6667L25.3332 17.3429M15.9955 26.6667L6.6665 17.3637M15.9955 26.6667L15.9955 5.33337', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ArrowLeft$1 = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M14.6254 6.66663L5.3335 16M5.3335 16L14.6668 25.3333M5.3335 16H26.6668', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ArrowRight$1 = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M17.3749 6.66663L26.6668 16M26.6668 16L17.3749 25.3333M26.6668 16H5.3335', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ArrowUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.0037 5.33337L6.6665 14.6667M16.0037 5.33337L25.3332 14.6667M16.0037 5.33337V26.6667', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Calendar = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_21434_55958)' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M23.1802 1C23.7325 1 24.1802 1.44772 24.1802 2V3.10352H27.4464C29.1032 3.10352 30.4464 4.44666 30.4464 6.10352V10.3447H30.4807V12.3447H30.4464V29.0001C30.4464 30.6569 29.1032 32.0001 27.4464 32.0001H4.54981C2.89295 32.0001 1.5498 30.6569 1.5498 29.0001V12.3447H1.51514V10.3447H1.5498V6.10352C1.5498 4.44666 2.89295 3.10352 4.5498 3.10352H7.81543V2C7.81543 1.44772 8.26314 1 8.81543 1C9.36771 1 9.81543 1.44772 9.81543 2V3.10352H22.1802V2C22.1802 1.44772 22.6279 1 23.1802 1ZM7.81543 5.10352V6.2069C7.81543 6.75918 8.26314 7.2069 8.81543 7.2069C9.36771 7.2069 9.81543 6.75918 9.81543 6.2069V5.10352H22.1802V6.2069C22.1802 6.75918 22.6279 7.2069 23.1802 7.2069C23.7325 7.2069 24.1802 6.75918 24.1802 6.2069V5.10352H27.4464C27.9986 5.10352 28.4464 5.55123 28.4464 6.10352V10.3447H3.5498V6.10352C3.5498 5.55123 3.99752 5.10352 4.5498 5.10352H7.81543ZM3.5498 12.3447V29.0001C3.5498 29.5524 3.99752 30.0001 4.54981 30.0001H27.4464C27.9986 30.0001 28.4464 29.5524 28.4464 29.0001V12.3447H3.5498Z' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_21434_55958' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Caption = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4.0165 5.33325C2.53472 5.33325 1.3335 6.53386 1.3335 8.01489M4.0165 5.33325H27.9838M4.0165 5.33325C2.55678 5.33325 1.3335 6.55591 1.3335 8.01489M1.3335 8.01489V23.9849M27.9838 5.33325C29.4656 5.33325 30.6668 6.53386 30.6668 8.01489M27.9838 5.33325C29.4435 5.33325 30.6668 6.55591 30.6668 8.01489M30.6668 8.01489V23.9849M30.6668 23.9849C30.6668 25.466 29.4656 26.6666 27.9838 26.6666M30.6668 23.9849C30.6668 25.4439 29.4435 26.6666 27.9838 26.6666M27.9838 26.6666H4.0165M4.0165 26.6666C2.53472 26.6666 1.3335 25.466 1.3335 23.9849M4.0165 26.6666C2.55678 26.6666 1.3335 25.4439 1.3335 23.9849M18.6832 15.9999C18.6832 13.7621 20.2019 12.0274 21.992 12.0274M18.6832 15.9999C18.6832 18.2378 20.2019 19.9725 21.992 19.9725M18.6832 15.9999C18.6832 18.2312 20.1549 19.9725 21.992 19.9725M18.6832 15.9999C18.6832 13.7686 20.1549 12.0274 21.992 12.0274M21.992 12.0274C22.7464 12.0274 23.4426 12.2864 24.0026 12.791C23.4483 12.2915 22.7344 12.0274 21.992 12.0274ZM21.992 19.9725C22.7344 19.9725 23.4215 19.6788 23.9759 19.1794C23.4158 19.6839 22.7463 19.9725 21.992 19.9725ZM8.03103 15.9999C8.03103 13.7621 9.54981 12.0274 11.3399 12.0274M8.03103 15.9999C8.03103 18.2378 9.54981 19.9725 11.3399 19.9725M8.03103 15.9999C8.03103 18.2312 9.50273 19.9725 11.3399 19.9725M8.03103 15.9999C8.03103 13.7686 9.50273 12.0274 11.3399 12.0274M11.3399 12.0274C12.0942 12.0274 12.7905 12.2864 13.3505 12.791C12.7962 12.2915 12.0823 12.0274 11.3399 12.0274ZM11.3399 19.9725C12.0822 19.9725 12.7694 19.6788 13.3238 19.1794C12.7637 19.6839 12.0942 19.9725 11.3399 19.9725Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Cast = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M1.3335 8.0109H0.333496C0.333496 8.01824 0.333577 8.02557 0.333738 8.03291L1.3335 8.0109ZM18.6642 25.6666C18.1119 25.6666 17.6642 26.1143 17.6642 26.6666C17.6642 27.2189 18.1119 27.6666 18.6642 27.6666V25.6666ZM0.363042 9.36441C0.375194 9.91656 0.832652 10.3543 1.3848 10.3422C1.93695 10.33 2.37471 9.87255 2.36256 9.3204L0.363042 9.36441ZM1.33381 13.6641C0.781529 13.6641 0.333814 14.1118 0.333814 14.6641C0.333814 15.2164 0.781529 15.6641 1.33381 15.6641V13.6641ZM12.3508 26.6519C12.3508 27.2042 12.7985 27.6519 13.3508 27.6519C13.9031 27.6519 14.3508 27.2042 14.3508 26.6519H12.3508ZM1.33381 18.9901C0.781529 18.9901 0.333814 19.4378 0.333814 19.9901C0.333814 20.5424 0.781529 20.9901 1.33381 20.9901V18.9901ZM7.02281 26.6519C7.02281 27.2042 7.47052 27.6519 8.02281 27.6519C8.57509 27.6519 9.02281 27.2042 9.02281 26.6519H7.02281ZM4.01215 4.33325C1.98084 4.33325 0.333496 5.97944 0.333496 8.0109H2.3335C2.3335 7.08472 3.0847 6.33325 4.01215 6.33325V4.33325ZM27.9882 4.33325H4.01215V6.33325H27.9882V4.33325ZM31.6668 8.0109C31.6668 5.97944 30.0195 4.33325 27.9882 4.33325V6.33325C28.9156 6.33325 29.6668 7.08472 29.6668 8.0109H31.6668ZM31.6668 23.9889V8.0109H29.6668V23.9889H31.6668ZM27.9882 27.6666C30.0195 27.6666 31.6668 26.0204 31.6668 23.9889H29.6668C29.6668 24.9151 28.9156 25.6666 27.9882 25.6666V27.6666ZM18.6642 27.6666H27.9882V25.6666H18.6642V27.6666ZM29.6668 23.9889C29.6668 24.8989 28.8994 25.6666 27.9882 25.6666V27.6666C30.0033 27.6666 31.6668 26.0042 31.6668 23.9889H29.6668ZM27.9882 6.33325C28.8994 6.33325 29.6668 7.10089 29.6668 8.0109H31.6668C31.6668 5.99561 30.0033 4.33325 27.9882 4.33325V6.33325ZM2.3335 8.0109C2.3335 7.10089 3.10089 6.33325 4.01215 6.33325V4.33325C1.99702 4.33325 0.333496 5.99562 0.333496 8.0109H2.3335ZM2.36256 9.3204L2.33325 7.9889L0.333738 8.03291L0.363042 9.36441L2.36256 9.3204ZM14.3508 26.6519C14.3508 19.4702 8.51196 13.6641 1.33381 13.6641V15.6641C7.41345 15.6641 12.3508 20.5808 12.3508 26.6519H14.3508ZM1.33381 15.6641C7.39726 15.6641 12.3508 20.597 12.3508 26.6519H14.3508C14.3508 19.4864 8.49578 13.6641 1.33381 13.6641V15.6641ZM9.02281 26.6519C9.02281 22.4096 5.56725 18.9901 1.33381 18.9901V20.9901C4.47301 20.9901 7.02281 23.5244 7.02281 26.6519H9.02281ZM1.33381 20.9901C4.45681 20.9901 7.02281 23.5406 7.02281 26.6519H9.02281C9.02281 22.4258 5.55107 18.9901 1.33381 18.9901V20.9901ZM2.01415 27.6666C2.94199 27.6666 3.6948 26.9146 3.6948 25.9862H1.6948C1.6948 25.8093 1.83813 25.6666 2.01415 25.6666V27.6666ZM0.333496 25.9862C0.333496 26.9146 1.0863 27.6666 2.01415 27.6666V25.6666C2.19017 25.6666 2.3335 25.8093 2.3335 25.9862H0.333496ZM2.01415 24.3058C1.0863 24.3058 0.333496 25.0578 0.333496 25.9862H2.3335C2.3335 26.163 2.19017 26.3058 2.01415 26.3058V24.3058ZM3.6948 25.9862C3.6948 25.0578 2.94199 24.3058 2.01415 24.3058V26.3058C1.83813 26.3058 1.6948 26.1631 1.6948 25.9862H3.6948Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Check = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4 16L12 24L28.0001 8', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Checkbox$1 = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M23.9737 10.6606L13.3372 21.2972L7.9977 16.0142M5.34915 2.66675C3.86756 2.66675 2.6665 3.86781 2.6665 5.34939M5.34915 2.66675H26.6505M5.34915 2.66675C3.88962 2.66675 2.6665 3.88987 2.6665 5.34939M2.6665 5.34939V26.6508M26.6505 2.66675C28.1321 2.66675 29.3332 3.86781 29.3332 5.34939M26.6505 2.66675C28.1101 2.66675 29.3332 3.88987 29.3332 5.34939M29.3332 5.34939V26.6508M29.3332 26.6508C29.3332 28.1324 28.1321 29.3334 26.6505 29.3334M29.3332 26.6508C29.3332 28.1103 28.1101 29.3334 26.6505 29.3334M26.6505 29.3334H5.34915M5.34915 29.3334C3.86756 29.3334 2.6665 28.1324 2.6665 26.6508M5.34915 29.3334C3.88962 29.3334 2.6665 28.1103 2.6665 26.6508', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronCircleDown = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55719)' },
            React.createElement("path", { d: 'M16.0002 19.9662L21.3121 14.6543M16.0002 19.9662C16.0055 19.9662 15.9964 19.97 16.0002 19.9662ZM16.0002 19.9662C16.0039 19.97 15.9949 19.9662 16.0002 19.9662ZM16.0002 19.9662L10.66 14.6825M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0783 30.6666 30.6668 24.078 30.6668 15.9999M16.0002 30.6666C7.92205 30.6666 1.3335 24.078 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.9218 24.0783 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.9218 7.92205 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55719' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronCircleLeft = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55742)' },
            React.createElement("path", { d: 'M12.0339 15.9999L17.3458 21.3119M12.0339 15.9999C12.0339 16.0052 12.0301 15.9962 12.0339 15.9999ZM12.0339 15.9999C12.0301 16.0037 12.0339 15.9946 12.0339 15.9999ZM12.0339 15.9999L17.3176 10.6597M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0783 30.6666 30.6668 24.078 30.6668 15.9999M16.0002 30.6666C7.92205 30.6666 1.3335 24.078 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.9218 24.0783 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.9218 7.92205 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55742' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronCircleRight = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55731)' },
            React.createElement("path", { d: 'M14.6578 10.6823L19.9754 15.9999L14.6785 21.3383M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0842 30.6666 30.6668 24.0839 30.6668 15.9999M16.0002 30.6666C7.91617 30.6666 1.3335 24.0839 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.91593 24.0842 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.91593 7.91617 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55731' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronCircleUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55728)' },
            React.createElement("path", { d: 'M10.6825 17.3423L16.0002 12.0246L21.3385 17.3216M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0842 30.6666 30.6668 24.0839 30.6668 15.9999M16.0002 30.6666C7.91617 30.6666 1.3335 24.0839 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.91593 24.0842 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.91593 7.91617 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55728' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronDown = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M26.6668 10.6666L16.0049 21.3333L5.3335 10.6761', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronLeft = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M21.3332 5.33337L10.6665 16L21.3332 26.6667', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronRight = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M10.6665 5.33337L21.3332 16L10.6665 26.6667', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ChevronUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M5.3335 21.3333L15.9898 10.6666L26.6668 21.3333', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CircleAlert = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55963)' },
            React.createElement("path", { d: 'M16.0002 9.4814V15.9999M16.0002 22.5184H16.0165M30.6668 15.9999C30.6668 17.926 30.2875 19.8332 29.5504 21.6126C28.8133 23.392 27.733 25.0089 26.3711 26.3708C25.0091 27.7327 23.3923 28.8131 21.6129 29.5502C19.8334 30.2872 17.9262 30.6666 16.0002 30.6666C14.0741 30.6666 12.1669 30.2872 10.3875 29.5502C8.60803 28.8131 6.99119 27.7327 5.62926 26.3708C4.26734 25.0089 3.187 23.392 2.44993 21.6126C1.71286 19.8332 1.3335 17.926 1.3335 15.9999C1.3335 12.1101 2.87873 8.37955 5.62926 5.62902C8.3798 2.87849 12.1103 1.33325 16.0002 1.33325C19.89 1.33325 23.6205 2.87849 26.3711 5.62902C29.1216 8.37955 30.6668 12.1101 30.6668 15.9999Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55963' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CircleCheck = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55482)' },
            React.createElement("path", { d: 'M22.6436 11.9912L13.3371 21.2977L7.99693 16.014M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0783 30.6666 30.6668 24.078 30.6668 15.9999M16.0002 30.6666C7.92205 30.6666 1.3335 24.078 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.9218 24.0783 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.9218 7.92205 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55482' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CircleClose = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55977)' },
            React.createElement("path", { d: 'M29.5504 21.6126C30.2875 19.8332 30.6668 17.926 30.6668 15.9999C30.6668 12.1101 29.1216 8.37955 26.3711 5.62902C23.6205 2.87849 19.89 1.33325 16.0002 1.33325C12.1103 1.33325 8.3798 2.87849 5.62926 5.62902C2.87873 8.37955 1.3335 12.1101 1.3335 15.9999C1.3335 17.926 1.71286 19.8332 2.44993 21.6126C3.187 23.392 4.26734 25.0089 5.62926 26.3708C6.99119 27.7327 8.60803 28.8131 10.3875 29.5502C12.1669 30.2872 14.0741 30.6666 16.0002 30.6666C17.9262 30.6666 19.8334 30.2872 21.6129 29.5502C23.3923 28.8131 25.0091 27.7327 26.3711 26.3708C27.733 25.0089 28.8133 23.392 29.5504 21.6126Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M21.3332 10.6667L15.9999 15.9893M15.9999 15.9893L10.6665 10.6667M15.9999 15.9893L10.6665 21.3334M15.9999 15.9893L21.3332 21.3334', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55977' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CircleInfo = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55972)' },
            React.createElement("path", { d: 'M29.5504 21.6126C30.2875 19.8332 30.6668 17.926 30.6668 15.9999C30.6668 12.1101 29.1216 8.37955 26.3711 5.62902C23.6205 2.87849 19.89 1.33325 16.0002 1.33325C12.1103 1.33325 8.3798 2.87849 5.62926 5.62902C2.87873 8.37955 1.3335 12.1101 1.3335 15.9999C1.3335 17.926 1.71286 19.8332 2.44993 21.6126C3.187 23.392 4.26734 25.0089 5.62926 26.3708C6.99119 27.7327 8.60803 28.8131 10.3875 29.5502C12.1669 30.2872 14.0741 30.6666 16.0002 30.6666C17.9262 30.6666 19.8334 30.2872 21.6129 29.5502C23.3923 28.8131 25.0091 27.7327 26.3711 26.3708C27.733 25.0089 28.8133 23.392 29.5504 21.6126Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M16.0161 22.5186L16.0161 16M15.9998 10.6667L15.9998 10.6533', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55972' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CircleQuestion = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_21257_54092)' },
            React.createElement("path", { d: 'M12.5196 8.64651C14.4412 6.96446 17.5592 6.96446 19.4808 8.64651C21.4041 10.3286 21.4041 13.0559 19.4808 14.738C19.1477 15.0317 18.7752 15.273 18.3813 15.4633C17.1588 16.0557 16.0018 17.1027 16.0018 18.4615V19.6923M30.7694 15.9999C30.7694 17.9395 30.3874 19.86 29.6452 21.6519C28.903 23.4438 27.8151 25.0719 26.4436 26.4434C25.0722 27.8148 23.444 28.9027 21.6521 29.6449C19.8602 30.3872 17.9397 30.7692 16.0002 30.7692C14.0607 30.7692 12.1401 30.3872 10.3482 29.6449C8.55636 28.9027 6.92821 27.8148 5.55676 26.4434C4.18531 25.0719 3.09742 23.4438 2.3552 21.6519C1.61297 19.86 1.23096 17.9395 1.23096 15.9999C1.23096 12.0829 2.787 8.32629 5.55676 5.55652C8.32653 2.78675 12.0831 1.23071 16.0002 1.23071C19.9172 1.23071 23.6738 2.78675 26.4436 5.55652C29.2134 8.32629 30.7694 12.0829 30.7694 15.9999ZM16.0002 24.6153H16.0133V24.6285H16.0002V24.6153Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_21257_54092' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Circle = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.0002 22.6666C19.6821 22.6666 22.6668 19.6818 22.6668 15.9999M16.0002 22.6666C12.3183 22.6666 9.3335 19.6818 9.3335 15.9999M16.0002 22.6666C19.6747 22.6666 22.6668 19.6745 22.6668 15.9999M16.0002 22.6666C12.3256 22.6666 9.3335 19.6745 9.3335 15.9999M22.6668 15.9999C22.6668 12.318 19.6821 9.33325 16.0002 9.33325M22.6668 15.9999C22.6668 12.3254 19.6747 9.33325 16.0002 9.33325M9.3335 15.9999C9.3335 12.318 12.3183 9.33325 16.0002 9.33325M9.3335 15.9999C9.3335 12.3254 12.3256 9.33325 16.0002 9.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Close = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M25.3332 6.66663L15.9999 15.9811M15.9999 15.9811L6.6665 6.66663M15.9999 15.9811L6.6665 25.3335M15.9999 15.9811L25.3332 25.3335', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CloudDownload = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M7.9028 11.9321L6.95111 12.0977C4.45785 12.5316 2.6665 14.4221 2.6665 16.7008M7.9028 11.9321L8.02839 10.9733C8.54375 7.03843 11.9084 4 15.9798 4M7.9028 11.9321C7.9028 7.51999 11.5726 4 15.9798 4M7.9028 11.9321C4.9469 11.9321 2.6665 14.1507 2.6665 16.7008M15.9798 4C20.0513 4 23.4159 7.03843 23.9313 10.9733L24.0569 11.9321M15.9798 4C20.3871 4 24.0569 7.51999 24.0569 11.9321M24.0569 11.9321L25.0086 12.0977C27.5018 12.5316 29.3332 14.4221 29.3332 16.7008M24.0569 11.9321C27.0128 11.9321 29.3332 14.1507 29.3332 16.7008M29.3332 16.7008C29.3332 19.2849 26.9447 21.3926 23.9798 21.3926C26.9357 21.3926 29.3332 19.2508 29.3332 16.7008ZM2.6665 16.7008C2.6665 19.2508 5.02393 21.3526 7.97984 21.3526C5.01493 21.3526 2.6665 19.2849 2.6665 16.7008ZM15.9998 27.9983L19.9657 24.0281M15.9998 27.9983C16.0051 27.9983 15.9961 28.0021 15.9998 27.9983ZM15.9998 27.9983C16.0036 28.0021 15.9945 27.9983 15.9998 27.9983ZM15.9998 27.9983L11.9657 24.0564M15.9998 27.9983L15.9598 13.3637', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CloudUpload = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M7.9028 11.9167L6.95111 12.082C4.45785 12.515 2.6665 14.4019 2.6665 16.6761M7.9028 11.9167L8.02839 10.9598C8.54375 7.03253 11.9084 4 15.9798 4M7.9028 11.9167C7.9028 7.51316 11.5726 4 15.9798 4M7.9028 11.9167C4.9469 11.9167 2.6665 14.131 2.6665 16.6761M15.9798 4C20.0513 4 23.4159 7.03253 23.9313 10.9598L24.0569 11.9167M15.9798 4C20.3871 4 24.0569 7.51316 24.0569 11.9167M24.0569 11.9167L25.0086 12.082C27.5018 12.515 29.3332 14.4019 29.3332 16.6761M24.0569 11.9167C27.0128 11.9167 29.3332 14.131 29.3332 16.6761M29.3332 16.6761C29.3332 19.2552 26.9447 21.3589 23.9798 21.3589C26.9357 21.3589 29.3332 19.2212 29.3332 16.6761ZM2.6665 16.6761C2.6665 19.2212 5.02393 21.3189 7.97984 21.3189C5.01493 21.3189 2.6665 19.2552 2.6665 16.6761ZM15.9998 13.3938L11.994 17.3563M15.9998 13.3938C15.9945 13.3938 16.0036 13.39 15.9998 13.3938ZM15.9998 13.3938C15.9961 13.39 16.0051 13.3938 15.9998 13.3938ZM15.9998 13.3938L19.994 17.3281M15.9998 13.3938V28', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Cloud = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M8.05213 16.0513H6.99504C4.50183 16.4839 2.6665 18.3703 2.6665 20.648M8.05213 16.0513V14.9509C8.56726 11.0287 11.9303 8 15.9998 8M8.05213 16.0513C8.05213 11.676 11.6174 8 15.9998 8M8.05213 16.0513C8.05674 16.0467 8.05213 16.0552 8.05213 16.0513ZM8.05213 16.0513C8.05605 16.0513 8.04753 16.0559 8.05213 16.0513ZM8.05213 16.0513C5.11422 16.0513 2.6665 18.1262 2.6665 20.648M15.9998 8C20.0694 8 23.4324 11.0287 23.9475 14.9509V16.0513M15.9998 8C20.3823 8 23.9475 11.676 23.9475 16.0513M23.9475 16.0513H25.0046C27.4978 16.4839 29.3332 18.3703 29.3332 20.648M23.9475 16.0513C26.8855 16.0513 29.3332 18.1262 29.3332 20.648M23.9475 16.0513C23.9521 16.0559 23.9436 16.0513 23.9475 16.0513ZM23.9475 16.0513C23.9475 16.0552 23.9429 16.0467 23.9475 16.0513ZM29.3332 20.648C29.3332 23.2312 26.9399 25.3333 23.9755 25.3333M29.3332 20.648C29.3332 23.1697 26.9134 25.3333 23.9755 25.3333M23.9755 25.3333H8.02416M8.02416 25.3333C5.05973 25.3333 2.6665 23.2312 2.6665 20.648M8.02416 25.3333C5.08625 25.3333 2.6665 23.1697 2.6665 20.648', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var CodeBracket = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M9.36235 9.3339L2.6665 15.9961L9.33641 22.6842M22.6762 9.35981L29.3332 16.009L22.7022 22.6842M16.0247 2.66675L16.0376 29.3334', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Copy = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M12.5414 8C11.5059 8 10.6665 9.01928 10.6665 10.2766M12.5414 8H27.4583M12.5414 8C11.5172 8 10.6665 9.03304 10.6665 10.2766M10.6665 10.2766V28.39M27.4583 8C28.4938 8 29.3332 9.01928 29.3332 10.2766M27.4583 8C28.4824 8 29.3332 9.03304 29.3332 10.2766M29.3332 10.2766V28.39M29.3332 28.39C29.3332 29.6474 28.4938 30.6667 27.4583 30.6667M29.3332 28.39C29.3332 29.6336 28.4824 30.6667 27.4583 30.6667M27.4583 30.6667H12.5414M12.5414 30.6667C11.5059 30.6667 10.6665 29.6474 10.6665 28.39M12.5414 30.6667C11.5172 30.6667 10.6665 29.6336 10.6665 28.39', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M5.87487 1.33337C4.83941 1.33337 4 2.35266 4 3.61M5.87487 1.33337H20.7918C21.54 1.33337 22.1956 1.88471 22.4946 2.66671M5.87487 1.33337C4.85074 1.33337 4 2.36641 4 3.61M4 3.61V21.7234M4 21.7234C4 22.9808 4.83941 24 5.87487 24C4.85074 24 4 22.967 4 21.7234Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronCircleDown = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55695)' },
            React.createElement("path", { d: 'M21.3192 17.3226L16.0002 22.6417L10.6623 17.3415M21.3192 10.662L16.0002 15.9811L10.6623 10.6808M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 24.1001 24.1003 30.6666 16.0002 30.6666M30.6668 15.9999C30.6668 7.91446 24.0856 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 24.0854 24.0856 30.6666 16.0002 30.6666M16.0002 1.33325C7.89999 1.33325 1.3335 7.89974 1.3335 15.9999M16.0002 1.33325C7.9147 1.33325 1.3335 7.91446 1.3335 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C7.9147 30.6666 1.3335 24.0854 1.3335 15.9999', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55695' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronCircleLeft = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55716)' },
            React.createElement("path", { d: 'M9.37082 15.9999L14.6828 21.3119M9.37082 15.9999C9.37082 16.0052 9.36707 15.9962 9.37082 15.9999ZM9.37082 15.9999C9.36707 16.0037 9.37082 15.9946 9.37082 15.9999ZM9.37082 15.9999L14.6545 10.6597M16.0284 15.9999L21.3404 21.3119M16.0284 15.9999C16.0284 16.0052 16.0247 15.9962 16.0284 15.9999ZM16.0284 15.9999C16.0247 16.0037 16.0284 15.9946 16.0284 15.9999ZM16.0284 15.9999L21.3121 10.6597M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C7.89999 30.6666 1.3335 24.1001 1.3335 15.9999M16.0002 30.6666C24.0783 30.6666 30.6668 24.078 30.6668 15.9999M16.0002 30.6666C7.92205 30.6666 1.3335 24.078 1.3335 15.9999M30.6668 15.9999C30.6668 7.89974 24.1003 1.33325 16.0002 1.33325M30.6668 15.9999C30.6668 7.9218 24.0783 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 7.9218 7.92205 1.33325 16.0002 1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55716' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronCircleRight = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55707)' },
            React.createElement("path", { d: 'M17.3282 10.6737L22.6544 15.9999L17.3376 21.3355M10.6645 10.6737L15.9907 15.9999L10.674 21.3355M16.0002 1.33325C7.89999 1.33325 1.3335 7.89974 1.3335 15.9999M16.0002 1.33325C24.1003 1.33325 30.6668 7.89975 30.6668 15.9999M16.0002 1.33325C7.90735 1.33325 1.3335 7.9071 1.3335 15.9999M16.0002 1.33325C24.093 1.33325 30.6668 7.9071 30.6668 15.9999M1.3335 15.9999C1.3335 24.1001 7.89998 30.6666 16.0002 30.6666M1.3335 15.9999C1.3335 24.0927 7.90734 30.6666 16.0002 30.6666M30.6668 15.9999C30.6668 24.1001 24.1003 30.6666 16.0002 30.6666M30.6668 15.9999C30.6668 24.0927 24.093 30.6666 16.0002 30.6666', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55707' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronCircleUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55704)' },
            React.createElement("path", { d: 'M16.0002 9.37058L10.6882 14.6825M16.0002 9.37058C15.9949 9.37058 16.0039 9.36683 16.0002 9.37058ZM16.0002 9.37058C15.9964 9.36683 16.0055 9.37058 16.0002 9.37058ZM16.0002 9.37058L21.3404 14.6543M16.0002 16.0282L10.6882 21.3401M16.0002 16.0282C15.9949 16.0282 16.0039 16.0244 16.0002 16.0282ZM16.0002 16.0282C15.9964 16.0244 16.0055 16.0282 16.0002 16.0282ZM16.0002 16.0282L21.3404 21.3119M1.3335 15.9999C1.3335 24.1001 7.89999 30.6666 16.0002 30.6666M1.3335 15.9999C1.3335 7.89974 7.89999 1.33325 16.0002 1.33325M1.3335 15.9999C1.3335 24.078 7.92204 30.6666 16.0002 30.6666M1.3335 15.9999C1.3335 7.9218 7.92205 1.33325 16.0002 1.33325M16.0002 30.6666C24.1003 30.6666 30.6668 24.1001 30.6668 15.9999M16.0002 30.6666C24.0783 30.6666 30.6668 24.078 30.6668 15.9999M16.0002 1.33325C24.1003 1.33325 30.6668 7.89974 30.6668 15.9999M16.0002 1.33325C24.0783 1.33325 30.6668 7.9218 30.6668 15.9999', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55704' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronDown = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M7.37361 15.293C6.98309 14.9025 6.34992 14.9025 5.9594 15.293C5.56887 15.6835 5.56887 16.3167 5.9594 16.7072L7.37361 15.293ZM15.9998 25.3334L15.2927 26.0405C15.6833 26.431 16.3164 26.431 16.7069 26.0405L15.9998 25.3334ZM26.0403 16.7072C26.4308 16.3167 26.4308 15.6835 26.0403 15.293C25.6498 14.9025 25.0166 14.9025 24.6261 15.293L26.0403 16.7072ZM15.9998 16.0001L15.2927 16.7072C15.6833 17.0977 16.3164 17.0977 16.7069 16.7072L15.9998 16.0001ZM26.0403 7.37385C26.4308 6.98333 26.4308 6.35017 26.0403 5.95964C25.6498 5.56912 25.0166 5.56912 24.6261 5.95964L26.0403 7.37385ZM7.37361 5.95964C6.98309 5.56912 6.34992 5.56912 5.9594 5.95964C5.56887 6.35017 5.56887 6.98333 5.9594 7.37385L7.37361 5.95964ZM5.9594 16.7072L15.2927 26.0405L16.7069 24.6263L7.37361 15.293L5.9594 16.7072ZM16.7069 26.0405L26.0403 16.7072L24.6261 15.293L15.2927 24.6263L16.7069 26.0405ZM16.7069 16.7072L26.0403 7.37385L24.6261 5.95964L15.2927 15.293L16.7069 16.7072ZM5.9594 7.37385L15.2927 16.7072L16.7069 15.293L7.37361 5.95964L5.9594 7.37385Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronLeft = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M15.9912 6.66675L6.6665 15.9923L15.9912 25.3076M25.3332 6.66675L15.9912 15.9923L25.3332 25.3076', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronRight = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M15.9894 6.66675L25.3228 16.0001L15.9894 25.3334M6.6665 25.3334L15.9894 16.0001L6.6665 6.66675', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var DoubleChevronUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M24.6259 16.707C25.0163 17.0976 25.6495 17.0978 26.0401 16.7074C26.4307 16.3169 26.4309 15.6838 26.0404 15.2931L24.6259 16.707ZM16.0041 6.66675L16.7114 5.9598C16.5239 5.77222 16.2696 5.66681 16.0043 5.66675C15.7391 5.66669 15.4848 5.77199 15.2972 5.95948L16.0041 6.66675ZM5.95956 15.2928C5.56895 15.6832 5.5688 16.3164 5.95924 16.707C6.34967 17.0976 6.98283 17.0978 7.37345 16.7074L5.95956 15.2928ZM24.6259 26.0404C25.0163 26.431 25.6495 26.4311 26.0401 26.0407C26.4307 25.6502 26.4309 25.0171 26.0404 24.6265L24.6259 26.0404ZM16.0041 16.0001L16.7114 15.2931C16.5239 15.1056 16.2696 15.0001 16.0043 15.0001C15.7391 15 15.4848 15.1053 15.2972 15.2928L16.0041 16.0001ZM5.95956 24.6261C5.56895 25.0166 5.5688 25.6497 5.95924 26.0404C6.34967 26.431 6.98283 26.4311 7.37345 26.0407L5.95956 24.6261ZM15.2972 5.95948L5.95956 15.2928L7.37345 16.7074L16.7111 7.37402L15.2972 5.95948ZM15.2972 15.2928L5.95956 24.6261L7.37345 26.0407L16.7111 16.7074L15.2972 15.2928ZM26.0404 15.2931L16.7114 5.9598L15.2968 7.37369L24.6259 16.707L26.0404 15.2931ZM26.0404 24.6265L16.7114 15.2931L15.2968 16.707L24.6259 26.0404L26.0404 24.6265Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Download = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M15.9903 21.3083L22.666 14.663M15.9903 21.3083L9.32319 14.6837M15.9903 21.3083V2.66675M2.6665 21.3293L2.67682 26.68M2.67682 26.68C2.67682 28.1454 3.86501 29.3334 5.33072 29.3334M2.67682 26.68C2.67682 28.1616 3.8488 29.3334 5.33072 29.3334M5.33072 29.3334H26.6793M26.6793 29.3334C28.145 29.3334 29.3332 28.1454 29.3332 26.68M26.6793 29.3334C28.1612 29.3334 29.3332 28.1616 29.3332 26.68M29.3332 26.68V21.3437', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ExpandAll = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4.03993 4.06813V10.6755M4.03993 4.06813L10.6755 4M4.03993 4.06813L12.0208 11.9925M27.9319 4.03993H21.3245M27.9319 4.03993L28 10.6755M27.9319 4.03993L20.0075 12.0208M27.9318 27.9601L27.9601 21.3245M27.9318 27.9601L21.3245 28M27.9318 27.9601L19.9792 20.0075M4.06813 27.9601H10.6755M4.06813 27.9601L4 21.3245M4.06813 27.9601L11.9925 19.9792', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ExpandDiagonal = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M6.70642 25.3051L15.9998 25.3334M6.70642 25.3051L6.6665 16.0009M6.70642 25.3051L25.265 6.66846M25.265 6.66846L15.9998 6.66847M25.265 6.66846C25.2613 6.66471 25.2703 6.66846 25.265 6.66846ZM25.265 6.66846C25.265 6.66315 25.2688 6.67222 25.265 6.66846ZM25.265 6.66846L25.3332 16.0009', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ExpandHorizontal = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M29.3332 16.0227L22.6665 9.33325M29.3332 16.0227L22.6665 22.6666M29.3332 16.0227H2.6665M2.6665 16.0227L9.09102 22.6666M2.6665 16.0227L9.07279 9.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ExpandVertical = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M9.3335 9.33626L15.9955 2.66675M15.9955 2.66675L22.6668 9.33626M15.9955 2.66675L16.0068 29.3334M16.0068 29.3334L22.6574 22.6753M16.0068 29.3334L9.3335 22.6847', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var External = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M29.2649 2.70675L30.2648 2.69819C30.2602 2.14927 29.8138 1.70675 29.2649 1.70675V2.70675ZM21.3132 1.70675C20.7609 1.70675 20.3132 2.15446 20.3132 2.70675C20.3132 3.25903 20.7609 3.70675 21.3132 3.70675V1.70675ZM28.3332 10.6953C28.3379 11.2476 28.7895 11.6914 29.3417 11.6867C29.894 11.682 30.3379 11.2305 30.3331 10.6782L28.3332 10.6953ZM11.2857 19.3283C10.8958 19.7194 10.8969 20.3526 11.288 20.7425C11.6792 21.1324 12.3124 21.1313 12.7022 20.7402L11.2857 19.3283ZM5.31317 2.70675V3.70676L5.31746 3.70674L5.31317 2.70675ZM30.2932 17.3534C30.2932 16.8011 29.8455 16.3534 29.2932 16.3534C28.7409 16.3534 28.2932 16.8011 28.2932 17.3534H30.2932ZM14.6508 3.66674C15.2031 3.66437 15.6489 3.21474 15.6465 2.66246C15.6441 2.11018 15.1945 1.66439 14.6422 1.66676L14.6508 3.66674ZM29.2649 1.70675H21.3132V3.70675H29.2649V1.70675ZM30.3331 10.6782L30.2648 2.69819L28.2649 2.7153L28.3332 10.6953L30.3331 10.6782ZM3.6665 5.35342C3.6665 4.44399 4.40374 3.70675 5.31317 3.70675V1.70675C3.29917 1.70675 1.6665 3.33942 1.6665 5.35342H3.6665ZM3.6665 26.6867V5.35342H1.6665V26.6867H3.6665ZM5.31317 28.3334C4.40374 28.3334 3.6665 27.5962 3.6665 26.6867H1.6665C1.6665 28.7007 3.29917 30.3334 5.31317 30.3334V28.3334ZM26.6465 28.3334H5.31317V30.3334H26.6465V28.3334ZM28.2932 26.6867C28.2932 27.5962 27.5559 28.3334 26.6465 28.3334V30.3334C28.6605 30.3334 30.2932 28.7007 30.2932 26.6867H28.2932ZM28.2932 17.3534V26.6867H30.2932V17.3534H28.2932ZM26.6465 30.3334C28.6826 30.3334 30.2932 28.7228 30.2932 26.6867H28.2932C28.2932 27.6183 27.578 28.3334 26.6465 28.3334V30.3334ZM1.6665 26.6867C1.6665 28.7228 3.27708 30.3334 5.31317 30.3334V28.3334C4.38165 28.3334 3.6665 27.6183 3.6665 26.6867H1.6665ZM5.31317 1.70675C3.27708 1.70675 1.6665 3.31733 1.6665 5.35342H3.6665C3.6665 4.42189 4.38165 3.70675 5.31317 3.70675V1.70675ZM14.6422 1.66676L5.30889 1.70676L5.31746 3.70674L14.6508 3.66674L14.6422 1.66676ZM28.5566 2.0008L11.2857 19.3283L12.7022 20.7402L29.9731 3.4127L28.5566 2.0008Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var FilterHamburger = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4 8H28M7.33333 16.0073H24.6667M10.6667 24H21.3333', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Filter = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M20.5097 19.501L31 3L1 3.01152L11.4966 19.501L11.5075 30L20.5097 25.4957V19.501Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var FullScreen = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4.01457 12.0262L4 6.6822M4 6.6822C4 5.20086 5.20213 4 6.68504 4M4 6.6822C4 5.22292 5.22421 4 6.68504 4M6.68504 4H12.0151M20.0103 28L25.3404 28M25.3404 28C26.8012 28 27.9854 26.7771 27.9854 25.3178M25.3404 28C26.8233 28 27.9854 26.7991 27.9854 25.3178M27.9854 25.3178V19.9933M28 12.0262L27.9854 6.6822M27.9854 6.6822C27.9854 5.22292 26.8012 4.03993 25.3404 4.03993M27.9854 6.6822C27.9854 5.20086 26.8233 4.03993 25.3404 4.03993M25.3404 4.03993L20.0103 4.03993M12.0151 27.9601H6.68504M6.68504 27.9601C5.20213 27.9601 4 26.7991 4 25.3178M6.68504 27.9601C5.22421 27.9601 4 26.7771 4 25.3178M4 25.3178V19.9933', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Heart = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M22.6678 23.1274C21.0018 24.8044 19.3275 26.2106 18.078 27.2083C17.7028 27.5079 16.2886 28.447 15.9998 28.6667C15.7109 28.4469 14.2889 27.5189 13.9135 27.2191C12.6639 26.2214 10.9979 24.8044 9.33184 23.1274M22.6678 23.1274C24.3339 21.4505 26.0001 19.5133 27.2499 17.4751M22.6678 23.1274C24.3334 21.4509 26.0008 19.5121 27.2499 17.4751M27.2499 17.4751C28.4996 15.437 29.3332 13.2975 29.3332 11.2159M27.2499 17.4751C28.4989 15.4381 29.3332 13.2938 29.3332 11.2159M29.3332 11.2159C29.3332 7.05135 26.9063 4.53927 24.0271 4.08825M29.3332 11.2159C29.3332 7.05668 26.8985 4.53805 24.0271 4.08825M24.0271 4.08825C21.1558 3.63846 17.8173 4.85624 15.9998 8.93624C14.1824 4.85625 10.8439 3.63846 7.97254 4.08825M7.97254 4.08825C5.09336 4.53927 2.6665 7.05135 2.6665 11.2159M7.97254 4.08825C5.1012 4.53805 2.6665 7.05668 2.6665 11.2159M2.6665 11.2159C2.6665 13.2975 3.50007 15.437 4.74982 17.4751M2.6665 11.2159C2.6665 13.2938 3.50073 15.4381 4.74982 17.4751M4.74982 17.4751C5.99958 19.5133 7.66582 21.4505 9.33184 23.1274M4.74982 17.4751C5.99883 19.512 7.66624 21.4509 9.33184 23.1274', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Language = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M30.6668 12.7354C30.6668 18.2731 26.3625 22.8039 21.1016 22.8039H17.2755L12.1741 28.174V22.8039H10.8987C5.63784 22.8039 1.3335 18.2731 1.3335 12.7354C1.3335 7.19763 5.63784 2.66675 10.8987 2.66675H21.1016C26.3625 2.66675 30.6668 7.19763 30.6668 12.7354Z', strokeWidth: '2', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var LightBulb = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_18594_55895)' },
            React.createElement("path", { d: 'M16.0024 3.42888V1.33325', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M24.894 7.10829L26.3764 5.62598', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M28.5767 16.0027H30.6723', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M24.894 24.8928L26.3764 26.3751', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M7.11171 7.10829L5.62939 5.62598', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M3.42913 16.0027H1.3335', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M7.11171 24.8928L5.62939 26.3751', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M11.811 23.262V26.4753C11.811 27.5869 12.2526 28.6529 13.0386 29.4389C13.8246 30.225 14.8907 30.6665 16.0023 30.6665C17.1139 30.6665 18.18 30.225 18.966 29.4389C19.752 28.6529 20.1936 27.5869 20.1936 26.4753V23.262', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            React.createElement("path", { d: 'M16.0031 24.3852C20.6327 24.3852 24.3857 20.6322 24.3857 16.0026C24.3857 11.3731 20.6327 7.62012 16.0031 7.62012C11.3736 7.62012 7.62061 11.3731 7.62061 16.0026C7.62061 20.6322 11.3736 24.3852 16.0031 24.3852Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_18594_55895' },
                React.createElement("rect", { width: '32', height: '31.9999' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Link$1 = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M14.2159 8.55932C13.8254 8.94985 13.8254 9.58301 14.2159 9.97354C14.6064 10.3641 15.2396 10.3641 15.6301 9.97354L14.2159 8.55932ZM9.97327 15.6304C10.3638 15.2399 10.3638 14.6067 9.97327 14.2162C9.58275 13.8257 8.94958 13.8257 8.55906 14.2162L9.97327 15.6304ZM17.5157 23.1729C17.9063 22.7823 17.9063 22.1492 17.5157 21.7587C17.1252 21.3681 16.4921 21.3681 16.1015 21.7587L17.5157 23.1729ZM21.7584 16.1018C21.3679 16.4923 21.3679 17.1255 21.7584 17.516C22.1489 17.9065 22.7821 17.9065 23.1726 17.516L21.7584 16.1018ZM11.3875 18.9302C10.997 19.3207 10.997 19.9539 11.3875 20.3444C11.778 20.735 12.4112 20.735 12.8017 20.3444L11.3875 18.9302ZM20.3442 12.802C20.7347 12.4114 20.7347 11.7783 20.3442 11.3878C19.9536 10.9972 19.3205 10.9972 18.93 11.3878L20.3442 12.802ZM15.6301 9.97354L18.4586 7.14511L17.0443 5.7309L14.2159 8.55932L15.6301 9.97354ZM7.14485 18.4588L9.97327 15.6304L8.55906 14.2162L5.73063 17.0446L7.14485 18.4588ZM16.1015 21.7587L13.2731 24.5871L14.6873 26.0013L17.5157 23.1729L16.1015 21.7587ZM24.5868 13.2734L21.7584 16.1018L23.1726 17.516L26.001 14.6876L24.5868 13.2734ZM5.73063 26.0013C8.20395 28.4746 12.214 28.4746 14.6873 26.0013L13.2731 24.5871C11.5808 26.2794 8.83712 26.2794 7.14485 24.5871L5.73063 26.0013ZM24.5868 7.14511C26.2791 8.83738 26.2791 11.5811 24.5868 13.2734L26.001 14.6876C28.4743 12.2143 28.4743 8.20422 26.001 5.7309L24.5868 7.14511ZM26.001 5.7309C23.5277 3.25758 19.5177 3.25758 17.0443 5.7309L18.4586 7.14511C20.1508 5.45284 22.8945 5.45284 24.5868 7.14511L26.001 5.7309ZM7.14485 24.5871C5.45257 22.8948 5.45257 20.1511 7.14485 18.4588L5.73063 17.0446C3.25731 19.5179 3.25731 23.528 5.73063 26.0013L7.14485 24.5871ZM12.8017 20.3444L20.3442 12.802L18.93 11.3878L11.3875 18.9302L12.8017 20.3444Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var LoadingCircle = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M25.9107 9.58079C22.5426 4.19306 15.484 2.40313 9.93723 5.60476M9.93723 5.60476C4.26839 8.87688 2.32616 16.1238 5.59902 21.7911M9.93723 5.60476C4.2492 8.88795 2.31498 16.1044 5.59902 21.7911M9.93723 5.60476C15.2587 2.53313 21.9496 4.0059 25.4801 8.87016L28 12.6667M5.59902 21.7911C8.87826 27.4671 16.1009 29.401 21.7806 26.124C24.8445 24.3563 26.8193 21.4273 27.4695 18.2143M28 5.33333V12.6667M28 12.6667C26.9784 12.3628 22.0697 10.8857 21.3333 10.6667', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Location = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.21044 9.2533C8.75425 5.52025 12.1409 3 15.9982 3C19.8555 3 23.2422 5.52025 24.786 9.2533C25.8269 11.7703 24.8498 14.6836 23.1506 17.349L15.9982 28.5685L8.84579 17.349C7.14662 14.6836 6.16952 11.7703 7.21044 9.2533ZM15.9982 1C11.2202 1 7.17048 4.11656 5.36225 8.48897C3.92843 11.956 5.3775 15.6291 7.15934 18.4241L14.7334 30.3049C15.323 31.2298 16.6734 31.2298 17.263 30.3049L24.8371 18.4241C26.6189 15.6291 28.068 11.956 26.6342 8.48897C24.8259 4.11656 20.7762 1 15.9982 1ZM12.8145 11.4359C12.8145 9.67636 14.2408 8.25 16.0003 8.25C17.7598 8.25 19.1862 9.67636 19.1862 11.4359C19.1862 13.1954 17.7598 14.6217 16.0003 14.6217C14.2408 14.6217 12.8145 13.1954 12.8145 11.4359ZM16.0003 6.25C13.1362 6.25 10.8145 8.57179 10.8145 11.4359C10.8145 14.2999 13.1362 16.6217 16.0003 16.6217C18.8644 16.6217 21.1862 14.2999 21.1862 11.4359C21.1862 8.57179 18.8644 6.25 16.0003 6.25Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Megaphone = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M2.22995 17.7403L2.83991 16.1406L1.41577 12.4046C1.31352 12.1351 1.30637 11.8388 1.3955 11.5647C1.48464 11.2906 1.66471 11.0551 1.90591 10.8974L5.25252 8.71212L6.29681 4.85358C6.37225 4.57531 6.5406 4.33122 6.77389 4.16182C7.00719 3.99242 7.2914 3.9079 7.57935 3.9223L11.5713 4.12516L14.6838 1.61316C14.9084 1.43203 15.1883 1.33325 15.4768 1.33325C15.7654 1.33325 16.0453 1.43203 16.2699 1.61316L19.3824 4.12516L23.3743 3.92638C23.6623 3.91199 23.9465 3.9965 24.1798 4.1659C24.4131 4.3353 24.5814 4.5794 24.6569 4.85766L25.7012 8.7162L29.0478 10.9014C29.2892 11.059 29.4694 11.2945 29.5585 11.5686C29.6477 11.8428 29.6404 12.1392 29.5379 12.4086L28.1151 16.1446L29.5379 19.8793C29.6405 20.1489 29.6478 20.4456 29.5587 20.7199C29.4695 20.9943 29.2893 21.23 29.0478 21.3878L25.7012 23.5663L24.6514 27.4262C24.5765 27.7048 24.4083 27.9494 24.1749 28.1191C23.9415 28.2888 23.6571 28.3734 23.3689 28.3588L19.3769 28.16C19.3769 28.16 17.48 29.6877 16.2645 30.6666', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M1.3335 25.3733L3.33404 28.5251', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M12.3965 11.3333L20 23.3123', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M19.6006 22.6818L2.93421 27.8957L1.7334 26.0039L12.7968 11.9639L19.6006 22.6818Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M6.53516 26.7685L7.59341 28.3946C7.76839 28.6814 8.00016 28.9295 8.27449 29.1235C8.54881 29.3176 8.8599 29.4535 9.18866 29.523C9.51742 29.5924 9.85691 29.594 10.1863 29.5275C10.5157 29.461 10.828 29.3279 11.104 29.1363C11.6684 28.7302 12.0562 28.1236 12.188 27.4409C12.3199 26.7582 12.1858 26.0509 11.8132 25.4638L11.6162 25.1787', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var MenuHamburger = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M4 8.01456L28 8M4 16.0073L28 15.9927M4 24L28 23.9854', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var MenuHorizontal = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M6.73872 16.0001C6.73872 16.7365 6.12564 17.3334 5.36936 17.3334C4.61308 17.3334 4 16.7365 4 16.0001C4 15.2637 4.61308 14.6667 5.36936 14.6667C6.12564 14.6667 6.73872 15.2637 6.73872 16.0001Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M17.3694 16.0001C17.3694 16.7365 16.7563 17.3334 16 17.3334C15.2437 17.3334 14.6306 16.7365 14.6306 16.0001C14.6306 15.2637 15.2437 14.6667 16 14.6667C16.7563 14.6667 17.3694 15.2637 17.3694 16.0001Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28 16.0001C28 16.7365 27.3869 17.3334 26.6306 17.3334C25.8744 17.3334 25.2613 16.7365 25.2613 16.0001C25.2613 15.2637 25.8744 14.6667 26.6306 14.6667C27.3869 14.6667 28 15.2637 28 16.0001Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var MenuSquaredot = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M17.3694 5.36936C17.3694 6.12564 16.7563 6.73872 16 6.73872C15.2437 6.73872 14.6306 6.12564 14.6306 5.36936C14.6306 4.61308 15.2437 4 16 4C16.7563 4 17.3694 4.61308 17.3694 5.36936Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M17.3694 16C17.3694 16.7563 16.7563 17.3694 16 17.3694C15.2437 17.3694 14.6306 16.7563 14.6306 16C14.6306 15.2437 15.2437 14.6306 16 14.6306C16.7563 14.6306 17.3694 15.2437 17.3694 16Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M17.3694 26.6306C17.3694 27.3869 16.7563 28 16 28C15.2437 28 14.6306 27.3869 14.6306 26.6306C14.6306 25.8744 15.2437 25.2613 16 25.2613C16.7563 25.2613 17.3694 25.8744 17.3694 26.6306Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M6.73872 16C6.73872 16.7563 6.12564 17.3694 5.36936 17.3694C4.61308 17.3694 4 16.7563 4 16C4 15.2437 4.61308 14.6306 5.36936 14.6306C6.12564 14.6306 6.73872 15.2437 6.73872 16Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M6.73872 5.36936C6.73872 6.12564 6.12564 6.73872 5.36936 6.73872C4.61308 6.73872 4 6.12564 4 5.36936C4 4.61308 4.61308 4 5.36936 4C6.12564 4 6.73872 4.61308 6.73872 5.36936Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M6.73872 26.6306C6.73872 27.3869 6.12564 28 5.36936 28C4.61308 28 4 27.3869 4 26.6306C4 25.8744 4.61308 25.2613 5.36936 25.2613C6.12564 25.2613 6.73872 25.8744 6.73872 26.6306Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28 16C28 16.7563 27.3869 17.3694 26.6306 17.3694C25.8744 17.3694 25.2613 16.7563 25.2613 16C25.2613 15.2437 25.8744 14.6306 26.6306 14.6306C27.3869 14.6306 28 15.2437 28 16Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28 5.36936C28 6.12564 27.3869 6.73872 26.6306 6.73872C25.8744 6.73872 25.2613 6.12564 25.2613 5.36936C25.2613 4.61308 25.8744 4 26.6306 4C27.3869 4 28 4.61308 28 5.36936Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28 26.6306C28 27.3869 27.3869 28 26.6306 28C25.8744 28 25.2613 27.3869 25.2613 26.6306C25.2613 25.8744 25.8744 25.2613 26.6306 25.2613C27.3869 25.2613 28 25.8744 28 26.6306Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var MenuVertical = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M17.3332 5.36936C17.3332 6.12564 16.7362 6.73872 15.9998 6.73872C15.2635 6.73872 14.6665 6.12564 14.6665 5.36936C14.6665 4.61308 15.2635 4 15.9998 4C16.7362 4 17.3332 4.61308 17.3332 5.36936Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M17.3332 16C17.3332 16.7563 16.7362 17.3694 15.9998 17.3694C15.2635 17.3694 14.6665 16.7563 14.6665 16C14.6665 15.2437 15.2635 14.6306 15.9998 14.6306C16.7362 14.6306 17.3332 15.2437 17.3332 16Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M17.3332 26.6306C17.3332 27.3869 16.7362 28 15.9998 28C15.2635 28 14.6665 27.3869 14.6665 26.6306C14.6665 25.8744 15.2635 25.2613 15.9998 25.2613C16.7362 25.2613 17.3332 25.8744 17.3332 26.6306Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var MinimizeFullScreen = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M11.9855 5.33325V11.9853L5.3335 12.0146M20.0148 26.6666V20.0146L26.6668 19.9853M26.6668 11.9853H20.0148L19.9855 5.33325M5.3335 20.0146H11.9855L12.0148 26.6666', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Minus = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M6.66572 15.0146C6.11344 15.015 5.66607 15.4631 5.6665 16.0154C5.66694 16.5676 6.115 17.015 6.66728 17.0146L6.66572 15.0146ZM25.334 17C25.8862 16.9996 26.3336 16.5515 26.3332 15.9992C26.3327 15.4469 25.8847 14.9996 25.3324 15L25.334 17ZM25.3324 15L6.66572 15.0146L6.66728 17.0146L25.334 17L25.3324 15Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var PasswordHide = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M26.9535 11.4512C29.3777 13.9498 30.6668 16.4103 30.6668 16.4103C30.6668 16.4103 25.3466 26.5642 16.0002 26.5642C14.3713 26.5642 12.8648 26.2557 11.4874 25.7466M20.513 7.07415C19.1356 6.56487 17.629 6.25647 16.0002 6.25647C6.65382 6.25647 1.3335 16.4103 1.3335 16.4103C1.3335 16.4103 2.72218 19.0606 5.32694 21.6533', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28.4113 4L3.59082 28.8206', strokeWidth: '2', strokeLinecap: 'round' }),
        React.createElement("path", { d: 'M10.4376 17.3548C10.3859 17.0477 10.3589 16.7321 10.3589 16.4102C10.3589 13.2947 12.8845 10.7692 15.9999 10.7692C16.2672 10.7692 16.5302 10.7878 16.7877 10.8237M21.5822 15.5925C21.6209 15.8595 21.641 16.1325 21.641 16.4102C21.641 19.5257 19.1154 22.0512 15.9999 22.0512C15.7867 22.0512 15.5763 22.0394 15.3692 22.0163', strokeWidth: '2', strokeLinecap: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var PasswordView = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M30.6667 16C30.6667 16 25.3463 26.1541 15.9996 26.1541C6.65299 26.1541 1.33252 16 1.33252 16C1.33252 16 6.65299 5.84583 15.9996 5.84583C25.3463 5.84583 30.6667 16 30.6667 16Z', strokeWidth: '2', strokeLinejoin: 'round' }),
        React.createElement("ellipse", { cx: '16.0001', cy: '15.9997', rx: '5.64119', ry: '5.64119', strokeWidth: '2' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Play = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M23.6463 18.6658L11.7905 27.4344C11.3119 27.7871 10.7449 28.0003 10.1525 28.0503C9.56012 28.1002 8.96544 27.9849 8.43458 27.7173C7.90372 27.4496 7.45745 27.0401 7.14533 26.5341C6.83321 26.0281 6.66747 25.4455 6.6665 24.851V7.21723C6.66625 6.62046 6.83208 6.03539 7.1454 5.52748C7.45872 5.01957 7.90716 4.60887 8.4406 4.34132C8.97403 4.07376 9.5714 3.95992 10.1658 4.01252C10.7603 4.06512 11.3284 4.2821 11.8066 4.63916L23.6571 13.5096C24.0579 13.8098 24.3831 14.1994 24.6067 14.6475C24.8304 15.0955 24.9463 15.5896 24.9452 16.0904C24.9442 16.5911 24.8262 17.0847 24.6007 17.5319C24.3752 17.979 24.0484 18.3672 23.6463 18.6658V18.6658Z', strokeWidth: '2', strokeMiterlimit: '10' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Plus = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.9798 6.66675C16.9798 6.11446 16.5321 5.66675 15.9798 5.66675C15.4276 5.66675 14.9798 6.11446 14.9798 6.66675H16.9798ZM25.3332 16.98C25.8855 16.98 26.3332 16.5322 26.3332 15.98C26.3332 15.4277 25.8855 14.98 25.3332 14.98V16.98ZM15.0198 25.3377C15.0222 25.89 15.4718 26.3358 16.0241 26.3334C16.5764 26.331 17.0222 25.8814 17.0198 25.3291L15.0198 25.3377ZM6.66221 15.02C6.10993 15.0223 5.66414 15.472 5.66651 16.0243C5.66888 16.5765 6.11852 17.0223 6.6708 17.0199L6.66221 15.02ZM15.9755 14.98L6.66221 15.02L6.6708 17.0199L15.9841 16.9799L15.9755 14.98ZM14.9798 6.66675V15.98H16.9798V6.66675H14.9798ZM25.3332 14.98L15.9798 14.98V16.98L25.3332 16.98V14.98ZM17.0198 25.3291L16.9798 15.9757L14.9798 15.9842L15.0198 25.3377L17.0198 25.3291Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Price = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.0002 1.33325C7.90416 1.33325 1.3335 7.90392 1.3335 15.9999C1.3335 24.0959 7.90416 30.6666 16.0002 30.6666C24.0962 30.6666 30.6668 24.0959 30.6668 15.9999C30.6668 7.90392 24.0962 1.33325 16.0002 1.33325ZM17.2908 24.4479V24.9759C17.2908 25.6799 16.7188 26.2666 16.0002 26.2666C15.2962 26.2666 14.7095 25.6946 14.7095 24.9759V24.3599C13.7855 24.1399 11.8788 23.4653 10.7642 21.2799C10.4268 20.6346 10.7495 19.8279 11.4242 19.5493L11.5268 19.5053C12.1282 19.2559 12.8028 19.5053 13.1108 20.0773C13.5802 20.9719 14.5042 22.0866 16.2202 22.0866C17.5842 22.0866 19.1242 21.3826 19.1242 19.7253C19.1242 18.3173 18.0975 17.5839 15.7802 16.7479C14.1668 16.1759 10.8668 15.2373 10.8668 11.8933C10.8668 11.7466 10.8815 8.37325 14.7095 7.55192V7.02392C14.7095 6.30525 15.2962 5.73325 16.0002 5.73325C16.7042 5.73325 17.2908 6.30525 17.2908 7.02392V7.56658C18.8602 7.84525 19.8575 8.68125 20.4588 9.47325C20.9575 10.1186 20.6935 11.0573 19.9308 11.3799C19.4028 11.5999 18.7868 11.4239 18.4348 10.9693C18.0242 10.4119 17.2908 9.83992 16.0882 9.83992C15.0615 9.83992 13.4335 10.3826 13.4335 11.8786C13.4335 13.2719 14.6948 13.7999 17.3055 14.6653C20.8255 15.8826 21.7202 17.6719 21.7202 19.7253C21.7202 23.5826 18.0535 24.3159 17.2908 24.4479Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Refresh = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M12.0007 21.3403L4.01655 19.3167M4.01655 19.3167L4 26.6548L4.02648 20.0815C4.02653 20.0687 4.04279 20.0633 4.05047 20.0735L6.3992 23.2001C8.58965 26.1159 12.0735 28 15.9993 28M4.01655 19.3167L5.67831 22.0723C7.75979 25.6035 11.6033 28 15.9993 28M15.9993 28C21.7095 28 26.4886 24.0109 27.7011 18.6667C26.4912 23.9991 21.6968 28 15.9993 28ZM27.9985 12.7986C28.0019 12.7986 27.9985 12.8028 27.9985 12.7986ZM27.9985 12.7986C28.0025 12.7986 27.995 12.7986 27.9985 12.7986ZM27.9985 12.7986L21.3222 10.6852M27.9985 12.7986V5.34514L27.972 11.9184C27.9719 11.9312 28.0061 12.8088 27.9985 12.7986ZM27.9985 12.7986L25.5993 8.7999C23.4088 5.88409 19.925 4 15.9993 4M15.9993 4C10.289 4 5.50995 7.9891 4.29735 13.3333C5.50727 8.0009 10.3018 4 15.9993 4Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ResizeIndicator = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M25.1512 30.0002L29.9997 25.1517M29.9997 17.879L17.8785 30.0002M29.9997 10.6062L10.6057 30.0002M29.9997 3.3335L3.33301 30.0002', strokeWidth: '2' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Search = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M23.1887 23.2256L22.2659 23.9813C20.1963 25.6762 17.5534 26.6921 14.6699 26.6921M23.1887 23.2256L23.9646 22.2814C25.6582 20.2101 26.6733 17.5652 26.6733 14.6794M23.1887 23.2256L29.3331 29.3333M14.6699 26.6921C8.04061 26.6921 2.6665 21.3138 2.6665 14.6794M14.6699 26.6921C21.283 26.6921 26.6733 21.2976 26.6733 14.6794M14.6699 26.6921C8.0568 26.6921 2.6665 21.2976 2.6665 14.6794M2.6665 14.6794C2.6665 8.04491 8.04061 2.66663 14.6699 2.66663M2.6665 14.6794C2.6665 8.0611 8.0568 2.66663 14.6699 2.66663M14.6699 2.66663C21.2992 2.66663 26.6733 8.04491 26.6733 14.6794M14.6699 2.66663C21.283 2.66663 26.6733 8.0611 26.6733 14.6794', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ShareOption = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M21.5728 8.51564L21.3649 7.54029C21.3071 7.26888 21.2764 6.9863 21.2764 6.69513M21.5728 8.51564L22.266 9.3398C23.0064 10.1896 24.0925 10.7235 25.3048 10.7235M21.5728 8.51564L10.4267 14.1793M21.2764 6.69513C21.2764 4.47032 23.08 2.66675 25.3048 2.66675M21.2764 6.69513C21.2764 4.5151 23.1248 2.66675 25.3048 2.66675M21.2764 6.69513C21.2764 8.87516 23.1248 10.7235 25.3048 10.7235M25.3048 2.66675C27.5296 2.66675 29.3332 4.47032 29.3332 6.69513M25.3048 2.66675C27.4848 2.66675 29.3332 4.5151 29.3332 6.69513M29.3332 6.69513C29.3332 8.91994 27.5296 10.7235 25.3048 10.7235M29.3332 6.69513C29.3332 8.87516 27.4848 10.7235 25.3048 10.7235M10.4267 14.1793L10.6347 15.1547C10.6926 15.4262 10.7233 15.7088 10.7233 16.0001M10.4267 14.1793L9.73353 13.3553C8.9931 12.5055 7.90709 11.9717 6.69488 11.9717M10.7233 16.0001C10.7233 16.1653 10.7134 16.3276 10.6943 16.4866L10.5903 17.3535M10.7233 16.0001C10.7233 18.1801 8.87491 20.0285 6.69488 20.0285M10.7233 16.0001C10.7233 13.82 8.87491 11.9717 6.69488 11.9717M10.5903 17.3535L9.95092 18.3726C9.21603 19.3789 8.03139 20.0285 6.69488 20.0285M10.5903 17.3535L21.6256 23.3727M21.6256 23.3727L22.3067 22.6144C23.046 21.7913 24.1144 21.2767 25.3048 21.2767M21.6256 23.3727L21.378 24.4006C21.3117 24.6901 21.2764 24.9927 21.2764 25.305M25.3048 21.2767C27.5296 21.2767 29.3332 23.0802 29.3332 25.305M25.3048 21.2767C27.4848 21.2767 29.3332 23.125 29.3332 25.305M25.3048 21.2767C23.1248 21.2767 21.2764 23.125 21.2764 25.305M29.3332 25.305C29.3332 27.5298 27.5296 29.3334 25.3048 29.3334M29.3332 25.305C29.3332 27.4851 27.4848 29.3334 25.3048 29.3334M25.3048 29.3334C23.08 29.3334 21.2764 27.5298 21.2764 25.305M25.3048 29.3334C23.1248 29.3334 21.2764 27.4851 21.2764 25.305M6.69488 20.0285C4.47007 20.0285 2.6665 18.2249 2.6665 16.0001M6.69488 20.0285C4.51485 20.0285 2.6665 18.1801 2.6665 16.0001M2.6665 16.0001C2.6665 13.7753 4.47007 11.9717 6.69488 11.9717M2.6665 16.0001C2.6665 13.82 4.51485 11.9717 6.69488 11.9717', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SocialFacebook = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M20.8867 6.00002C18.9482 6.00002 18.3859 6.80497 18.3859 8.57493V11.5118H23.5589L23.0419 16.2613H18.3859V30.6666H12.1796V16.2613H8V11.5118H12.1796V8.65478C12.1796 3.86805 14.2493 1.33325 20.0244 1.33325C21.2748 1.33325 22.7396 1.41346 23.6444 1.53342V6.00002' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SocialGithub = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.5337 25.2056C26.6218 27.8222 24.152 29.6329 21.1243 30.6378C20.772 30.703 20.5142 30.6574 20.3511 30.5008C20.188 30.3442 20.1064 30.1484 20.1064 29.9135V25.7831C20.1064 24.5172 19.7671 23.5906 19.0885 23.0033C19.8324 22.925 20.5012 22.8076 21.095 22.651C21.6888 22.4944 22.3021 22.2399 22.9351 21.8875C23.568 21.5352 24.0966 21.1013 24.5207 20.5858C24.9448 20.0703 25.2907 19.3851 25.5582 18.5303C25.8257 17.6755 25.9595 16.6935 25.9595 15.5842C25.9595 14.0051 25.444 12.661 24.413 11.5517C24.8959 10.3641 24.8437 9.03296 24.2564 7.55827C23.891 7.44081 23.3625 7.51259 22.6708 7.7736C21.9791 8.0346 21.3788 8.32171 20.8699 8.63492L20.126 9.10473C18.9123 8.76542 17.6595 8.59577 16.3675 8.59577C15.0755 8.59577 13.8227 8.76542 12.609 9.10473C12.4002 8.96118 12.1229 8.785 11.777 8.57619C11.4312 8.36738 10.8864 8.11617 10.1425 7.82254C9.39861 7.5289 8.83745 7.44081 8.45898 7.55827C7.88477 9.03296 7.83909 10.3641 8.32196 11.5517C7.29097 12.661 6.77549 14.0051 6.77549 15.5842C6.77549 16.6935 6.90925 17.6723 7.17679 18.5206C7.44432 19.3688 7.78689 20.054 8.2045 20.576C8.62212 21.098 9.14739 21.5352 9.78033 21.8875C10.4133 22.2399 11.0266 22.4944 11.6204 22.651C12.2142 22.8076 12.883 22.925 13.6269 23.0033C13.1049 23.4732 12.7852 24.1452 12.6677 25.0196C12.3937 25.1501 12.1 25.248 11.7868 25.3133C11.4736 25.3785 11.1017 25.4111 10.671 25.4111C10.2404 25.4111 9.81296 25.2708 9.38882 24.9903C8.96468 24.7097 8.60254 24.3019 8.30238 23.7668C8.05442 23.3492 7.73795 23.0099 7.35297 22.7489C6.96798 22.4879 6.64499 22.3313 6.38398 22.2791L5.99247 22.2203C5.71841 22.2203 5.52918 22.2497 5.42478 22.3084C5.32038 22.3671 5.28775 22.4422 5.3269 22.5335C5.36605 22.6249 5.42478 22.7162 5.50308 22.8076C5.58138 22.8989 5.66621 22.9772 5.75756 23.0425L5.89459 23.1404C6.1817 23.2709 6.46554 23.5188 6.74613 23.8842C7.02671 24.2497 7.23225 24.5824 7.36275 24.8826L7.55851 25.3328C7.72817 25.8287 8.01527 26.23 8.41983 26.5367C8.8244 26.8434 9.26158 27.0392 9.73139 27.124C10.2012 27.2088 10.6547 27.2545 11.0919 27.261C11.5291 27.2675 11.8912 27.2447 12.1783 27.1925L12.6286 27.1142C12.6286 27.6101 12.6318 28.1909 12.6384 28.8564C12.6449 29.522 12.6481 29.8744 12.6481 29.9135C12.6481 30.1484 12.5633 30.3442 12.3937 30.5008C12.224 30.6574 11.963 30.703 11.6106 30.6378C8.58295 29.6329 6.11319 27.8222 4.20131 25.2056C2.28942 22.589 1.3335 19.6429 1.3335 16.3672C1.3335 13.6397 2.00558 11.1243 3.34977 8.82089C4.69397 6.51749 6.51773 4.69372 8.82113 3.34953C11.1245 2.00534 13.64 1.33325 16.3675 1.33325C19.095 1.33325 21.6105 2.00534 23.9139 3.34953C26.2173 4.69372 28.041 6.51749 29.3852 8.82089C30.7294 11.1243 31.4015 13.6397 31.4015 16.3672C31.4015 19.6429 30.4456 22.589 28.5337 25.2056Z' }),
        React.createElement("mask", { id: 'mask0_18594_55780', maskUnits: 'userSpaceOnUse', x: '1', y: '1', width: '31', height: '30' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.5337 25.2056C26.6218 27.8222 24.152 29.6329 21.1243 30.6378C20.772 30.703 20.5142 30.6574 20.3511 30.5008C20.188 30.3442 20.1064 30.1484 20.1064 29.9135V25.7831C20.1064 24.5172 19.7671 23.5906 19.0885 23.0033C19.8324 22.925 20.5012 22.8076 21.095 22.651C21.6888 22.4944 22.3021 22.2399 22.9351 21.8875C23.568 21.5352 24.0966 21.1013 24.5207 20.5858C24.9448 20.0703 25.2907 19.3851 25.5582 18.5303C25.8257 17.6755 25.9595 16.6935 25.9595 15.5842C25.9595 14.0051 25.444 12.661 24.413 11.5517C24.8959 10.3641 24.8437 9.03296 24.2564 7.55827C23.891 7.44081 23.3625 7.51259 22.6708 7.7736C21.9791 8.0346 21.3788 8.32171 20.8699 8.63492L20.126 9.10473C18.9123 8.76542 17.6595 8.59577 16.3675 8.59577C15.0755 8.59577 13.8227 8.76542 12.609 9.10473C12.4002 8.96118 12.1229 8.785 11.777 8.57619C11.4312 8.36738 10.8864 8.11617 10.1425 7.82254C9.39861 7.5289 8.83745 7.44081 8.45898 7.55827C7.88477 9.03296 7.83909 10.3641 8.32196 11.5517C7.29097 12.661 6.77549 14.0051 6.77549 15.5842C6.77549 16.6935 6.90925 17.6723 7.17679 18.5206C7.44432 19.3688 7.78689 20.054 8.2045 20.576C8.62212 21.098 9.14739 21.5352 9.78033 21.8875C10.4133 22.2399 11.0266 22.4944 11.6204 22.651C12.2142 22.8076 12.883 22.925 13.6269 23.0033C13.1049 23.4732 12.7852 24.1452 12.6677 25.0196C12.3937 25.1501 12.1 25.248 11.7868 25.3133C11.4736 25.3785 11.1017 25.4111 10.671 25.4111C10.2404 25.4111 9.81296 25.2708 9.38882 24.9903C8.96468 24.7097 8.60254 24.3019 8.30238 23.7668C8.05442 23.3492 7.73795 23.0099 7.35297 22.7489C6.96798 22.4879 6.64499 22.3313 6.38398 22.2791L5.99247 22.2203C5.71841 22.2203 5.52918 22.2497 5.42478 22.3084C5.32038 22.3671 5.28775 22.4422 5.3269 22.5335C5.36605 22.6249 5.42478 22.7162 5.50308 22.8076C5.58138 22.8989 5.66621 22.9772 5.75756 23.0425L5.89459 23.1404C6.1817 23.2709 6.46554 23.5188 6.74613 23.8842C7.02671 24.2497 7.23225 24.5824 7.36275 24.8826L7.55851 25.3328C7.72817 25.8287 8.01527 26.23 8.41983 26.5367C8.8244 26.8434 9.26158 27.0392 9.73139 27.124C10.2012 27.2088 10.6547 27.2545 11.0919 27.261C11.5291 27.2675 11.8912 27.2447 12.1783 27.1925L12.6286 27.1142C12.6286 27.6101 12.6318 28.1909 12.6384 28.8564C12.6449 29.522 12.6481 29.8744 12.6481 29.9135C12.6481 30.1484 12.5633 30.3442 12.3937 30.5008C12.224 30.6574 11.963 30.703 11.6106 30.6378C8.58295 29.6329 6.11319 27.8222 4.20131 25.2056C2.28942 22.589 1.3335 19.6429 1.3335 16.3672C1.3335 13.6397 2.00558 11.1243 3.34977 8.82089C4.69397 6.51749 6.51773 4.69372 8.82113 3.34953C11.1245 2.00534 13.64 1.33325 16.3675 1.33325C19.095 1.33325 21.6105 2.00534 23.9139 3.34953C26.2173 4.69372 28.041 6.51749 29.3852 8.82089C30.7294 11.1243 31.4015 13.6397 31.4015 16.3672C31.4015 19.6429 30.4456 22.589 28.5337 25.2056Z' })),
        React.createElement("g", { mask: 'url(#mask0_18594_55780)' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SocialLinkedin = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.5008 1.33325H3.50086C2.30377 1.33325 1.3335 2.27392 1.3335 3.43495V28.5643C1.3335 29.7254 2.30411 30.6669 3.50086 30.6669H28.5008C29.6977 30.6669 30.6668 29.7248 30.6668 28.5643V3.43495C30.6668 2.27426 29.6976 1.33325 28.5008 1.33325ZM10.2266 25.8875H5.79452V12.6437H10.2266V25.8875ZM8.01077 10.8343H7.98096C6.4947 10.8343 5.53125 9.81789 5.53125 8.54536C5.53125 7.24719 6.523 6.2583 8.03873 6.2583C9.55459 6.2583 10.487 7.24692 10.5165 8.54536C10.5165 9.81816 9.55493 10.8343 8.01077 10.8343ZM26.203 25.8876H21.7724V18.8017C21.7724 17.0213 21.1304 15.8064 19.5281 15.8064C18.3024 15.8064 17.5748 16.626 17.2553 17.4173C17.1369 17.6999 17.1075 18.0952 17.1075 18.4899V25.8874H12.6777C12.6777 25.8874 12.7357 13.8857 12.6777 12.6436H17.1082V14.5212C17.6964 13.619 18.7474 12.332 21.1002 12.332C24.0164 12.332 26.203 14.2238 26.203 18.2936V25.8876H26.203ZM17.0796 14.6415C17.1013 14.6059 17.1316 14.5631 17.1617 14.5214V14.6415H17.0796Z' }),
        React.createElement("mask", { id: 'mask0_18594_55754', maskUnits: 'userSpaceOnUse', x: '1', y: '1', width: '30', height: '30' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.5008 1.33325H3.50086C2.30377 1.33325 1.3335 2.27392 1.3335 3.43495V28.5643C1.3335 29.7254 2.30411 30.6669 3.50086 30.6669H28.5008C29.6977 30.6669 30.6668 29.7248 30.6668 28.5643V3.43495C30.6668 2.27426 29.6976 1.33325 28.5008 1.33325ZM10.2266 25.8875H5.79452V12.6437H10.2266V25.8875ZM8.01077 10.8343H7.98096C6.4947 10.8343 5.53125 9.81789 5.53125 8.54536C5.53125 7.24719 6.523 6.2583 8.03873 6.2583C9.55459 6.2583 10.487 7.24692 10.5165 8.54536C10.5165 9.81816 9.55493 10.8343 8.01077 10.8343ZM26.203 25.8876H21.7724V18.8017C21.7724 17.0213 21.1304 15.8064 19.5281 15.8064C18.3024 15.8064 17.5748 16.626 17.2553 17.4173C17.1369 17.6999 17.1075 18.0952 17.1075 18.4899V25.8874H12.6777C12.6777 25.8874 12.7357 13.8857 12.6777 12.6436H17.1082V14.5212C17.6964 13.619 18.7474 12.332 21.1002 12.332C24.0164 12.332 26.203 14.2238 26.203 18.2936V25.8876H26.203ZM17.0796 14.6415C17.1013 14.6059 17.1316 14.5631 17.1617 14.5214V14.6415H17.0796Z' })),
        React.createElement("g", { mask: 'url(#mask0_18594_55754)' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SocialTwitter = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.7107 9.04675C28.7242 9.23341 28.731 9.51341 28.731 9.88675C28.731 11.6201 28.4738 13.3501 27.9594 15.0767C27.445 16.8034 26.6633 18.4601 25.6142 20.0467C24.5651 21.6334 23.3164 23.0367 21.868 24.2567C20.4196 25.4768 18.6734 26.4501 16.6294 27.1767C14.5854 27.9034 12.3993 28.2667 10.0711 28.2667C6.40269 28.2667 3.0457 27.3001 0 25.3667C0.473776 25.4201 1.00169 25.4467 1.58376 25.4467C4.62946 25.4467 7.34348 24.5268 9.72589 22.6867C8.30456 22.6601 7.03215 22.2301 5.90863 21.3967C4.7851 20.5634 4.01354 19.5001 3.59391 18.2067C4.04061 18.2734 4.45347 18.3067 4.83249 18.3067C5.41456 18.3067 5.98985 18.2334 6.55837 18.0867C5.04229 17.7801 3.78681 17.0368 2.79188 15.8567C1.79695 14.6767 1.29949 13.3068 1.29949 11.7467V11.6667C2.21997 12.1734 3.20812 12.4467 4.26396 12.4867C3.37055 11.9001 2.6599 11.1334 2.13198 10.1867C1.60406 9.24008 1.3401 8.21342 1.3401 7.10675C1.3401 5.93341 1.6379 4.84676 2.2335 3.84675C3.87141 5.83343 5.86463 7.42341 8.2132 8.61675C10.5618 9.81009 13.0761 10.4734 15.7563 10.6067C15.6481 10.1001 15.5939 9.60675 15.5939 9.12675C15.5939 7.34007 16.2335 5.81676 17.5127 4.55675C18.7919 3.29674 20.3384 2.66675 22.1523 2.66675C24.0474 2.66675 25.6447 3.34674 26.9442 4.70675C28.4196 4.42675 29.8071 3.90675 31.1066 3.14675C30.6058 4.68009 29.6447 5.86674 28.2234 6.70675C29.4822 6.57341 30.7411 6.24008 32 5.70675C31.0931 7.01342 29.9966 8.12674 28.7107 9.04675Z' }),
        React.createElement("mask", { id: 'mask0_18594_55769', maskUnits: 'userSpaceOnUse', x: '0', y: '2', width: '32', height: '27' },
            React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28.7107 9.04675C28.7242 9.23341 28.731 9.51341 28.731 9.88675C28.731 11.6201 28.4738 13.3501 27.9594 15.0767C27.445 16.8034 26.6633 18.4601 25.6142 20.0467C24.5651 21.6334 23.3164 23.0367 21.868 24.2567C20.4196 25.4768 18.6734 26.4501 16.6294 27.1767C14.5854 27.9034 12.3993 28.2667 10.0711 28.2667C6.40269 28.2667 3.0457 27.3001 0 25.3667C0.473776 25.4201 1.00169 25.4467 1.58376 25.4467C4.62946 25.4467 7.34348 24.5268 9.72589 22.6867C8.30456 22.6601 7.03215 22.2301 5.90863 21.3967C4.7851 20.5634 4.01354 19.5001 3.59391 18.2067C4.04061 18.2734 4.45347 18.3067 4.83249 18.3067C5.41456 18.3067 5.98985 18.2334 6.55837 18.0867C5.04229 17.7801 3.78681 17.0368 2.79188 15.8567C1.79695 14.6767 1.29949 13.3068 1.29949 11.7467V11.6667C2.21997 12.1734 3.20812 12.4467 4.26396 12.4867C3.37055 11.9001 2.6599 11.1334 2.13198 10.1867C1.60406 9.24008 1.3401 8.21342 1.3401 7.10675C1.3401 5.93341 1.6379 4.84676 2.2335 3.84675C3.87141 5.83343 5.86463 7.42341 8.2132 8.61675C10.5618 9.81009 13.0761 10.4734 15.7563 10.6067C15.6481 10.1001 15.5939 9.60675 15.5939 9.12675C15.5939 7.34007 16.2335 5.81676 17.5127 4.55675C18.7919 3.29674 20.3384 2.66675 22.1523 2.66675C24.0474 2.66675 25.6447 3.34674 26.9442 4.70675C28.4196 4.42675 29.8071 3.90675 31.1066 3.14675C30.6058 4.68009 29.6447 5.86674 28.2234 6.70675C29.4822 6.57341 30.7411 6.24008 32 5.70675C31.0931 7.01342 29.9966 8.12674 28.7107 9.04675Z' })),
        React.createElement("g", { mask: 'url(#mask0_18594_55769)' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Star = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M14.3135 4.9597C14.7292 3.6801 16.5396 3.6801 16.9554 4.9597L19.0646 11.451C19.2504 12.0233 19.7838 12.4107 20.3854 12.4107H27.2108C28.5563 12.4107 29.1156 14.1324 28.0272 14.9233L22.5054 18.9352C22.0186 19.2888 21.8148 19.9157 22.0008 20.488L24.1099 26.9793C24.5258 28.2589 23.0611 29.3229 21.9727 28.5321L16.4508 24.5202C15.964 24.1666 15.3048 24.1666 14.818 24.5202L9.29621 28.5321C8.20771 29.3229 6.74315 28.2589 7.15893 26.9793L9.26809 20.488C9.45402 19.9157 9.25033 19.2888 8.76354 18.9352L3.24169 14.9233C2.15319 14.1324 2.71261 12.4107 4.05805 12.4107H10.8834C11.4852 12.4107 12.0184 12.0233 12.2044 11.451L14.3135 4.9597Z', strokeWidth: '2' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Suitcase = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_22448_57593)' },
            React.createElement("path", { d: 'M28.8333 19.3443V25.9554C28.8333 27.6572 27.609 29.1225 25.9213 29.3465C22.6748 29.7774 19.3631 29.9998 16 29.9998C12.6369 29.9998 9.32515 29.7774 6.07873 29.3465C4.39096 29.1225 3.16675 27.6572 3.16675 25.9554V19.3443M28.8333 19.3443C29.2026 19.0234 29.4982 18.6262 29.6995 18.1802C29.9009 17.7342 30.0034 17.2499 29.9999 16.7606V10.8759C29.9999 9.1944 28.8053 7.74152 27.1424 7.49263C25.3804 7.22884 23.6096 7.02805 21.8333 6.89064M28.8333 19.3443C28.5315 19.601 28.1799 19.8032 27.7864 19.9354C23.985 21.1968 20.0052 21.8375 16 21.8332C11.8809 21.8332 7.91894 21.1659 4.21363 19.9354C3.82981 19.8078 3.47432 19.607 3.16675 19.3443M3.16675 19.3443C2.79737 19.0234 2.50184 18.6262 2.30046 18.1802C2.09908 17.7342 1.99661 17.2499 2.00009 16.7606V10.8759C2.00009 9.1944 3.19475 7.74152 4.85762 7.49263C6.61959 7.22884 8.39041 7.02805 10.1667 6.89064M21.8333 6.89064V5.49998C21.8333 4.57173 21.4646 3.68149 20.8082 3.02512C20.1518 2.36875 19.2616 2 18.3333 2H13.6667C12.7384 2 11.8482 2.36875 11.1918 3.02512C10.5354 3.68149 10.1667 4.57173 10.1667 5.49998V6.89064M21.8333 6.89064C17.9502 6.59054 14.0498 6.59054 10.1667 6.89064M16 17.1666H16.0124V17.179H16V17.1666Z', strokeWidth: '2.33333', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_22448_57593' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SwapCollideHorizontal = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M14.6759 13.3207L9.3426 18.6793M14.6759 13.3207L9.32374 8M14.6759 13.3207L2.6665 13.3435M17.3654 18.6832L22.6759 24M17.3654 18.6832L22.6571 13.3207M17.3654 18.6832L29.3332 18.6565', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SwapCollideVertical = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M13.3221 14.6313L18.6529 9.32304M13.3221 14.6313L8 9.34379M13.3221 14.6313V2.66675M18.6486 17.3688L13.3471 22.6771M18.6486 17.3688L24 22.6564M18.6486 17.3688L18.6779 29.3334', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SwapOppositeHorizontal = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M29.3332 13.3384L24.0048 8M29.3332 13.3384L24.0142 18.673M29.3332 13.3384H17.3348M2.6665 18.6749L7.99489 24M2.6665 18.6749L7.98545 13.327L8.93412 12.3884M2.6665 18.6749L14.6649 18.6616', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var SwapOppositeVertical = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M13.3333 7.96838L18.6624 2.66675M18.6624 2.66675L24 7.98918M18.6624 2.66675V14.6632M13.3584 29.3334L18.6667 24.011M13.3584 29.3334L8 24.0318M13.3584 29.3334L13.329 17.337', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ThumbsDown = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M22.1025 17.7677L21.7541 18.5396C20.9265 20.3735 19.7454 21.6901 18.4582 23.0294M22.1025 17.7677C21.2772 19.8837 19.8609 21.57 18.4582 23.0294M22.1025 17.7677L28.0653 17.7477L28.0452 4.41117H22.0565M22.1025 17.7677L22.0565 4.41117M18.4582 23.0294C18.3192 23.174 18.1804 23.3176 18.0403 23.4624M18.4582 23.0294C18.3181 23.1752 18.1829 23.3153 18.0403 23.4624M18.0403 23.4624C16.7112 24.8368 15.2836 26.313 14.0853 28.4109M18.0403 23.4624C16.8469 24.6943 15.555 25.9743 14.4431 27.7374L14.0853 28.4109M14.0853 28.4109C14.0925 28.4109 14.0817 28.4171 14.0853 28.4109ZM14.0853 28.4109C12.7516 28.4109 11.6902 28.1708 10.9477 27.7105M14.0853 28.4109L13.2141 28.3436C12.2968 28.2592 11.5217 28.0664 10.9477 27.7105M10.9477 27.7105C10.2043 27.2496 9.76415 26.5787 9.63849 25.7407M10.9477 27.7105C10.2139 27.2556 9.76236 26.5667 9.63849 25.7407M9.63849 25.7407C9.51297 24.9035 9.70136 23.9009 10.212 22.7749M9.63849 25.7407C9.51451 24.9138 9.70317 23.8969 10.212 22.7749M10.212 22.7749C10.4477 22.2552 10.7533 21.7067 11.1313 21.133L12.6667 19.0994M10.212 22.7749C10.7206 21.6535 11.5028 20.43 12.6667 19.0994M12.6667 19.0994H6.68353M12.6667 19.0994C12.6667 19.0922 12.6746 19.0994 12.6667 19.0994ZM12.6667 19.0994C12.6718 19.0935 12.6667 19.1065 12.6667 19.0994ZM6.68353 19.0994C4.78593 19.0994 3.48985 17.1822 4.19465 15.4196M6.68353 19.0994C4.81504 19.0994 3.50004 17.1567 4.19465 15.4196M4.19465 15.4196L5.39513 12.4173V8.01446M5.39513 8.01446C5.39513 4.72473 8.33683 2.21522 11.5843 2.73501M5.39513 8.01446C5.39513 4.7491 8.36139 2.21916 11.5843 2.73501M11.5843 2.73501L22.0565 4.41117', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ThumbsUp = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M28.0506 13.3219L29.0506 13.3208C29.0499 12.769 28.6024 12.3219 28.0506 12.3219V13.3219ZM28.0653 26.6543L28.0677 27.6543C28.6195 27.653 29.0659 27.205 29.0653 26.6532L28.0653 26.6543ZM11.5815 28.3453L11.7395 29.3328H11.7395L11.5815 28.3453ZM5.39575 18.6665H6.39575C6.39575 18.5393 6.37147 18.4132 6.32422 18.2951L5.39575 18.6665ZM4.19435 15.663L3.26587 16.0344H3.26587L4.19435 15.663ZM11.1335 9.94808L10.2986 10.4984C10.3157 10.5243 10.3339 10.5494 10.3533 10.5736L11.1335 9.94808ZM10.2143 8.30681L9.30365 8.71998L9.30366 8.71998L10.2143 8.30681ZM9.64092 5.34376L10.6299 5.4921L10.6299 5.4921L9.64092 5.34376ZM10.9483 3.37745L10.4215 2.52744V2.52744L10.9483 3.37745ZM13.2124 2.73446L13.304 3.73025L13.2124 2.73446ZM21.7518 12.5468L20.8404 12.9583V12.9583L21.7518 12.5468ZM29.0653 26.6532L29.0506 13.3208L27.0506 13.323L27.0653 26.6554L29.0653 26.6532ZM4.39575 23.0707C4.39575 26.9727 7.88621 29.9493 11.7395 29.3328L11.4235 27.3579C8.78542 27.78 6.39575 25.7421 6.39575 23.0707H4.39575ZM6.67939 10.9902C4.07638 10.9902 2.29974 13.619 3.26587 16.0344L5.12283 15.2916C4.68153 14.1883 5.49307 12.9902 6.67939 12.9902V10.9902ZM10.3533 10.5736L11.9906 12.6157L13.551 11.3646L11.9137 9.32254L10.3533 10.5736ZM9.30366 8.71998C9.56391 9.2936 9.89606 9.88775 10.2986 10.4984L11.9685 9.39772C11.6149 8.86139 11.336 8.35877 11.125 7.89364L9.30366 8.71998ZM8.65199 5.19542C8.48835 6.28637 8.74526 7.48922 9.30365 8.71998L11.125 7.89364C10.6621 6.87335 10.5428 6.07282 10.6299 5.4921L8.65199 5.19542ZM10.4215 2.52744C9.43289 3.1401 8.82163 4.0645 8.65199 5.19542L10.6299 5.4921C10.7112 4.95 10.9787 4.53504 11.475 4.22746L10.4215 2.52744ZM13.9144 1.66874C12.5375 1.68708 11.3429 1.95641 10.4215 2.52744L11.475 4.22746C11.985 3.91142 12.7836 3.68397 13.9411 3.66856L13.9144 1.66874ZM13.304 3.73025L14.0194 3.66445L13.8361 1.67285L13.1208 1.73866L13.304 3.73025ZM11.475 4.22746C11.8648 3.9859 12.4619 3.80773 13.304 3.73025L13.1208 1.73866C12.1262 1.83016 11.182 2.05615 10.4215 2.52744L11.475 4.22746ZM10.6299 5.4921C10.7099 4.95867 10.9859 4.5306 11.475 4.22746L10.4215 2.52744C9.4398 3.13581 8.82028 4.07345 8.65199 5.19542L10.6299 5.4921ZM11.125 7.89364C10.6637 6.87688 10.5438 6.06574 10.6299 5.4921L8.65199 5.19542C8.48956 6.27828 8.74625 7.49141 9.30365 8.71998L11.125 7.89364ZM13.5234 11.3317C12.3848 10.0303 11.5751 8.88571 11.125 7.89364L9.30365 8.71998C9.8717 9.972 10.8276 11.2879 12.0183 12.6487L13.5234 11.3317ZM13.7708 11.9902C13.7708 12.0176 13.7697 12.0602 13.7634 12.1118C13.7577 12.1577 13.7437 12.247 13.7025 12.3526C13.6661 12.4458 13.5674 12.6585 13.3287 12.8188C13.2013 12.9043 13.05 12.9633 12.8846 12.9821C12.723 13.0006 12.5805 12.9772 12.4688 12.9417C12.2624 12.8762 12.1319 12.7611 12.0773 12.7084C12.0131 12.6464 11.9699 12.5881 11.9449 12.5514C11.8947 12.4774 11.8628 12.4093 11.8428 12.3588C11.8236 12.3103 11.7971 12.2327 11.7828 12.1337C11.7758 12.0856 11.7664 11.9969 11.778 11.8862C11.7878 11.7936 11.8248 11.557 12.0178 11.3351C12.1228 11.2143 12.2625 11.1125 12.4311 11.0513C12.5956 10.9916 12.7497 10.9841 12.8714 10.9963C13.0937 11.0184 13.2479 11.109 13.3061 11.1458C13.3778 11.1911 13.4286 11.2361 13.4557 11.2616C13.4856 11.2896 13.5084 11.3145 13.5234 11.3317L12.0183 12.6487C12.0337 12.6663 12.057 12.6917 12.0872 12.7201C12.1147 12.7458 12.1658 12.7911 12.2378 12.8366C12.2962 12.8735 12.4506 12.9642 12.673 12.9864C12.7949 12.9985 12.949 12.991 13.1136 12.9313C13.2822 12.8701 13.422 12.7682 13.5271 12.6474C13.7201 12.4254 13.7572 12.1887 13.767 12.0958C13.7787 11.985 13.7692 11.896 13.7622 11.8477C13.7478 11.7481 13.7212 11.6699 13.7017 11.6208C13.6814 11.5698 13.6493 11.5011 13.5987 11.4267C13.5736 11.3897 13.5303 11.3312 13.4659 11.2691C13.4111 11.2162 13.2804 11.101 13.0739 11.0354C12.9622 11 12.8196 10.9766 12.6579 10.995C12.4925 11.0139 12.3411 11.0729 12.2136 11.1584C11.9748 11.3188 11.876 11.5316 11.8395 11.6251C11.7982 11.7309 11.7841 11.8206 11.7784 11.867C11.772 11.919 11.7708 11.962 11.7708 11.9902H13.7708ZM12.7708 12.9902C12.7056 12.9902 12.5912 12.9839 12.4569 12.9393C12.3252 12.8955 12.1051 12.7901 11.9425 12.5475C11.7652 12.2829 11.7414 11.981 11.807 11.7346C11.8666 11.5105 11.9913 11.3498 12.1059 11.2471C12.3012 11.0723 12.7521 10.8467 13.2449 11.1115C13.7433 11.3792 13.7708 11.8763 13.7708 11.9902H11.7708C11.7708 12.1066 11.7991 12.605 12.2984 12.8733C12.7921 13.1385 13.2441 12.9126 13.4401 12.7371C13.5551 12.6342 13.6801 12.473 13.7398 12.2485C13.8055 12.0016 13.7816 11.6993 13.604 11.4343C13.4412 11.1913 13.2206 11.0856 13.0881 11.0415C12.953 10.9965 12.8375 10.9902 12.7708 10.9902V12.9902ZM6.67939 12.9902H12.7708V10.9902H6.67939V12.9902ZM5.12283 15.2916C4.68911 14.2073 5.51416 12.9902 6.67939 12.9902V10.9902C4.09844 10.9902 2.30696 13.6371 3.26587 16.0344L5.12283 15.2916ZM6.32422 18.2951L5.12283 15.2916L3.26587 16.0344L4.46727 19.0379L6.32422 18.2951ZM6.39575 23.0707V18.6665H4.39575V23.0707H6.39575ZM11.4235 27.3579C8.80345 27.7771 6.39575 25.7243 6.39575 23.0707H4.39575C4.39575 26.955 7.90437 29.9464 11.7395 29.3328L11.4235 27.3579ZM17.7133 8.7714C19.0996 10.2134 20.4196 11.7618 21.1702 13.6854L23.0334 12.9585C22.1318 10.6477 20.5753 8.8626 19.155 7.38527L17.7133 8.7714ZM17.2903 8.33382C17.4333 8.48136 17.5746 8.62718 17.7133 8.7714L19.155 7.38527C19.0131 7.23767 18.869 7.08896 18.7265 6.94191L17.2903 8.33382ZM13.9277 1.66865C13.9277 1.66865 13.9277 1.66865 13.9277 1.66865C13.9276 1.66865 13.9276 1.66865 13.9276 1.66865C13.9275 1.66865 13.9275 1.66865 13.9275 1.66865C13.9275 1.66865 13.9274 1.66865 13.9274 1.66865C13.9274 1.66865 13.9273 1.66865 13.9273 1.66865C13.9273 1.66865 13.9273 1.66865 13.9272 1.66865C13.9272 1.66865 13.9272 1.66865 13.9271 1.66865C13.9271 1.66865 13.9271 1.66865 13.9271 1.66865C13.927 1.66865 13.927 1.66865 13.927 1.66865C13.9269 1.66865 13.9269 1.66865 13.9269 1.66865C13.9269 1.66865 13.9268 1.66865 13.9268 1.66865C13.9268 1.66865 13.9268 1.66865 13.9267 1.66865C13.9267 1.66865 13.9267 1.66865 13.9267 1.66865C13.9266 1.66865 13.9266 1.66865 13.9266 1.66865C13.9266 1.66865 13.9265 1.66865 13.9265 1.66865C13.9265 1.66865 13.9265 1.66865 13.9264 1.66865C13.9264 1.66865 13.9264 1.66865 13.9264 1.66865C13.9263 1.66865 13.9263 1.66865 13.9263 1.66865C13.9263 1.66865 13.9262 1.66865 13.9262 1.66865C13.9262 1.66865 13.9262 1.66865 13.9261 1.66865C13.9261 1.66865 13.9261 1.66865 13.9261 1.66865C13.9261 1.66865 13.926 1.66865 13.926 1.66865C13.926 1.66865 13.926 1.66865 13.9259 1.66865C13.9259 1.66865 13.9259 1.66865 13.9259 1.66865C13.9259 1.66865 13.9258 1.66865 13.9258 1.66865C13.9258 1.66865 13.9258 1.66865 13.9257 1.66865C13.9257 1.66865 13.9257 1.66865 13.9257 1.66865C13.9257 1.66865 13.9256 1.66865 13.9256 1.66865C13.9256 1.66865 13.9256 1.66865 13.9256 1.66865C13.9255 1.66865 13.9255 1.66865 13.9255 1.66865C13.9255 1.66865 13.9255 1.66865 13.9254 1.66865C13.9254 1.66865 13.9254 1.66865 13.9254 1.66865C13.9254 1.66865 13.9253 1.66865 13.9253 1.66865C13.9253 1.66865 13.9253 1.66865 13.9253 1.66865C13.9252 1.66865 13.9252 1.66865 13.9252 1.66865C13.9252 1.66865 13.9252 1.66865 13.9251 1.66865C13.9251 1.66865 13.9251 1.66865 13.9251 1.66865C13.9251 1.66865 13.9251 1.66865 13.925 1.66865C13.925 1.66865 13.925 1.66865 13.925 1.66865C13.925 1.66865 13.9249 1.66865 13.9249 1.66865C13.9249 1.66865 13.9249 1.66865 13.9249 1.66865C13.9249 1.66865 13.9248 1.66865 13.9248 1.66865C13.9248 1.66865 13.9248 1.66865 13.9248 1.66865C13.9248 1.66865 13.9248 1.66865 13.9247 1.66865C13.9247 1.66865 13.9247 1.66865 13.9247 1.66865C13.9247 1.66865 13.9247 1.66865 13.9246 1.66865C13.9246 1.66865 13.9246 1.66865 13.9246 1.66865C13.9246 1.66865 13.9246 1.66865 13.9246 1.66865C13.9245 1.66865 13.9245 1.66865 13.9245 1.66865C13.9245 1.66865 13.9245 1.66865 13.9245 1.66865C13.9244 1.66865 13.9244 1.66865 13.9244 1.66865C13.9244 1.66865 13.9244 1.66865 13.9244 1.66865C13.9244 1.66865 13.9244 1.66865 13.9243 1.66865C13.9243 1.66865 13.9243 1.66865 13.9243 1.66865C13.9243 1.66865 13.9243 1.66865 13.9243 1.66865C13.9242 1.66865 13.9242 1.66865 13.9242 1.66865C13.9242 1.66865 13.9242 1.66865 13.9242 1.66865C13.9242 1.66865 13.9242 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 2.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865H13.9233C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.9241 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9241 3.66865 13.9242 3.66865 13.9242 3.66865C13.9242 3.66865 13.9242 3.66865 13.9242 3.66865C13.9242 3.66865 13.9242 3.66865 13.9242 3.66865C13.9242 3.66865 13.9242 3.66865 13.9243 3.66865C13.9243 3.66865 13.9243 3.66865 13.9243 3.66865C13.9243 3.66865 13.9243 3.66865 13.9243 3.66865C13.9243 3.66865 13.9243 3.66865 13.9243 3.66865C13.9244 3.66865 13.9244 3.66865 13.9244 3.66865C13.9244 3.66865 13.9244 3.66865 13.9244 3.66865C13.9244 3.66865 13.9244 3.66865 13.9244 3.66865C13.9244 3.66865 13.9245 3.66865 13.9245 3.66865C13.9245 3.66865 13.9245 3.66865 13.9245 3.66865C13.9245 3.66865 13.9245 3.66865 13.9245 3.66865C13.9245 3.66865 13.9246 3.66865 13.9246 3.66865C13.9246 3.66865 13.9246 3.66865 13.9246 3.66865C13.9246 3.66865 13.9246 3.66865 13.9246 3.66865C13.9246 3.66865 13.9247 3.66865 13.9247 3.66865C13.9247 3.66865 13.9247 3.66865 13.9247 3.66865C13.9247 3.66865 13.9247 3.66865 13.9247 3.66865C13.9247 3.66865 13.9248 3.66865 13.9248 3.66865C13.9248 3.66865 13.9248 3.66865 13.9248 3.66865C13.9248 3.66865 13.9248 3.66865 13.9248 3.66865C13.9248 3.66865 13.9249 3.66865 13.9249 3.66865C13.9249 3.66865 13.9249 3.66865 13.9249 3.66865C13.9249 3.66865 13.9249 3.66865 13.9249 3.66865C13.925 3.66865 13.925 3.66865 13.925 3.66865C13.925 3.66865 13.925 3.66865 13.925 3.66865C13.925 3.66865 13.925 3.66865 13.9251 3.66865C13.9251 3.66865 13.9251 3.66865 13.9251 3.66865C13.9251 3.66865 13.9251 3.66865 13.9251 3.66865C13.9251 3.66865 13.9251 3.66865 13.9252 3.66865C13.9252 3.66865 13.9252 3.66865 13.9252 3.66865C13.9252 3.66865 13.9252 3.66865 13.9252 3.66865C13.9253 3.66865 13.9253 3.66865 13.9253 3.66865C13.9253 3.66865 13.9253 3.66865 13.9253 3.66865C13.9253 3.66865 13.9253 3.66865 13.9254 3.66865C13.9254 3.66865 13.9254 3.66865 13.9254 3.66865C13.9254 3.66865 13.9254 3.66865 13.9254 3.66865C13.9254 3.66865 13.9255 3.66865 13.9255 3.66865C13.9255 3.66865 13.9255 3.66865 13.9255 3.66865C13.9255 3.66865 13.9255 3.66865 13.9256 3.66865C13.9256 3.66865 13.9256 3.66865 13.9256 3.66865C13.9256 3.66865 13.9256 3.66865 13.9256 3.66865C13.9256 3.66865 13.9257 3.66865 13.9257 3.66865C13.9257 3.66865 13.9257 3.66865 13.9257 3.66865C13.9257 3.66865 13.9257 3.66865 13.9258 3.66865C13.9258 3.66865 13.9258 3.66865 13.9258 3.66865C13.9258 3.66865 13.9258 3.66865 13.9258 3.66865C13.9258 3.66865 13.9259 3.66865 13.9259 3.66865C13.9259 3.66865 13.9259 3.66865 13.9259 3.66865C13.9259 3.66865 13.9259 3.66865 13.926 3.66865C13.926 3.66865 13.926 3.66865 13.926 3.66865C13.926 3.66865 13.926 3.66865 13.926 3.66865C13.9261 3.66865 13.9261 3.66865 13.9261 3.66865C13.9261 3.66865 13.9261 3.66865 13.9261 3.66865C13.9261 3.66865 13.9262 3.66865 13.9262 3.66865C13.9262 3.66865 13.9262 3.66865 13.9262 3.66865C13.9262 3.66865 13.9262 3.66865 13.9263 3.66865C13.9263 3.66865 13.9263 3.66865 13.9263 3.66865C13.9263 3.66865 13.9263 3.66865 13.9263 3.66865C13.9264 3.66865 13.9264 3.66865 13.9264 3.66865C13.9264 3.66865 13.9264 3.66865 13.9264 3.66865C13.9264 3.66865 13.9265 3.66865 13.9265 3.66865C13.9265 3.66865 13.9265 3.66865 13.9265 3.66865C13.9265 3.66865 13.9265 3.66865 13.9266 3.66865C13.9266 3.66865 13.9266 3.66865 13.9266 3.66865C13.9266 3.66865 13.9266 3.66865 13.9266 3.66865C13.9267 3.66865 13.9267 3.66865 13.9267 3.66865C13.9267 3.66865 13.9267 3.66865 13.9267 3.66865C13.9267 3.66865 13.9268 3.66865 13.9268 3.66865C13.9268 3.66865 13.9268 3.66865 13.9268 3.66865C13.9268 3.66865 13.9269 3.66865 13.9269 3.66865C13.9269 3.66865 13.9269 3.66865 13.9269 3.66865C13.9269 3.66865 13.9269 3.66865 13.927 3.66865C13.927 3.66865 13.927 3.66865 13.927 3.66865C13.927 3.66865 13.927 3.66865 13.927 3.66865C13.9271 3.66865 13.9271 3.66865 13.9271 3.66865C13.9271 3.66865 13.9271 3.66865 13.9271 3.66865C13.9271 3.66865 13.9272 3.66865 13.9272 3.66865C13.9272 3.66865 13.9272 3.66865 13.9272 3.66865C13.9272 3.66865 13.9273 3.66865 13.9273 3.66865C13.9273 3.66865 13.9273 3.66865 13.9273 3.66865C13.9273 3.66865 13.9273 3.66865 13.9274 3.66865C13.9274 3.66865 13.9274 3.66865 13.9274 3.66865C13.9274 3.66865 13.9274 3.66865 13.9274 3.66865C13.9275 3.66865 13.9275 3.66865 13.9275 3.66865C13.9275 3.66865 13.9275 3.66865 13.9275 3.66865C13.9276 3.66865 13.9276 3.66865 13.9276 3.66865C13.9276 3.66865 13.9276 3.66865 13.9276 3.66865C13.9276 3.66865 13.9277 3.66865 13.9277 3.66865C13.9277 3.66865 13.9277 3.66865 13.9277 3.66865C13.9277 3.66865 13.9277 3.66865 13.9278 3.66865C13.9278 3.66865 13.9278 3.66865 13.9278 3.66865C13.9278 3.66865 13.9278 3.66865 13.9279 3.66865C13.9279 3.66865 13.9279 3.66865 13.9279 3.66865C13.9279 3.66865 13.9279 3.66865 13.9279 3.66865C13.928 3.66865 13.928 3.66865 13.928 3.66865C13.928 3.66865 13.928 3.66865 13.928 3.66865C13.928 3.66865 13.9281 3.66865 13.9281 3.66865C13.9281 3.66865 13.9281 3.66865 13.9281 3.66865C13.9281 3.66865 13.9282 3.66865 13.9282 3.66865C13.9282 3.66865 13.9282 3.66865 13.9282 3.66865C13.9282 3.66865 13.9282 3.66865 13.9283 3.66865C13.9283 3.66865 13.9283 3.66865 13.9283 3.66865C13.9283 3.66865 13.9283 3.66865 13.9283 3.66865C13.9284 3.66865 13.9284 3.66865 13.9284 3.66865C13.9284 3.66865 13.9284 3.66865 13.9284 3.66865C13.9285 3.66865 13.9285 3.66865 13.9285 3.66865C13.9285 3.66865 13.9285 3.66865 13.9285 3.66865C13.9285 3.66865 13.9286 3.66865 13.9286 3.66865C13.9286 3.66865 13.9286 3.66865 13.9286 3.66865C13.9286 3.66865 13.9286 3.66865 13.9287 3.66865C13.9287 3.66865 13.9287 3.66865 13.9287 3.66865C13.9287 3.66865 13.9287 3.66865 13.9287 3.66865C13.9288 3.66865 13.9288 3.66865 13.9288 3.66865C13.9288 3.66865 13.9288 3.66865 13.9288 3.66865C13.9288 3.66865 13.9289 3.66865 13.9289 3.66865C13.9289 3.66865 13.9289 3.66865 13.9289 3.66865C13.9289 3.66865 13.929 3.66865 13.929 3.66865C13.929 3.66865 13.929 3.66865 13.929 3.66865C13.929 3.66865 13.929 3.66865 13.9291 3.66865C13.9291 3.66865 13.9291 3.66865 13.9291 3.66865C13.9291 3.66865 13.9291 3.66865 13.9291 3.66865C13.9292 3.66865 13.9292 3.66865 13.9292 3.66865C13.9292 3.66865 13.9292 3.66865 13.9292 3.66865C13.9292 3.66865 13.9293 3.66865 13.9293 3.66865C13.9293 3.66865 13.9293 3.66865 13.9293 3.66865C13.9293 3.66865 13.9293 3.66865 13.9294 3.66865C13.9294 3.66865 13.9294 3.66865 13.9294 3.66865C13.9294 3.66865 13.9294 3.66865 13.9294 3.66865C13.9295 3.66865 13.9295 3.66865 13.9295 3.66865C13.9295 3.66865 13.9295 3.66865 13.9295 3.66865C13.9295 3.66865 13.9295 3.66865 13.9296 3.66865C13.9296 3.66865 13.9296 3.66865 13.9296 3.66865C13.9296 3.66865 13.9296 3.66865 13.9296 3.66865C13.9297 3.66865 13.9297 3.66865 13.9297 3.66865C13.9297 3.66865 13.9297 3.66865 13.9297 3.66865C13.9297 3.66865 13.9298 3.66865 13.9298 3.66865C13.9298 3.66865 13.9298 3.66865 13.9298 3.66865C13.9298 3.66865 13.9298 3.66865 13.9298 3.66865C13.9299 3.66865 13.9299 3.66865 13.9299 3.66865C13.9299 3.66865 13.9299 3.66865 13.9299 3.66865C13.9299 3.66865 13.93 3.66865 13.93 3.66865C13.93 3.66865 13.93 3.66865 13.93 3.66865C13.93 3.66865 13.93 3.66865 13.93 3.66865C13.9301 3.66865 13.9301 3.66865 13.9301 3.66865C13.9301 3.66865 13.9301 3.66865 13.9301 3.66865C13.9301 3.66865 13.9302 3.66865 13.9302 3.66865C13.9302 3.66865 13.9302 3.66865 13.9302 3.66865C13.9302 3.66865 13.9302 3.66865 13.9302 3.66865C13.9303 3.66865 13.9303 3.66865 13.9303 3.66865C13.9303 3.66865 13.9303 3.66865 13.9303 3.66865C13.9303 3.66865 13.9303 3.66865 13.9304 3.66865C13.9304 3.66865 13.9304 3.66865 13.9304 3.66865C13.9304 3.66865 13.9304 3.66865 13.9304 3.66865C13.9304 3.66865 13.9305 3.66865 13.9305 3.66865C13.9305 3.66865 13.9305 3.66865 13.9305 3.66865C13.9305 3.66865 13.9305 3.66865 13.9305 3.66865C13.9305 3.66865 13.9306 3.66865 13.9306 3.66865C13.9306 3.66865 13.9306 3.66865 13.9306 3.66865C13.9306 3.66865 13.9306 3.66865 13.9306 3.66865C13.9307 3.66865 13.9307 3.66865 13.9307 3.66865C13.9307 3.66865 13.9307 3.66865 13.9307 3.66865C13.9307 3.66865 13.9307 3.66865 13.9307 3.66865C13.9308 3.66865 13.9308 3.66865 13.9308 3.66865C13.9308 3.66865 13.9308 3.66865 13.9308 3.66865C13.9308 3.66865 13.9308 3.66865 13.9308 3.66865C13.9309 3.66865 13.9309 3.66865 13.9309 3.66865C13.9309 3.66865 13.9309 3.66865 13.9309 3.66865C13.9309 3.66865 13.9309 3.66865 13.9309 3.66865C13.931 3.66865 13.931 3.66865 13.931 3.66865C13.931 3.66865 13.931 3.66865 13.931 3.66865C13.931 3.66865 13.931 3.66865 13.931 3.66865C13.9311 3.66865 13.9311 3.66865 13.9311 3.66865C13.9311 3.66865 13.9311 3.66865 13.9311 3.66865C13.9311 3.66865 13.9311 3.66865 13.9311 3.66865C13.9311 3.66865 13.9312 3.66865 13.9312 3.66865C13.9312 3.66865 13.9312 3.66865 13.9312 3.66865C13.9312 3.66865 13.9312 3.66865 13.9312 3.66865C13.9312 3.66865 13.9312 3.66865 13.9312 3.66865C13.9313 3.66865 13.9313 3.66865 13.9313 3.66865C13.9313 3.66865 13.9313 3.66865 13.9313 3.66865C13.9313 3.66865 13.9313 3.66865 13.9313 3.66865C13.9313 3.66865 13.9314 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9314 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865H13.9322C13.9322 2.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9313 1.66865 13.9313 1.66865 13.9313 1.66865C13.9313 1.66865 13.9313 1.66865 13.9313 1.66865C13.9313 1.66865 13.9313 1.66865 13.9313 1.66865C13.9312 1.66865 13.9312 1.66865 13.9312 1.66865C13.9312 1.66865 13.9312 1.66865 13.9312 1.66865C13.9312 1.66865 13.9311 1.66865 13.9311 1.66865C13.9311 1.66865 13.9311 1.66865 13.9311 1.66865C13.9311 1.66865 13.9311 1.66865 13.9311 1.66865C13.931 1.66865 13.931 1.66865 13.931 1.66865C13.931 1.66865 13.931 1.66865 13.931 1.66865C13.931 1.66865 13.9309 1.66865 13.9309 1.66865C13.9309 1.66865 13.9309 1.66865 13.9309 1.66865C13.9309 1.66865 13.9309 1.66865 13.9308 1.66865C13.9308 1.66865 13.9308 1.66865 13.9308 1.66865C13.9308 1.66865 13.9308 1.66865 13.9307 1.66865C13.9307 1.66865 13.9307 1.66865 13.9307 1.66865C13.9307 1.66865 13.9307 1.66865 13.9306 1.66865C13.9306 1.66865 13.9306 1.66865 13.9306 1.66865C13.9306 1.66865 13.9306 1.66865 13.9305 1.66865C13.9305 1.66865 13.9305 1.66865 13.9305 1.66865C13.9305 1.66865 13.9305 1.66865 13.9304 1.66865C13.9304 1.66865 13.9304 1.66865 13.9304 1.66865C13.9304 1.66865 13.9304 1.66865 13.9303 1.66865C13.9303 1.66865 13.9303 1.66865 13.9303 1.66865C13.9303 1.66865 13.9302 1.66865 13.9302 1.66865C13.9302 1.66865 13.9302 1.66865 13.9302 1.66865C13.9301 1.66865 13.9301 1.66865 13.9301 1.66865C13.9301 1.66865 13.9301 1.66865 13.93 1.66865C13.93 1.66865 13.93 1.66865 13.93 1.66865C13.93 1.66865 13.9299 1.66865 13.9299 1.66865C13.9299 1.66865 13.9299 1.66865 13.9299 1.66865C13.9298 1.66865 13.9298 1.66865 13.9298 1.66865C13.9298 1.66865 13.9298 1.66865 13.9297 1.66865C13.9297 1.66865 13.9297 1.66865 13.9297 1.66865C13.9297 1.66865 13.9296 1.66865 13.9296 1.66865C13.9296 1.66865 13.9296 1.66865 13.9295 1.66865C13.9295 1.66865 13.9295 1.66865 13.9295 1.66865C13.9295 1.66865 13.9294 1.66865 13.9294 1.66865C13.9294 1.66865 13.9294 1.66865 13.9293 1.66865C13.9293 1.66865 13.9293 1.66865 13.9293 1.66865C13.9292 1.66865 13.9292 1.66865 13.9292 1.66865C13.9292 1.66865 13.9292 1.66865 13.9291 1.66865C13.9291 1.66865 13.9291 1.66865 13.9291 1.66865C13.929 1.66865 13.929 1.66865 13.929 1.66865C13.929 1.66865 13.9289 1.66865 13.9289 1.66865C13.9289 1.66865 13.9289 1.66865 13.9288 1.66865C13.9288 1.66865 13.9288 1.66865 13.9288 1.66865C13.9287 1.66865 13.9287 1.66865 13.9287 1.66865C13.9286 1.66865 13.9286 1.66865 13.9286 1.66865C13.9286 1.66865 13.9285 1.66865 13.9285 1.66865C13.9285 1.66865 13.9285 1.66865 13.9284 1.66865C13.9284 1.66865 13.9284 1.66865 13.9284 1.66865C13.9283 1.66865 13.9283 1.66865 13.9283 1.66865C13.9282 1.66865 13.9282 1.66865 13.9282 1.66865C13.9282 1.66865 13.9281 1.66865 13.9281 1.66865C13.9281 1.66865 13.928 1.66865 13.928 1.66865C13.928 1.66865 13.928 1.66865 13.9279 1.66865C13.9279 1.66865 13.9279 1.66865 13.9278 1.66865C13.9278 1.66865 13.9278 1.66865 13.9277 1.66865V3.66865C13.9278 3.66865 13.9278 3.66865 13.9278 3.66865C13.9279 3.66865 13.9279 3.66865 13.9279 3.66865C13.928 3.66865 13.928 3.66865 13.928 3.66865C13.928 3.66865 13.9281 3.66865 13.9281 3.66865C13.9281 3.66865 13.9282 3.66865 13.9282 3.66865C13.9282 3.66865 13.9282 3.66865 13.9283 3.66865C13.9283 3.66865 13.9283 3.66865 13.9284 3.66865C13.9284 3.66865 13.9284 3.66865 13.9284 3.66865C13.9285 3.66865 13.9285 3.66865 13.9285 3.66865C13.9285 3.66865 13.9286 3.66865 13.9286 3.66865C13.9286 3.66865 13.9286 3.66865 13.9287 3.66865C13.9287 3.66865 13.9287 3.66865 13.9288 3.66865C13.9288 3.66865 13.9288 3.66865 13.9288 3.66865C13.9289 3.66865 13.9289 3.66865 13.9289 3.66865C13.9289 3.66865 13.929 3.66865 13.929 3.66865C13.929 3.66865 13.929 3.66865 13.9291 3.66865C13.9291 3.66865 13.9291 3.66865 13.9291 3.66865C13.9292 3.66865 13.9292 3.66865 13.9292 3.66865C13.9292 3.66865 13.9292 3.66865 13.9293 3.66865C13.9293 3.66865 13.9293 3.66865 13.9293 3.66865C13.9294 3.66865 13.9294 3.66865 13.9294 3.66865C13.9294 3.66865 13.9295 3.66865 13.9295 3.66865C13.9295 3.66865 13.9295 3.66865 13.9295 3.66865C13.9296 3.66865 13.9296 3.66865 13.9296 3.66865C13.9296 3.66865 13.9297 3.66865 13.9297 3.66865C13.9297 3.66865 13.9297 3.66865 13.9297 3.66865C13.9298 3.66865 13.9298 3.66865 13.9298 3.66865C13.9298 3.66865 13.9298 3.66865 13.9299 3.66865C13.9299 3.66865 13.9299 3.66865 13.9299 3.66865C13.9299 3.66865 13.93 3.66865 13.93 3.66865C13.93 3.66865 13.93 3.66865 13.93 3.66865C13.9301 3.66865 13.9301 3.66865 13.9301 3.66865C13.9301 3.66865 13.9301 3.66865 13.9302 3.66865C13.9302 3.66865 13.9302 3.66865 13.9302 3.66865C13.9302 3.66865 13.9303 3.66865 13.9303 3.66865C13.9303 3.66865 13.9303 3.66865 13.9303 3.66865C13.9304 3.66865 13.9304 3.66865 13.9304 3.66865C13.9304 3.66865 13.9304 3.66865 13.9304 3.66865C13.9305 3.66865 13.9305 3.66865 13.9305 3.66865C13.9305 3.66865 13.9305 3.66865 13.9305 3.66865C13.9306 3.66865 13.9306 3.66865 13.9306 3.66865C13.9306 3.66865 13.9306 3.66865 13.9306 3.66865C13.9307 3.66865 13.9307 3.66865 13.9307 3.66865C13.9307 3.66865 13.9307 3.66865 13.9307 3.66865C13.9308 3.66865 13.9308 3.66865 13.9308 3.66865C13.9308 3.66865 13.9308 3.66865 13.9308 3.66865C13.9309 3.66865 13.9309 3.66865 13.9309 3.66865C13.9309 3.66865 13.9309 3.66865 13.9309 3.66865C13.9309 3.66865 13.931 3.66865 13.931 3.66865C13.931 3.66865 13.931 3.66865 13.931 3.66865C13.931 3.66865 13.931 3.66865 13.9311 3.66865C13.9311 3.66865 13.9311 3.66865 13.9311 3.66865C13.9311 3.66865 13.9311 3.66865 13.9311 3.66865C13.9311 3.66865 13.9312 3.66865 13.9312 3.66865C13.9312 3.66865 13.9312 3.66865 13.9312 3.66865C13.9312 3.66865 13.9312 3.66865 13.9313 3.66865C13.9313 3.66865 13.9313 3.66865 13.9313 3.66865C13.9313 3.66865 13.9313 3.66865 13.9313 3.66865C13.9313 3.66865 13.9313 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9314 3.66865C13.9314 3.66865 13.9314 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9315 3.66865C13.9315 3.66865 13.9315 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9316 3.66865 13.9316 3.66865C13.9316 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9317 3.66865 13.9317 3.66865 13.9317 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9318 3.66865 13.9318 3.66865C13.9318 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.9319 3.66865C13.9319 3.66865 13.9319 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.932 3.66865 13.932 3.66865C13.932 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9321 3.66865C13.9321 3.66865 13.9321 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 3.66865 13.9322 3.66865C13.9322 3.66865 13.9322 2.66865 13.9322 1.66865H13.9322C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9322 1.66865 13.9322 1.66865C13.9322 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.9321 1.66865 13.9321 1.66865C13.9321 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.932 1.66865C13.932 1.66865 13.932 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9319 1.66865C13.9319 1.66865 13.9319 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9318 1.66865C13.9318 1.66865 13.9318 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9317 1.66865 13.9317 1.66865C13.9317 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9316 1.66865C13.9316 1.66865 13.9316 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9315 1.66865C13.9315 1.66865 13.9315 1.66865 13.9314 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9314 1.66865 13.9314 1.66865 13.9314 1.66865C13.9314 1.66865 13.9313 1.66865 13.9313 1.66865C13.9313 1.66865 13.9313 1.66865 13.9313 1.66865C13.9313 1.66865 13.9313 1.66865 13.9313 1.66865C13.9313 1.66865 13.9313 1.66865 13.9312 1.66865C13.9312 1.66865 13.9312 1.66865 13.9312 1.66865C13.9312 1.66865 13.9312 1.66865 13.9312 1.66865C13.9312 1.66865 13.9312 1.66865 13.9312 1.66865C13.9312 1.66865 13.9311 1.66865 13.9311 1.66865C13.9311 1.66865 13.9311 1.66865 13.9311 1.66865C13.9311 1.66865 13.9311 1.66865 13.9311 1.66865C13.9311 1.66865 13.9311 1.66865 13.931 1.66865C13.931 1.66865 13.931 1.66865 13.931 1.66865C13.931 1.66865 13.931 1.66865 13.931 1.66865C13.931 1.66865 13.931 1.66865 13.9309 1.66865C13.9309 1.66865 13.9309 1.66865 13.9309 1.66865C13.9309 1.66865 13.9309 1.66865 13.9309 1.66865C13.9309 1.66865 13.9309 1.66865 13.9308 1.66865C13.9308 1.66865 13.9308 1.66865 13.9308 1.66865C13.9308 1.66865 13.9308 1.66865 13.9308 1.66865C13.9308 1.66865 13.9308 1.66865 13.9307 1.66865C13.9307 1.66865 13.9307 1.66865 13.9307 1.66865C13.9307 1.66865 13.9307 1.66865 13.9307 1.66865C13.9307 1.66865 13.9307 1.66865 13.9306 1.66865C13.9306 1.66865 13.9306 1.66865 13.9306 1.66865C13.9306 1.66865 13.9306 1.66865 13.9306 1.66865C13.9306 1.66865 13.9305 1.66865 13.9305 1.66865C13.9305 1.66865 13.9305 1.66865 13.9305 1.66865C13.9305 1.66865 13.9305 1.66865 13.9305 1.66865C13.9305 1.66865 13.9304 1.66865 13.9304 1.66865C13.9304 1.66865 13.9304 1.66865 13.9304 1.66865C13.9304 1.66865 13.9304 1.66865 13.9304 1.66865C13.9303 1.66865 13.9303 1.66865 13.9303 1.66865C13.9303 1.66865 13.9303 1.66865 13.9303 1.66865C13.9303 1.66865 13.9303 1.66865 13.9302 1.66865C13.9302 1.66865 13.9302 1.66865 13.9302 1.66865C13.9302 1.66865 13.9302 1.66865 13.9302 1.66865C13.9302 1.66865 13.9301 1.66865 13.9301 1.66865C13.9301 1.66865 13.9301 1.66865 13.9301 1.66865C13.9301 1.66865 13.9301 1.66865 13.93 1.66865C13.93 1.66865 13.93 1.66865 13.93 1.66865C13.93 1.66865 13.93 1.66865 13.93 1.66865C13.93 1.66865 13.9299 1.66865 13.9299 1.66865C13.9299 1.66865 13.9299 1.66865 13.9299 1.66865C13.9299 1.66865 13.9299 1.66865 13.9298 1.66865C13.9298 1.66865 13.9298 1.66865 13.9298 1.66865C13.9298 1.66865 13.9298 1.66865 13.9298 1.66865C13.9298 1.66865 13.9297 1.66865 13.9297 1.66865C13.9297 1.66865 13.9297 1.66865 13.9297 1.66865C13.9297 1.66865 13.9297 1.66865 13.9296 1.66865C13.9296 1.66865 13.9296 1.66865 13.9296 1.66865C13.9296 1.66865 13.9296 1.66865 13.9296 1.66865C13.9295 1.66865 13.9295 1.66865 13.9295 1.66865C13.9295 1.66865 13.9295 1.66865 13.9295 1.66865C13.9295 1.66865 13.9295 1.66865 13.9294 1.66865C13.9294 1.66865 13.9294 1.66865 13.9294 1.66865C13.9294 1.66865 13.9294 1.66865 13.9294 1.66865C13.9293 1.66865 13.9293 1.66865 13.9293 1.66865C13.9293 1.66865 13.9293 1.66865 13.9293 1.66865C13.9293 1.66865 13.9292 1.66865 13.9292 1.66865C13.9292 1.66865 13.9292 1.66865 13.9292 1.66865C13.9292 1.66865 13.9292 1.66865 13.9291 1.66865C13.9291 1.66865 13.9291 1.66865 13.9291 1.66865C13.9291 1.66865 13.9291 1.66865 13.9291 1.66865C13.929 1.66865 13.929 1.66865 13.929 1.66865C13.929 1.66865 13.929 1.66865 13.929 1.66865C13.929 1.66865 13.9289 1.66865 13.9289 1.66865C13.9289 1.66865 13.9289 1.66865 13.9289 1.66865C13.9289 1.66865 13.9288 1.66865 13.9288 1.66865C13.9288 1.66865 13.9288 1.66865 13.9288 1.66865C13.9288 1.66865 13.9288 1.66865 13.9287 1.66865C13.9287 1.66865 13.9287 1.66865 13.9287 1.66865C13.9287 1.66865 13.9287 1.66865 13.9287 1.66865C13.9286 1.66865 13.9286 1.66865 13.9286 1.66865C13.9286 1.66865 13.9286 1.66865 13.9286 1.66865C13.9286 1.66865 13.9285 1.66865 13.9285 1.66865C13.9285 1.66865 13.9285 1.66865 13.9285 1.66865C13.9285 1.66865 13.9285 1.66865 13.9284 1.66865C13.9284 1.66865 13.9284 1.66865 13.9284 1.66865C13.9284 1.66865 13.9284 1.66865 13.9283 1.66865C13.9283 1.66865 13.9283 1.66865 13.9283 1.66865C13.9283 1.66865 13.9283 1.66865 13.9283 1.66865C13.9282 1.66865 13.9282 1.66865 13.9282 1.66865C13.9282 1.66865 13.9282 1.66865 13.9282 1.66865C13.9282 1.66865 13.9281 1.66865 13.9281 1.66865C13.9281 1.66865 13.9281 1.66865 13.9281 1.66865C13.9281 1.66865 13.928 1.66865 13.928 1.66865C13.928 1.66865 13.928 1.66865 13.928 1.66865C13.928 1.66865 13.928 1.66865 13.9279 1.66865C13.9279 1.66865 13.9279 1.66865 13.9279 1.66865C13.9279 1.66865 13.9279 1.66865 13.9279 1.66865C13.9278 1.66865 13.9278 1.66865 13.9278 1.66865C13.9278 1.66865 13.9278 1.66865 13.9278 1.66865C13.9277 1.66865 13.9277 1.66865 13.9277 1.66865C13.9277 1.66865 13.9277 1.66865 13.9277 1.66865C13.9277 1.66865 13.9276 1.66865 13.9276 1.66865C13.9276 1.66865 13.9276 1.66865 13.9276 1.66865C13.9276 1.66865 13.9276 1.66865 13.9275 1.66865C13.9275 1.66865 13.9275 1.66865 13.9275 1.66865C13.9275 1.66865 13.9275 1.66865 13.9274 1.66865C13.9274 1.66865 13.9274 1.66865 13.9274 1.66865C13.9274 1.66865 13.9274 1.66865 13.9274 1.66865C13.9273 1.66865 13.9273 1.66865 13.9273 1.66865C13.9273 1.66865 13.9273 1.66865 13.9273 1.66865C13.9273 1.66865 13.9272 1.66865 13.9272 1.66865C13.9272 1.66865 13.9272 1.66865 13.9272 1.66865C13.9272 1.66865 13.9271 1.66865 13.9271 1.66865C13.9271 1.66865 13.9271 1.66865 13.9271 1.66865C13.9271 1.66865 13.9271 1.66865 13.927 1.66865C13.927 1.66865 13.927 1.66865 13.927 1.66865C13.927 1.66865 13.927 1.66865 13.927 1.66865C13.9269 1.66865 13.9269 1.66865 13.9269 1.66865C13.9269 1.66865 13.9269 1.66865 13.9269 1.66865C13.9269 1.66865 13.9268 1.66865 13.9268 1.66865C13.9268 1.66865 13.9268 1.66865 13.9268 1.66865C13.9268 1.66865 13.9267 1.66865 13.9267 1.66865C13.9267 1.66865 13.9267 1.66865 13.9267 1.66865C13.9267 1.66865 13.9267 1.66865 13.9266 1.66865C13.9266 1.66865 13.9266 1.66865 13.9266 1.66865C13.9266 1.66865 13.9266 1.66865 13.9266 1.66865C13.9265 1.66865 13.9265 1.66865 13.9265 1.66865C13.9265 1.66865 13.9265 1.66865 13.9265 1.66865C13.9265 1.66865 13.9264 1.66865 13.9264 1.66865C13.9264 1.66865 13.9264 1.66865 13.9264 1.66865C13.9264 1.66865 13.9264 1.66865 13.9263 1.66865C13.9263 1.66865 13.9263 1.66865 13.9263 1.66865C13.9263 1.66865 13.9263 1.66865 13.9263 1.66865C13.9262 1.66865 13.9262 1.66865 13.9262 1.66865C13.9262 1.66865 13.9262 1.66865 13.9262 1.66865C13.9262 1.66865 13.9261 1.66865 13.9261 1.66865C13.9261 1.66865 13.9261 1.66865 13.9261 1.66865C13.9261 1.66865 13.9261 1.66865 13.926 1.66865C13.926 1.66865 13.926 1.66865 13.926 1.66865C13.926 1.66865 13.926 1.66865 13.926 1.66865C13.9259 1.66865 13.9259 1.66865 13.9259 1.66865C13.9259 1.66865 13.9259 1.66865 13.9259 1.66865C13.9259 1.66865 13.9258 1.66865 13.9258 1.66865C13.9258 1.66865 13.9258 1.66865 13.9258 1.66865C13.9258 1.66865 13.9258 1.66865 13.9258 1.66865C13.9257 1.66865 13.9257 1.66865 13.9257 1.66865C13.9257 1.66865 13.9257 1.66865 13.9257 1.66865C13.9257 1.66865 13.9256 1.66865 13.9256 1.66865C13.9256 1.66865 13.9256 1.66865 13.9256 1.66865C13.9256 1.66865 13.9256 1.66865 13.9256 1.66865C13.9255 1.66865 13.9255 1.66865 13.9255 1.66865C13.9255 1.66865 13.9255 1.66865 13.9255 1.66865C13.9255 1.66865 13.9254 1.66865 13.9254 1.66865C13.9254 1.66865 13.9254 1.66865 13.9254 1.66865C13.9254 1.66865 13.9254 1.66865 13.9254 1.66865C13.9253 1.66865 13.9253 1.66865 13.9253 1.66865C13.9253 1.66865 13.9253 1.66865 13.9253 1.66865C13.9253 1.66865 13.9253 1.66865 13.9252 1.66865C13.9252 1.66865 13.9252 1.66865 13.9252 1.66865C13.9252 1.66865 13.9252 1.66865 13.9252 1.66865C13.9251 1.66865 13.9251 1.66865 13.9251 1.66865C13.9251 1.66865 13.9251 1.66865 13.9251 1.66865C13.9251 1.66865 13.9251 1.66865 13.9251 1.66865C13.925 1.66865 13.925 1.66865 13.925 1.66865C13.925 1.66865 13.925 1.66865 13.925 1.66865C13.925 1.66865 13.925 1.66865 13.9249 1.66865C13.9249 1.66865 13.9249 1.66865 13.9249 1.66865C13.9249 1.66865 13.9249 1.66865 13.9249 1.66865C13.9249 1.66865 13.9248 1.66865 13.9248 1.66865C13.9248 1.66865 13.9248 1.66865 13.9248 1.66865C13.9248 1.66865 13.9248 1.66865 13.9248 1.66865C13.9248 1.66865 13.9247 1.66865 13.9247 1.66865C13.9247 1.66865 13.9247 1.66865 13.9247 1.66865C13.9247 1.66865 13.9247 1.66865 13.9247 1.66865C13.9247 1.66865 13.9246 1.66865 13.9246 1.66865C13.9246 1.66865 13.9246 1.66865 13.9246 1.66865C13.9246 1.66865 13.9246 1.66865 13.9246 1.66865C13.9246 1.66865 13.9245 1.66865 13.9245 1.66865C13.9245 1.66865 13.9245 1.66865 13.9245 1.66865C13.9245 1.66865 13.9245 1.66865 13.9245 1.66865C13.9245 1.66865 13.9244 1.66865 13.9244 1.66865C13.9244 1.66865 13.9244 1.66865 13.9244 1.66865C13.9244 1.66865 13.9244 1.66865 13.9244 1.66865C13.9244 1.66865 13.9244 1.66865 13.9243 1.66865C13.9243 1.66865 13.9243 1.66865 13.9243 1.66865C13.9243 1.66865 13.9243 1.66865 13.9243 1.66865C13.9243 1.66865 13.9243 1.66865 13.9243 1.66865C13.9242 1.66865 13.9242 1.66865 13.9242 1.66865C13.9242 1.66865 13.9242 1.66865 13.9242 1.66865C13.9242 1.66865 13.9242 1.66865 13.9242 1.66865C13.9242 1.66865 13.9241 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.9241 1.66865C13.9241 1.66865 13.9241 1.66865 13.9241 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.924 1.66865 13.924 1.66865 13.924 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9239 1.66865 13.9239 1.66865 13.9239 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9238 1.66865 13.9238 1.66865C13.9238 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9237 1.66865 13.9237 1.66865C13.9237 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9236 1.66865 13.9236 1.66865 13.9236 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9235 1.66865 13.9235 1.66865C13.9235 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9234 1.66865C13.9234 1.66865 13.9234 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865H13.9233C13.9233 1.66865 13.9233 1.66865 13.9233 1.66865C13.9233 1.66865 13.9233 2.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9233 3.66865C13.9233 3.66865 13.9233 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9234 3.66865 13.9234 3.66865 13.9234 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9235 3.66865 13.9235 3.66865 13.9235 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9236 3.66865C13.9236 3.66865 13.9236 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9237 3.66865 13.9237 3.66865 13.9237 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9238 3.66865C13.9238 3.66865 13.9238 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.9239 3.66865 13.9239 3.66865 13.9239 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.924 3.66865 13.924 3.66865 13.924 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9241 3.66865 13.9241 3.66865 13.9241 3.66865C13.9242 3.66865 13.9242 3.66865 13.9242 3.66865C13.9242 3.66865 13.9242 3.66865 13.9242 3.66865C13.9242 3.66865 13.9242 3.66865 13.9243 3.66865C13.9243 3.66865 13.9243 3.66865 13.9243 3.66865C13.9243 3.66865 13.9243 3.66865 13.9243 3.66865C13.9244 3.66865 13.9244 3.66865 13.9244 3.66865C13.9244 3.66865 13.9244 3.66865 13.9244 3.66865C13.9244 3.66865 13.9244 3.66865 13.9245 3.66865C13.9245 3.66865 13.9245 3.66865 13.9245 3.66865C13.9245 3.66865 13.9245 3.66865 13.9246 3.66865C13.9246 3.66865 13.9246 3.66865 13.9246 3.66865C13.9246 3.66865 13.9246 3.66865 13.9246 3.66865C13.9247 3.66865 13.9247 3.66865 13.9247 3.66865C13.9247 3.66865 13.9247 3.66865 13.9247 3.66865C13.9248 3.66865 13.9248 3.66865 13.9248 3.66865C13.9248 3.66865 13.9248 3.66865 13.9248 3.66865C13.9248 3.66865 13.9249 3.66865 13.9249 3.66865C13.9249 3.66865 13.9249 3.66865 13.9249 3.66865C13.9249 3.66865 13.925 3.66865 13.925 3.66865C13.925 3.66865 13.925 3.66865 13.925 3.66865C13.9251 3.66865 13.9251 3.66865 13.9251 3.66865C13.9251 3.66865 13.9251 3.66865 13.9251 3.66865C13.9252 3.66865 13.9252 3.66865 13.9252 3.66865C13.9252 3.66865 13.9252 3.66865 13.9253 3.66865C13.9253 3.66865 13.9253 3.66865 13.9253 3.66865C13.9253 3.66865 13.9254 3.66865 13.9254 3.66865C13.9254 3.66865 13.9254 3.66865 13.9254 3.66865C13.9255 3.66865 13.9255 3.66865 13.9255 3.66865C13.9255 3.66865 13.9255 3.66865 13.9256 3.66865C13.9256 3.66865 13.9256 3.66865 13.9256 3.66865C13.9256 3.66865 13.9257 3.66865 13.9257 3.66865C13.9257 3.66865 13.9257 3.66865 13.9257 3.66865C13.9258 3.66865 13.9258 3.66865 13.9258 3.66865C13.9258 3.66865 13.9259 3.66865 13.9259 3.66865C13.9259 3.66865 13.9259 3.66865 13.9259 3.66865C13.926 3.66865 13.926 3.66865 13.926 3.66865C13.926 3.66865 13.9261 3.66865 13.9261 3.66865C13.9261 3.66865 13.9261 3.66865 13.9261 3.66865C13.9262 3.66865 13.9262 3.66865 13.9262 3.66865C13.9262 3.66865 13.9263 3.66865 13.9263 3.66865C13.9263 3.66865 13.9263 3.66865 13.9264 3.66865C13.9264 3.66865 13.9264 3.66865 13.9264 3.66865C13.9265 3.66865 13.9265 3.66865 13.9265 3.66865C13.9265 3.66865 13.9266 3.66865 13.9266 3.66865C13.9266 3.66865 13.9266 3.66865 13.9267 3.66865C13.9267 3.66865 13.9267 3.66865 13.9267 3.66865C13.9268 3.66865 13.9268 3.66865 13.9268 3.66865C13.9268 3.66865 13.9269 3.66865 13.9269 3.66865C13.9269 3.66865 13.9269 3.66865 13.927 3.66865C13.927 3.66865 13.927 3.66865 13.9271 3.66865C13.9271 3.66865 13.9271 3.66865 13.9271 3.66865C13.9272 3.66865 13.9272 3.66865 13.9272 3.66865C13.9273 3.66865 13.9273 3.66865 13.9273 3.66865C13.9273 3.66865 13.9274 3.66865 13.9274 3.66865C13.9274 3.66865 13.9275 3.66865 13.9275 3.66865C13.9275 3.66865 13.9275 3.66865 13.9276 3.66865C13.9276 3.66865 13.9276 3.66865 13.9277 3.66865C13.9277 3.66865 13.9277 3.66865 13.9277 3.66865V1.66865ZM14.9277 2.66865C14.9277 2.80184 14.8887 3.29785 14.3852 3.55632C13.9119 3.79937 13.4785 3.59699 13.2796 3.42673C13.1645 3.32824 13.0312 3.16742 12.9667 2.93551C12.8946 2.67645 12.923 2.36229 13.1112 2.09391C13.2797 1.85365 13.5023 1.75489 13.6264 1.71544C13.756 1.67425 13.8657 1.66865 13.9277 1.66865V3.66865C13.9911 3.66865 14.1019 3.6629 14.2322 3.62148C14.357 3.5818 14.5801 3.48272 14.7488 3.24211C14.9372 2.97338 14.9657 2.65883 14.8935 2.39939C14.8289 2.1671 14.6953 2.00593 14.5799 1.90715C14.3803 1.73632 13.9459 1.53366 13.4717 1.77713C12.9675 2.03603 12.9277 2.53318 12.9277 2.66865H14.9277ZM18.7271 6.94256C17.3679 5.53759 15.9195 4.13866 14.796 2.17251L13.0595 3.16479C14.3345 5.396 15.9895 6.98925 17.2897 8.33317L18.7271 6.94256ZM19.155 7.38527C19.0146 7.2392 18.8655 7.08562 18.7271 6.94258L17.2897 8.33315C17.4315 8.47974 17.5757 8.62829 17.7133 8.7714L19.155 7.38527ZM22.6632 12.1353C21.7575 10.1293 20.4428 8.72477 19.155 7.38527L17.7133 8.7714C19.0008 10.1107 20.0908 11.298 20.8404 12.9583L22.6632 12.1353ZM23.0132 12.9105L22.6632 12.1353L20.8404 12.9583L21.1903 13.7334L23.0132 12.9105ZM28.0506 12.3219H22.1018V14.3219H28.0506V12.3219ZM22.0612 27.669L28.0677 27.6543L28.0628 25.6543L22.0563 25.669L22.0612 27.669ZM11.7395 29.3328L22.2168 27.6564L21.9008 25.6815L11.4235 27.3579L11.7395 29.3328ZM21.1018 13.3187L21.0588 26.6657L23.0588 26.6722L23.1018 13.3252L21.1018 13.3187Z' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Trashcan = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M13.3135 6.66663L5.3335 6.70663L26.6668 6.66663H18.6868M13.3135 6.66663V2.68663L18.6668 2.66663L18.6868 6.66663M13.3135 6.66663H18.6868M6.68683 26.6866C6.68683 28.1483 7.87178 29.3333 9.3335 29.3333M6.68683 26.6866C6.68683 28.1704 7.84969 29.3333 9.3335 29.3333M6.68683 26.6866V10.7066H25.3135V26.6866M9.3335 29.3333H22.6668M22.6668 29.3333C24.1285 29.3333 25.3135 28.1483 25.3135 26.6866M22.6668 29.3333C24.1506 29.3333 25.3135 28.1704 25.3135 26.6866M13.3363 16.0001L13.3535 24.02M18.6701 16.0001L18.6868 24.02', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Upload = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.0086 2.66675L9.33774 9.32772M16.0086 2.66675L22.6756 9.31828L23.5765 10.2291M16.0086 2.66675L16.0086 21.3333M2.6665 21.3267L2.67075 26.6711M2.67075 26.6711C2.67075 28.1415 3.86208 29.3334 5.33166 29.3334M2.67075 26.6711C2.67075 28.1488 3.85472 29.3334 5.33166 29.3334M5.33166 29.3334H26.6723M26.6723 29.3334C28.1418 29.3334 29.3332 28.1415 29.3332 26.6711M26.6723 29.3334C28.1492 29.3334 29.3332 28.1488 29.3332 26.6711M29.3332 26.6711V21.3333', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var User = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M16.0002 14.6667C19.6821 14.6667 22.6668 11.6819 22.6668 8.00004C22.6668 4.31814 19.6821 1.33337 16.0002 1.33337C12.3183 1.33337 9.3335 4.31814 9.3335 8.00004C9.3335 11.6819 12.3183 14.6667 16.0002 14.6667Z', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' }),
        React.createElement("path", { d: 'M28 30.6666C28 24.0392 22.6274 18.6666 16 18.6666C9.37258 18.6666 4 24.0392 4 30.6666', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var Users = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("g", { clipPath: 'url(#clip0_22448_57590)' },
            React.createElement("path", { d: 'M20.1265 27.192C21.406 27.5635 22.7317 27.7514 24.064 27.75C26.2066 27.7531 28.3214 27.2646 30.2455 26.322C30.3024 24.9776 29.9194 23.6512 29.1547 22.544C28.3899 21.4368 27.2851 20.609 26.0076 20.1863C24.73 19.7635 23.3495 19.7687 22.0752 20.2011C20.801 20.6335 19.7024 21.4695 18.946 22.5825M20.1265 27.192V27.1875C20.1265 25.518 19.699 23.9475 18.9475 22.5825M20.1265 27.192V27.351C17.2397 29.0896 13.9324 30.0057 10.5625 30C7.066 30 3.7945 29.0325 1.0015 27.351L1 27.1875C0.99885 25.0642 1.70442 23.0009 3.00548 21.3229C4.30653 19.6449 6.12906 18.4476 8.18573 17.9199C10.2424 17.3921 12.4162 17.5639 14.3645 18.4081C16.3128 19.2523 17.9246 20.721 18.946 22.5825M15.6265 8.0625C15.6265 9.40516 15.0931 10.6928 14.1437 11.6422C13.1943 12.5916 11.9067 13.125 10.564 13.125C9.22134 13.125 7.93367 12.5916 6.98427 11.6422C6.03487 10.6928 5.5015 9.40516 5.5015 8.0625C5.5015 6.71984 6.03487 5.43217 6.98427 4.48277C7.93367 3.53337 9.22134 3 10.564 3C11.9067 3 13.1943 3.53337 14.1437 4.48277C15.0931 5.43217 15.6265 6.71984 15.6265 8.0625V8.0625ZM28.0015 11.4375C28.0015 12.4818 27.5867 13.4833 26.8482 14.2217C26.1098 14.9602 25.1083 15.375 24.064 15.375C23.0197 15.375 22.0182 14.9602 21.2798 14.2217C20.5413 13.4833 20.1265 12.4818 20.1265 11.4375C20.1265 10.3932 20.5413 9.39169 21.2798 8.65327C22.0182 7.91484 23.0197 7.5 24.064 7.5C25.1083 7.5 26.1098 7.91484 26.8482 8.65327C27.5867 9.39169 28.0015 10.3932 28.0015 11.4375V11.4375Z', strokeWidth: '2.25', strokeLinecap: 'round', strokeLinejoin: 'round' })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: 'clip0_22448_57590' },
                React.createElement("rect", { width: '32', height: '32' })))));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ZoomIn = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M23.1887 23.2256L22.2659 23.9813C20.1963 25.6762 17.5534 26.6921 14.6699 26.6921M23.1887 23.2256L23.9646 22.2814C25.6582 20.2101 26.6733 17.5652 26.6733 14.6794M23.1887 23.2256L29.3331 29.3333M14.6699 26.6921C8.04061 26.6921 2.6665 21.3138 2.6665 14.6794M14.6699 26.6921C21.283 26.6921 26.6733 21.2976 26.6733 14.6794M14.6699 26.6921C8.0568 26.6921 2.6665 21.2976 2.6665 14.6794M2.6665 14.6794C2.6665 8.04491 8.04061 2.66663 14.6699 2.66663M2.6665 14.6794C2.6665 8.0611 8.0568 2.66663 14.6699 2.66663M14.6699 2.66663C21.2992 2.66663 26.6733 8.04491 26.6733 14.6794M14.6699 2.66663C21.283 2.66663 26.6733 8.0611 26.6733 14.6794M14.6846 14.6647L14.6552 10.68M14.6846 14.6647H18.6661M14.6846 14.6647V18.6787M14.6846 14.6647L10.6737 14.694', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
var ZoomOut = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: 'M23.1887 23.2256L22.2659 23.9813C20.1963 25.6762 17.5534 26.6921 14.6699 26.6921M23.1887 23.2256L23.9646 22.2814C25.6582 20.2101 26.6733 17.5652 26.6733 14.6794M23.1887 23.2256L29.3331 29.3333M14.6699 26.6921C8.04061 26.6921 2.6665 21.3138 2.6665 14.6794M14.6699 26.6921C21.283 26.6921 26.6733 21.2976 26.6733 14.6794M14.6699 26.6921C8.0568 26.6921 2.6665 21.2976 2.6665 14.6794M2.6665 14.6794C2.6665 8.04491 8.04061 2.66663 14.6699 2.66663M2.6665 14.6794C2.6665 8.0611 8.0568 2.66663 14.6699 2.66663M14.6699 2.66663C21.2992 2.66663 26.6733 8.04491 26.6733 14.6794M14.6699 2.66663C21.283 2.66663 26.6733 8.0611 26.6733 14.6794M18.6661 14.6647H14.6846L10.6737 14.694', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' })));
};

// DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-system-icons'
// ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN]
var _a$4;
var ESystemIconNames;
(function (ESystemIconNames) {
    ESystemIconNames["ACADEMIC_CAP"] = "academic-cap";
    ESystemIconNames["APP_WINDOW"] = "app-window";
    ESystemIconNames["ARROW_DOWN"] = "arrow-down";
    ESystemIconNames["ARROW_LEFT"] = "arrow-left";
    ESystemIconNames["ARROW_RIGHT"] = "arrow-right";
    ESystemIconNames["ARROW_UP"] = "arrow-up";
    ESystemIconNames["CALENDAR"] = "calendar";
    ESystemIconNames["CAPTION"] = "caption";
    ESystemIconNames["CAST"] = "cast";
    ESystemIconNames["CHECK"] = "check";
    ESystemIconNames["CHECKBOX"] = "checkbox";
    ESystemIconNames["CHEVRON_CIRCLE_DOWN"] = "chevron-circle-down";
    ESystemIconNames["CHEVRON_CIRCLE_LEFT"] = "chevron-circle-left";
    ESystemIconNames["CHEVRON_CIRCLE_RIGHT"] = "chevron-circle-right";
    ESystemIconNames["CHEVRON_CIRCLE_UP"] = "chevron-circle-up";
    ESystemIconNames["CHEVRON_DOWN"] = "chevron-down";
    ESystemIconNames["CHEVRON_LEFT"] = "chevron-left";
    ESystemIconNames["CHEVRON_RIGHT"] = "chevron-right";
    ESystemIconNames["CHEVRON_UP"] = "chevron-up";
    ESystemIconNames["CIRCLE_ALERT"] = "circle-alert";
    ESystemIconNames["CIRCLE_CHECK"] = "circle-check";
    ESystemIconNames["CIRCLE_CLOSE"] = "circle-close";
    ESystemIconNames["CIRCLE_INFO"] = "circle-info";
    ESystemIconNames["CIRCLE_QUESTION"] = "circle-question";
    ESystemIconNames["CIRCLE"] = "circle";
    ESystemIconNames["CLOSE"] = "close";
    ESystemIconNames["CLOUD_DOWNLOAD"] = "cloud-download";
    ESystemIconNames["CLOUD_UPLOAD"] = "cloud-upload";
    ESystemIconNames["CLOUD"] = "cloud";
    ESystemIconNames["CODE_BRACKET"] = "code-bracket";
    ESystemIconNames["COPY"] = "copy";
    ESystemIconNames["DOUBLE_CHEVRON_CIRCLE_DOWN"] = "double-chevron-circle-down";
    ESystemIconNames["DOUBLE_CHEVRON_CIRCLE_LEFT"] = "double-chevron-circle-left";
    ESystemIconNames["DOUBLE_CHEVRON_CIRCLE_RIGHT"] = "double-chevron-circle-right";
    ESystemIconNames["DOUBLE_CHEVRON_CIRCLE_UP"] = "double-chevron-circle-up";
    ESystemIconNames["DOUBLE_CHEVRON_DOWN"] = "double-chevron-down";
    ESystemIconNames["DOUBLE_CHEVRON_LEFT"] = "double-chevron-left";
    ESystemIconNames["DOUBLE_CHEVRON_RIGHT"] = "double-chevron-right";
    ESystemIconNames["DOUBLE_CHEVRON_UP"] = "double-chevron-up";
    ESystemIconNames["DOWNLOAD"] = "download";
    ESystemIconNames["EXPAND_ALL"] = "expand-all";
    ESystemIconNames["EXPAND_DIAGONAL"] = "expand-diagonal";
    ESystemIconNames["EXPAND_HORIZONTAL"] = "expand-horizontal";
    ESystemIconNames["EXPAND_VERTICAL"] = "expand-vertical";
    ESystemIconNames["EXTERNAL"] = "external";
    ESystemIconNames["FILTER_HAMBURGER"] = "filter-hamburger";
    ESystemIconNames["FILTER"] = "filter";
    ESystemIconNames["FULL_SCREEN"] = "full-screen";
    ESystemIconNames["HEART"] = "heart";
    ESystemIconNames["LANGUAGE"] = "language";
    ESystemIconNames["LIGHT_BULB"] = "light-bulb";
    ESystemIconNames["LINK"] = "link";
    ESystemIconNames["LOADING_CIRCLE"] = "loading-circle";
    ESystemIconNames["LOCATION"] = "location";
    ESystemIconNames["MEGAPHONE"] = "megaphone";
    ESystemIconNames["MENU_HAMBURGER"] = "menu-hamburger";
    ESystemIconNames["MENU_HORIZONTAL"] = "menu-horizontal";
    ESystemIconNames["MENU_SQUAREDOT"] = "menu-squaredot";
    ESystemIconNames["MENU_VERTICAL"] = "menu-vertical";
    ESystemIconNames["MINIMIZE_FULL_SCREEN"] = "minimize-full-screen";
    ESystemIconNames["MINUS"] = "minus";
    ESystemIconNames["PASSWORD_HIDE"] = "password-hide";
    ESystemIconNames["PASSWORD_VIEW"] = "password-view";
    ESystemIconNames["PLAY"] = "play";
    ESystemIconNames["PLUS"] = "plus";
    ESystemIconNames["PRICE"] = "price";
    ESystemIconNames["REFRESH"] = "refresh";
    ESystemIconNames["RESIZE_INDICATOR"] = "resize-indicator";
    ESystemIconNames["SEARCH"] = "search";
    ESystemIconNames["SHARE_OPTION"] = "share-option";
    ESystemIconNames["SOCIAL_FACEBOOK"] = "social-facebook";
    ESystemIconNames["SOCIAL_GITHUB"] = "social-github";
    ESystemIconNames["SOCIAL_LINKEDIN"] = "social-linkedin";
    ESystemIconNames["SOCIAL_TWITTER"] = "social-twitter";
    ESystemIconNames["STAR"] = "star";
    ESystemIconNames["SUITCASE"] = "suitcase";
    ESystemIconNames["SWAP_COLLIDE_HORIZONTAL"] = "swap-collide-horizontal";
    ESystemIconNames["SWAP_COLLIDE_VERTICAL"] = "swap-collide-vertical";
    ESystemIconNames["SWAP_OPPOSITE_HORIZONTAL"] = "swap-opposite-horizontal";
    ESystemIconNames["SWAP_OPPOSITE_VERTICAL"] = "swap-opposite-vertical";
    ESystemIconNames["THUMBS_DOWN"] = "thumbs-down";
    ESystemIconNames["THUMBS_UP"] = "thumbs-up";
    ESystemIconNames["TRASHCAN"] = "trashcan";
    ESystemIconNames["UPLOAD"] = "upload";
    ESystemIconNames["USER"] = "user";
    ESystemIconNames["USERS"] = "users";
    ESystemIconNames["ZOOM_IN"] = "zoom-in";
    ESystemIconNames["ZOOM_OUT"] = "zoom-out";
    // backwards compatibility
    ESystemIconNames["MEATBALLS"] = "menu-horizontal";
    ESystemIconNames["HAMBURGER"] = "menu-hamburger";
    ESystemIconNames["SHAREOPTION"] = "share-option";
})(ESystemIconNames || (ESystemIconNames = {}));
var IconComponent = (_a$4 = {},
    _a$4[ESystemIconNames.ACADEMIC_CAP] = AcademicCap,
    _a$4[ESystemIconNames.APP_WINDOW] = AppWindow,
    _a$4[ESystemIconNames.ARROW_DOWN] = ArrowDown$1,
    _a$4[ESystemIconNames.ARROW_LEFT] = ArrowLeft$1,
    _a$4[ESystemIconNames.ARROW_RIGHT] = ArrowRight$1,
    _a$4[ESystemIconNames.ARROW_UP] = ArrowUp,
    _a$4[ESystemIconNames.CALENDAR] = Calendar,
    _a$4[ESystemIconNames.CAPTION] = Caption,
    _a$4[ESystemIconNames.CAST] = Cast,
    _a$4[ESystemIconNames.CHECK] = Check,
    _a$4[ESystemIconNames.CHECKBOX] = Checkbox$1,
    _a$4[ESystemIconNames.CHEVRON_CIRCLE_DOWN] = ChevronCircleDown,
    _a$4[ESystemIconNames.CHEVRON_CIRCLE_LEFT] = ChevronCircleLeft,
    _a$4[ESystemIconNames.CHEVRON_CIRCLE_RIGHT] = ChevronCircleRight,
    _a$4[ESystemIconNames.CHEVRON_CIRCLE_UP] = ChevronCircleUp,
    _a$4[ESystemIconNames.CHEVRON_DOWN] = ChevronDown,
    _a$4[ESystemIconNames.CHEVRON_LEFT] = ChevronLeft,
    _a$4[ESystemIconNames.CHEVRON_RIGHT] = ChevronRight,
    _a$4[ESystemIconNames.CHEVRON_UP] = ChevronUp,
    _a$4[ESystemIconNames.CIRCLE_ALERT] = CircleAlert,
    _a$4[ESystemIconNames.CIRCLE_CHECK] = CircleCheck,
    _a$4[ESystemIconNames.CIRCLE_CLOSE] = CircleClose,
    _a$4[ESystemIconNames.CIRCLE_INFO] = CircleInfo,
    _a$4[ESystemIconNames.CIRCLE_QUESTION] = CircleQuestion,
    _a$4[ESystemIconNames.CIRCLE] = Circle,
    _a$4[ESystemIconNames.CLOSE] = Close,
    _a$4[ESystemIconNames.CLOUD_DOWNLOAD] = CloudDownload,
    _a$4[ESystemIconNames.CLOUD_UPLOAD] = CloudUpload,
    _a$4[ESystemIconNames.CLOUD] = Cloud,
    _a$4[ESystemIconNames.CODE_BRACKET] = CodeBracket,
    _a$4[ESystemIconNames.COPY] = Copy,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_CIRCLE_DOWN] = DoubleChevronCircleDown,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_CIRCLE_LEFT] = DoubleChevronCircleLeft,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_CIRCLE_RIGHT] = DoubleChevronCircleRight,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_CIRCLE_UP] = DoubleChevronCircleUp,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_DOWN] = DoubleChevronDown,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_LEFT] = DoubleChevronLeft,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_RIGHT] = DoubleChevronRight,
    _a$4[ESystemIconNames.DOUBLE_CHEVRON_UP] = DoubleChevronUp,
    _a$4[ESystemIconNames.DOWNLOAD] = Download,
    _a$4[ESystemIconNames.EXPAND_ALL] = ExpandAll,
    _a$4[ESystemIconNames.EXPAND_DIAGONAL] = ExpandDiagonal,
    _a$4[ESystemIconNames.EXPAND_HORIZONTAL] = ExpandHorizontal,
    _a$4[ESystemIconNames.EXPAND_VERTICAL] = ExpandVertical,
    _a$4[ESystemIconNames.EXTERNAL] = External,
    _a$4[ESystemIconNames.FILTER_HAMBURGER] = FilterHamburger,
    _a$4[ESystemIconNames.FILTER] = Filter,
    _a$4[ESystemIconNames.FULL_SCREEN] = FullScreen,
    _a$4[ESystemIconNames.HEART] = Heart,
    _a$4[ESystemIconNames.LANGUAGE] = Language,
    _a$4[ESystemIconNames.LIGHT_BULB] = LightBulb,
    _a$4[ESystemIconNames.LINK] = Link$1,
    _a$4[ESystemIconNames.LOADING_CIRCLE] = LoadingCircle,
    _a$4[ESystemIconNames.LOCATION] = Location,
    _a$4[ESystemIconNames.MEGAPHONE] = Megaphone,
    _a$4[ESystemIconNames.MENU_HAMBURGER] = MenuHamburger,
    _a$4[ESystemIconNames.MENU_HORIZONTAL] = MenuHorizontal,
    _a$4[ESystemIconNames.MENU_SQUAREDOT] = MenuSquaredot,
    _a$4[ESystemIconNames.MENU_VERTICAL] = MenuVertical,
    _a$4[ESystemIconNames.MINIMIZE_FULL_SCREEN] = MinimizeFullScreen,
    _a$4[ESystemIconNames.MINUS] = Minus,
    _a$4[ESystemIconNames.PASSWORD_HIDE] = PasswordHide,
    _a$4[ESystemIconNames.PASSWORD_VIEW] = PasswordView,
    _a$4[ESystemIconNames.PLAY] = Play,
    _a$4[ESystemIconNames.PLUS] = Plus,
    _a$4[ESystemIconNames.PRICE] = Price,
    _a$4[ESystemIconNames.REFRESH] = Refresh,
    _a$4[ESystemIconNames.RESIZE_INDICATOR] = ResizeIndicator,
    _a$4[ESystemIconNames.SEARCH] = Search,
    _a$4[ESystemIconNames.SHARE_OPTION] = ShareOption,
    _a$4[ESystemIconNames.SOCIAL_FACEBOOK] = SocialFacebook,
    _a$4[ESystemIconNames.SOCIAL_GITHUB] = SocialGithub,
    _a$4[ESystemIconNames.SOCIAL_LINKEDIN] = SocialLinkedin,
    _a$4[ESystemIconNames.SOCIAL_TWITTER] = SocialTwitter,
    _a$4[ESystemIconNames.STAR] = Star,
    _a$4[ESystemIconNames.SUITCASE] = Suitcase,
    _a$4[ESystemIconNames.SWAP_COLLIDE_HORIZONTAL] = SwapCollideHorizontal,
    _a$4[ESystemIconNames.SWAP_COLLIDE_VERTICAL] = SwapCollideVertical,
    _a$4[ESystemIconNames.SWAP_OPPOSITE_HORIZONTAL] = SwapOppositeHorizontal,
    _a$4[ESystemIconNames.SWAP_OPPOSITE_VERTICAL] = SwapOppositeVertical,
    _a$4[ESystemIconNames.THUMBS_DOWN] = ThumbsDown,
    _a$4[ESystemIconNames.THUMBS_UP] = ThumbsUp,
    _a$4[ESystemIconNames.TRASHCAN] = Trashcan,
    _a$4[ESystemIconNames.UPLOAD] = Upload,
    _a$4[ESystemIconNames.USER] = User,
    _a$4[ESystemIconNames.USERS] = Users,
    _a$4[ESystemIconNames.ZOOM_IN] = ZoomIn,
    _a$4[ESystemIconNames.ZOOM_OUT] = ZoomOut,
    // backwards compatibility
    _a$4[ESystemIconNames.MEATBALLS] = MenuHorizontal,
    _a$4[ESystemIconNames.HAMBURGER] = MenuHamburger,
    _a$4[ESystemIconNames.SHAREOPTION] = ShareOption,
    _a$4);

var getViewBox = function (icon) {
    switch (icon) {
        default:
            return '0 0 32 32';
    }
};
var iconIsFilled = function (iconName) {
    switch (iconName) {
        case ESystemIconNames.MINUS:
        case ESystemIconNames.PLUS:
        case ESystemIconNames.LINK:
        case ESystemIconNames.CAST:
        case ESystemIconNames.DOUBLE_CHEVRON_DOWN:
        case ESystemIconNames.DOUBLE_CHEVRON_UP:
        case ESystemIconNames.EXTERNAL:
        case ESystemIconNames.PRICE:
        case ESystemIconNames.SOCIAL_FACEBOOK:
        case ESystemIconNames.SOCIAL_GITHUB:
        case ESystemIconNames.SOCIAL_LINKEDIN:
        case ESystemIconNames.SOCIAL_TWITTER:
        case ESystemIconNames.THUMBS_UP:
        case ESystemIconNames.CALENDAR:
        case ESystemIconNames.LOCATION:
            return true;
        default:
            return false;
    }
};
var getSizeStyles$1 = function (size) {
    switch (size) {
        case 'medium': {
            return {
                width: 'systemIconMedium',
                height: 'systemIconMedium'
            };
        }
        case 'large': {
            return {
                width: 'systemIconLarge',
                height: 'systemIconLarge'
            };
        }
        default: {
            return {
                width: 'systemIconSmall',
                height: 'systemIconSmall'
            };
        }
    }
};
var getColor$4 = function (color, inverse) {
    var Color = {
        warning: 'icon.warning',
        neutral: inverse
            ? 'icon.system.inverseNeutral'
            : 'icon.system.defaultNeutral',
        success: inverse ? 'icon.system.successInverse' : 'icon.system.success',
        error: inverse ? 'icon.errorInverse' : 'icon.error',
        default: inverse ? 'icon.system.inverse' : 'icon.system.default',
        secondaryError: '#EF5752' // missing token
    };
    return Color[color];
};
var getStrokeWeightToken = function (strokeWeight, icon) {
    var filled = iconIsFilled(icon);
    switch (strokeWeight) {
        case 'medium': {
            return filled ? 'systemIconSmall' : 'systemIconMedium';
        }
        case 'large': {
            return filled ? 'systemIconSmall' : 'systemIconLarge';
        }
        default: {
            return filled ? null : 'systemIconSmall';
        }
    }
};

var SystemIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.color, color = _e === void 0 ? 'default' : _e, _f = _a.inverse, inverse = _f === void 0 ? false : _f, _g = _a.strokeWeight, strokeWeight = _g === void 0 ? 'small' : _g, customStyles = _a.customStyles, _h = _a.inheritColor, inheritColor = _h === void 0 ? false : _h, hideTitle = _a.hideTitle, name = _a.name;
    var Icon = IconComponent[name];
    var strokeWeightToken = getStrokeWeightToken(strokeWeight, name);
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var viewBox = getViewBox(name);
    var filled = iconIsFilled(name);
    var iconColor = inheritColor ? 'inherit' : getColor$4(color, inverse);
    return (jsxs("svg", __assign({ className: className, viewBox: viewBox, fill: 'none', xmlns: 'http://www.w3.org/2000/svg', sx: __assign(__assign(__assign({}, getSizeStyles$1(size)), { 
            // The external icon is weird, combines fills with transparent strokes and visible strokes.
            stroke: filled && strokeWeight === 'small' ? 'none' : iconColor, fill: filled ? iconColor : 'none', strokeWidth: get(selectedTheme, "borderWidths." + strokeWeightToken, '1px') }), customStyles) }, { children: [!hideTitle && jsx("title", { children: name }, void 0),
            jsx(Icon, {}, void 0)] }), void 0));
};

var LinkIcon = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    _a.inverse; var linkIcon = _a.linkIcon, _h = _a.linkIconSize, linkIconSize = _h === void 0 ? 'large' : _h, linkIconColor = _a.linkIconColor, arrowOnly = _a.arrowOnly, props = __rest(_a, ["inverse", "linkIcon", "linkIconSize", "linkIconColor", "arrowOnly"]);
    var legacy = props.theme === 'legacy';
    var selectedTheme = legacy ? legacyTheme : defaultTheme;
    var iconStyles = props.iconStyles;
    var Icon;
    switch (linkIcon) {
        case 'arrow':
            Icon = (jsx("span", __assign({ "aria-label": arrowOnly ? 'Arrow' : undefined, "data-testid": 'arrow-container', sx: {
                    display: 'flex',
                    height: '100%',
                    minHeight: arrowOnly ? '48px' : '16px',
                    alignItems: 'center',
                    width: (_b = iconStyles.arrowBody) === null || _b === void 0 ? void 0 : _b.width,
                    transition: "width " + selectedTheme.motion.linkAnimation + " ease"
                } }, { children: jsx("span", __assign({ "data-testid": 'arrow-body', sx: {
                        display: 'flex',
                        height: '2px',
                        position: 'relative',
                        background: linkIconColor,
                        width: '100%',
                        transition: "width " + selectedTheme.motion.linkAnimation + " ease"
                    } }, { children: jsx("span", { "data-testid": 'arrow-head', sx: {
                            border: "2px solid",
                            borderColor: linkIconColor,
                            borderRadius: '2px',
                            width: '12px',
                            position: 'absolute',
                            borderTop: 'none',
                            borderLeft: 'none',
                            height: '12px',
                            transform: 'rotate(-45deg)',
                            right: 0,
                            top: '-5px'
                        } }, void 0) }), void 0) }), void 0));
            break;
        case 'chevron':
            Icon = (jsx("span", __assign({ "aria-label": arrowOnly ? 'Chevron right' : undefined, "data-testid": 'chevron-container', sx: {
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center',
                    width: (_c = iconStyles.chevronBody) === null || _c === void 0 ? void 0 : _c.width,
                    transition: "width " + selectedTheme.motion.linkAnimation + " ease"
                } }, { children: jsx("span", __assign({ "data-testid": 'chevron-body', sx: {
                        display: 'flex',
                        height: '2px',
                        position: 'relative',
                        background: (_d = iconStyles.chevron) === null || _d === void 0 ? void 0 : _d.background,
                        marginTop: '16px',
                        marginBottom: '16px',
                        width: '100%',
                        transition: "width " + selectedTheme.motion.linkAnimation + " ease, background " + selectedTheme.motion.linkAnimation + " ease"
                    } }, { children: jsx("span", { "data-testid": 'chevron-head', sx: {
                            border: "2px solid",
                            borderColor: linkIconColor,
                            borderRadius: '2px',
                            width: (_e = iconStyles.chevron) === null || _e === void 0 ? void 0 : _e.width,
                            height: (_f = iconStyles.chevron) === null || _f === void 0 ? void 0 : _f.height,
                            top: (_g = iconStyles.chevron) === null || _g === void 0 ? void 0 : _g.top,
                            transition: "width " + selectedTheme.motion.linkAnimation + " ease,height " + selectedTheme.motion.linkAnimation + " ease,top " + selectedTheme.motion.linkAnimation + " ease",
                            position: 'absolute',
                            borderTop: 'none',
                            borderLeft: 'none',
                            transform: 'rotate(-45deg)',
                            right: 0
                        } }, void 0) }), void 0) }), void 0));
            break;
        case 'chevron-left':
            Icon = (jsx("span", __assign({ "aria-label": arrowOnly ? 'Chevron left' : undefined, "data-testid": 'chevron-container', sx: {
                    display: 'flex',
                    height: '100%',
                    alignItems: 'center',
                    width: '9px'
                } }, { children: jsx("span", __assign({ "data-testid": 'chevron-body', sx: {
                        display: 'flex',
                        height: '2px',
                        position: 'relative',
                        background: 'transparent',
                        marginTop: 'inc30',
                        marginBottom: 'inc30',
                        width: '100%'
                    } }, { children: jsx("span", { "data-testid": 'chevron-head', sx: {
                            border: "2px solid",
                            borderColor: linkIconColor,
                            borderRadius: '2px',
                            width: '14px',
                            height: '14px',
                            top: '-6px',
                            position: 'absolute',
                            borderTop: 'none',
                            borderLeft: 'none',
                            transform: 'rotate(135deg)',
                            right: '-6px'
                        } }, void 0) }), void 0) }), void 0));
            break;
        default:
            Icon = (jsx("div", __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fill: linkIconColor,
                    stroke: linkIconColor
                } }, { children: jsx(SystemIcon, { size: linkIconSize, name: linkIcon, inheritColor: true }, void 0) }), void 0));
    }
    var isFirst = linkIcon === 'chevron-left';
    return (jsx("div", __assign({ "data-testid": 'link-icon-container', onMouseOver: props.onMouseOver, onMouseLeave: props.onMouseLeave, sx: {
            minWidth: arrowOnly
                ? null
                : linkIcon === 'arrow'
                    ? selectedTheme.sizes.inc50
                    : selectedTheme.sizes.inc40,
            marginLeft: arrowOnly || isFirst ? 0 : 'inc30',
            order: isFirst && -1,
            marginRight: isFirst && 'inc30'
        } }, { children: Icon || null }), void 0));
};

var Text = function (_a) {
    var children = _a.children, href = _a.href, className = _a.className, theme = _a.theme, props = __rest(_a, ["children", "href", "className", "theme"]);
    return (jsx("span", __assign({ className: className, sx: __assign({ display: 'flex', maxWidth: props.textContentMaxWidth, alignItems: 'center' }, getVariantStyles$4(__assign(__assign({}, props), { href: href, theme: theme }))) }, { children: children }), void 0));
};

var LinkContent = function (props) {
    var _a;
    var theme = props.theme, defaultArrow = props.defaultArrow, href = props.href, children = props.children, isNav = props.isNav, arrowOnly = props.arrowOnly, linkIcon = props.linkIcon, linkIconSize = props.linkIconSize, linkIconColor = props.linkIconColor, linkIconDisableExpand = props.linkIconDisableExpand, navItem = props.navItem, navTitle = props.navTitle, customStyles = props.customStyles, inverse = props.inverse;
    var content;
    var textClass = 'textlink-text-class';
    var arrowClass = 'textlink-arrow-class';
    var linkIconClass = 'textlink-link-icon-class';
    var defaultTextClass = 'textlink-default-text-class';
    var legacy = theme === 'legacy';
    var selectedTheme = legacy ? legacyTheme : defaultTheme;
    var arrowBody = {
        width: arrowOnly ? selectedTheme.sizes.inc50 : selectedTheme.sizes.inc30
    };
    var chevronBody = {
        width: '9px'
    };
    var chevron = {
        width: '12px',
        height: '12px',
        background: 'transparent',
        top: '-6px'
    };
    var initialStyles = {
        arrowBody: arrowBody,
        chevronBody: chevronBody,
        chevron: chevron
    };
    var _b = useState(initialStyles), iconStyles = _b[0], setIconStyles = _b[1];
    var iconColor = getIconColor$1(linkIconColor, inverse, selectedTheme);
    var changeIconStyles = function (styles) {
        setIconStyles(styles);
    };
    var resetIconStyles = function () { return setIconStyles(initialStyles); };
    if (defaultArrow) {
        content = (jsxs(Fragment, { children: [jsx(Text, __assign({ className: textClass }, props, { href: href }, { children: children }), void 0), ' ', jsx(Arrow$2, __assign({ className: arrowClass }, props, { isNav: isNav }), void 0)] }, void 0));
    }
    else if (arrowOnly) {
        content = (jsx(Fragment, { children: linkIcon ? (jsx(LinkIcon, __assign({ className: linkIconClass }, props, { linkIcon: linkIcon, linkIconSize: linkIconSize, linkIconColor: iconColor, iconStyles: iconStyles, onMouseOver: function () {
                    return changeIconStyles({
                        arrowBody: { width: selectedTheme.sizes.inc70 },
                        chevronBody: { width: selectedTheme.sizes.inc70 },
                        chevron: {
                            background: iconColor,
                            width: '12px',
                            height: '12px',
                            top: '-5px'
                        }
                    });
                }, onMouseLeave: resetIconStyles }), void 0)) : (jsx(Arrow$2, __assign({ className: arrowClass }, props, { isNav: isNav, navItem: navItem }), void 0)) }, void 0));
    }
    else if (linkIcon) {
        content = (jsxs("div", __assign({ sx: {
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                '&:hover': {
                    color: navItem || navTitle
                        ? inverse
                            ? 'link.cta.inverse.text'
                            : 'link.navigation.text'
                        : inverse
                            ? 'link.cta.inverse.text'
                            : 'link.cta.default.text',
                    span: {
                        color: inverse
                            ? 'link.cta.inverse.icon'
                            : 'link.cta.default.textHover'
                    }
                }
            }, onMouseOver: function () {
                return !linkIconDisableExpand &&
                    changeIconStyles({
                        arrowBody: { width: selectedTheme.sizes.inc50 },
                        chevronBody: { width: selectedTheme.sizes.inc40 },
                        chevron: {
                            background: iconColor,
                            width: '12px',
                            height: '12px',
                            top: '-5px'
                        }
                    });
            }, onMouseLeave: resetIconStyles }, { children: [jsx(Text, __assign({ className: linkIconClass }, props, { href: href }, { children: children }), void 0),
                jsx(LinkIcon, __assign({ className: arrowClass }, props, { linkIcon: linkIcon, linkIconColor: iconColor, iconStyles: iconStyles }), void 0)] }), void 0));
    }
    else {
        content = (jsx(Fragment, { children: jsx(Text, __assign({ className: legacy ? textClass : defaultTextClass }, props, { href: href }, { children: children }), void 0) }, void 0));
    }
    return (jsx("span", __assign({ sx: (_a = {
                display: 'flex',
                alignItems: navTitle ? 'flex-end' : 'center',
                textAlign: 'left'
            },
            _a["& ." + defaultTextClass] = __assign({ color: isNav
                    ? inverse
                        ? 'black00'
                        : 'link.navigation.text'
                    : inverse
                        ? selectedTheme.colors.link.inline.inverse.text
                        : selectedTheme.colors.link.inline.default.text, lineHeight: !isNav && 'inc30', borderBottom: "2px solid transparent", '&:hover': {
                    borderBottom: inverse
                        ? "2px solid " + selectedTheme.colors.link.inline.inverse.underline
                        : "2px solid " + selectedTheme.colors.link.inline.default.underline
                } }, customStyles),
            _a["& ." + arrowClass] = {
                color: isNav ? 'green50' : selectedTheme.colors.link.cta.default.text,
                lineHeight: !isNav && 'inc30'
            },
            _a["& ." + linkIconClass] = {
                color: isNav
                    ? 'link.navigation.text'
                    : inverse
                        ? selectedTheme.colors.link.cta.inverse.text
                        : selectedTheme.colors.link.cta.default.text,
                lineHeight: !isNav && 'inc30'
            },
            _a["&:hover ." + textClass] = isNav && {
                color: 'green50',
                WebkitAnimation: 'linear 1 alternate',
                WebkitAnimationName: 'color',
                WebkitAnimationDuration: selectedTheme.motion.linkAnimation,
                '@-webkit-keyframes color': {
                    '0%': { color: 'black80' },
                    '100%': { left: 'green50' }
                }
            },
            _a["&:hover ." + arrowClass] = isNav && {
                left: navItem && '0',
                WebkitAnimation: 'linear 1 alternate',
                WebkitAnimationName: navItem ? 'runLink' : 'runTitle',
                WebkitAnimationDuration: selectedTheme.motion.linkAnimation,
                '@-webkit-keyframes runTitle': {
                    '0%': { left: '0' },
                    '33%': { left: '25px' },
                    '66%': { left: '-25px' },
                    '100%': { left: '0' }
                },
                '@-webkit-keyframes runLink': {
                    '0%': { left: '-100px' },
                    '100%': { left: '0' }
                }
            },
            _a) }, { children: content }), void 0));
};

var Link = function (_a) {
    var href = _a.href, target = _a.target, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.onTouchStart, onTouchStart = _e === void 0 ? function () { } : _e, _f = _a.onMouseEnter, onMouseEnter = _f === void 0 ? function () { } : _f, _g = _a.onMouseLeave, onMouseLeave = _g === void 0 ? function () { } : _g, _h = _a.tabIndex, tabIndex = _h === void 0 ? 0 : _h, arrowOnly = _a.arrowOnly, defaultArrow = _a.defaultArrow, linkIcon = _a.linkIcon, linkIconSize = _a.linkIconSize, // Will only affect ESystemIconNames icons.
    linkIconColor = _a.linkIconColor, _j = _a.linkIconDisableExpand, linkIconDisableExpand = _j === void 0 ? false : _j, children = _a.children, _k = _a.trackClick, trackClick = _k === void 0 ? true : _k, _l = _a.trackCategory, trackCategory = _l === void 0 ? '' : _l, customStyles = _a.customStyles, customLinkContentStyles = _a.customLinkContentStyles, itemProp = _a.itemProp, _m = _a.disableAnchor, disableAnchor = _m === void 0 ? false : _m, _o = _a.stopPropagation, stopPropagation = _o === void 0 ? false : _o, props = __rest(_a, ["href", "target", "className", "theme", "onClick", "onTouchStart", "onMouseEnter", "onMouseLeave", "tabIndex", "arrowOnly", "defaultArrow", "linkIcon", "linkIconSize", "linkIconColor", "linkIconDisableExpand", "children", "trackClick", "trackCategory", "customStyles", "customLinkContentStyles", "itemProp", "disableAnchor", "stopPropagation"]);
    var isNav = props.navItem || props.navTitle;
    var contentProps = __assign(__assign({}, props), { defaultArrow: defaultArrow,
        linkIcon: linkIcon,
        linkIconSize: linkIconSize,
        linkIconColor: linkIconColor,
        linkIconDisableExpand: linkIconDisableExpand,
        arrowOnly: arrowOnly,
        href: href,
        target: target,
        isNav: isNav,
        theme: theme, customStyles: customLinkContentStyles });
    var handleClick = function (e) {
        if (stopPropagation) {
            e.stopPropagation();
        }
        onClick();
    };
    return (jsx(Fragment, { children: href && !disableAnchor ? (jsx("a", __assign({ itemProp: itemProp, tabIndex: tabIndex, href: fixHref(href), target: target, className: className, onClick: handleClick, sx: __assign(__assign({ fontFamily: 'body', fontWeight: props.navItem ? '300' : '500', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' }, getVariantStyles$4(__assign(__assign({}, props), { href: href, theme: theme }))), customStyles), "data-track": trackClick.toString(), "data-track-category": trackCategory === '' ? undefined : trackCategory }, { children: jsx(LinkContent, __assign({}, contentProps, { children: children }), void 0) }), void 0)) : (jsx("button", __assign({ tabIndex: tabIndex, className: className, onClick: handleClick, onTouchStart: onTouchStart, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, sx: __assign(__assign({ fontFamily: 'body', fontWeight: props.navItem ? '300' : '500', cursor: 'pointer', background: 'none', border: 'none', px: 'inc00' }, getVariantStyles$4(__assign(__assign({}, props), { href: href, theme: theme }))), customStyles), "data-track": trackClick.toString(), "data-track-category": trackCategory === '' ? undefined : trackCategory }, { children: jsx(LinkContent, __assign({}, contentProps, { children: children }), void 0) }), void 0)) }, void 0));
};

var Container$1 = function (_a) {
    var children = _a.children, fullscreen = _a.fullscreen;
    var sharedProps = {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        zIndex: '1000001'
    };
    return (jsx("div", __assign({ sx: fullscreen
            ? __assign(__assign({}, sharedProps), { maxHeight: '85vh', maxWidth: '85vw', flexDirection: 'column' }) : __assign(__assign({}, sharedProps), { padding: "0 inc20", width: ['100%', null, '600px', '800px'], height: ['350px', '500px', '600px', '600px'], flexDirection: 'column' }) }, { children: children }), void 0));
};

// Hook that listens for Escape key presses
var useEscape = function (bind, handler) {
    useEffect(function () {
        var listener = function (event) {
            if (event.key === 'Escape') {
                handler();
            }
        };
        // Bind the event listener
        if (bind) {
            document.addEventListener('keydown', listener);
        }
        else {
            // Unbind the event listener if bind is false
            document.removeEventListener('keydown', listener);
        }
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('keydown', listener);
        };
    }, [bind]);
};

var LightboxElement = function (_a) {
    var children = _a.children, className = _a.className, isOpen = _a.isOpen, theme = _a.theme, onClose = _a.onClose;
    useEscape(isOpen, onClose);
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx("div", __assign({ "aria-label": 'lightbox', className: className, onClick: onClose, sx: {
            position: 'fixed',
            display: isOpen ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            zIndex: 9999,
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            '&::after': {
                content: '""',
                width: '100%',
                height: '100%',
                backgroundColor: 'background.containerInverseDarker',
                opacity: "" + selectedTheme.opacity.modalScrim,
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 9999,
                display: isOpen ? 'flex' : 'none',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
            }
        } }, { children: children }), void 0));
};
var Lightbox = function (_a) {
    var isOpen = _a.isOpen, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.theme, theme = _d === void 0 ? 'default' : _d, fullscreen = _a.fullscreen;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx(ThemeProvider, __assign({ theme: selectedTheme }, { children: jsx(LightboxElement, __assign({ className: className, isOpen: isOpen, theme: theme, onClose: onClose }, { children: jsxs(Container$1, __assign({ fullscreen: fullscreen }, { children: [jsx(ButtonIcon, { customStyles: { marginBottom: '16px' }, onClick: onClose, theme: theme, variant: 'secondary', iconName: ESystemIconNames.CLOSE, ariaLabel: 'lightbox-close', inverse: true }, void 0),
                    jsx("div", __assign({ onClick: function (e) {
                            e.stopPropagation();
                        }, sx: { width: '100%', height: '100%' } }, { children: children }), void 0)] }), void 0) }), void 0) }), void 0));
};

var useDimension = function (ref) {
    var getDimensions = function () {
        var _a, _b;
        return ({
            width: ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0,
            height: ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0
        });
    };
    var _a = useState({
        width: 0,
        height: 0
    }), dimensions = _a[0], setDimensions = _a[1];
    var handleResize = function () {
        setDimensions(getDimensions());
    };
    useEffect(function () {
        if (ref.current) {
            setDimensions(getDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, [ref]);
    return dimensions;
};

var PADDING = 8;
var topCalc = function (_a) {
    var height = _a.height, direction = _a.direction, parentHeight = _a.parentHeight, isMobile = _a.isMobile;
    if ((direction === ARROW_DIRECTION.LeftCenter ||
        direction === ARROW_DIRECTION.LeftTop ||
        direction === ARROW_DIRECTION.RightCenter ||
        direction === ARROW_DIRECTION.RightTop ||
        direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.RightBottom) &&
        !isMobile) {
        return -PADDING;
    }
    if (direction === ARROW_DIRECTION.TopCenter ||
        direction === ARROW_DIRECTION.TopLeft ||
        direction === ARROW_DIRECTION.TopRight) {
        return parentHeight;
    }
    return (height + PADDING) * -1;
};
var bottomCalc = function (_a) {
    var direction = _a.direction, isMobile = _a.isMobile;
    if ((direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.RightBottom) &&
        !isMobile) {
        return 0;
    }
    return;
};
var leftCalc = function (_a) {
    var width = _a.width, direction = _a.direction, parentWidth = _a.parentWidth, isMobile = _a.isMobile;
    if ((direction === ARROW_DIRECTION.LeftCenter ||
        direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.LeftTop) &&
        !isMobile) {
        return parentWidth + PADDING;
    }
    if (direction === ARROW_DIRECTION.TopLeft ||
        direction === ARROW_DIRECTION.BottomLeft) {
        return 0;
    }
    if (direction === ARROW_DIRECTION.TopCenter ||
        direction === ARROW_DIRECTION.BottomCenter ||
        direction === ARROW_DIRECTION.LeftCenter) {
        return (parentWidth - width) / 2;
    }
    return;
};
var rightCalc = function (_a) {
    var direction = _a.direction, parentWidth = _a.parentWidth, isMobile = _a.isMobile, width = _a.width;
    if ((direction === ARROW_DIRECTION.RightBottom ||
        direction === ARROW_DIRECTION.RightCenter ||
        direction === ARROW_DIRECTION.RightTop) &&
        !isMobile) {
        return parentWidth + PADDING;
    }
    if (direction === ARROW_DIRECTION.RightCenter) {
        return (parentWidth - width) / 2;
    }
    if (direction === ARROW_DIRECTION.TopRight ||
        direction === ARROW_DIRECTION.BottomRight ||
        direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.RightBottom) {
        return 0;
    }
    return;
};
var isFlexStart = function (_a) {
    var direction = _a.direction;
    return direction === ARROW_DIRECTION.TopLeft ||
        direction === ARROW_DIRECTION.BottomLeft ||
        direction === ARROW_DIRECTION.LeftTop ||
        direction === ARROW_DIRECTION.RightTop;
};
var isFlexEnd = function (_a) {
    var direction = _a.direction;
    return direction === ARROW_DIRECTION.TopRight ||
        direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.BottomRight ||
        direction === ARROW_DIRECTION.RightBottom;
};
var isRowReverse = function (_a) {
    var direction = _a.direction;
    return direction === ARROW_DIRECTION.LeftBottom ||
        direction === ARROW_DIRECTION.LeftCenter ||
        direction === ARROW_DIRECTION.LeftTop;
};
var isRow = function (_a) {
    var direction = _a.direction;
    return direction === ARROW_DIRECTION.RightBottom ||
        direction === ARROW_DIRECTION.RightCenter ||
        direction === ARROW_DIRECTION.RightTop;
};
var isColumnReverse = function (_a) {
    var direction = _a.direction;
    return direction === ARROW_DIRECTION.TopCenter ||
        direction === ARROW_DIRECTION.TopRight ||
        direction === ARROW_DIRECTION.TopLeft;
};
var alignItems = function (direction) {
    if (isFlexStart({ direction: direction })) {
        return 'flex-start';
    }
    if (isFlexEnd({ direction: direction })) {
        return 'flex-end';
    }
    return 'center';
};
var flexDirection = function (direction, isMobile) {
    if (!isMobile && isRowReverse({ direction: direction })) {
        return 'row-reverse';
    }
    if (isColumnReverse({ direction: direction })) {
        return 'column-reverse';
    }
    if (!isMobile && isRow({ direction: direction })) {
        return 'row';
    }
    return 'column';
};

var Content$1 = function (_a) {
    var _b;
    var direction = _a.direction, children = _a.children, theme = _a.theme;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var tabletBreakpoint = selectedTheme.breakpoints[1];
    var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
    return (jsx("div", __assign({ "aria-label": 'tooltip-content', sx: (_b = {
                position: 'relative',
                display: 'flex',
                flexDirection: flexDirection(direction, true),
                alignItems: alignItems(direction)
            },
            _b[desktopMediaQuerySelector] = {
                flexDirection: flexDirection(direction, false),
                alignItems: alignItems(direction)
            },
            _b) }, { children: children }), void 0));
};

var Shared = function (_a) {
    var style = _a.style;
    return (jsx("div", { sx: __assign({ width: 0, height: 0 }, style) }, void 0));
};
var tabletBreakpoint = defaultTheme.breakpoints[1];
var tabletMediaQuerySelector = "@media screen and (max-width: " + tabletBreakpoint + ")";
var ArrowDown = function (_a) {
    var direction = _a.direction, inverse = _a.inverse;
    return (jsx(Shared, { style: {
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            marginLeft: direction === ARROW_DIRECTION.BottomLeft ? 'base' : '0',
            marginRight: direction === ARROW_DIRECTION.BottomRight ? 'base' : '0',
            borderTop: "8px solid " + (inverse
                ? defaultTheme.colors.background.containerLighter
                : defaultTheme.colors.background.containerInverse)
        } }, void 0));
};
var ArrowTop = function (_a) {
    var direction = _a.direction, inverse = _a.inverse;
    return (jsx(Shared, { style: {
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            marginLeft: direction === ARROW_DIRECTION.TopLeft ? 'base' : '0',
            marginRight: direction === ARROW_DIRECTION.TopRight ? 'base' : '0',
            borderBottom: "8px solid " + (inverse
                ? defaultTheme.colors.background.containerLighter
                : defaultTheme.colors.background.containerInverse)
        } }, void 0));
};
var ArrowLeft = function (_a) {
    var _b;
    var inverse = _a.inverse, direction = _a.direction;
    return (jsx(Shared, { style: (_b = {
                borderTop: '8px solid transparent',
                borderRight: "8px solid " + (inverse
                    ? defaultTheme.colors.background.containerLighter
                    : defaultTheme.colors.background.containerInverse),
                borderBottom: '8px solid transparent',
                marginTop: direction === ARROW_DIRECTION.LeftTop ? 'base' : 0,
                marginBottom: direction === ARROW_DIRECTION.LeftBottom ? 'base' : 0
            },
            _b[tabletMediaQuerySelector] = {
                borderLeft: '8px solid transparent',
                borderRight: '8px solid transparent',
                borderBottom: 'none',
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 'base',
                marginRight: 'base',
                borderTop: "8px solid " + (inverse
                    ? defaultTheme.colors.background.containerLighter
                    : defaultTheme.colors.background.containerInverse)
            },
            _b) }, void 0));
};
var ArrowRight = function (_a) {
    var _b;
    var inverse = _a.inverse, direction = _a.direction;
    return (jsx(Shared, { style: (_b = {
                borderTop: '8px solid transparent',
                borderLeft: "8px solid " + (inverse
                    ? defaultTheme.colors.background.containerLighter
                    : defaultTheme.colors.background.containerInverse),
                borderBottom: '8px solid transparent',
                marginTop: direction === ARROW_DIRECTION.RightTop ? 'base' : 0,
                marginBottom: direction === ARROW_DIRECTION.RightBottom ? 'base' : 0
            },
            _b[tabletMediaQuerySelector] = {
                borderLeft: '8px solid transparent',
                borderRight: '8px solid transparent',
                borderBottom: 'none',
                marginTop: 0,
                marginBottom: 0,
                marginLeft: 'base',
                marginRight: 'base',
                borderTop: "8px solid " + (inverse
                    ? defaultTheme.colors.background.containerLighter
                    : defaultTheme.colors.background.containerInverse)
            },
            _b) }, void 0));
};
var Arrow$1 = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? ARROW_DIRECTION.BottomCenter : _b, inverse = _a.inverse;
    switch (direction) {
        case ARROW_DIRECTION.LeftCenter:
        case ARROW_DIRECTION.LeftBottom:
        case ARROW_DIRECTION.LeftTop:
            return jsx(ArrowLeft, { direction: direction, inverse: inverse }, void 0);
        case ARROW_DIRECTION.RightCenter:
        case ARROW_DIRECTION.RightTop:
        case ARROW_DIRECTION.RightBottom:
            return jsx(ArrowRight, { direction: direction, inverse: inverse }, void 0);
        case ARROW_DIRECTION.TopCenter:
        case ARROW_DIRECTION.TopRight:
        case ARROW_DIRECTION.TopLeft:
            return jsx(ArrowTop, { direction: direction, inverse: inverse }, void 0);
        default:
            return jsx(ArrowDown, { direction: direction, inverse: inverse }, void 0);
    }
};

var Container = function (_a) {
    var _b;
    var children = _a.children, props = __rest(_a, ["children"]);
    var ref = useRef(null);
    var _c = useDimension(ref), width = _c.width, height = _c.height;
    var tabletBreakpoint = defaultTheme.breakpoints[1];
    var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
    return (jsx("div", __assign({ ref: ref, "aria-label": 'tooltip-container', sx: (_b = {
                position: 'absolute',
                zIndex: 999,
                maxWidth: 272,
                width: 'max-content',
                top: topCalc(__assign(__assign({}, props), { height: height, isMobile: true })),
                left: leftCalc(__assign(__assign({}, props), { width: width, isMobile: true })),
                right: rightCalc(__assign(__assign({}, props), { width: width, isMobile: true })),
                bottom: bottomCalc(__assign(__assign({}, props), { isMobile: true }))
            },
            _b[desktopMediaQuerySelector] = {
                top: topCalc(__assign(__assign({}, props), { height: height, isMobile: false })),
                bottom: bottomCalc(__assign(__assign({}, props), { isMobile: false })),
                left: leftCalc(__assign(__assign({}, props), { width: width, isMobile: false })),
                right: rightCalc(__assign(__assign({}, props), { width: width, isMobile: false }))
            },
            _b) }, { children: children }), void 0));
};

var Box = function (_a) {
    var _b;
    var children = _a.children, inverse = _a.inverse;
    var tabletBreakpoint = defaultTheme.breakpoints[1];
    var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
    return (jsx("div", __assign({ "aria-label": 'tooltip-box', sx: (_b = {
                bg: inverse
                    ? 'background.containerLighter'
                    : 'background.containerInverse',
                color: inverse ? 'text.default' : 'text.inverse',
                borderRadius: 'tooltips',
                padding: 'inc10',
                textAlign: 'left',
                fontSize: 'inc00',
                lineHeight: 'inc10',
                fontFamily: 'body',
                width: '100%',
                boxShadow: 'level01'
            },
            _b[desktopMediaQuerySelector] = {
                fontSize: 'inc10',
                lineHeight: 'inc20',
                padding: 'inc20'
            },
            _b) }, { children: children }), void 0));
};

var ARROW_DIRECTION;
(function (ARROW_DIRECTION) {
    ARROW_DIRECTION["BottomCenter"] = "bottom-center";
    ARROW_DIRECTION["BottomLeft"] = "bottom-left";
    ARROW_DIRECTION["BottomRight"] = "bottom-right";
    ARROW_DIRECTION["TopCenter"] = "top-center";
    ARROW_DIRECTION["TopLeft"] = "top-left";
    ARROW_DIRECTION["TopRight"] = "top-right";
    ARROW_DIRECTION["LeftCenter"] = "left-center";
    ARROW_DIRECTION["LeftTop"] = "left-top";
    ARROW_DIRECTION["LeftBottom"] = "left-bottom";
    ARROW_DIRECTION["RightCenter"] = "right-center";
    ARROW_DIRECTION["RightTop"] = "right-top";
    ARROW_DIRECTION["RightBottom"] = "right-bottom";
})(ARROW_DIRECTION || (ARROW_DIRECTION = {}));
var fadeIn = keyframes(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var fadeOut = keyframes(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"], ["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
var Fade = function (_a) {
    var children = _a.children, visible = _a.visible;
    return (jsx("div", __assign({ sx: {
            display: 'inline-block',
            visibility: visible ? 'visible' : 'hidden',
            animation: (visible ? fadeIn : fadeOut) + " 0.2s linear"
        } }, { children: children }), void 0));
};
var TooltipBlock = function (_a) {
    var text = _a.text, arrowDirection = _a.arrowDirection, parentWidth = _a.parentWidth, parentHeight = _a.parentHeight, visible = _a.visible, theme = _a.theme, inverse = _a.inverse;
    return (jsx(Container, __assign({}, { parentHeight: parentHeight, parentWidth: parentWidth, direction: arrowDirection }, { children: jsx(Fade, __assign({}, { visible: visible }, { children: jsxs(Content$1, __assign({ direction: arrowDirection, theme: theme }, { children: [jsx(Box, __assign({ inverse: inverse }, { children: text }), void 0),
                    jsx(Arrow$1, { direction: arrowDirection, inverse: inverse }, void 0)] }), void 0) }), void 0) }), void 0));
};
var templateObject_1$3, templateObject_2$2;

var useOnClickOutside = function (ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};

var Tooltip = function (_a) {
    var children = _a.children, text = _a.text, _b = _a.arrowDirection, arrowDirection = _b === void 0 ? ARROW_DIRECTION.BottomCenter : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, visible = _a.visible, _d = _a.theme, theme = _d === void 0 ? 'default' : _d;
    var hoverable = typeof visible === 'undefined';
    var _e = useState(visible), isVisible = _e[0], setIsVisible = _e[1];
    var ref = useRef(null);
    var _f = useDimension(ref), width = _f.width, height = _f.height;
    useOnClickOutside(ref, function () { return setIsVisible(false); });
    var mobileStateHandler = function (value) {
        setIsVisible(value);
    };
    var onTouch = hoverable ? function () { return mobileStateHandler(!isVisible); } : function () { };
    useEffect(function () {
        setIsVisible(visible);
    }, [visible]);
    return (jsxs("div", __assign({ "aria-label": 'tooltip-wrapper', sx: {
            position: 'relative',
            display: 'inline-flex',
            color: inverse ? 'text.inverse' : 'text.default'
        }, ref: ref, onMouseEnter: hoverable
            ? function () {
                setIsVisible(true);
            }
            : undefined, onMouseLeave: hoverable
            ? function () {
                setIsVisible(false);
            }
            : undefined, onTouchStart: onTouch }, { children: [text && isVisible && (jsx(TooltipBlock, __assign({}, {
                text: text,
                arrowDirection: arrowDirection,
                parentWidth: width,
                parentHeight: height,
                visible: isVisible,
                inverse: inverse,
                theme: theme
            }), void 0)), children] }), void 0));
};

var _a$3, _b;
var ELogoVariant;
(function (ELogoVariant) {
    ELogoVariant["STACKED_DEFAULT"] = "Stacked Default";
    ELogoVariant["STACKED_INVERSE"] = "Stacked Inverse";
    ELogoVariant["STACKED_SPRING_GREEN"] = "Stacked Spring Green";
    ELogoVariant["STACKED_FOREST_GREEN"] = "Stacked Forest Green";
    ELogoVariant["STACKED_ALL_BLACK"] = "Stacked All Black";
    ELogoVariant["STACKED_ALL_WHITE"] = "Stacked All White";
    ELogoVariant["HORIZONTAL_DEFAULT"] = "Horizontal Default";
    ELogoVariant["HORIZONTAL_INVERSE"] = "Horizontal Inverse";
    ELogoVariant["HORIZONTAL_FOREST_GREEN"] = "Horizontal Forest Green";
    ELogoVariant["HORIZONTAL_SPRING_GREEN"] = "Horizontal Spring Green";
    ELogoVariant["HORIZONTAL_ALL_BLACK"] = "Horizontal All Black";
    ELogoVariant["HORIZONTAL_ALL_WHITE"] = "Horizontal All White";
    ELogoVariant["LEAF_DEFAULT"] = "Leaf Default";
    ELogoVariant["LEAF_ALL_BLACK"] = "Leaf All Black";
    ELogoVariant["LEAF_ALL_WHITE"] = "Leaf All White";
})(ELogoVariant || (ELogoVariant = {}));
var LogoPaths$1 = (_a$3 = {},
    _a$3[ELogoVariant.LEAF_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.LEAF_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj3d95v5vbmm2f4-horizontal_white.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjf3vea2hg34taa-horizontal_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjf3vea2hg34taa-horizontal_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj3d95v5vbmm2f4-horizontal_white.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.LEAF_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjaqno04qecjezz-horizontal_spring_green.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjc2nyso711vv9y-stacked_forest_green.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.HORIZONTAL_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjdssznhgeuje6g-horizontal_forest_green.svg?auto=format%252Ccompress',
    _a$3[ELogoVariant.STACKED_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjefaguj6vxb77f-stacked_spring_green.svg?auto=format%252Ccompress',
    _a$3);
var LegacyLogoPaths = (_b = {},
    _b[ELogoVariant.LEAF_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5tquvsd872oci1-Leaf_AllBlack.svg?auto=format%252Ccompress',
    _b[ELogoVariant.LEAF_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo66lvkvhd3f3b2e-Leaf_AllWhite.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5i82g0bmzw0af5-Stacked_AllWhite.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5nndrayrczjmgb-Stacked_AllBlack.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo67f03j7lysjkc7-Stacked_Inverse.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5vhhgq7u6e0ot6-Stacked_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5u9my2lllbpclj-Horizontal_Inverse.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5loumhtiy9kgdw-Horizontal_AllBlack.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5v3dveeadn53k2-Horizontal_AllWhite.svg?auto=format%252Ccompress',
    _b[ELogoVariant.LEAF_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.HORIZONTAL_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress',
    _b[ELogoVariant.STACKED_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress',
    _b);

var MDBLogo = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, href = _a.href, target = _a.target, imageWidth = _a.imageWidth, _d = _a.variant, variant = _d === void 0 ? ELogoVariant.HORIZONTAL_DEFAULT : _d;
    var selectedLogoPaths = theme === 'legacy' ? LegacyLogoPaths : LogoPaths$1;
    var getVariantStyles = function () {
        switch (variant) {
            case ELogoVariant.HORIZONTAL_DEFAULT:
            case ELogoVariant.HORIZONTAL_INVERSE:
            case ELogoVariant.HORIZONTAL_ALL_BLACK:
            case ELogoVariant.HORIZONTAL_ALL_WHITE: {
                return {
                    minWidth: 100
                };
            }
            case ELogoVariant.LEAF_ALL_BLACK:
            case ELogoVariant.LEAF_DEFAULT:
            case ELogoVariant.LEAF_ALL_WHITE: {
                return {
                    maxHeight: 50
                };
            }
        }
    };
    return (jsx("a", __assign({ href: href, target: target, className: className }, { children: jsx("img", { src: selectedLogoPaths[variant], className: className, alt: 'MongoDB logo', sx: __assign({ width: imageWidth || 384 }, getVariantStyles()) }, void 0) }), void 0));
};

var getColor$3 = function (color, inverse) {
    var Color = {
        default: "forms.textInput." + (inverse ? 'inverse' : 'default') + ".text",
        secondary: "text." + (inverse ? 'inverseSecondary' : 'secondary')
    };
    return Color[color];
};
var HelperText = function (_a) {
    var text = _a.text, inverse = _a.inverse, _b = _a.color, color = _b === void 0 ? 'default' : _b;
    return (jsx("span", __assign({ "aria-label": 'helper-text', sx: {
            display: 'inline-block',
            margin: 0,
            marginTop: 'inc20',
            marginLeft: 'inc40',
            fontFamily: 'body',
            fontSize: 'bodyXS',
            lineHeight: '20px',
            color: getColor$3(color, inverse)
        } }, { children: text }), void 0));
};

var getStyles$8 = function (state, selectedTheme) {
    var inverse = state.inverse, invalid = state.invalid, onTop = state.onTop, focus = state.focus;
    var textInputColors = selectedTheme.colors.forms.textInput;
    var inputColors = textInputColors[inverse ? 'inverse' : 'default'];
    var focusColors = inputColors.focus, errorColors = inputColors.error;
    var textColor = inputColors.label;
    if (focus) {
        if (invalid) {
            textColor = errorColors.labelFocus;
        }
        else if (onTop) {
            textColor = focusColors.label;
        }
    }
    else if (invalid) {
        textColor = errorColors.label;
    }
    return {
        width: '100%',
        overflowX: 'hidden',
        display: 'block',
        pointerEvents: onTop ? null : 'none',
        fontFamily: 'body',
        textTransform: 'capitalize',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        cursor: 'inherit',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        height: 'fit-content',
        margin: 'auto',
        willChange: 'transform, color, font-size',
        transitionProperty: 'transform, color, font-size',
        transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        transitionDuration: '200ms',
        transitionDelay: '0ms',
        transform: "translateY(-" + (onTop ? selectedTheme.space.inc30 : '0px') + ")",
        color: textColor,
        fontSize: onTop ? 'inc10' : 'inc40',
        lineHeight: onTop ? 'inc20' : 'inc40'
    };
};

var Label = function (_a) {
    var onTop = _a.onTop, focus = _a.focus, htmlFor = _a.htmlFor, inverse = _a.inverse, invalid = _a.invalid, children = _a.children, selectedTheme = _a.selectedTheme, customStyles = _a.customStyles;
    var state = { invalid: invalid, inverse: inverse, onTop: onTop, focus: focus };
    var styles = getStyles$8(state, selectedTheme);
    return (jsx("label", __assign({ "aria-label": htmlFor, htmlFor: htmlFor, sx: __assign(__assign({}, styles), customStyles) }, { children: children }), void 0));
};

var getStyles$7 = function (state, theme) {
    var disabled = state.disabled, invalid = state.invalid, inverse = state.inverse, focus = state.focus, clickableIcon = state.clickableIcon;
    var textInputColors = theme.colors.forms.textInput;
    var inputColors = textInputColors[inverse ? 'inverse' : 'default'];
    var focusColors = inputColors.focus, errorColors = inputColors.error;
    var borderColor = inputColors.border, rightIconColor = 'inherit';
    if (focus) {
        if (invalid) {
            borderColor = errorColors.borderFocus;
            rightIconColor = errorColors.iconFocus;
        }
        else {
            borderColor = focusColors.border;
        }
    }
    else if (invalid) {
        borderColor = errorColors.border;
        rightIconColor = errorColors.icon;
    }
    return {
        wrapper: {
            maxWidth: ['100%', null, 441, 456],
            display: 'flex',
            flexDirection: 'column'
        },
        inputRow: {
            width: '100%',
            display: 'flex',
            alignItems: 'center'
        },
        inputBox: {
            width: '100%',
            height: 80,
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            backgroundColor: inputColors.bg,
            padding: "0px " + theme.space.inc40,
            borderBottom: "4px solid " + borderColor,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            cursor: disabled ? 'not-allowed' : 'text',
            opacity: disabled ? 0.6 : 1
        },
        inputText: {
            width: 'inherit',
            fontSize: ['bodyLResponsive', null, null, 'bodyL'],
            marginTop: 'inc30',
            marginRight: 'inc40',
            color: inputColors.text,
            '&, &:focus, &:active': {
                background: 'transparent',
                border: 'none',
                outline: 'none'
            },
            '&:-webkit-autofill': {
                '-webkit-box-shadow': "0 0 0 16px " + inputColors.bg + " inset",
                '-webkit-text-fill-color': inputColors.text,
                filter: 'none'
            }
        },
        valueContainer: {
            width: 'inherit',
            flexGrow: 1,
            paddingRight: 'inc10',
            position: 'relative'
        },
        leftIconContainer: {
            margin: 'auto',
            marginTop: 'inc50',
            marginRight: 'inc20',
            marginLeft: 0,
            cursor: clickableIcon ? 'pointer' : 'inherit'
        },
        rightIconContainer: {
            margin: 'auto',
            marginTop: 'inc50',
            marginLeft: 'inc10',
            marginRight: 0,
            stroke: rightIconColor,
            cursor: clickableIcon ? 'pointer' : 'inherit'
        },
        button: {
            marginLeft: 'inc20'
        }
    };
};

var TextInput = forwardRef(function (_a, ref) {
    var _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b, inverse = _a.inverse, invalid = _a.invalid, disabled = _a.disabled, iconName = _a.iconName, helper = _a.helper, buttonText = _a.buttonText, onChange = _a.onChange, onIconClick = _a.onIconClick, onButtonClick = _a.onButtonClick, label = _a.label, theme = _a.theme, name = _a.name, _c = _a.type, type = _c === void 0 ? 'text' : _c, autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, props = __rest(_a, ["iconPosition", "inverse", "invalid", "disabled", "iconName", "helper", "buttonText", "onChange", "onIconClick", "onButtonClick", "label", "theme", "name", "type", "autoComplete", "autoFocus"]);
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var inputRef = useRef(null);
    useImperativeHandle(ref, function () { return inputRef.current; });
    var _d = useState(props.value || ''), value = _d[0], setValue = _d[1];
    var _e = useState(false), focus = _e[0], setFocus = _e[1];
    var clickableIcon = !!onIconClick;
    var styles = getStyles$7({
        disabled: disabled,
        invalid: invalid,
        inverse: inverse,
        focus: focus,
        clickableIcon: clickableIcon
    }, selectedTheme);
    var setInputFocus = function () {
        var _a;
        if (!disabled) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            setFocus(true);
        }
    };
    var handleChange = function (event) {
        var value = event.target.value;
        setValue(value);
        if (onChange)
            onChange(event);
    };
    var renderLeftIcon = function () {
        if (iconName && iconPosition === 'left') {
            return (jsx("span", __assign({ "aria-label": 'left-icon', sx: styles.leftIconContainer, onClick: onIconClick }, { children: jsx(SystemIcon, { inverse: inverse, name: iconName, color: 'neutral' }, void 0) }), void 0));
        }
        return null;
    };
    var renderRightIcon = function () {
        if (invalid) {
            return (jsx("span", __assign({ onClick: onIconClick, "aria-label": 'alert-icon', sx: styles.rightIconContainer }, { children: jsx(SystemIcon, { name: ESystemIconNames.CIRCLE_ALERT, inheritColor: true }, void 0) }), void 0));
        }
        if (iconName && iconPosition === 'right') {
            return (jsx("span", __assign({ "aria-label": 'right-icon', sx: styles.rightIconContainer, onClick: onIconClick }, { children: jsx(SystemIcon, { name: iconName, color: 'neutral', inverse: inverse }, void 0) }), void 0));
        }
        return null;
    };
    var renderButton = function () {
        if (!!buttonText && !!onButtonClick) {
            return (jsx(Button, __assign({ "aria-label": 'button', sx: styles.button, variant: 'secondary', onClick: onButtonClick, inverse: inverse }, { children: buttonText }), void 0));
        }
        return null;
    };
    useEffect(function () {
        if (autoFocus) {
            setInputFocus();
        }
    }, []);
    useEffect(function () {
        if (props.value !== value) {
            setValue(props.value || '');
        }
    }, [props.value]);
    return (jsxs("div", __assign({ sx: styles.wrapper }, { children: [jsxs("div", __assign({ sx: styles.inputRow }, { children: [jsxs("div", __assign({ "aria-label": 'input-box', sx: styles.inputBox, onClick: setInputFocus }, { children: [renderLeftIcon(), jsxs("div", __assign({ sx: styles.valueContainer }, { children: [jsx(Label, __assign({ focus: focus, onTop: !!value || focus, htmlFor: name, invalid: invalid, inverse: inverse, selectedTheme: selectedTheme }, { children: label }), void 0),
                                    jsx("input", { id: name, sx: styles.inputText, ref: inputRef, onFocus: function () { return setFocus(true); }, onBlur: function () { return setFocus(false); }, onChange: handleChange, name: name, value: value, type: type, disabled: disabled, autoComplete: autoComplete, autoFocus: autoFocus }, void 0)] }), void 0), renderRightIcon()] }), void 0), renderButton()] }), void 0),
            !!helper && jsx(HelperText, { inverse: inverse, text: helper }, void 0)] }), void 0));
});
TextInput.displayName = 'TextInput';

var grabber = 'https://webimages.mongodb.com/_com_assets/cms/kwxrz5ki294m89td9-grabber.svg?auto=format%252Ccompress';

var defaultToken = defaultTheme.colors.forms.textInput.default;
var inverseToken = defaultTheme.colors.forms.textInput.inverse;
var getStyles$6 = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, _d = _a.focus, focus = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.onTop, onTop = _f === void 0 ? false : _f;
    return {
        wrapper: __assign({ display: 'flex', flexDirection: 'column', position: 'relative', width: '100%' }, getIconColor({ invalid: invalid, focus: focus, inverse: inverse })),
        area: __assign(__assign({ width: '100%', cursor: disabled ? 'not-allowed' : 'text', minWidth: ['100%', null, null, '456px'], minHeight: ['119px', null, null, '152px'], fontFamily: 'body', fontSize: ['bodyLResponsive', null, null, 'bodyL'], lineHeight: ['bodyLResponsive', null, null, 'bodyL'], outline: 'none', border: 'none', borderTopLeftRadius: 'input', borderTopRightRadius: 'input', borderBottomStyle: 'solid', borderBottomWidth: '4px', boxSizing: 'border-box', padding: 'inc40', paddingTop: 'inc50', opacity: disabled ? 0.6 : 1, resize: ['vertical', null, 'both'], zIndex: 10 }, getColors({ invalid: invalid, inverse: inverse, focus: focus })), { '::-webkit-resizer': {
                backgroundImage: "url(" + grabber + ")",
                backgroundRepeat: 'no-repeat'
            } }),
        icon: {
            position: 'absolute',
            right: 'inc40',
            top: onTop ? '12px' : 'inc50',
            transition: 'all 200ms' // need a token
        },
        labelCustomStyle: {
            left: 'inc40',
            top: 'inc40',
            margin: 0,
            width: "calc(100% - " + defaultTheme.space.inc40 + ")",
            zIndex: 20
        }
    };
};
var getColors = function (_a) {
    var _b = _a.invalid, invalid = _b === void 0 ? false : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, _d = _a.focus, focus = _d === void 0 ? false : _d;
    if (inverse) {
        return {
            color: inverseToken.text,
            bg: inverseToken.bg,
            borderColor: getInverseBorderColor(invalid, focus)
        };
    }
    return {
        color: defaultToken.text,
        bg: defaultToken.bg,
        borderColor: getDefaultBorderColor(invalid, focus)
    };
};
var getDefaultBorderColor = function (invalid, focus) {
    var errorToken = defaultToken.error;
    var focusToken = defaultToken.focus;
    if (invalid)
        return focus ? errorToken.borderFocus : errorToken.border;
    return focus ? focusToken.border : defaultToken.border;
};
var getInverseBorderColor = function (invalid, focus) {
    var errorToken = inverseToken.error;
    var focusToken = inverseToken.focus;
    if (invalid)
        return focus ? errorToken.borderFocus : errorToken.border;
    return focus ? focusToken.border : inverseToken.border;
};
var getIconColor = function (_a) {
    var _b = _a.invalid, invalid = _b === void 0 ? false : _b, _c = _a.focus, focus = _c === void 0 ? false : _c, _d = _a.inverse, inverse = _d === void 0 ? false : _d;
    if (invalid) {
        if (focus) {
            return {
                stroke: inverse
                    ? inverseToken.error.iconFocus
                    : defaultToken.error.iconFocus
            };
        }
        else {
            return {
                stroke: inverse ? inverseToken.error.icon : defaultToken.error.icon
            };
        }
    }
    return null;
};

var Area = forwardRef(function (_a, ref) {
    var id = _a.id, textAreaStyles = _a.textAreaStyles, name = _a.name, value = _a.value, invalid = _a.invalid, disabled = _a.disabled, inverse = _a.inverse, focus = _a.focus, autoComplete = _a.autoComplete, onFocus = _a.onFocus, onBlur = _a.onBlur, onChange = _a.onChange, autoFocus = _a.autoFocus;
    var textAreaHTMLAttributes = {
        id: id,
        disabled: disabled,
        name: name,
        value: value,
        autoComplete: autoComplete,
        onFocus: onFocus,
        onChange: onChange,
        onBlur: onBlur,
        autoFocus: autoFocus
    };
    var onTop = !!value || focus;
    var styles = getStyles$6({ invalid: invalid, inverse: inverse, focus: focus, disabled: disabled, onTop: onTop });
    return (jsxs(Fragment, { children: [jsx("textarea", __assign({ ref: ref }, textAreaHTMLAttributes, { sx: __assign(__assign({}, styles.area), textAreaStyles) }), void 0),
            invalid && (jsx(SystemIcon, { inheritColor: true, customStyles: styles.icon, name: ESystemIconNames.CIRCLE_ALERT }, void 0))] }, void 0));
});
Area.displayName = 'TextArea';

var TextArea = forwardRef(function (_a, ref) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, id = _a.id, textAreaStyles = _a.textAreaStyles, name = _a.name, label = _a.label, helper = _a.helper; _a.className; var disabled = _a.disabled, autoComplete = _a.autoComplete; _a.onFocus; _a.onBlur; var onChange = _a.onChange, wrapperStyles = _a.wrapperStyles, autoFocus = _a.autoFocus, props = __rest(_a, ["inverse", "invalid", "id", "textAreaStyles", "name", "label", "helper", "className", "disabled", "autoComplete", "onFocus", "onBlur", "onChange", "wrapperStyles", "autoFocus"]);
    var _d = useState(false), focus = _d[0], setFocus = _d[1];
    var _e = useState(props.value || ''), value = _e[0], setValue = _e[1];
    var idValue = id || name.toLowerCase().replace(/\s/g, '');
    var handleChange = useCallback(function (event) {
        var value = event.target.value;
        setValue(value);
        if (onChange)
            onChange(event);
    }, [setValue, onChange]);
    var styles = getStyles$6({
        invalid: invalid,
        focus: focus,
        inverse: inverse,
        disabled: disabled
    });
    return (jsxs("div", __assign({ sx: __assign(__assign({}, styles.wrapper), wrapperStyles) }, { children: [jsxs("div", __assign({ sx: { display: 'flex' } }, { children: [jsx(Label, __assign({ focus: focus, onTop: !!value || focus, htmlFor: idValue, invalid: invalid, inverse: inverse, selectedTheme: defaultTheme, customStyles: styles.labelCustomStyle }, { children: label }), void 0),
                    jsx(Area, { ref: ref, id: idValue, inverse: inverse, invalid: invalid, focus: focus, textAreaStyles: textAreaStyles, value: value, name: name, label: label, disabled: disabled, autoComplete: autoComplete, onChange: handleChange, onFocus: function () { return setFocus(true); }, onBlur: function () { return setFocus(false); }, autoFocus: autoFocus }, void 0)] }), void 0),
            !!helper && jsx(HelperText, { inverse: inverse, text: helper }, void 0)] }), void 0));
});
TextArea.displayName = 'TextArea';

var _a$2;
var EThirdPartyLogoVariant;
(function (EThirdPartyLogoVariant) {
    // Programming Languages
    EThirdPartyLogoVariant["BASH"] = "Bash";
    EThirdPartyLogoVariant["C"] = "C";
    EThirdPartyLogoVariant["C_PLUS_PLUS"] = "C++";
    EThirdPartyLogoVariant["C_SHARP"] = "C#";
    EThirdPartyLogoVariant["DART"] = "Dart";
    EThirdPartyLogoVariant["GO"] = "Go";
    EThirdPartyLogoVariant["JAVA"] = "Java";
    EThirdPartyLogoVariant["JAVA_RED"] = "Java Red";
    EThirdPartyLogoVariant["JAVA_LOGOMARK"] = "Java LogoMark";
    EThirdPartyLogoVariant["JAVA_LOGOMARK_RED"] = "Java LogoMark Red";
    EThirdPartyLogoVariant["JAVASCRIPT"] = "Javascript";
    EThirdPartyLogoVariant["JAVASCRIPT_WHITE"] = "Javascript White";
    EThirdPartyLogoVariant["KOTLIN"] = "Kotlin";
    EThirdPartyLogoVariant["PERL"] = "Perl";
    EThirdPartyLogoVariant["PHP"] = "PHP";
    EThirdPartyLogoVariant["PHP_KNOCKOUT"] = "PHP Knockout";
    EThirdPartyLogoVariant["PYTHON"] = "Python";
    EThirdPartyLogoVariant["PYTHON_LOGOMARK"] = "Python LogoMark";
    EThirdPartyLogoVariant["PYTHON_LOGOMARK_YELLOW"] = "Python LogoMark Yellow";
    EThirdPartyLogoVariant["PYTHON_STACKED"] = "Python Stacked";
    EThirdPartyLogoVariant["RUBY"] = "Ruby";
    EThirdPartyLogoVariant["RUBY_KNOCKOUT"] = "Ruby Knockout";
    EThirdPartyLogoVariant["RUBY_LOGOMARK"] = "Ruby LogoMark";
    EThirdPartyLogoVariant["RUBY_LOGOMARK_KNOCKOUT"] = "Ruby LogoMark Knockout";
    EThirdPartyLogoVariant["RUST"] = "Rust";
    EThirdPartyLogoVariant["SCALA"] = "Scala";
    EThirdPartyLogoVariant["SCALA_LOGOMARK_KNOCKOUT"] = "Scala LogoMark Knockout";
    EThirdPartyLogoVariant["SWIFT"] = "Swift";
    EThirdPartyLogoVariant["TYPESCRIPT"] = "TypeScript";
    // Partners
    EThirdPartyLogoVariant["AWS"] = "AWS";
    EThirdPartyLogoVariant["AZURE"] = "Azure";
    EThirdPartyLogoVariant["AZURE_OLD"] = "Azure Old";
    EThirdPartyLogoVariant["CARAHSOFT"] = "Carahsoft";
    EThirdPartyLogoVariant["FEATURESPACE"] = "Featurespace";
    EThirdPartyLogoVariant["GOOGLE_CLOUD"] = "Google Cloud";
    EThirdPartyLogoVariant["GOOGLE_CLOUD_LOGOMARK"] = "Google Cloud LogoMark";
    EThirdPartyLogoVariant["RED_HAT"] = "Red Hat";
    EThirdPartyLogoVariant["RED_HAT_KNOCKOUT"] = "Red Hat Knockout";
    EThirdPartyLogoVariant["TCS"] = "TCS";
    EThirdPartyLogoVariant["ZALONI"] = "Zaloni";
    // Compliance
    EThirdPartyLogoVariant["AICPA_SOC"] = "AICPA SOC";
    EThirdPartyLogoVariant["FEDRAMP"] = "FedRAMP";
    EThirdPartyLogoVariant["GDPR"] = "GDPR";
    EThirdPartyLogoVariant["HIPAA"] = "HIPAA";
    EThirdPartyLogoVariant["ISO_27001"] = "ISO 27001";
    EThirdPartyLogoVariant["PCI"] = "PCI";
    // Customers
    EThirdPartyLogoVariant["SEVEN_ELEVEN"] = "Seven Eleven";
    EThirdPartyLogoVariant["ACXIOM"] = "Acxiom";
    EThirdPartyLogoVariant["ACXIOM_WHITE"] = "Acxiom White";
    EThirdPartyLogoVariant["ADOBE_HORIZONTAL_BLACK"] = "Adobe Horizontal Black";
    EThirdPartyLogoVariant["ADOBE_HORIZONTAL_RED"] = "Adobe Horizontal Red";
    EThirdPartyLogoVariant["ADOBE_VERTICAL_BLACK"] = "Adobe Vertical Black";
    EThirdPartyLogoVariant["ADOBE_VERTICAL_RED"] = "Adobe Vertical Red";
    EThirdPartyLogoVariant["ADP"] = "ADP";
    EThirdPartyLogoVariant["ATD_WHITE"] = "ATD White";
    EThirdPartyLogoVariant["BARCLAYS"] = "Barclays";
    EThirdPartyLogoVariant["BORDERFREE"] = "Borderfree";
    EThirdPartyLogoVariant["BOSH"] = "Bosh";
    EThirdPartyLogoVariant["COINBASE"] = "Coinbase";
    EThirdPartyLogoVariant["COMPARE_THE_MARKET"] = "Compare the Market";
    EThirdPartyLogoVariant["EA"] = "EA";
    EThirdPartyLogoVariant["EBAY"] = "Ebay";
    EThirdPartyLogoVariant["EHARMONY"] = "eharmony";
    EThirdPartyLogoVariant["FORBES"] = "Forbes";
    EThirdPartyLogoVariant["GOOGLE"] = "Google";
    EThirdPartyLogoVariant["GOOGLE_ICON"] = "Google Icon";
    EThirdPartyLogoVariant["GOV_UK"] = "gov.uk";
    EThirdPartyLogoVariant["HUMANITIX"] = "humanitix";
    EThirdPartyLogoVariant["HUMANITIX_lOGOMARK"] = "humanitix LogoMark";
    EThirdPartyLogoVariant["INGENIQ"] = "Ingeniq";
    EThirdPartyLogoVariant["INTUIT"] = "Intuit";
    EThirdPartyLogoVariant["INVISION"] = "Invision";
    EThirdPartyLogoVariant["KPMG"] = "KPMG";
    EThirdPartyLogoVariant["LIBERTY_MUTUAL"] = "Liberty Mutual";
    EThirdPartyLogoVariant["MET_OFFICE"] = "Met Office";
    EThirdPartyLogoVariant["OXFORD_NANOPORE"] = "Oxford Nanopore";
    EThirdPartyLogoVariant["NESTO"] = "Nesto";
    EThirdPartyLogoVariant["PATHAO"] = "Pathao";
    EThirdPartyLogoVariant["PITNEY_BOWES"] = "Pitney Powes";
    EThirdPartyLogoVariant["PRACTICEFUSION"] = "Practicefusion";
    EThirdPartyLogoVariant["SANOMA"] = "Sanoma";
    EThirdPartyLogoVariant["SAP"] = "SAP";
    EThirdPartyLogoVariant["SEGA"] = "SEGA";
    EThirdPartyLogoVariant["SOFTWARE_AG"] = "Software AG";
    EThirdPartyLogoVariant["SQUARE_SPACE"] = "Square Space";
    EThirdPartyLogoVariant["SQUARE_SPACE_STACKED"] = "Square Space Stacked";
    EThirdPartyLogoVariant["SWIMLANE"] = "Swimlane";
    EThirdPartyLogoVariant["TOYOTA_MH1"] = "Toyota Material Handling 1";
    EThirdPartyLogoVariant["TOYOTA_MH2"] = "Toyota Material Handling 2";
    EThirdPartyLogoVariant["VERIZON"] = "Verizon";
    EThirdPartyLogoVariant["VSCO"] = "VSCO";
    EThirdPartyLogoVariant["YOU_GOV"] = "You Gov";
    // Miscellaneous
    EThirdPartyLogoVariant["ANDROID"] = "Android";
    EThirdPartyLogoVariant["CLOUDFLARE"] = "Cloudflare";
    EThirdPartyLogoVariant["DJANGO"] = "Django";
    EThirdPartyLogoVariant["DOCKER"] = "Docker";
    EThirdPartyLogoVariant["DOTNET"] = ".Net";
    EThirdPartyLogoVariant["EXCEL"] = "Excel";
    EThirdPartyLogoVariant["FASTAPI"] = "FastAPI";
    EThirdPartyLogoVariant["FLASK"] = "Flask";
    EThirdPartyLogoVariant["FLUTTER"] = "Flutter";
    EThirdPartyLogoVariant["GITHUB_ACTIONS"] = "GitHub Actions";
    EThirdPartyLogoVariant["GRAPHQL"] = "GraphQL";
    EThirdPartyLogoVariant["IOS"] = "iOS";
    EThirdPartyLogoVariant["JETPACK_COMPOSE"] = "Jetpack Compose";
    EThirdPartyLogoVariant["KAFKA"] = "Kafka";
    EThirdPartyLogoVariant["KUBERNETES"] = "Kubernetes";
    EThirdPartyLogoVariant["NETLIFY"] = "Netlify";
    EThirdPartyLogoVariant["NEXTJS"] = "NextJS";
    EThirdPartyLogoVariant["NODEJS"] = "Node.js";
    EThirdPartyLogoVariant["PANDAS"] = "Pandas";
    EThirdPartyLogoVariant["PARQUET"] = "Parquet";
    EThirdPartyLogoVariant["POSTMAN"] = "Postman";
    EThirdPartyLogoVariant["PRISMA"] = "Prisma";
    EThirdPartyLogoVariant["RASPBERRY_PI"] = "Raspberry Pi";
    EThirdPartyLogoVariant["REACT"] = "React";
    EThirdPartyLogoVariant["SQL"] = "SQL";
    EThirdPartyLogoVariant["SPARK"] = "Spark";
    EThirdPartyLogoVariant["SPRING"] = "Spring";
    EThirdPartyLogoVariant["SVELTE"] = "Svelte";
    EThirdPartyLogoVariant["TERRAFORM"] = "Terraform";
    EThirdPartyLogoVariant["TLS"] = "TLS";
    EThirdPartyLogoVariant["UNITY"] = "Unity";
    EThirdPartyLogoVariant["VERCEL"] = "Vercel";
    EThirdPartyLogoVariant["VS_CODE"] = "VS Code";
    EThirdPartyLogoVariant["XAMARIN"] = "Xamarin";
    EThirdPartyLogoVariant["GITHUB"] = "Github";
})(EThirdPartyLogoVariant || (EThirdPartyLogoVariant = {}));
var LogoPaths = (_a$2 = {},
    _a$2[EThirdPartyLogoVariant.BASH] = 'https://webimages.mongodb.com/_com_assets/cms/l33o3agflprrzmgdy-Language-logo-Bash.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.C] = 'https://webimages.mongodb.com/_com_assets/cms/ks66s0ohwdti1j4es-lang_c.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.C_PLUS_PLUS] = 'https://webimages.mongodb.com/_com_assets/cms/ks67kvzgzoi0g33va-lang_c_plus_plus.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.C_SHARP] = 'https://webimages.mongodb.com/_com_assets/cms/ks67l72x98g3whceo-lang_c_sharp.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.DART] = 'https://webimages.mongodb.com/_com_assets/cms/l33o56mwwaf7bevgx-Language-logo-Dart.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GO] = 'https://webimages.mongodb.com/_com_assets/cms/ks67n6mbb5spon689-lang_go.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVA] = 'https://webimages.mongodb.com/_com_assets/cms/ks67o2jcxlujkbk0d-lang_java.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVA_RED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67ofl617k43nfbh-lang_java_red.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVA_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67or52h1vtq9spj-lang_java_logomark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVA_LOGOMARK_RED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67p0pnlloxd7xqu-lang_java_logomark_red.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVASCRIPT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pb1b0pxch9df4-lang_javascript.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JAVASCRIPT_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pjqmlkk6hbrt5-lang_javascript_white.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.KOTLIN] = 'https://webimages.mongodb.com/_com_assets/cms/l33o0vvxc9mp6wcmx-Language-logo-Kotlin.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PERL] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pv8yhrv81wc52-lang_pearl.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PHP] = 'https://webimages.mongodb.com/_com_assets/cms/ks67q3q71plcgkyrz-lang_php.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PHP_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67qmaunv56pjkcj-lang_php_knockout.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PYTHON] = 'https://webimages.mongodb.com/_com_assets/cms/ks67qw1a1whct10lb-lang_python.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PYTHON_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67r63qo5kuxary0-lang_python_logomark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PYTHON_LOGOMARK_YELLOW] = 'https://webimages.mongodb.com/_com_assets/cms/ks67rf0247qeyz7j4-lang_python_logomark_yellow.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PYTHON_STACKED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67rpgpvz8v3c0fq-lang_python_stacked.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RUBY] = 'https://webimages.mongodb.com/_com_assets/cms/ks67ry8jk1mga18vz-lang_ruby.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RUBY_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67s5ujd11affu87-lang_ruby_knockout.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RUBY_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67sdtrn76jurziq-lang_ruby_logomark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RUBY_LOGOMARK_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67sptgens44qpkc-lang_ruby_logomark_knockout.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RUST] = 'https://webimages.mongodb.com/_com_assets/cms/l33o3qr7xlwge9cm7-Language-logo-Rust.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SCALA] = 'https://webimages.mongodb.com/_com_assets/cms/ks67swsruf8mrukfd-lang_scala.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SCALA_LOGOMARK_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67t82pir7hv3ptl-lang_scala_logomark_knockout.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SWIFT] = 'https://webimages.mongodb.com/_com_assets/cms/l33o4bisbg9moskmo-Language-logo-Swift.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TYPESCRIPT] = 'https://webimages.mongodb.com/_com_assets/cms/l33o5hgbxqgpwwi3g-Language-logo-TypeScript.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.AWS] = 'https://webimages.mongodb.com/_com_assets/cms/ks6id0fldyolj0yvv-aws.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.AZURE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6idk2lqjypjk4t7-azure.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.AZURE_OLD] = 'https://webimages.mongodb.com/_com_assets/cms/ks6idsxqwglzueamt-azure_old.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.CARAHSOFT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ie35g4ikheindg-carahsoft.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FEATURESPACE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ieehmj92claby0-featurespace.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GOOGLE_CLOUD] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ientx6nxyanvfn-google_cloud.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GOOGLE_CLOUD_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks6it6zwfg8u6nrjb-google_cloud_logomark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RED_HAT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6if5nyi5vs50goc-redhat.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RED_HAT_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifdbntwyt0rzu0-redhat_knockout.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TCS] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifk6ipbho8ewmu-tos.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ZALONI] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifqt4vg57ml6tz-zaloni.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.AICPA_SOC] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j7f0g0091y4irt-aicpa_soc.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FEDRAMP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6ft3y8m0xcur30n-fedramp-logo.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GDPR] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j85vyqtkx742f3-gdpr.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.HIPAA] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8f6cv32h18p0i-hipaa.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ISO_27001] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8mjjj50e8zixu-iso_27001.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PCI] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8wuk84hx55up8-pci.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SEVEN_ELEVEN] = 'https://webimages.mongodb.com/_com_assets/cms/kr6es7jbos7hvv09w-7-Eleven.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ACXIOM] = 'https://webimages.mongodb.com/_com_assets/cms/kr6et2jascmp64ba4-Acxiom.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ACXIOM_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6jmq5cufv26sqqc-acxiom_white.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ADOBE_HORIZONTAL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f16wp4j46qcbc1-Adobe-horizontal-black.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ADOBE_HORIZONTAL_RED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f30ytyvhsl347z-Adobe-horizontal-red.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ADOBE_VERTICAL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f3b9tmt7jckx9b-Adobe-vertical-black.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ADOBE_VERTICAL_RED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f3mmruyh3xf3fm-Adobe-vertical-red.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ADP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f6pjpu3c0au7vk-ADP.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ATD_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6jtlv22ewtbxct3-atd_white.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.BARCLAYS] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f7se6k5ax8fa3g-Barclays.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.BORDERFREE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fbqc6kbb4nkpw0-Borderfree.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.BOSH] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fc1009fao1f6in-Bosch.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.COINBASE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fcd51mwis3uv4z-Coinbase.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.COMPARE_THE_MARKET] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fcnjuo9t5h25x0-Compare%20the%20Market.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.EA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsegcpeuyw49aq-EA.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.EBAY] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsnogsj8arp6vp-Ebay.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.EHARMONY] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsweujn9sso6wi-eharmony.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FORBES] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fuwe4n1ptbykc6-Forbes.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GOOGLE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fv7u35e8f7ksql-Google.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GOOGLE_ICON] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fvgdym4qzsgqo3-Google%20Icon.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GOV_UK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fvvdfx5091481o-gov.uk.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.HUMANITIX] = 'https://webimages.mongodb.com/_com_assets/cms/ks6kmbqzdycm59idh-humanitix.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.HUMANITIX_lOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks6lsq1xj1l3gyghw-humanitix_logomark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.INGENIQ] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fyk1whj88z80b5-Ingeniq.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.INTUIT] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fyvdyxnbb7hk6c-Intuit.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.INVISION] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fz6q2gf69z4nzh-Invision.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.KPMG] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g1yj0qxcuh9g10-KPMG.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.LIBERTY_MUTUAL] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g28v57p1j6yss9-LibertyMutual.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.MET_OFFICE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g2yh5102dl9znd-Met%20Office.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.OXFORD_NANOPORE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g4smemfi3ed2t8-Oxford%20Nanopore.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.NESTO] = 'https://webimages.mongodb.com/_com_assets/cms/ks6lxdqpo7morksyp-nesto.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PATHAO] = 'https://webimages.mongodb.com/_com_assets/cms/ks6m2l4wtu84ffv4b-pathao.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PITNEY_BOWES] = 'https://webimages.mongodb.com/_com_assets/cms/ks6m2xrynwanj8ph6-pitney_bowes.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PRACTICEFUSION] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g5cq2jtx1cuy3v-Practicefusion.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SANOMA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g7mzgvgqpqm0ds-Sanoma.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SAP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g7xek6crjapgl3-SAP.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SEGA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g9cgdb0oyojhzh-Sega.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SOFTWARE_AG] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g9yihl2d2rn9xz-software%20AG.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SQUARE_SPACE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gaa2dcm92ty4vt-Squarespace.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SQUARE_SPACE_STACKED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gbvoyn2b51i55q-Squarespace-Stacked.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SWIMLANE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gc7jnqhscclq45-Swimlane.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TOYOTA_MH1] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gcggixl0qp659i-ToyotaMH1.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TOYOTA_MH2] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gcpxvmgfg2bat3-ToyotaMH2.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.VERIZON] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gez4jikdzp1e0m-verizon.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.VSCO] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gg6ueye3a9ldmy-VSCO.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.YOU_GOV] = 'https://webimages.mongodb.com/_com_assets/cms/kr6ggflr1lky2rudf-YouGov.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.ANDROID] = 'https://webimages.mongodb.com/_com_assets/cms/l33ooa13i79261tsc-Technology-logo-Android.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.CLOUDFLARE] = 'https://webimages.mongodb.com/_com_assets/cms/l33octiag5sfne7up-Technology-logo-Cloudflare.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.DJANGO] = 'https://webimages.mongodb.com/_com_assets/cms/l33odbhwamx0pdbmy-Technology-logo-django.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.DOCKER] = 'https://webimages.mongodb.com/_com_assets/cms/l33oom4mn2sup435m-Technology-logo-Docker.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.DOTNET] = 'https://webimages.mongodb.com/_com_assets/cms/l33oscgq8tr1aloxi-Technology-logo-dotnet.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.EXCEL] = 'https://webimages.mongodb.com/_com_assets/cms/l33odrfyjsmiy54ei-Technology-logo-Excel.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FASTAPI] = 'https://webimages.mongodb.com/_com_assets/cms/l33oovtghlt08f0d7-Technology-logo-FastAPI.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FLASK] = 'https://webimages.mongodb.com/_com_assets/cms/l33oe2k8w0g8kgut8-Technology-logo-Flask.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.FLUTTER] = 'https://webimages.mongodb.com/_com_assets/cms/l33oecd18v2yakjy1-Technology-logo-Flutter.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GITHUB_ACTIONS] = 'https://webimages.mongodb.com/_com_assets/cms/l33oem9yetc8h6hlq-Technology-logo-githubactions.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GRAPHQL] = 'https://webimages.mongodb.com/_com_assets/cms/l33oevly5bnigtkj6-Technology-logo-GraphQL.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.IOS] = 'https://webimages.mongodb.com/_com_assets/cms/l33op8x52suu2irt8-Technology-logo-ios.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.JETPACK_COMPOSE] = 'https://webimages.mongodb.com/_com_assets/cms/l395ywxd0l5h0ibu9-Technology-logo-jetpackcompose.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.KAFKA] = 'https://webimages.mongodb.com/_com_assets/cms/l33ok7ydh6f9b5nlz-Technology-logo-Kafka.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.KUBERNETES] = 'https://webimages.mongodb.com/_com_assets/cms/l33opoaq4so08r71u-Technology-logo-Kubernetes.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.NETLIFY] = 'https://webimages.mongodb.com/_com_assets/cms/l33okhenm68sf61zu-Technology-logo-Netlify.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.NEXTJS] = 'https://webimages.mongodb.com/_com_assets/cms/l33opykjpq9k3z303-Technology-logo-NextJS.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.NODEJS] = 'https://webimages.mongodb.com/_com_assets/cms/l33oq8cte0w6l2k61-Technology-logo-Nodejs.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PANDAS] = 'https://webimages.mongodb.com/_com_assets/cms/l33ol4wg1rahpsuo0-Technology-logo-Pandas.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PARQUET] = 'https://webimages.mongodb.com/_com_assets/cms/l33olfge30eagpe03-Technology-logo-Parquet.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.POSTMAN] = 'https://webimages.mongodb.com/_com_assets/cms/l33oloo2hh82osiy8-Technology-logo-PostmanAPI.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.PRISMA] = 'https://webimages.mongodb.com/_com_assets/cms/l33olz6zn9im330j2-Technology-logo-Prisma.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.RASPBERRY_PI] = 'https://webimages.mongodb.com/_com_assets/cms/l33om8qeecbl9a9k1-Technology-logo-Raspberrypi.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.REACT] = 'https://webimages.mongodb.com/_com_assets/cms/l33omikp2v1el7cvk-Technology-logo-React.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SQL] = 'https://webimages.mongodb.com/_com_assets/cms/l33oqjcwmk4zkthoz-Technology-logo-SQL.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SPARK] = 'https://webimages.mongodb.com/_com_assets/cms/l33omu7t20ccmhxh8-Technology-logo-Spark.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SPRING] = 'https://webimages.mongodb.com/_com_assets/cms/l7hvb19vulrih2hba-Technology-logo-Spring.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.SVELTE] = 'https://webimages.mongodb.com/_com_assets/cms/l33on2skzgajd7j8r-Technology-logo-Svelte.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TERRAFORM] = 'https://webimages.mongodb.com/_com_assets/cms/lbl2b48lekus2mfmv-Technology-logo-Terraform-01.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.TLS] = 'https://webimages.mongodb.com/_com_assets/cms/l33onckyq3i0v4rp9-Technology-logo-TLS.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.UNITY] = 'https://webimages.mongodb.com/_com_assets/cms/l33oqup54xyl3kpuf-Technology-logo-Unity.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.VERCEL] = 'https://webimages.mongodb.com/_com_assets/cms/l33onletldvsoo43o-Technology-logo-Vercel.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.VS_CODE] = 'https://webimages.mongodb.com/_com_assets/cms/l3n4tmq26v0e31yy1-Technology-logo-VScode.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.XAMARIN] = 'https://webimages.mongodb.com/_com_assets/cms/l33oo06uil69oundf-Technology-logo-Xamarin.svg?auto=format%252Ccompress',
    _a$2[EThirdPartyLogoVariant.GITHUB] = 'https://webimages.mongodb.com/_com_assets/cms/l9ihe7j6851h094o1-github.svg?auto=format%252Ccompress',
    _a$2);

var ThirdPartyLogo = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b; _a.theme; var _d = _a.alt, alt = _d === void 0 ? '' : _d, href = _a.href, target = _a.target, _e = _a.imageWidth, imageWidth = _e === void 0 ? '150px' : _e, variant = _a.variant;
    return (jsx("a", __assign({ sx: { display: 'inline-block' }, href: href, target: target, className: className }, { children: jsx("img", { src: LogoPaths[variant], className: className, alt: alt, sx: {
                width: imageWidth,
                display: 'inline-block'
            } }, void 0) }), void 0));
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// Hook that listens for Tab key presses on the passed ref
var useTabEscape = function (ref, handler) {
    useEffect(function () {
        // Alert if Tab key pressed on element
        var listener = function (event) {
            var tabMatches = event.key === 'Tab';
            var refMatches = Array.isArray(ref === null || ref === void 0 ? void 0 : ref.current)
                ? !(ref === null || ref === void 0 ? void 0 : ref.current.some(function (el) { return el.contains(event.target); }))
                : !(ref === null || ref === void 0 ? void 0 : ref.current.contains(event.target));
            if (ref && ref.current && refMatches && tabMatches) {
                handler(event);
            }
        };
        // Bind the event listener
        document.addEventListener('keydown', listener);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener('keydown', listener);
        };
    }, [ref, handler]);
};

var getElementByVariant = function (variant, customElement) {
    if (customElement) {
        return customElement;
    }
    return isBody(variant) || isMono(variant)
        ? 'span'
        : getAppropriateHeading(variant);
};
var isBody = function (variant) {
    return variant.includes('body');
};
var isMono = function (variant) {
    return variant.includes('mono');
};
var Heading = {
    heading1: 'h1',
    heading2: 'h2',
    heading3: 'h3',
    heading4: 'h4',
    heading5: 'h5',
    heading6: 'h6'
};
var getAppropriateHeading = function (variant) {
    return Heading[variant];
};
var Color = {
    default: 'text.default',
    secondary: 'text.secondary',
    error: 'text.error',
    neutral: 'text.neutral',
    selected: 'text.selected',
    mark: 'text.mark'
};
var InverseColor = {
    default: 'text.inverse',
    secondary: 'text.inverseSecondary',
    error: 'text.errorInverse',
    neutral: 'text.neutral',
    selected: 'text.inverseSelected',
    mark: 'text.inverseMark'
};
var getColor$2 = function (inverse, color) { return (inverse ? InverseColor[color] : Color[color]); };
var getVariantStyles$1 = function (variant, flashCard, largeTitle) {
    var fontFamily = getFontFamily(variant, flashCard);
    var fontToken = getFontToken(variant, flashCard, largeTitle);
    // theme-ui handles responsiveness by passing fontSize/lineHeights as an array of values, the order is important!
    return {
        fontFamily: fontFamily,
        fontSize: [
            fontToken + "Responsive",
            fontToken + "Responsive",
            fontToken + "Responsive",
            "" + fontToken // size when screen is 1024px or greater
        ],
        lineHeight: [
            fontToken + "Responsive",
            fontToken + "Responsive",
            fontToken + "Responsive",
            "" + fontToken // size when screen is 1024px or greater
        ],
        letterSpacing: isMono(variant) ? '3px' : null
    };
};
var getFontFamily = function (variant, flashCard) {
    if (variant === 'heading5' || variant === 'heading6' || flashCard) {
        return 'body';
    }
    return variant.replace(/[0-9]/g, '');
};
var getFontToken = function (variant, flashCard, largeTitle) {
    var sizes = getSizes(variant);
    var fontToken = variant.replace(/[0-9]/g, function (match) { return sizes[match] || 'M'; });
    // To meet SEO requirements, small and large FlashCard headings will both be <h3>'s with appropriate styles
    if (flashCard && largeTitle) {
        fontToken = 'headingS';
    }
    else if (flashCard) {
        fontToken = 'headingXS';
    }
    return fontToken;
};
var getSizes = function (variant) {
    var monoSizes = { 1: 'L', 2: 'M', 3: 'S' };
    var bodySizes = { 1: 'L', 2: 'M', 3: 'S', 4: 'XS' };
    var headingSizes = { 1: 'XXL', 2: 'XL', 3: 'L', 4: 'M', 5: 'S', 6: 'XS' };
    if (isMono(variant))
        return monoSizes;
    if (isBody(variant))
        return bodySizes;
    return headingSizes;
};

var TypographyScale = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b; _a.theme; var children = _a.children, _d = _a.variant, variant = _d === void 0 ? 'body1' : _d, _e = _a.inverse, inverse = _e === void 0 ? false : _e, _f = _a.color, color = _f === void 0 ? 'default' : _f, customStyles = _a.customStyles, customElement = _a.customElement, _g = _a.flashCard, flashCard = _g === void 0 ? false : _g, _h = _a.largeTitle, largeTitle = _h === void 0 ? false : _h;
    var Element = getElementByVariant(variant, customElement);
    return (jsx(Element, __assign({ className: className, sx: __assign(__assign({ margin: 0, color: getColor$2(inverse, color) }, getVariantStyles$1(variant, flashCard, largeTitle)), customStyles) }, { children: children }), void 0));
};

var getStyles$5 = function (state) {
    var open = state.open, value = state.value, invalid = state.invalid, inverse = state.inverse, disabled = state.disabled, width = state.width, height = state.height;
    var colors = defaultTheme.colors, space = defaultTheme.space, fontSizes = defaultTheme.fontSizes;
    var inputColors = colors.forms.textInput[inverse ? 'inverse' : 'default'];
    var errorColors = inputColors.error;
    var bottomBorderColor = inputColors.border, labelColor = inputColors.label;
    if (open || value) {
        labelColor = inputColors.focus.label;
    }
    if (invalid && !value) {
        bottomBorderColor = errorColors.border;
        labelColor = errorColors.label;
    }
    if (invalid && value) {
        bottomBorderColor = errorColors.borderFocus;
        labelColor = errorColors.labelFocus;
    }
    return {
        bottomBorder: {
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: '4px',
            bg: bottomBorderColor
        },
        button: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            width: ['100%', null, null, width],
            height: height,
            padding: 'inc40',
            bg: inputColors.bg,
            boxSizing: 'border-box',
            border: 0,
            borderTopLeftRadius: 'input',
            borderTopRightRadius: 'input',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? '60%' : '1',
            '&:focus-visible': {
                outline: "1px solid " + inputColors.border
            }
        },
        label: {
            fontFamily: 'body',
            textTransform: 'capitalize',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            left: 0,
            position: open || value ? 'absolute' : 'relative',
            marginLeft: open || value ? 'inc40' : 'unset',
            whiteSpace: 'nowrap',
            willChange: 'transform, color, font-size',
            transitionProperty: 'transform, color, font-size',
            transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
            transitionDuration: '200ms',
            transitionDelay: '0ms',
            transform: "translateY(" + (open || value ? "-" + space.inc40 : '0px') + ")",
            fontSize: open || value ? fontSizes.inc10 : fontSizes.inc40,
            color: labelColor
        },
        value: {
            width: width || '100%',
            textAlign: 'left',
            color: inverse ? 'text.inverse' : 'text.default'
        }
    };
};

var SelectButton = function (_a) {
    var id = _a.id, name = _a.name, inverse = _a.inverse, invalid = _a.invalid, disabled = _a.disabled, open = _a.open, value = _a.value, width = _a.width, height = _a.height, children = _a.children, onKeyDown = _a.onKeyDown;
    var styles = getStyles$5({
        open: open,
        value: value,
        invalid: invalid,
        inverse: inverse,
        disabled: disabled,
        width: width,
        height: height
    });
    return (jsxs("button", __assign({ id: id, name: name, role: 'select', sx: styles.button, type: 'button', onKeyDown: onKeyDown }, { children: [value && (jsx(TypographyScale, __assign({ customStyles: __assign(__assign({}, styles.value), { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '93%' }) }, { children: value }), void 0)),
            jsx("label", __assign({ htmlFor: id, sx: styles.label }, { children: children }), void 0),
            jsx(SystemIcon, { name: invalid && !value
                    ? ESystemIconNames.CIRCLE_ALERT
                    : ESystemIconNames.CHEVRON_DOWN, color: invalid && !value ? 'secondaryError' : 'default', inverse: inverse, customStyles: {
                    transform: open && !invalid ? 'rotateZ(180deg)' : 'rotateZ(0.5deg)',
                    transition: 'transform .15s ease-in-out',
                    position: 'absolute',
                    right: 'inc40'
                } }, void 0),
            jsx("div", { sx: styles.bottomBorder }, void 0)] }), void 0));
};

var getStyles$4 = function (_a) {
    var open = _a.open, placement = _a.placement, wrapperHeight = _a.wrapperHeight;
    var colors = defaultTheme.colors, space = defaultTheme.space;
    return {
        dropdown: __assign({ visibility: placement ? 'visible' : 'hidden', position: 'absolute', zIndex: 1000, display: open ? 'block' : 'none', width: '100%', maxHeight: 'calc(70px * 6)', overflowX: 'hidden', overflowY: 'auto', padding: space.inc30 + " " + space.inc40, bg: 'background.body', boxShadow: '0px 3px 9px rgba(0, 0, 0, 0.15)' }, (placement === 'top'
            ? {
                borderTopLeftRadius: 'input',
                borderTopRightRadius: 'input',
                bottom: wrapperHeight
            }
            : {
                borderBottomLeftRadius: 'input',
                borderBottomRightRadius: 'input'
            })),
        singleOption: {
            position: 'relative',
            padding: space.inc30 + " 0",
            listStyle: 'none',
            display: 'flex',
            alignItems: 'center',
            ':not(:last-child)': {
                borderBottom: "1px solid " + colors.black20
            },
            '&:hover': {
                borderRadius: 'input',
                bg: 'black20',
                width: 'auto',
                marginLeft: '-12px',
                paddingLeft: '12px',
                marginRight: '-12px',
                paddingRight: '12px',
                cursor: 'pointer'
            },
            '&:hover::before': {
                content: "''",
                position: 'absolute',
                bg: 'black20',
                height: '4px',
                top: '-1px',
                left: '0',
                width: '100%',
                borderTopLeftRadius: 'input',
                borderTopRightRadius: 'input'
            },
            '&:hover span': {
                color: 'text.default'
            }
        },
        selectedOption: {
            span: {
                fontWeight: 500,
                color: 'blue80'
            },
            svg: {
                stroke: 'blue60'
            }
        }
    };
};

var img = "data:image/gif;base64,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";

var LoadingAnimation = function (_a) {
    var _b = _a.height, height = _b === void 0 ? '24px' : _b, _c = _a.width, width = _c === void 0 ? '24px' : _c;
    return (jsx("div", __assign({ sx: {
            display: 'flex',
            justifyContent: 'center'
        } }, { children: jsx("img", { src: img, alt: 'Loading...', sx: {
                height: height,
                width: width
            } }, void 0) }), void 0));
};

var ITEMS_PER_SCROLL = 40;
var Options = function (_a) {
    var options = _a.options, styles = _a.styles, onClick = _a.onClick, onKeyPress = _a.onKeyPress, selection = _a.selection;
    return options.map(function (option, i) {
        var icon = null;
        var label = '';
        if (typeof option === 'string') {
            label = option;
        }
        else {
            label = option.label;
            icon = option.icon;
        }
        var isSelected = label === selection;
        return (jsxs("li", __assign({ role: 'option', tabIndex: 0, sx: __assign(__assign({}, styles.singleOption), (isSelected && __assign({}, styles.selectedOption))), onClick: onClick, onKeyPress: onKeyPress }, { children: [icon && (jsx(SystemIcon, { name: icon, sx: {
                        height: 'inc20',
                        width: 'inc20',
                        marginRight: 'inc40',
                        stroke: 'black50'
                    } }, void 0)),
                jsx("span", __assign({ sx: {
                        width: '100%',
                        color: 'text.secondary',
                        fontSize: 'inc40',
                        lineHeight: 'inc30',
                        fontFamily: 'euclid-circular-a'
                    } }, { children: label }), void 0),
                isSelected && (jsx(SystemIcon, { name: ESystemIconNames.CHECK, sx: {
                        height: 'inc20',
                        width: 'inc20'
                    } }, void 0))] }), "dropdown-options-" + option + "--" + i));
    });
};
var Dropdown$1 = function (_a) {
    var options = _a.options, open = _a.open, selection = _a.selection, _b = _a.noResults, noResults = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.lazyLoad, lazyLoad = _d === void 0 ? false : _d, _e = _a.itemsPerScroll, itemsPerScroll = _e === void 0 ? ITEMS_PER_SCROLL : _e, isSearching = _a.isSearching, menuPlacement = _a.menuPlacement, wrapperHeight = _a.wrapperHeight, wrapperOffsetTop = _a.wrapperOffsetTop, containerOffsetHeight = _a.containerOffsetHeight, onSelect = _a.onSelect;
    var _f = useState(options.slice(0, itemsPerScroll)), current = _f[0], setCurrent = _f[1];
    var _g = useState(current.length < options.length), hasMore = _g[0], setHasMore = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(undefined), placement = _j[0], setPlacement = _j[1];
    var dropdownRef = useRef(null);
    var getValue = function (event) {
        var el = event.target;
        return el.innerText;
    };
    var onClickHandler = function (e) {
        e.stopPropagation();
        var value = getValue(e);
        onSelect(value);
    };
    var onKeyPressHandler = function (e) {
        if (e.key === 'Enter') {
            e.stopPropagation();
            var value = getValue(e);
            onSelect(value);
        }
    };
    var styles = getStyles$4({ open: open, placement: placement, wrapperHeight: wrapperHeight });
    useEffect(function () {
        if (menuPlacement === 'auto') {
            if (open &&
                dropdownRef &&
                dropdownRef.current &&
                wrapperOffsetTop &&
                wrapperHeight) {
                var wrapperOffsetHeight = containerOffsetHeight || document.body.offsetHeight;
                var spaceAfterSelect = wrapperOffsetHeight - wrapperOffsetTop - wrapperHeight;
                if (spaceAfterSelect < dropdownRef.current.offsetHeight) {
                    setPlacement('top');
                }
                else {
                    setPlacement('bottom');
                }
            }
            else {
                setPlacement(undefined);
            }
        }
        else {
            setPlacement(menuPlacement);
        }
    }, [open]);
    var ListBox = function (_a) {
        var children = _a.children;
        return (jsx("ul", __assign({ role: 'listbox', sx: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            } }, { children: children }), void 0));
    };
    if (lazyLoad) {
        var showLoadingElement = loading && hasMore && !isSearching;
        var fetchMoreOptions_1 = function () {
            if (current.length === options.length) {
                setHasMore(false);
                setLoading(false);
                return;
            }
            setCurrent(current.concat(options.slice(current.length, current.length + itemsPerScroll)));
            setLoading(true);
        };
        var handleScroll = function (e) {
            var _a = e.currentTarget, scrollHeight = _a.scrollHeight, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight;
            var bottom = scrollHeight - scrollTop === clientHeight;
            if (bottom) {
                hasMore && fetchMoreOptions_1();
            }
        };
        return (jsxs("div", __assign({ ref: dropdownRef, role: 'dropdown', sx: styles.dropdown, onScroll: handleScroll }, { children: [jsx(ListBox, { children: jsx(Options, { styles: styles, options: options, selection: selection, onClick: onClickHandler, onKeyPress: onKeyPressHandler }, void 0) }, void 0),
                showLoadingElement && jsx(LoadingAnimation, {}, void 0)] }), void 0));
    }
    var getOptions = function () {
        var component = (jsx(Options, { options: options, selection: selection, styles: styles, onClick: onClickHandler, onKeyPress: onKeyPressHandler }, void 0));
        if (isLoading) {
            component = jsx(LoadingAnimation, {}, void 0);
        }
        else if (noResults) {
            component = (jsx(TypographyScale, __assign({ variant: 'body1', color: 'secondary' }, { children: "No results found" }), void 0));
        }
        return component;
    };
    return (jsx("div", __assign({ ref: dropdownRef, role: 'dropdown', sx: styles.dropdown }, { children: jsx(ListBox, { children: getOptions() }, void 0) }), void 0));
};

var KEYS;
(function (KEYS) {
    KEYS["Escape"] = "Escape";
    KEYS["Tab"] = "Tab";
})(KEYS || (KEYS = {}));

var Select = function (_a) {
    var _b, _c;
    var _d = _a.inverse, inverse = _d === void 0 ? false : _d, _e = _a.invalid, invalid = _e === void 0 ? false : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.lazyLoad, lazyLoad = _g === void 0 ? false : _g, itemsPerScroll = _a.itemsPerScroll, name = _a.name, label = _a.label, options = _a.options, id = _a.id, className = _a.className, onSelect = _a.onSelect, onDropdownOpen = _a.onDropdownOpen, _h = _a.value, value = _h === void 0 ? undefined : _h, helper = _a.helper, _j = _a.open, open = _j === void 0 ? false : _j, _k = _a.width, width = _k === void 0 ? '456px' : _k, _l = _a.height, height = _l === void 0 ? '80px' : _l, _m = _a.menuPlacement, menuPlacement = _m === void 0 ? 'bottom' : _m, containerOffsetHeight = _a.containerOffsetHeight;
    var idValue = id || name.toLowerCase().replace(/\s/g, '');
    var _o = useState(open), isDropdownOpen = _o[0], setIsDropdownOpen = _o[1];
    var _p = useState(value), selectedValue = _p[0], setSelectedValue = _p[1];
    var _q = useState([]), filteredOptions = _q[0], setFilteredOptions = _q[1];
    var isSearching = !!filteredOptions.length;
    var wrapperRef = useRef(null);
    var wrapperHeight = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight;
    var wrapperOffsetTop = (_c = wrapperRef.current) === null || _c === void 0 ? void 0 : _c.offsetTop;
    var handleSelect = function (value) {
        setSelectedValue(value);
        if (onSelect)
            onSelect(value);
        setIsDropdownOpen(!isDropdownOpen);
    };
    var onSearch = function (key) {
        if (key === KEYS.Escape)
            setIsDropdownOpen(false);
        if (key === KEYS.Tab)
            return;
        var filteredOptions = options.filter(function (option) { return option[0].toLowerCase() === key; });
        setFilteredOptions(filteredOptions);
    };
    useOnClickOutside(wrapperRef, function () { return setIsDropdownOpen(false); });
    useTabEscape(wrapperRef, function () { return setIsDropdownOpen(false); });
    useEffect(function () {
        if (value !== selectedValue) {
            setSelectedValue(value);
            if (onSelect)
                onSelect(value);
            setIsDropdownOpen(!isDropdownOpen);
        }
    }, [value]);
    useEffect(function () {
        if (isDropdownOpen && onDropdownOpen) {
            onDropdownOpen();
        }
    }, [isDropdownOpen]);
    useEffect(function () {
        setIsDropdownOpen(open);
    }, [open]);
    return (jsxs("div", __assign({ ref: wrapperRef, className: className, sx: {
            position: 'relative',
            width: ['100%', null, null, width],
            height: height
        }, onClick: function () {
            if (!disabled) {
                setIsDropdownOpen(!isDropdownOpen);
            }
        } }, { children: [jsx(SelectButton, __assign({ id: idValue, name: name, inverse: inverse, invalid: invalid, disabled: disabled, open: isDropdownOpen, value: selectedValue, width: width, height: height, onKeyDown: function (e) { return onSearch(e.key); } }, { children: label }), void 0),
            jsx(Dropdown$1, { options: isSearching ? filteredOptions : options, isSearching: isSearching, open: isDropdownOpen, onSelect: handleSelect, lazyLoad: lazyLoad, itemsPerScroll: itemsPerScroll, menuPlacement: menuPlacement, wrapperHeight: wrapperHeight, wrapperOffsetTop: wrapperOffsetTop, containerOffsetHeight: containerOffsetHeight }, void 0),
            helper && jsx(HelperText, { text: helper, inverse: inverse }, void 0)] }), void 0));
};

var getVariantStyles = function (variant) {
    var Style = {
        large: {
            padding: defaultTheme.space.inc20 + " " + defaultTheme.space.inc30,
            fontSize: 'inc20'
        },
        small: {
            padding: defaultTheme.space.inc10 + " " + defaultTheme.space.inc20,
            fontSize: 'inc00'
        }
    };
    return Style[variant];
};

var Tag = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b; _a.theme; var _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, href = _a.href, target = _a.target, _e = _a.inverse, inverse = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'large' : _f, children = _a.children;
    var TagName = href ? 'a' : 'span';
    return (jsx(TagName, __assign({ "aria-label": 'tag-container', className: className, sx: __assign({ cursor: href ? 'pointer' : 'default', textDecoration: 'none', display: 'inline-block', border: '1px solid', borderColor: inverse ? 'tag.inverseBorder' : 'tag.border', borderRadius: 'inc20', backgroundColor: inverse ? 'tag.inverseBG' : 'tag.bg', fontFamily: 'body', fontWeight: 500, lineHeight: 'inc00', color: inverse ? 'tag.inverseText' : 'tag.text', '&:hover': {
                boxShadow: inverse ? 'tagHoverInverse' : 'tagHover',
                transition: 'motion.tag'
            }, '&:active': {
                boxShadow: 'none',
                transition: 'motion.tag'
            } }, getVariantStyles(variant)), onClick: onClick, href: href, target: target }, { children: children }), void 0));
};

var GridLayout = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, customStyles = _a.customStyles, children = _a.children;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx(Grid, __assign({ columns: [6, null, 8, 12], gap: selectedTheme.space.inc40, className: className, sx: __assign({ maxWidth: selectedTheme.sizes.maxWidthDesktop, margin: 'auto' }, customStyles) }, { children: children }), void 0));
};

var getSizeStyles = function (size) {
    switch (size) {
        case 'medium': {
            return {
                width: 'brandedIconMedium',
                height: 'brandedIconMedium'
            };
        }
        case 'large': {
            return {
                width: 'brandedIconLarge',
                height: 'brandedIconLarge'
            };
        }
        default: {
            return {
                width: 'brandedIconSmall',
                height: 'brandedIconSmall'
            };
        }
    }
};

var BrandedIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.inverse, inverse = _d === void 0 ? false : _d; _a.theme; var name = _a.name, alt = _a.alt, customStyles = _a.customStyles;
    var imgSource = "https://webimages.mongodb.com/_com_assets/icons/" + name + (inverse ? '_inverse' : '') + ".svg";
    return (jsx("img", { className: className, src: imgSource, alt: alt || name, sx: __assign(__assign({}, getSizeStyles(size)), customStyles) }, void 0));
};

var EBrandedIcons;
(function (EBrandedIcons) {
    EBrandedIcons[EBrandedIcons["general_action_archive"] = 0] = "general_action_archive";
    EBrandedIcons[EBrandedIcons["general_action_archive_inverse"] = 1] = "general_action_archive_inverse";
    EBrandedIcons[EBrandedIcons["general_action_audit"] = 2] = "general_action_audit";
    EBrandedIcons[EBrandedIcons["general_action_audit_inverse"] = 3] = "general_action_audit_inverse";
    EBrandedIcons[EBrandedIcons["general_action_barriers"] = 4] = "general_action_barriers";
    EBrandedIcons[EBrandedIcons["general_action_barriers_inverse"] = 5] = "general_action_barriers_inverse";
    EBrandedIcons[EBrandedIcons["general_action_best_practices"] = 6] = "general_action_best_practices";
    EBrandedIcons[EBrandedIcons["general_action_best_practices_inverse"] = 7] = "general_action_best_practices_inverse";
    EBrandedIcons[EBrandedIcons["general_action_call"] = 8] = "general_action_call";
    EBrandedIcons[EBrandedIcons["general_action_call_inverse"] = 9] = "general_action_call_inverse";
    EBrandedIcons[EBrandedIcons["general_action_develop"] = 10] = "general_action_develop";
    EBrandedIcons[EBrandedIcons["general_action_develop_inverse"] = 11] = "general_action_develop_inverse";
    EBrandedIcons[EBrandedIcons["general_action_download"] = 12] = "general_action_download";
    EBrandedIcons[EBrandedIcons["general_action_download_inverse"] = 13] = "general_action_download_inverse";
    EBrandedIcons[EBrandedIcons["general_action_event_driven"] = 14] = "general_action_event_driven";
    EBrandedIcons[EBrandedIcons["general_action_event_driven_inverse"] = 15] = "general_action_event_driven_inverse";
    EBrandedIcons[EBrandedIcons["general_action_favorite"] = 16] = "general_action_favorite";
    EBrandedIcons[EBrandedIcons["general_action_favorite_inverse"] = 17] = "general_action_favorite_inverse";
    EBrandedIcons[EBrandedIcons["general_action_locked"] = 18] = "general_action_locked";
    EBrandedIcons[EBrandedIcons["general_action_locked_inverse"] = 19] = "general_action_locked_inverse";
    EBrandedIcons[EBrandedIcons["general_action_login"] = 20] = "general_action_login";
    EBrandedIcons[EBrandedIcons["general_action_login_inverse"] = 21] = "general_action_login_inverse";
    EBrandedIcons[EBrandedIcons["general_action_read"] = 22] = "general_action_read";
    EBrandedIcons[EBrandedIcons["general_action_read_inverse"] = 23] = "general_action_read_inverse";
    EBrandedIcons[EBrandedIcons["general_action_search"] = 24] = "general_action_search";
    EBrandedIcons[EBrandedIcons["general_action_search_inverse"] = 25] = "general_action_search_inverse";
    EBrandedIcons[EBrandedIcons["general_action_share"] = 26] = "general_action_share";
    EBrandedIcons[EBrandedIcons["general_action_share_inverse"] = 27] = "general_action_share_inverse";
    EBrandedIcons[EBrandedIcons["general_action_star"] = 28] = "general_action_star";
    EBrandedIcons[EBrandedIcons["general_action_star_inverse"] = 29] = "general_action_star_inverse";
    EBrandedIcons[EBrandedIcons["general_action_unlocked"] = 30] = "general_action_unlocked";
    EBrandedIcons[EBrandedIcons["general_action_unlocked_inverse"] = 31] = "general_action_unlocked_inverse";
    EBrandedIcons[EBrandedIcons["general_action_view"] = 32] = "general_action_view";
    EBrandedIcons[EBrandedIcons["general_action_view_inverse"] = 33] = "general_action_view_inverse";
    EBrandedIcons[EBrandedIcons["general_alert"] = 34] = "general_alert";
    EBrandedIcons[EBrandedIcons["general_alert_change_alert"] = 35] = "general_alert_change_alert";
    EBrandedIcons[EBrandedIcons["general_alert_change_alert_inverse"] = 36] = "general_alert_change_alert_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_error"] = 37] = "general_alert_error";
    EBrandedIcons[EBrandedIcons["general_alert_error_inverse"] = 38] = "general_alert_error_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_high_cost"] = 39] = "general_alert_high_cost";
    EBrandedIcons[EBrandedIcons["general_alert_high_cost_inverse"] = 40] = "general_alert_high_cost_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_incompatible"] = 41] = "general_alert_incompatible";
    EBrandedIcons[EBrandedIcons["cloud_blocker"] = 42] = "cloud_blocker";
    EBrandedIcons[EBrandedIcons["cloud_blocker_inverse"] = 43] = "cloud_blocker_inverse";
    EBrandedIcons[EBrandedIcons["cloud_disaster_recovery"] = 44] = "cloud_disaster_recovery";
    EBrandedIcons[EBrandedIcons["cloud_disaster_recovery_inverse"] = 45] = "cloud_disaster_recovery_inverse";
    EBrandedIcons[EBrandedIcons["cloud_global"] = 46] = "cloud_global";
    EBrandedIcons[EBrandedIcons["cloud_global_inverse"] = 47] = "cloud_global_inverse";
    EBrandedIcons[EBrandedIcons["cloud_iot"] = 48] = "cloud_iot";
    EBrandedIcons[EBrandedIcons["cloud_iot_inverse"] = 49] = "cloud_iot_inverse";
    EBrandedIcons[EBrandedIcons["cloud_manage_users"] = 50] = "cloud_manage_users";
    EBrandedIcons[EBrandedIcons["cloud_manage_users_inverse"] = 51] = "cloud_manage_users_inverse";
    EBrandedIcons[EBrandedIcons["cloud_managed"] = 52] = "cloud_managed";
    EBrandedIcons[EBrandedIcons["cloud_managed_inverse"] = 53] = "cloud_managed_inverse";
    EBrandedIcons[EBrandedIcons["general_content_blog"] = 54] = "general_content_blog";
    EBrandedIcons[EBrandedIcons["general_content_blog_inverse"] = 55] = "general_content_blog_inverse";
    EBrandedIcons[EBrandedIcons["general_content_collaborate"] = 56] = "general_content_collaborate";
    EBrandedIcons[EBrandedIcons["general_content_collaborate_inverse"] = 57] = "general_content_collaborate_inverse";
    EBrandedIcons[EBrandedIcons["general_content_community"] = 58] = "general_content_community";
    EBrandedIcons[EBrandedIcons["general_content_community_inverse"] = 59] = "general_content_community_inverse";
    EBrandedIcons[EBrandedIcons["general_content_ebook"] = 60] = "general_content_ebook";
    EBrandedIcons[EBrandedIcons["general_content_ebook_inverse"] = 61] = "general_content_ebook_inverse";
    EBrandedIcons[EBrandedIcons["general_content_expertise"] = 62] = "general_content_expertise";
    EBrandedIcons[EBrandedIcons["general_content_expertise_inverse"] = 63] = "general_content_expertise_inverse";
    EBrandedIcons[EBrandedIcons["general_content_learn"] = 64] = "general_content_learn";
    EBrandedIcons[EBrandedIcons["general_content_learn_inverse"] = 65] = "general_content_learn_inverse";
    EBrandedIcons[EBrandedIcons["general_content_play"] = 66] = "general_content_play";
    EBrandedIcons[EBrandedIcons["general_content_play_inverse"] = 67] = "general_content_play_inverse";
    EBrandedIcons[EBrandedIcons["general_content_presentations"] = 68] = "general_content_presentations";
    EBrandedIcons[EBrandedIcons["general_content_presentations_inverse"] = 69] = "general_content_presentations_inverse";
    EBrandedIcons[EBrandedIcons["general_content_pricing"] = 70] = "general_content_pricing";
    EBrandedIcons[EBrandedIcons["general_content_pricing_inverse"] = 71] = "general_content_pricing_inverse";
    EBrandedIcons[EBrandedIcons["general_content_tutorial"] = 72] = "general_content_tutorial";
    EBrandedIcons[EBrandedIcons["general_content_tutorial_inverse"] = 73] = "general_content_tutorial_inverse";
    EBrandedIcons[EBrandedIcons["general_content_user"] = 74] = "general_content_user";
    EBrandedIcons[EBrandedIcons["general_content_user_inverse"] = 75] = "general_content_user_inverse";
    EBrandedIcons[EBrandedIcons["general_content_users"] = 76] = "general_content_users";
    EBrandedIcons[EBrandedIcons["general_content_users_inverse"] = 77] = "general_content_users_inverse";
    EBrandedIcons[EBrandedIcons["general_content_white_paper"] = 78] = "general_content_white_paper";
    EBrandedIcons[EBrandedIcons["general_content_white_paper_inverse"] = 79] = "general_content_white_paper_inverse";
    EBrandedIcons[EBrandedIcons["general_events"] = 80] = "general_events";
    EBrandedIcons[EBrandedIcons["general_events_ask_the_experts"] = 81] = "general_events_ask_the_experts";
    EBrandedIcons[EBrandedIcons["general_events_ask_the_experts_inverse"] = 82] = "general_events_ask_the_experts_inverse";
    EBrandedIcons[EBrandedIcons["general_events_breakout"] = 83] = "general_events_breakout";
    EBrandedIcons[EBrandedIcons["general_events_breakout_inverse"] = 84] = "general_events_breakout_inverse";
    EBrandedIcons[EBrandedIcons["general_events_inverse"] = 85] = "general_events_inverse";
    EBrandedIcons[EBrandedIcons["general_events_keynote"] = 86] = "general_events_keynote";
    EBrandedIcons[EBrandedIcons["general_events_keynote_inverse"] = 87] = "general_events_keynote_inverse";
    EBrandedIcons[EBrandedIcons["general_events_register"] = 88] = "general_events_register";
    EBrandedIcons[EBrandedIcons["general_events_register_inverse"] = 89] = "general_events_register_inverse";
    EBrandedIcons[EBrandedIcons["general_events_restrooms"] = 90] = "general_events_restrooms";
    EBrandedIcons[EBrandedIcons["general_events_restrooms_inverse"] = 91] = "general_events_restrooms_inverse";
    EBrandedIcons[EBrandedIcons["general_events_session"] = 92] = "general_events_session";
    EBrandedIcons[EBrandedIcons["general_events_session_inverse"] = 93] = "general_events_session_inverse";
    EBrandedIcons[EBrandedIcons["general_events_ticketing"] = 94] = "general_events_ticketing";
    EBrandedIcons[EBrandedIcons["general_events_ticketing_inverse"] = 95] = "general_events_ticketing_inverse";
    EBrandedIcons[EBrandedIcons["general_events_vendor_lock_in"] = 96] = "general_events_vendor_lock_in";
    EBrandedIcons[EBrandedIcons["general_events_vendor_lock_in_inverse"] = 97] = "general_events_vendor_lock_in_inverse";
    EBrandedIcons[EBrandedIcons["general_features_api"] = 98] = "general_features_api";
    EBrandedIcons[EBrandedIcons["general_features_api_inverse"] = 99] = "general_features_api_inverse";
    EBrandedIcons[EBrandedIcons["general_features_automation"] = 100] = "general_features_automation";
    EBrandedIcons[EBrandedIcons["general_features_automation_inverse"] = 101] = "general_features_automation_inverse";
    EBrandedIcons[EBrandedIcons["general_features_build_faster"] = 102] = "general_features_build_faster";
    EBrandedIcons[EBrandedIcons["general_features_build_faster_inverse"] = 103] = "general_features_build_faster_inverse";
    EBrandedIcons[EBrandedIcons["general_features_commercial_license"] = 104] = "general_features_commercial_license";
    EBrandedIcons[EBrandedIcons["general_features_commercial_license_inverse"] = 105] = "general_features_commercial_license_inverse";
    EBrandedIcons[EBrandedIcons["general_features_complexity"] = 106] = "general_features_complexity";
    EBrandedIcons[EBrandedIcons["general_features_complexity_inverse"] = 107] = "general_features_complexity_inverse";
    EBrandedIcons[EBrandedIcons["general_features_conversion"] = 108] = "general_features_conversion";
    EBrandedIcons[EBrandedIcons["general_features_conversion_inverse"] = 109] = "general_features_conversion_inverse";
    EBrandedIcons[EBrandedIcons["general_features_data_analytics"] = 110] = "general_features_data_analytics";
    EBrandedIcons[EBrandedIcons["general_features_data_analytics_inverse"] = 111] = "general_features_data_analytics_inverse";
    EBrandedIcons[EBrandedIcons["general_features_data_silos"] = 112] = "general_features_data_silos";
    EBrandedIcons[EBrandedIcons["general_features_data_silos_inverse"] = 113] = "general_features_data_silos_inverse";
    EBrandedIcons[EBrandedIcons["general_features_dynamic"] = 114] = "general_features_dynamic";
    EBrandedIcons[EBrandedIcons["general_features_dynamic_inverse"] = 115] = "general_features_dynamic_inverse";
    EBrandedIcons[EBrandedIcons["general_features_faq"] = 116] = "general_features_faq";
    EBrandedIcons[EBrandedIcons["general_features_faq_inverse"] = 117] = "general_features_faq_inverse";
    EBrandedIcons[EBrandedIcons["general_features_flexibility"] = 118] = "general_features_flexibility";
    EBrandedIcons[EBrandedIcons["general_features_flexibility_inverse"] = 119] = "general_features_flexibility_inverse";
    EBrandedIcons[EBrandedIcons["general_features_global"] = 120] = "general_features_global";
    EBrandedIcons[EBrandedIcons["general_features_global_clusters"] = 121] = "general_features_global_clusters";
    EBrandedIcons[EBrandedIcons["general_features_global_clusters_inverse"] = 122] = "general_features_global_clusters_inverse";
    EBrandedIcons[EBrandedIcons["general_features_global_inverse"] = 123] = "general_features_global_inverse";
    EBrandedIcons[EBrandedIcons["general_features_insight"] = 124] = "general_features_insight";
    EBrandedIcons[EBrandedIcons["general_features_insight_inverse"] = 125] = "general_features_insight_inverse";
    EBrandedIcons[EBrandedIcons["general_features_intelligent_edge"] = 126] = "general_features_intelligent_edge";
    EBrandedIcons[EBrandedIcons["general_features_intelligent_edge_inverse"] = 127] = "general_features_intelligent_edge_inverse";
    EBrandedIcons[EBrandedIcons["general_features_list"] = 128] = "general_features_list";
    EBrandedIcons[EBrandedIcons["general_features_list_inverse"] = 129] = "general_features_list_inverse";
    EBrandedIcons[EBrandedIcons["general_features_management"] = 130] = "general_features_management";
    EBrandedIcons[EBrandedIcons["general_features_management_inverse"] = 131] = "general_features_management_inverse";
    EBrandedIcons[EBrandedIcons["general_features_marketing_support"] = 132] = "general_features_marketing_support";
    EBrandedIcons[EBrandedIcons["general_features_marketing_support_inverse"] = 133] = "general_features_marketing_support_inverse";
    EBrandedIcons[EBrandedIcons["general_features_multiple_formats"] = 134] = "general_features_multiple_formats";
    EBrandedIcons[EBrandedIcons["general_features_multiple_formats_inverse"] = 135] = "general_features_multiple_formats_inverse";
    EBrandedIcons[EBrandedIcons["general_features_on_demand"] = 136] = "general_features_on_demand";
    EBrandedIcons[EBrandedIcons["general_features_on_demand_inverse"] = 137] = "general_features_on_demand_inverse";
    EBrandedIcons[EBrandedIcons["general_features_realtime"] = 138] = "general_features_realtime";
    EBrandedIcons[EBrandedIcons["general_features_realtime_inverse"] = 139] = "general_features_realtime_inverse";
    EBrandedIcons[EBrandedIcons["general_features_scale_bigger"] = 140] = "general_features_scale_bigger";
    EBrandedIcons[EBrandedIcons["general_features_scale_bigger_inverse"] = 141] = "general_features_scale_bigger_inverse";
    EBrandedIcons[EBrandedIcons["general_features_support"] = 142] = "general_features_support";
    EBrandedIcons[EBrandedIcons["general_features_support_inverse"] = 143] = "general_features_support_inverse";
    EBrandedIcons[EBrandedIcons["general_features_table"] = 144] = "general_features_table";
    EBrandedIcons[EBrandedIcons["general_features_table_inverse"] = 145] = "general_features_table_inverse";
    EBrandedIcons[EBrandedIcons["general_features_tools"] = 146] = "general_features_tools";
    EBrandedIcons[EBrandedIcons["general_features_tools_inverse"] = 147] = "general_features_tools_inverse";
    EBrandedIcons[EBrandedIcons["general_features_transactions"] = 148] = "general_features_transactions";
    EBrandedIcons[EBrandedIcons["general_features_transactions_inverse"] = 149] = "general_features_transactions_inverse";
    EBrandedIcons[EBrandedIcons["industry_ai"] = 150] = "industry_ai";
    EBrandedIcons[EBrandedIcons["industry_ai_inverse"] = 151] = "industry_ai_inverse";
    EBrandedIcons[EBrandedIcons["industry_airline_app"] = 152] = "industry_airline_app";
    EBrandedIcons[EBrandedIcons["industry_airline_app_inverse"] = 153] = "industry_airline_app_inverse";
    EBrandedIcons[EBrandedIcons["industry_automotive"] = 154] = "industry_automotive";
    EBrandedIcons[EBrandedIcons["industry_automotive_inverse"] = 155] = "industry_automotive_inverse";
    EBrandedIcons[EBrandedIcons["industry_enterprise"] = 156] = "industry_enterprise";
    EBrandedIcons[EBrandedIcons["industry_enterprise_inverse"] = 157] = "industry_enterprise_inverse";
    EBrandedIcons[EBrandedIcons["industry_finance"] = 158] = "industry_finance";
    EBrandedIcons[EBrandedIcons["industry_finance_inverse"] = 159] = "industry_finance_inverse";
    EBrandedIcons[EBrandedIcons["industry_healthcare"] = 160] = "industry_healthcare";
    EBrandedIcons[EBrandedIcons["industry_healthcare_inverse"] = 161] = "industry_healthcare_inverse";
    EBrandedIcons[EBrandedIcons["misc_achievement"] = 162] = "misc_achievement";
    EBrandedIcons[EBrandedIcons["misc_achievement_inverse"] = 163] = "misc_achievement_inverse";
    EBrandedIcons[EBrandedIcons["misc_bug"] = 164] = "misc_bug";
    EBrandedIcons[EBrandedIcons["misc_bug_inverse"] = 165] = "misc_bug_inverse";
    EBrandedIcons[EBrandedIcons["misc_create"] = 166] = "misc_create";
    EBrandedIcons[EBrandedIcons["misc_create_inverse"] = 167] = "misc_create_inverse";
    EBrandedIcons[EBrandedIcons["misc_delete"] = 168] = "misc_delete";
    EBrandedIcons[EBrandedIcons["misc_delete_inverse"] = 169] = "misc_delete_inverse";
    EBrandedIcons[EBrandedIcons["misc_desktop"] = 170] = "misc_desktop";
    EBrandedIcons[EBrandedIcons["misc_desktop_inverse"] = 171] = "misc_desktop_inverse";
    EBrandedIcons[EBrandedIcons["misc_global"] = 172] = "misc_global";
    EBrandedIcons[EBrandedIcons["misc_global_inverse"] = 173] = "misc_global_inverse";
    EBrandedIcons[EBrandedIcons["number_plus"] = 174] = "number_plus";
    EBrandedIcons[EBrandedIcons["number_plus_inverse"] = 175] = "number_plus_inverse";
    EBrandedIcons[EBrandedIcons["number_minus"] = 176] = "number_minus";
    EBrandedIcons[EBrandedIcons["number_minus_inverse"] = 177] = "number_minus_inverse";
    EBrandedIcons[EBrandedIcons["number_0"] = 178] = "number_0";
    EBrandedIcons[EBrandedIcons["number_0_inverse"] = 179] = "number_0_inverse";
    EBrandedIcons[EBrandedIcons["number_1"] = 180] = "number_1";
    EBrandedIcons[EBrandedIcons["number_1_inverse"] = 181] = "number_1_inverse";
    EBrandedIcons[EBrandedIcons["number_2"] = 182] = "number_2";
    EBrandedIcons[EBrandedIcons["number_2_inverse"] = 183] = "number_2_inverse";
    EBrandedIcons[EBrandedIcons["number_3"] = 184] = "number_3";
    EBrandedIcons[EBrandedIcons["number_3_inverse"] = 185] = "number_3_inverse";
    EBrandedIcons[EBrandedIcons["number_4"] = 186] = "number_4";
    EBrandedIcons[EBrandedIcons["number_4_inverse"] = 187] = "number_4_inverse";
    EBrandedIcons[EBrandedIcons["number_5"] = 188] = "number_5";
    EBrandedIcons[EBrandedIcons["number_5_inverse"] = 189] = "number_5_inverse";
    EBrandedIcons[EBrandedIcons["number_6"] = 190] = "number_6";
    EBrandedIcons[EBrandedIcons["number_6_inverse"] = 191] = "number_6_inverse";
    EBrandedIcons[EBrandedIcons["number_7"] = 192] = "number_7";
    EBrandedIcons[EBrandedIcons["number_7_inverse"] = 193] = "number_7_inverse";
    EBrandedIcons[EBrandedIcons["number_8"] = 194] = "number_8";
    EBrandedIcons[EBrandedIcons["number_8_inverse"] = 195] = "number_8_inverse";
    EBrandedIcons[EBrandedIcons["number_secondary_node_inverse"] = 196] = "number_secondary_node_inverse";
    EBrandedIcons[EBrandedIcons["number_9"] = 197] = "number_9";
    EBrandedIcons[EBrandedIcons["number_9_inverse"] = 198] = "number_9_inverse";
    EBrandedIcons[EBrandedIcons["number_secondary_node"] = 199] = "number_secondary_node";
    EBrandedIcons[EBrandedIcons["number_primary_node_inverse"] = 200] = "number_primary_node_inverse";
    EBrandedIcons[EBrandedIcons["number_compute_node"] = 201] = "number_compute_node";
    EBrandedIcons[EBrandedIcons["number_compute_node_inverse"] = 202] = "number_compute_node_inverse";
    EBrandedIcons[EBrandedIcons["number_primary_node"] = 203] = "number_primary_node";
    EBrandedIcons[EBrandedIcons["general_security"] = 204] = "general_security";
    EBrandedIcons[EBrandedIcons["general_security_encrypted_storage"] = 205] = "general_security_encrypted_storage";
    EBrandedIcons[EBrandedIcons["general_security_encrypted_storage_inverse"] = 206] = "general_security_encrypted_storage_inverse";
    EBrandedIcons[EBrandedIcons["general_security_encryption"] = 207] = "general_security_encryption";
    EBrandedIcons[EBrandedIcons["general_security_encryption_inverse"] = 208] = "general_security_encryption_inverse";
    EBrandedIcons[EBrandedIcons["general_security_federated_identity"] = 209] = "general_security_federated_identity";
    EBrandedIcons[EBrandedIcons["general_security_federated_identity_inverse"] = 210] = "general_security_federated_identity_inverse";
    EBrandedIcons[EBrandedIcons["general_security_hipaa_compliance"] = 211] = "general_security_hipaa_compliance";
    EBrandedIcons[EBrandedIcons["general_security_hipaa_compliance_inverse"] = 212] = "general_security_hipaa_compliance_inverse";
    EBrandedIcons[EBrandedIcons["general_security_inverse"] = 213] = "general_security_inverse";
    EBrandedIcons[EBrandedIcons["general_security_privacy"] = 214] = "general_security_privacy";
    EBrandedIcons[EBrandedIcons["general_security_privacy_inverse"] = 215] = "general_security_privacy_inverse";
    EBrandedIcons[EBrandedIcons["general_security_secure_by_default"] = 216] = "general_security_secure_by_default";
    EBrandedIcons[EBrandedIcons["general_security_secure_by_default_inverse"] = 217] = "general_security_secure_by_default_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_incompatible_inverse"] = 218] = "general_alert_incompatible_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_info_inverse"] = 219] = "general_alert_info_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_inverse"] = 220] = "general_alert_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_mobile"] = 221] = "general_alert_mobile";
    EBrandedIcons[EBrandedIcons["general_alert_mobile_inverse"] = 222] = "general_alert_mobile_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_security"] = 223] = "general_alert_security";
    EBrandedIcons[EBrandedIcons["cloud_multicloud_inverse"] = 224] = "cloud_multicloud_inverse";
    EBrandedIcons[EBrandedIcons["cloud_private_link"] = 225] = "cloud_private_link";
    EBrandedIcons[EBrandedIcons["cloud_private_link_inverse"] = 226] = "cloud_private_link_inverse";
    EBrandedIcons[EBrandedIcons["cloud_settings"] = 227] = "cloud_settings";
    EBrandedIcons[EBrandedIcons["cloud_settings_inverse"] = 228] = "cloud_settings_inverse";
    EBrandedIcons[EBrandedIcons["industry_mobile_gaming"] = 229] = "industry_mobile_gaming";
    EBrandedIcons[EBrandedIcons["industry_mobile_gaming_inverse"] = 230] = "industry_mobile_gaming_inverse";
    EBrandedIcons[EBrandedIcons["industry_retail"] = 231] = "industry_retail";
    EBrandedIcons[EBrandedIcons["industry_retail_inverse"] = 232] = "industry_retail_inverse";
    EBrandedIcons[EBrandedIcons["misc_grow_inverse"] = 233] = "misc_grow_inverse";
    EBrandedIcons[EBrandedIcons["misc_mobile"] = 234] = "misc_mobile";
    EBrandedIcons[EBrandedIcons["misc_mobile_inverse"] = 235] = "misc_mobile_inverse";
    EBrandedIcons[EBrandedIcons["misc_send"] = 236] = "misc_send";
    EBrandedIcons[EBrandedIcons["misc_send_inverse"] = 237] = "misc_send_inverse";
    EBrandedIcons[EBrandedIcons["misc_transform"] = 238] = "misc_transform";
    EBrandedIcons[EBrandedIcons["misc_transform_inverse"] = 239] = "misc_transform_inverse";
    EBrandedIcons[EBrandedIcons["general_alert_info"] = 240] = "general_alert_info";
    EBrandedIcons[EBrandedIcons["general_alert_security_inverse"] = 241] = "general_alert_security_inverse";
    EBrandedIcons[EBrandedIcons["cloud_mobility"] = 242] = "cloud_mobility";
    EBrandedIcons[EBrandedIcons["cloud_mobility_inverse"] = 243] = "cloud_mobility_inverse";
    EBrandedIcons[EBrandedIcons["cloud_multicloud"] = 244] = "cloud_multicloud";
    EBrandedIcons[EBrandedIcons["cloud_schedule"] = 245] = "cloud_schedule";
    EBrandedIcons[EBrandedIcons["cloud_schedule_inverse"] = 246] = "cloud_schedule_inverse";
    EBrandedIcons[EBrandedIcons["cloud_transfer"] = 247] = "cloud_transfer";
    EBrandedIcons[EBrandedIcons["cloud_transfer_inverse"] = 248] = "cloud_transfer_inverse";
    EBrandedIcons[EBrandedIcons["industry_healthcare_query"] = 249] = "industry_healthcare_query";
    EBrandedIcons[EBrandedIcons["industry_healthcare_query_inverse"] = 250] = "industry_healthcare_query_inverse";
    EBrandedIcons[EBrandedIcons["industry_oil_gas_energy"] = 251] = "industry_oil_gas_energy";
    EBrandedIcons[EBrandedIcons["industry_oil_gas_energy_inverse"] = 252] = "industry_oil_gas_energy_inverse";
    EBrandedIcons[EBrandedIcons["industry_restaurant"] = 253] = "industry_restaurant";
    EBrandedIcons[EBrandedIcons["industry_restaurant_inverse"] = 254] = "industry_restaurant_inverse";
    EBrandedIcons[EBrandedIcons["industry_telecom"] = 255] = "industry_telecom";
    EBrandedIcons[EBrandedIcons["industry_telecom_inverse"] = 256] = "industry_telecom_inverse";
    EBrandedIcons[EBrandedIcons["misc_grow"] = 257] = "misc_grow";
    EBrandedIcons[EBrandedIcons["misc_laptop"] = 258] = "misc_laptop";
    EBrandedIcons[EBrandedIcons["misc_laptop_inverse"] = 259] = "misc_laptop_inverse";
    EBrandedIcons[EBrandedIcons["misc_sunrise"] = 260] = "misc_sunrise";
    EBrandedIcons[EBrandedIcons["misc_sunrise_inverse"] = 261] = "misc_sunrise_inverse";
})(EBrandedIcons || (EBrandedIcons = {}));

var getStyles$3 = function (state, theme) {
    var disabled = state.disabled, inverse = state.inverse, selected = state.selected, focused = state.focused, indeterminate = state.indeterminate;
    var colors = theme.colors.forms;
    var checkboxType = inverse ? 'checkboxInverse' : 'checkbox';
    var glyphColor = 'transparent', outlineColor = 'transparent', borderColor = colors[checkboxType].boxBorder, backgroundColor = 'transparent';
    if (selected) {
        borderColor = 'transparent';
        glyphColor = colors[checkboxType].icon;
        backgroundColor = colors[checkboxType].bgSelected;
    }
    if (focused) {
        outlineColor = colors[checkboxType].focusBorder;
    }
    return {
        input: {
            position: 'absolute',
            width: 0,
            height: 0,
            margin: 0,
            opacity: 0
        },
        label: {
            display: 'grid',
            gridTemplateColumns: 'repeat(2, auto)',
            gridTemplateAreas: "\n        \"checkbox  label-text\"\n        \".         helper-text\"\n      ",
            columnGap: 10,
            alignItems: 'center',
            justifyContent: 'flex-start',
            opacity: disabled ? 0.6 : 1
        },
        checkbox: {
            position: 'relative',
            display: 'inline-block',
            gridArea: 'checkbox',
            cursor: disabled ? 'not-allowed' : 'pointer',
            width: [16, null, null, 20],
            height: [16, null, null, 20],
            borderStyle: 'solid',
            borderWidth: 2,
            borderRadius: 4,
            borderColor: borderColor,
            backgroundColor: backgroundColor,
            outlineStyle: 'solid',
            outlineWidth: 2,
            outlineOffset: 2,
            outlineColor: outlineColor
        },
        glyph: {
            position: 'relative',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            height: 10,
            width: 10,
            '&::before': {
                content: '""',
                position: 'absolute',
                margin: 'auto',
                top: indeterminate ? 0 : ['10%', null, null, '0%'],
                bottom: indeterminate ? 0 : null,
                left: indeterminate ? 0 : null,
                right: indeterminate ? 0 : ['10%', null, null, '0%'],
                transform: indeterminate ? null : 'rotate(-45deg)',
                transformOrigin: '100% 0%',
                width: indeterminate ? [8, null, null, 10] : [8, null, null, 11],
                height: indeterminate ? 3 : [2, null, null, 2.5],
                borderRadius: '0.5rem',
                backgroundColor: glyphColor
            },
            '&::after': {
                content: indeterminate ? null : '""',
                position: 'absolute',
                bottom: '45%',
                left: ['10%', null, null, '0%'],
                transform: 'rotate(45deg)',
                transformOrigin: '0% 45%',
                width: [5, null, null, 6.5],
                height: [2, null, null, 2.5],
                borderRadius: '0.5rem',
                backgroundColor: glyphColor
            }
        }
    };
};

var Checkbox = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.label, label = _c === void 0 ? '' : _c, _d = _a.helper, helper = _d === void 0 ? '' : _d, _e = _a.name, name = _e === void 0 ? '' : _e, _f = _a.theme, theme = _f === void 0 ? 'default' : _f; _a.children; var _g = _a.onToggle, onToggle = _g === void 0 ? function () { } : _g, props = __rest(_a, ["className", "label", "helper", "name", "theme", "children", "onToggle"]);
    var _h = props.checked, checked = _h === void 0 ? false : _h, _j = props.disabled, disabled = _j === void 0 ? false : _j, _k = props.inverse, inverse = _k === void 0 ? false : _k, _l = props.indeterminate, indeterminate = _l === void 0 ? false : _l;
    var _m = useState(checked), selected = _m[0], setSelected = _m[1];
    var _o = useState(false), focused = _o[0], setFocused = _o[1];
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var checkboxState = { disabled: disabled, inverse: inverse, selected: selected, focused: focused, indeterminate: indeterminate };
    var styles = getStyles$3(checkboxState, selectedTheme);
    // updates the selected state to match the storybook checked control
    useEffect(function () {
        setSelected(checked);
    }, [checked]);
    var handleSelected = function () {
        setSelected(function (s) { return !s; });
        if (onToggle) {
            onToggle(!selected);
        }
    };
    return (jsxs("div", __assign({ className: className, sx: props.customStyles }, { children: [jsx("input", { checked: selected, onChange: disabled ? function () { } : handleSelected, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, type: 'checkbox', id: name, name: name, sx: styles.input }, void 0),
            jsxs("label", __assign({ "aria-label": name, htmlFor: name, sx: styles.label }, { children: [jsx("span", __assign({ "aria-label": 'checkbox', sx: styles.checkbox }, { children: jsx("span", __assign({ sx: {
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            } }, { children: jsx("span", { sx: styles.glyph }, void 0) }), void 0) }), void 0),
                    jsx(TypographyScale, __assign({ inverse: inverse, variant: 'body3', sx: { gridArea: 'label-text ' } }, { children: label }), void 0),
                    jsx(TypographyScale, __assign({ inverse: inverse, variant: 'body3', color: 'secondary', customStyles: {
                            marginTop: selectedTheme.space.neg10,
                            maxWidth: 300,
                            gridArea: 'helper-text'
                        } }, { children: label && helper }), void 0)] }), void 0)] }), void 0));
};

var getFontStyles = function (textSize) {
    var FontStyles = {
        small: {
            fontSize: ['inc10', 'inc10', 'inc10', 'inc20'],
            lineHeight: ['inc20', 'inc20', 'inc20', 'inc30']
        },
        medium: {
            fontSize: ['inc30', 'inc30', 'inc30', 'inc40'],
            lineHeight: ['inc30', 'inc30', 'inc30', 'inc30']
        },
        large: {
            fontSize: ['inc40', 'inc40', 'inc40', 'inc70'],
            lineHeight: ['inc30', 'inc30', 'inc30', 'inc40']
        }
    };
    return FontStyles[textSize];
};
var getGlyphStyles = function (glyph, textSize, inverse) {
    var large = textSize === 'large';
    var GlyphStyle = {
        circle: {
            width: '12px',
            height: '12px',
            bg: inverse ? 'list.inverse.bullet' : 'list.default.bullet',
            borderRadius: '50%',
            top: large
                ? ['10px', '10px', '10px', '14px']
                : ['6px', '6px', '6px', '10px'],
            left: large ? ['3px', '3px', '3px', '8px'] : '2px'
        },
        checkmark: __assign(__assign({}, getCheckmarkStyles(textSize, inverse)), { transform: 'rotate(-45deg)' })
    };
    return GlyphStyle[glyph];
};
var getCheckmarkStyles = function (textSize, inverse) {
    var color = inverse
        ? defaultTheme.colors.list.inverse.checkmark
        : defaultTheme.colors.list.default.checkmark;
    var thinBorder = "2px solid " + color;
    var thickBorder = "3px solid " + color;
    var CheckmarkStyles = {
        small: {
            width: '15px',
            height: '6px',
            borderBottom: thinBorder,
            borderLeft: thinBorder,
            top: ['4px', '4px', '4px', '7px'],
            left: '1px'
        },
        medium: {
            width: ['15px', '15px', '15px', '22px'],
            height: ['7px', '7px', '7px', '9px'],
            borderBottom: [thinBorder, thinBorder, thinBorder, thickBorder],
            borderLeft: [thinBorder, thinBorder, thinBorder, thickBorder],
            top: '8px',
            left: '2px'
        },
        large: {
            width: ['15px', '15px', '15px', '22px'],
            height: ['7px', '7px', '7px', '9px'],
            borderBottom: [thinBorder, thinBorder, thinBorder, thickBorder],
            borderLeft: [thinBorder, thinBorder, thinBorder, thickBorder],
            top: '8px',
            left: '2px'
        }
    };
    return CheckmarkStyles[textSize];
};
var getMarginBottom = function (textSize, description) {
    var MarginBottomStyles = {
        small: {
            marginBottom: description ? 'inc70' : 'inc30'
        },
        medium: {
            marginBottom: description ? 'inc70' : 'inc30'
        },
        large: {
            marginBottom: description ? 'inc70' : ['inc20', null, null, 'inc40']
        }
    };
    return MarginBottomStyles[textSize];
};

var Unordered = function (_a) {
    var _b = _a.glyph, glyph = _b === void 0 ? 'checkmark' : _b, items = _a.items, _c = _a.inverse, inverse = _c === void 0 ? false : _c, _d = _a.textSize, textSize = _d === void 0 ? 'small' : _d;
    var large = textSize === 'large';
    return (jsx("ul", __assign({ sx: {
            margin: 0,
            padding: 0,
            listStyleType: 'none'
        } }, { children: items.map(function (item, index) {
            return (jsxs("li", __assign({ sx: __assign(__assign({ position: 'relative', marginBottom: large ? ['inc20', null, null, 'inc40'] : 'inc30', paddingLeft: large
                        ? ['32px', '32px', '32px', '48px']
                        : ['32px', '32px', '32px', '40px'] }, getFontStyles(textSize)), getMarginBottom(textSize, (typeof item !== 'string' && item.description) || '')) }, { children: [jsx("span", { sx: {
                            position: 'absolute',
                            left: 0,
                            '&::before': __assign({ content: '""', position: 'absolute', left: 0 }, getGlyphStyles(glyph, textSize, inverse))
                        } }, void 0),
                    typeof item === 'string' && (jsx("span", __assign({ sx: __assign({}, getFontStyles(textSize)) }, { children: item }), void 0)),
                    typeof item !== 'string' && item.title && (jsx("span", __assign({ sx: __assign(__assign({}, getFontStyles(textSize)), { display: 'block', fontWeight: 500 }) }, { children: item.title }), void 0)),
                    typeof item !== 'string' && item.description && (jsx("span", __assign({ sx: __assign(__assign({}, getFontStyles(textSize)), { color: inverse ? 'text.inverseSecondary' : 'text.secondary' }) }, { children: item.description }), void 0))] }), index));
        }) }), void 0));
};

var Ordered = function (_a) {
    var items = _a.items, _b = _a.textSize, textSize = _b === void 0 ? 'small' : _b, inverse = _a.inverse;
    return (jsx("ol", __assign({ sx: { margin: 0 } }, { children: items.map(function (item, index) {
            return (jsxs("li", __assign({ sx: __assign(__assign({ paddingLeft: 'inc40' }, getMarginBottom(textSize, (typeof item !== 'string' && item.description) || '')), getFontStyles(textSize)) }, { children: [typeof item === 'string' && (jsx("span", __assign({ sx: __assign({}, getFontStyles(textSize)) }, { children: item }), void 0)),
                    typeof item !== 'string' && item.title && (jsx("span", __assign({ sx: __assign(__assign({}, getFontStyles(textSize)), { display: 'block', fontWeight: 500 }) }, { children: item.title }), void 0)),
                    typeof item !== 'string' && item.description && (jsx("span", __assign({ sx: __assign(__assign({}, getFontStyles(textSize)), { color: inverse ? 'text.inverseSecondary' : 'text.secondary' }) }, { children: item.description }), void 0))] }), index));
        }) }), void 0));
};

var List = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.variant, variant = _c === void 0 ? 'unordered' : _c; _a.theme; var items = _a.items, _e = _a.glyph, glyph = _e === void 0 ? 'checkmark' : _e, _f = _a.textSize, textSize = _f === void 0 ? 'small' : _f, _g = _a.inverse, inverse = _g === void 0 ? false : _g;
    var sharedProps = { items: items, textSize: textSize, inverse: inverse };
    return (jsx("div", __assign({ className: className, sx: {
            color: inverse ? 'list.inverse.text' : 'list.default.text',
            fontFamily: 'body'
        } }, { children: variant === 'unordered' ? (jsx(Unordered, __assign({}, sharedProps, { glyph: glyph }), void 0)) : (jsx(Ordered, __assign({}, sharedProps), void 0)) }), void 0));
};

var getBadgeStyles = function (size, theme) {
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    if (size === 'small') {
        return {
            borderRadius: 'inc20',
            padding: get(selectedTheme, 'spacing.inc10', '4px') + " " + get(selectedTheme, 'spacing.inc20', '8px'),
            fontSize: 'inc00'
        };
    }
    return {
        borderRadius: 'inc30',
        padding: get(selectedTheme, 'spacing.inc20', '8px') + " " + get(selectedTheme, 'spacing.inc30', '16px'),
        fontSize: 'inc10'
    };
};
var getBadgeColors = function (inverse) {
    if (inverse) {
        return {
            backgroundColor: 'pill.badge.inverse.bg',
            color: 'pill.badge.inverse.text'
        };
    }
    return {
        backgroundColor: 'pill.badge.default.bg',
        color: 'pill.badge.default.text'
    };
};
var getIdentifierStyles = function (size, theme) {
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    if (size === 'small') {
        return {
            padding: get(selectedTheme, 'spacing.inc10', '4px') + " " + get(selectedTheme, 'spacing.inc30', '16px'),
            letterSpacing: 2.5
        };
    }
    return {
        padding: get(selectedTheme, 'spacing.inc20', '8px') + " " + get(selectedTheme, 'spacing.inc40', '24px'),
        letterSpacing: 3
    };
};
var getIdentifierColorStyles = function (color, inverse) {
    if (inverse) {
        return {
            color: 'pill.identifier.inverse.inverseText',
            background: 'transparent',
            borderWidth: 'inc10',
            borderStyle: 'solid',
            borderColor: 'pill.identifier.inverse.borderInformational'
        };
    }
    if (color === 'primary') {
        return {
            color: 'pill.identifier.primary.textInformational',
            backgroundColor: 'pill.identifier.primary.bgInformational'
        };
    }
    return {
        color: 'pill.identifier.secondary.textInformational',
        backgroundColor: 'pill.identifier.secondary.bgInformational'
    };
};

var Badge = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.inverse, inverse = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? 'default' : _e, _f = _a.shouldUppercase, shouldUppercase = _f === void 0 ? true : _f, text = _a.text;
    var transformedText = shouldUppercase
        ? text.toUpperCase()
        : text.charAt(0).toUpperCase() + text.slice(1);
    return (jsx("span", __assign({ className: className, sx: __assign(__assign({ display: 'inline-block', fontWeight: 600, fontFamily: 'body', lineHeight: 'inc00' }, getBadgeColors(inverse)), getBadgeStyles(size, theme)) }, { children: transformedText }), void 0));
};

var Identifier = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, _e = _a.color, color = _e === void 0 ? 'primary' : _e, _f = _a.theme, theme = _f === void 0 ? 'default' : _f, text = _a.text;
    return (jsx("span", __assign({ className: className, sx: __assign(__assign({ fontWeight: 600, textTransform: 'uppercase', fontFamily: 'mono', lineHeight: 'inc00', fontSize: 'inc00', display: 'inline-block', borderRadius: 'circle' }, getIdentifierStyles(size, theme)), getIdentifierColorStyles(color, inverse)) }, { children: text }), void 0));
};

var Pill = function (props) {
    return (jsxs(Fragment, { children: [props.variant === 'badge' && jsx(Badge, __assign({}, props), void 0),
            props.variant === 'identifier' && jsx(Identifier, __assign({}, props), void 0)] }, void 0));
};

var EListItemPillColors;
(function (EListItemPillColors) {
    EListItemPillColors["BLUE"] = "blue";
    EListItemPillColors["PURPLE"] = "purple";
})(EListItemPillColors || (EListItemPillColors = {}));
var EListItemVariantTypes;
(function (EListItemVariantTypes) {
    EListItemVariantTypes["PILL"] = "pill";
    EListItemVariantTypes["CHEVRON"] = "chevron";
})(EListItemVariantTypes || (EListItemVariantTypes = {}));

var getPillBackgroundColor = function (pillColor) {
    switch (pillColor) {
        case EListItemPillColors.BLUE:
            return 'blue10';
        case EListItemPillColors.PURPLE:
            return 'purple10';
        default:
            return 'blue10';
    }
};
var getPillColor = function (pillColor) {
    switch (pillColor) {
        case EListItemPillColors.BLUE:
            return 'blue70';
        case EListItemPillColors.PURPLE:
            return 'purple80';
        default:
            return 'blue70';
    }
};

var ListItem = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.url, url = _c === void 0 ? '' : _c, _d = _a.department, department = _d === void 0 ? '' : _d, _e = _a.location, location = _e === void 0 ? '' : _e, _f = _a.type, type = _f === void 0 ? '' : _f, _g = _a.pillText, pillText = _g === void 0 ? '' : _g, _h = _a.pillColor, pillColor = _h === void 0 ? EListItemPillColors.BLUE : _h, _j = _a.plainText, plainText = _j === void 0 ? '' : _j, _k = _a.className, className = _k === void 0 ? '' : _k, _l = _a.variant, variant = _l === void 0 ? 'chevron' : _l, customStyles = _a.customStyles;
    var space = defaultTheme.space;
    var hasDepartment = department && department !== '';
    var hasLocation = location && location !== '';
    var hasType = type && type !== '';
    return (jsx("a", __assign({ href: url, sx: {
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'none'
            }
        } }, { children: jsxs("div", __assign({ className: className, sx: __assign({ width: '100%', height: ['100%', null, null, '84px'], display: 'flex', justifyContent: 'space-between', borderRadius: 'inc30', padding: [
                    space.inc40 + " " + space.inc30,
                    null,
                    null,
                    space.inc25 + " " + space.inc30
                ], backgroundColor: 'black10', '&:hover': {
                    backgroundColor: 'black15',
                    boxShadow: 'level01',
                    cursor: 'pointer'
                }, '&:hover div:last-child > svg': {
                    willChange: 'transform',
                    transitionProperty: 'transform',
                    transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
                    transitionDuration: '200ms',
                    transitionDelay: '0ms',
                    transform: 'translateX(4px)'
                } }, customStyles) }, { children: [jsxs("div", __assign({ sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        fontFamily: 'body'
                    } }, { children: [jsx("span", __assign({ sx: {
                                fontSize: ['inc30', null, null, 'inc40'],
                                lineHeight: ['inc20', null, null, 'inc30'],
                                color: 'black70'
                            } }, { children: title }), void 0),
                        plainText ? (jsx("span", __assign({ sx: {
                                fontSize: 'inc10',
                                lineHeight: 'inc20',
                                color: 'black50',
                                marginTop: ['inc25', null, null, 'inc10']
                            } }, { children: plainText }), void 0)) : (jsxs("div", __assign({ sx: {
                                display: 'flex',
                                flexDirection: ['column', null, null, 'row'],
                                marginTop: ['inc25', null, null, 'inc10']
                            } }, { children: [hasDepartment && (jsxs("div", __assign({ sx: {
                                        display: 'flex',
                                        alignItems: 'end',
                                        marginRight: ['none', null, null, 'inc40'],
                                        marginBottom: ['inc20', null, null, 'none']
                                    } }, { children: [jsx("span", { children: jsx(SystemIcon, { name: ESystemIconNames.USERS, customStyles: { marginRight: 'inc20' } }, void 0) }, void 0),
                                        jsx("div", __assign({ sx: {
                                                fontSize: 'inc20',
                                                lineHeight: 'inc20',
                                                color: 'black50'
                                            } }, { children: department }), void 0)] }), void 0)),
                                hasLocation && (jsxs("div", __assign({ sx: {
                                        display: 'flex',
                                        alignItems: 'end',
                                        marginRight: ['none', null, null, 'inc40'],
                                        marginBottom: ['inc20', null, null, 'none']
                                    } }, { children: [jsx("span", { children: jsx(SystemIcon, { name: ESystemIconNames.LOCATION, customStyles: { marginRight: 'inc20' } }, void 0) }, void 0),
                                        jsx("div", __assign({ sx: {
                                                fontSize: 'inc20',
                                                lineHeight: 'inc20',
                                                color: 'black50'
                                            } }, { children: location }), void 0)] }), void 0)),
                                hasType && (jsxs("div", __assign({ sx: {
                                        display: 'flex',
                                        alignItems: 'end',
                                        marginRight: ['none', null, null, 'inc40'],
                                        marginBottom: ['none', null, null, 'inc20']
                                    } }, { children: [jsx("span", { children: jsx(SystemIcon, { name: ESystemIconNames.SUITCASE, customStyles: { marginRight: 'inc20' } }, void 0) }, void 0),
                                        jsx("div", __assign({ sx: {
                                                fontSize: 'inc20',
                                                lineHeight: 'inc20',
                                                color: 'black50'
                                            } }, { children: type }), void 0)] }), void 0))] }), void 0))] }), void 0),
                jsxs("div", __assign({ sx: {
                        display: ['none', null, null, 'flex'],
                        alignItems: variant === 'chevron' && 'center'
                    } }, { children: [variant === EListItemVariantTypes.PILL && (jsx(Pill, { variant: 'badge', text: pillText, shouldUppercase: false, sx: {
                                height: '20px',
                                fontWeight: 500,
                                fontSize: 'inc00',
                                lineHeight: '12px',
                                backgroundColor: getPillBackgroundColor(pillColor),
                                color: getPillColor(pillColor),
                                textAlign: 'center',
                                padding: space.inc10 + " " + space.inc25,
                                borderRadius: 'inc60'
                            } }, void 0)),
                        variant === EListItemVariantTypes.CHEVRON && (jsx(SystemIcon, { name: ESystemIconNames.CHEVRON_RIGHT, customStyles: {
                                stroke: 'black50',
                                strokeWidth: '2px'
                            } }, void 0))] }), void 0)] }), void 0) }), void 0));
};

var ListV2 = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.items, items = _c === void 0 ? [] : _c, customStyles = _a.customStyles;
    var space = defaultTheme.space;
    return (jsx("div", __assign({ className: className, sx: __assign({}, customStyles) }, { children: items.map(function (listItem, index) {
            var title = listItem.title, url = listItem.url, department = listItem.department, location = listItem.location, type = listItem.type, variant = listItem.variant, pillText = listItem.pillText, pillColor = listItem.pillColor, plainText = listItem.plainText;
            var listItemVariant = variant === EListItemVariantTypes.PILL
                ? EListItemVariantTypes.PILL
                : EListItemVariantTypes.CHEVRON;
            return (jsx(ListItem, { title: title, url: url, department: department && department, location: location && location, type: type && type, variant: listItemVariant, pillText: pillText && pillText, pillColor: pillColor && pillColor, plainText: plainText && plainText, customStyles: {
                    marginBottom: index !== items.length - 1 && space.inc30
                } }, index));
        }) }), void 0));
};

var Panel = function (_a) {
    var bgColor = _a.bgColor, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, borderColor = _a.borderColor, borderWidth = _a.borderWidth, borderRadius = _a.borderRadius, _d = _a.borderStyle, borderStyle = _d === void 0 ? 'solid' : _d, _e = _a.gridColumn, gridColumn = _e === void 0 ? '1 / span 12' : _e, boxShadow = _a.boxShadow, children = _a.children;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx("div", __assign({ className: className, sx: {
            gridColumn: gridColumn,
            backgroundColor: bgColor || selectedTheme.colors.panels.default.bg,
            borderColor: borderColor || selectedTheme.colors.panels.default.border,
            borderRadius: borderRadius || selectedTheme.radii.inc50,
            borderWidth: borderWidth || selectedTheme.borderWidths.inc10,
            borderStyle: borderStyle,
            boxShadow: boxShadow
        } }, { children: children }), void 0));
};

var _a$1;
var DEFAULT_OPTIONS = {
    theme: 'flora',
    readOnly: true,
    scrollbarStyle: 'simple'
};
var ELanguageModeMap;
(function (ELanguageModeMap) {
    ELanguageModeMap["C"] = "text/x-csrc";
    ELanguageModeMap["CSS"] = "css";
    ELanguageModeMap["C#"] = "text/x-csharp";
    ELanguageModeMap["C++"] = "text/x-c++src";
    ELanguageModeMap["Dart"] = "application/dart";
    ELanguageModeMap["Flutter"] = "application/dart";
    ELanguageModeMap["Go"] = "text/x-go";
    ELanguageModeMap["HTML"] = "htmlmixed";
    ELanguageModeMap["Java"] = "text/x-java";
    ELanguageModeMap["JavaScript"] = "javascript";
    ELanguageModeMap["JSON"] = "application/json";
    ELanguageModeMap["Kotlin"] = "text/x-kotlin";
    ELanguageModeMap["Markdown"] = "markdown";
    ELanguageModeMap["MQL"] = "javascript";
    ELanguageModeMap["Node"] = "javascript";
    ELanguageModeMap["PHP"] = "php";
    ELanguageModeMap["Python"] = "python";
    ELanguageModeMap["React"] = "text/jsx";
    ELanguageModeMap["React Native"] = "text/jsx";
    ELanguageModeMap["Ruby"] = "ruby";
    /* rust is broke in codemirror-ssr as of 2021-08-30.
      so commenting this out until either the library gets updated
      or we propose a fix. */
    // Rust = 'rust',
    ELanguageModeMap["Shell"] = "text/x-sh";
    ELanguageModeMap["Swift"] = "text/x-swift";
    ELanguageModeMap["TypeScript"] = "application/typescript";
    ELanguageModeMap[".NET"] = "text/x-csharp";
})(ELanguageModeMap || (ELanguageModeMap = {}));
var HeightMap = {
    small: defaultTheme.sizes.codeSnippetSmall,
    medium: defaultTheme.sizes.codeSnippetMedium,
    large: defaultTheme.sizes.codeSnippetLarge,
    auto: 'auto'
};
var ECopyIconMap;
(function (ECopyIconMap) {
    ECopyIconMap["COPY"] = "Copy";
    ECopyIconMap["COPIED"] = "Copied";
})(ECopyIconMap || (ECopyIconMap = {}));
var ICONS$1 = (_a$1 = {},
    _a$1[ECopyIconMap.COPY] = 'https://webimages.mongodb.com/_com_assets/cms/ks9ey91u6mgoo8on4-copyIcon.svg?auto=format%252Ccompress',
    _a$1[ECopyIconMap.COPIED] = 'https://webimages.mongodb.com/_com_assets/cms/ks9eylc6k5vu2cf1m-copiedIcon.svg?auto=format%252Ccompress',
    _a$1);

var getLanguageMode = function (language) {
    return ELanguageModeMap[language];
};
var getHeight = function (height) {
    return HeightMap[height];
};
var msStringToInt = function (msString) {
    return Number(msString.split('ms')[0]);
};

var css_248z$2 = "/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  font-family: monospace;\n  height: 300px;\n  color: black;\n  direction: ltr;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n.CodeMirror-linenumbers {}\n.CodeMirror-linenumber {\n  padding: 0 3px 0 5px;\n  min-width: 20px;\n  text-align: right;\n  color: #999;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker { color: black; }\n.CodeMirror-guttermarker-subtle { color: #999; }\n\n/* CURSOR */\n\n.CodeMirror-cursor {\n  border-left: 1px solid black;\n  border-right: none;\n  width: 0;\n}\n/* Shown when moving in bi-directional text */\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n.cm-fat-cursor .CodeMirror-cursor {\n  width: auto;\n  border: 0 !important;\n  background: #7e7;\n}\n.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n.cm-fat-cursor-mark {\n  background-color: rgba(20, 255, 20, 0.5);\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n}\n.cm-animate-fat-cursor {\n  width: auto;\n  border: 0;\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n  background-color: #7e7;\n}\n@-moz-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@-webkit-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n.CodeMirror-overwrite .CodeMirror-cursor {}\n\n.cm-tab { display: inline-block; text-decoration: inherit; }\n\n.CodeMirror-rulers {\n  position: absolute;\n  left: 0; right: 0; top: -50px; bottom: 0;\n  overflow: hidden;\n}\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  top: 0; bottom: 0;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-header {color: blue;}\n.cm-s-default .cm-quote {color: #090;}\n.cm-negative {color: #d44;}\n.cm-positive {color: #292;}\n.cm-header, .cm-strong {font-weight: bold;}\n.cm-em {font-style: italic;}\n.cm-link {text-decoration: underline;}\n.cm-strikethrough {text-decoration: line-through;}\n\n.cm-s-default .cm-keyword {color: #708;}\n.cm-s-default .cm-atom {color: #219;}\n.cm-s-default .cm-number {color: #164;}\n.cm-s-default .cm-def {color: #00f;}\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {}\n.cm-s-default .cm-variable-2 {color: #05a;}\n.cm-s-default .cm-variable-3, .cm-s-default .cm-type {color: #085;}\n.cm-s-default .cm-comment {color: #a50;}\n.cm-s-default .cm-string {color: #a11;}\n.cm-s-default .cm-string-2 {color: #f50;}\n.cm-s-default .cm-meta {color: #555;}\n.cm-s-default .cm-qualifier {color: #555;}\n.cm-s-default .cm-builtin {color: #30a;}\n.cm-s-default .cm-bracket {color: #997;}\n.cm-s-default .cm-tag {color: #170;}\n.cm-s-default .cm-attribute {color: #00c;}\n.cm-s-default .cm-hr {color: #999;}\n.cm-s-default .cm-link {color: #00c;}\n\n.cm-s-default .cm-error {color: #f00;}\n.cm-invalidchar {color: #f00;}\n\n.CodeMirror-composing { border-bottom: 2px solid; }\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {color: #0b0;}\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {color: #a22;}\n.CodeMirror-matchingtag { background: rgba(255, 150, 0, .3); }\n.CodeMirror-activeline-background {background: #e8f2ff;}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  position: relative;\n  overflow: hidden;\n  background: white;\n}\n\n.CodeMirror-scroll {\n  overflow: scroll !important; /* Things will break if this is overridden */\n  /* 50px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -50px; margin-right: -50px;\n  padding-bottom: 50px;\n  height: 100%;\n  outline: none; /* Prevent dragging from highlighting the element */\n  position: relative;\n}\n.CodeMirror-sizer {\n  position: relative;\n  border-right: 50px solid transparent;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n.CodeMirror-vscrollbar, .CodeMirror-hscrollbar, .CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  position: absolute;\n  z-index: 6;\n  display: none;\n  outline: none;\n}\n.CodeMirror-vscrollbar {\n  right: 0; top: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.CodeMirror-hscrollbar {\n  bottom: 0; left: 0;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.CodeMirror-scrollbar-filler {\n  right: 0; bottom: 0;\n}\n.CodeMirror-gutter-filler {\n  left: 0; bottom: 0;\n}\n\n.CodeMirror-gutters {\n  position: absolute; left: 0; top: 0;\n  min-height: 100%;\n  z-index: 3;\n}\n.CodeMirror-gutter {\n  white-space: normal;\n  height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: -50px;\n}\n.CodeMirror-gutter-wrapper {\n  position: absolute;\n  z-index: 4;\n  background: none !important;\n  border: none !important;\n}\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0; bottom: 0;\n  z-index: 4;\n}\n.CodeMirror-gutter-elt {\n  position: absolute;\n  cursor: default;\n  z-index: 4;\n}\n.CodeMirror-gutter-wrapper ::selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  /* Reset some styles that the rest of the page might have set */\n  -moz-border-radius: 0; -webkit-border-radius: 0; border-radius: 0;\n  border-width: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  white-space: pre;\n  word-wrap: normal;\n  line-height: inherit;\n  color: inherit;\n  z-index: 2;\n  position: relative;\n  overflow: visible;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-variant-ligatures: contextual;\n  font-variant-ligatures: contextual;\n}\n.CodeMirror-wrap pre.CodeMirror-line,\n.CodeMirror-wrap pre.CodeMirror-line-like {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0; right: 0; top: 0; bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  position: relative;\n  z-index: 2;\n  padding: 0.1px; /* Force widget margins to stay inside of the container */\n}\n\n.CodeMirror-widget {}\n\n.CodeMirror-rtl pre { direction: rtl; }\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n  pointer-events: none;\n}\n.CodeMirror-measure pre { position: static; }\n\ndiv.CodeMirror-cursors {\n  visibility: hidden;\n  position: relative;\n  z-index: 3;\n}\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected { background: #d9d9d9; }\n.CodeMirror-focused .CodeMirror-selected { background: #d7d4f0; }\n.CodeMirror-crosshair { cursor: crosshair; }\n.CodeMirror-line::selection, .CodeMirror-line > span::selection, .CodeMirror-line > span > span::selection { background: #d7d4f0; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n\n.cm-searching {\n  background-color: #ffa;\n  background-color: rgba(255, 255, 0, .4);\n}\n\n/* Used to force a border model for a node */\n.cm-force-border { padding-right: .1px; }\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n.cm-tab-wrap-hack:after { content: ''; }\n\n/* Help users use markselection to safely style text background */\nspan.CodeMirror-selectedtext { background: none; }\n";

var css_248z$1 = ".CodeMirror-simplescroll-horizontal div, .CodeMirror-simplescroll-vertical div {\n  position: absolute;\n  background: #ccc;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n}\n\n.CodeMirror-simplescroll-horizontal, .CodeMirror-simplescroll-vertical {\n  position: absolute;\n  z-index: 6;\n  background: #eee;\n}\n\n.CodeMirror-simplescroll-horizontal {\n  bottom: 0; left: 0;\n  height: 8px;\n}\n.CodeMirror-simplescroll-horizontal div {\n  bottom: 0;\n  height: 100%;\n}\n\n.CodeMirror-simplescroll-vertical {\n  right: 0; top: 0;\n  width: 8px;\n}\n.CodeMirror-simplescroll-vertical div {\n  right: 0;\n  width: 100%;\n}\n\n\n.CodeMirror-overlayscroll .CodeMirror-scrollbar-filler, .CodeMirror-overlayscroll .CodeMirror-gutter-filler {\n  display: none;\n}\n\n.CodeMirror-overlayscroll-horizontal div, .CodeMirror-overlayscroll-vertical div {\n  position: absolute;\n  background: #bcd;\n  border-radius: 3px;\n}\n\n.CodeMirror-overlayscroll-horizontal, .CodeMirror-overlayscroll-vertical {\n  position: absolute;\n  z-index: 6;\n}\n\n.CodeMirror-overlayscroll-horizontal {\n  bottom: 0; left: 0;\n  height: 6px;\n}\n.CodeMirror-overlayscroll-horizontal div {\n  bottom: 0;\n  height: 100%;\n}\n\n.CodeMirror-overlayscroll-vertical {\n  right: 0; top: 0;\n  width: 6px;\n}\n.CodeMirror-overlayscroll-vertical div {\n  right: 0;\n  width: 100%;\n}\n";

var css_248z = "/* Syntax Highlighting */\n.cm-s-flora span.cm-comment {\n  color: var(--comments);\n}\n.cm-s-flora span.cm-atom {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-number {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-property,\n.cm-s-flora span.cm-attribute {\n  color: var(--attributes);\n}\n.cm-s-flora span.cm-keyword {\n  color: var(--keywords);\n}\n.cm-s-flora span.cm-builtin {\n  color: var(--type);\n}\n.cm-s-flora span.cm-string {\n  color: var(--strings);\n}\n.cm-s-flora span.cm-variable {\n  color: var(--operators);\n}\n.cm-s-flora span.cm-variable-2 {\n  color: var(--variables-alt);\n}\n.cm-s-flora span.cm-variable-3,\n.cm-s-flora span.cm-type {\n  color: var(--type);\n}\n.cm-s-flora span.cm-def {\n  color: var(--definitions);\n}\n.cm-s-flora span.cm-bracket {\n  color: var(--operators);\n}\n.cm-s-flora span.cm-tag {\n  color: var(--keywords);\n}\n.cm-s-flora span.cm-header {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-link {\n  color: var(--numbers);\n}\n\n/* Scrollbars */\n.CodeMirror-simplescroll-horizontal div,\n.CodeMirror-simplescroll-vertical div {\n  background: transparent;\n  border: 1px solid transparent;\n}\n\n.CodeMirror-simplescroll-horizontal,\n.CodeMirror-simplescroll-vertical {\n  background: transparent;\n}\n\n.CodeMirror-overlayscroll-horizontal div,\n.CodeMirror-overlayscroll-vertical div {\n  background: transparent;\n}\n";

var loadModules = function (CodeMirror) {
    if (typeof window !== 'undefined' &&
        typeof window.navigator !== 'undefined') {
        useClike(CodeMirror);
        useCSS(CodeMirror);
        useGo(CodeMirror);
        useHtml(CodeMirror);
        useJavascript(CodeMirror);
        useJSX(CodeMirror);
        useMarkdown(CodeMirror);
        usePHP(CodeMirror);
        usePython(CodeMirror);
        useRuby(CodeMirror);
        /* rust is broke in codemirror-ssr as of 2021-08-30.
        so commenting this out until either the library gets updated
        or we propose a fix. */
        // useRust(CodeMirror)
        useShell(CodeMirror);
        useSimpleScrollbars(CodeMirror);
        useSwift(CodeMirror);
        useXML(CodeMirror);
        useDart(CodeMirror);
    }
};
// Make the label invisible but still accessible by screen readers and SEO tools
var hiddenLabelClass = css$1(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip-path: inset(50%);\n  border: 0;\n  white-space: nowrap;\n"], ["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip-path: inset(50%);\n  border: 0;\n  white-space: nowrap;\n"])));
var CodeSnippet = function (_a) {
    var _b;
    var language = _a.language, code = _a.code, _c = _a.borderRadiusTop, borderRadiusTop = _c === void 0 ? true : _c, _d = _a.copyButton, copyButton = _d === void 0 ? true : _d, _e = _a.copyButtonPosition, copyButtonPosition = _e === void 0 ? 'bottom' : _e, _f = _a.lineNumbers, lineNumbers = _f === void 0 ? true : _f, _g = _a.lineWrapping, lineWrapping = _g === void 0 ? true : _g, _h = _a.height, height = _h === void 0 ? 'medium' : _h, _j = _a.theme, theme = _j === void 0 ? 'default' : _j, _k = _a.label, label = _k === void 0 ? 'Code Snippet' : _k, _l = _a.copyBtnTitle, copyBtnTitle = _l === void 0 ? 'Copy Code' : _l;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var fromTextArea = useRef(null);
    var cmInstance = useRef(null);
    var textareaNode = useRef(null);
    var _m = useState(false), codeIsCopied = _m[0], setCodeIsCopied = _m[1];
    var textareaId = useMemo(function () { return "codesnippet-" + new Date().getTime(); }, []);
    var options = __assign(__assign({}, DEFAULT_OPTIONS), { mode: getLanguageMode(language), lineNumbers: lineNumbers,
        lineWrapping: lineWrapping });
    var setOption = function (optionName, newValue) {
        var codeMirror = cmInstance.current;
        var oldValue = codeMirror === null || codeMirror === void 0 ? void 0 : codeMirror.getOption(optionName);
        if (oldValue !== newValue) {
            codeMirror === null || codeMirror === void 0 ? void 0 : codeMirror.setOption(optionName, newValue);
        }
    };
    var handleCopyClick = function () {
        var _a;
        if ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) {
            navigator.clipboard.writeText(code);
            setCodeIsCopied(true);
            window.setTimeout(function () {
                setCodeIsCopied(false);
            }, msStringToInt(selectedTheme.motion.codeSnippetCopyFade)); // token returns ms, which is invalid here
        }
    };
    useEffect(function () {
        /* eslint-disable @typescript-eslint/no-var-requires */
        var CodeMirror = factory();
        fromTextArea.current = CodeMirror.fromTextArea;
        loadModules(CodeMirror);
    }, []);
    useEffect(function () {
        if (fromTextArea.current &&
            textareaNode.current instanceof HTMLTextAreaElement) {
            cmInstance.current = fromTextArea.current(textareaNode.current, options);
            if (!cmInstance.current)
                return;
        }
        return function () {
            var codeMirror = cmInstance.current;
            codeMirror && codeMirror.toTextArea();
        };
    }, [textareaNode.current]);
    useEffect(function () {
        var codeMirror = cmInstance.current;
        codeMirror && codeMirror.setValue(code);
    }, [code]);
    useEffect(function () {
        if (!cmInstance.current)
            return;
        Object.entries(options).forEach(function (_a) {
            var optionName = _a[0], optionValue = _a[1];
            return setOption(optionName, optionValue);
        });
    }, [options]);
    var codemirrorStyles = css$1(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n  "])), css_248z$2, css_248z$1, css_248z);
    return (jsxs("div", __assign({ "aria-label": 'code-snippet-container', style: {
            display: 'flex',
            position: 'relative'
        }, className: codemirrorStyles, sx: {
            '--operators': selectedTheme.colors.code.operators,
            '--comments': selectedTheme.colors.code.comments,
            '--definitions': selectedTheme.colors.code.definitions,
            '--numbers': selectedTheme.colors.code.numbers,
            '--keywords': selectedTheme.colors.code.keywords,
            '--variables': selectedTheme.colors.code.variables,
            '--type': selectedTheme.colors.code.type,
            '--strings': selectedTheme.colors.code.strings,
            '--attributes': selectedTheme.colors.code.attributes,
            '.cm-s-flora.CodeMirror': {
                width: '100%',
                color: 'var(--operators)',
                height: getHeight(height),
                fontFamily: selectedTheme.fonts.mono,
                fontSize: selectedTheme.fontSizes.inc20,
                lineHeight: selectedTheme.lineHeights.inc30,
                borderRadius: borderRadiusTop
                    ? selectedTheme.radii.inc60
                    : "0 0 " + selectedTheme.radii.inc60 + " " + selectedTheme.radii.inc60,
                background: selectedTheme.colors.code.bg
            },
            '.cm-s-flora .CodeMirror-lines': {
                padding: lineNumbers
                    ? selectedTheme.space.inc40 + " 0"
                    : selectedTheme.space.inc40
            },
            '.cm-s-flora .CodeMirror-linenumbers': {
                width: '58px'
            },
            '.cm-s-flora .CodeMirror-linenumber': {
                textAlign: 'center',
                color: selectedTheme.colors.black00
            },
            '.cm-s-flora .CodeMirror-scroll, .cm-s-flora .CodeMirror-sizer': {
                background: selectedTheme.colors.code.bg
            },
            '.cm-s-flora .CodeMirror-gutters': {
                background: selectedTheme.colors.code.bg,
                borderRight: selectedTheme.space.inc20 + " solid " + selectedTheme.colors.code.bg
            },
            '.cm-s-flora .CodeMirror-gutter, .cm-s-flora .CodeMirror-gutters, .cm-s-flora .CodeMirror-linenumber': {
                background: selectedTheme.colors.code.bgLines
            }
        } }, { children: [jsx("label", __assign({ htmlFor: textareaId, className: hiddenLabelClass }, { children: label }), void 0),
            jsx("textarea", { id: textareaId, "aria-label": 'code-snippet', ref: textareaNode, defaultValue: code, autoComplete: 'off' }, void 0),
            copyButton && (jsx("div", __assign({ role: 'button', title: copyBtnTitle, "aria-label": 'copy-code', sx: (_b = {
                        position: 'absolute',
                        zIndex: 2,
                        right: 0
                    },
                    _b[copyButtonPosition === 'bottom' ? 'bottom' : 'top'] = 0,
                    _b), onClick: handleCopyClick }, { children: jsx("img", { role: 'presentation', "aria-hidden": 'true' // Hide the image from screen readers, as the div already has an aria-label
                    , sx: {
                        height: '40px',
                        width: '40px',
                        margin: selectedTheme.space.inc30,
                        cursor: 'pointer'
                    }, src: codeIsCopied ? ICONS$1.Copied : ICONS$1.Copy }, void 0) }), void 0))] }), void 0));
};
var templateObject_1$2, templateObject_2$1;

var responsiveSpacingMap = {
    xxlarge: 'sectionXXLarge',
    xlarge: 'sectionXLarge',
    large: 'sectionLarge',
    medium: 'sectionMedium',
    small: 'sectionSmall',
    xsmall: 'sectionXSmall',
    xxsmall: 'sectionXXSmall',
    zero: 'sectionZero'
};
var VerticalSectionSpacing = function (_a) {
    var children = _a.children, top = _a.top, bottom = _a.bottom, customStyles = _a.customStyles;
    var verticalGap = defaultTheme.responsive.verticalGap;
    return (jsx("div", __assign({ sx: __assign({ paddingTop: verticalGap[responsiveSpacingMap[top]], paddingBottom: verticalGap[responsiveSpacingMap[bottom]] }, customStyles) }, { children: children }), void 0));
};

var Mark = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c; _a.theme; var children = _a.children;
    return (jsx("mark", __assign({ className: className, sx: {
            backgroundColor: 'transparent',
            color: inverse ? 'text.inverseMark' : 'text.mark'
        } }, { children: children }), void 0));
};

var Eyebrow = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c; _a.theme; var _e = _a.variant, variant = _e === void 0 ? 'primary' : _e, _f = _a.customElement, customElement = _f === void 0 ? 'h1' : _f, customStyles = _a.customStyles, children = _a.children;
    var secondary = variant === 'secondary';
    return (jsx(TypographyScale, __assign({ className: className, variant: 'mono3', customElement: customElement, inverse: inverse, customStyles: __assign({ textTransform: 'uppercase', color: inverse
                ? "text.eyebrowInverse" + (secondary ? 'Secondary' : '')
                : 'text.eyebrowDefault', fontWeight: 600 }, customStyles) }, { children: children }), void 0));
};

var ESingleImageVariant;
(function (ESingleImageVariant) {
    ESingleImageVariant["NO_RATIO"] = "no ratio";
    ESingleImageVariant["SQUARE"] = "square";
    ESingleImageVariant["DIAGRAM"] = "diagram";
    ESingleImageVariant["LETTERBOX"] = "letterbox";
    ESingleImageVariant["VIDEO"] = "video";
})(ESingleImageVariant || (ESingleImageVariant = {}));

var WEB_ASSETS_SUBDOMAIN = 'webassets.mongodb.com';
var IMGIX_SUBDOMAIN = 'webimages.mongodb.com';
var normalizeImageSource = function (imageSrc) {
    if (!imageSrc) {
        return undefined;
    }
    if (imageSrc.match(IMGIX_SUBDOMAIN)) {
        return imageSrc;
    }
    else if (imageSrc.match(WEB_ASSETS_SUBDOMAIN)) {
        // Decode and re-encode, src may or may not be encoded already
        return encodeURI(decodeURI(imageSrc.replace(WEB_ASSETS_SUBDOMAIN, IMGIX_SUBDOMAIN)));
    }
    return undefined;
};
var isGif = function (url) { return /\.gif/.test(url); };

var ls_attrchange = {exports: {}};

(function (module) {
(function(window, factory) {
	if(!window) {return;}
	var globalInstall = function(){
		factory(window.lazySizes);
		window.removeEventListener('lazyunveilread', globalInstall, true);
	};

	factory = factory.bind(null, window, window.document);

	if(module.exports){
		factory(require$$0);
	} else if(window.lazySizes) {
		globalInstall();
	} else {
		window.addEventListener('lazyunveilread', globalInstall, true);
	}
}(typeof window != 'undefined' ?
	window : 0, function(window, document, lazySizes) {

	var addObserver = function(){
		var connect, disconnect, observer, connected;
		var lsCfg = lazySizes.cfg;
		var attributes = {'data-bgset': 1, 'data-include': 1, 'data-poster': 1, 'data-bg': 1, 'data-script': 1};
		var regClassTest = '(\\s|^)(' + lsCfg.loadedClass;
		var docElem = document.documentElement;

		var setClass = function(target){
			lazySizes.rAF(function(){
				lazySizes.rC(target, lsCfg.loadedClass);
				if(lsCfg.unloadedClass){
					lazySizes.rC(target, lsCfg.unloadedClass);
				}
				lazySizes.aC(target, lsCfg.lazyClass);

				if(target.style.display == 'none' || (target.parentNode && target.parentNode.style.display == 'none')){
					setTimeout(function () {
						lazySizes.loader.unveil(target);
					}, 0);
				}
			});
		};

		var onMutation = function(mutations){
			var i, len, mutation, target;
			for(i = 0, len = mutations.length; i < len; i++){
				mutation = mutations[i];
				target = mutation.target;

				if(!target.getAttribute(mutation.attributeName)){continue;}

				if(target.localName == 'source' && target.parentNode){
					target = target.parentNode.querySelector('img');
				}

				if(target && regClassTest.test(target.className)){
					setClass(target);
				}
			}
		};

		if(lsCfg.unloadedClass){
			regClassTest += '|' + lsCfg.unloadedClass;
		}

		regClassTest += '|' + lsCfg.loadingClass + ')(\\s|$)';

		regClassTest = new RegExp(regClassTest);

		attributes[lsCfg.srcAttr] = 1;
		attributes[lsCfg.srcsetAttr] = 1;

		if(window.MutationObserver){
			observer = new MutationObserver(onMutation);

			connect = function(){
				if(!connected){
					connected = true;
					observer.observe( docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes)} );
				}
			};
			disconnect = function(){
				if(connected){
					connected = false;
					observer.disconnect();
				}
			};
		} else {
			docElem.addEventListener('DOMAttrModified', (function(){
				var runs;
				var modifications = [];
				var callMutations = function(){
					onMutation(modifications);
					modifications = [];
					runs = false;
				};
				return function(e){
					if(connected && attributes[e.attrName] && e.newValue){
						modifications.push({target: e.target, attributeName: e.attrName});
						if(!runs){
							setTimeout(callMutations);
							runs = true;
						}
					}
				};
			})(), true);

			connect = function(){
				connected = true;
			};
			disconnect = function(){
				connected = false;
			};
		}

		addEventListener('lazybeforeunveil', disconnect, true);
		addEventListener('lazybeforeunveil', connect);

		addEventListener('lazybeforesizes', disconnect, true);
		addEventListener('lazybeforesizes', connect);
		connect();

		removeEventListener('lazybeforeunveil', addObserver);
	};


	addEventListener('lazybeforeunveil', addObserver);
}));
}(ls_attrchange));

var client = new ImgixClient({
    domain: 'webimages.mongodb.com'
});
var getRatio = function (variant) {
    switch (variant) {
        case ESingleImageVariant.NO_RATIO:
            return undefined;
        case ESingleImageVariant.DIAGRAM:
            return 5 / 4;
        case ESingleImageVariant.SQUARE:
            return 1;
        case ESingleImageVariant.LETTERBOX:
            return 3 / 2;
        case ESingleImageVariant.VIDEO:
            return 16 / 9;
        default:
            return undefined;
    }
};
var SingleImage = function (_a) {
    var variant = _a.variant; _a.theme; var src = _a.src, lazyLoad = _a.lazyLoad, altText = _a.altText, customStyles = _a.customStyles, props = __rest(_a, ["variant", "theme", "src", "lazyLoad", "altText", "customStyles"]);
    var ratio = getRatio(variant);
    useEffect(function () {
        window.lazySizesConfig = {
            loadMode: 1
        };
    }, []);
    var normalizedSrc = normalizeImageSource(src);
    var urlObject = (function () {
        try {
            return new URL(normalizedSrc || src);
        }
        catch (e) {
            return false;
        }
    })();
    if (!urlObject)
        return null;
    var srcSet = props.bleed
        ? undefined
        : normalizedSrc &&
            client.buildSrcSet(decodeURI(urlObject.pathname), isGif(src) ? {} : { auto: 'format,compress' });
    var imageElement = lazyLoad ? (jsx("img", { alt: altText, className: 'lazyload', sx: {
            width: '100%'
        }, "data-src": urlObject.href, "data-srcset": srcSet, "data-sizes": 'auto' }, void 0)) : (jsx("img", { alt: altText, src: urlObject.href, srcSet: srcSet, sx: { width: '100%' } }, void 0));
    return (jsx(Fragment, { children: ratio && !props.bleed ? (jsx(AspectRatio, __assign({ ratio: ratio, sx: __assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center' }, customStyles) }, { children: imageElement }), void 0)) : (jsx("div", __assign({ sx: __assign(__assign({}, (!props.bleed && {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            })), customStyles) }, { children: imageElement }), void 0)) }, void 0));
};

var radioGroupStyles = {
    boxSizing: 'border-box',
    width: 'max-content'
};
var getRadioButtonStyles = function (_a) {
    var disabled = _a.disabled, focused = _a.focused, inverse = _a.inverse, checked = _a.checked;
    var _b = defaultTheme.colors.forms[inverse ? 'radioButtonInverse' : 'radioButton'], bgDisabled = _b.bgDisabled, boxBorder = _b.boxBorder, boxBorderDisabled = _b.boxBorderDisabled, focusBorder = _b.focusBorder, icon = _b.icon, iconDisabled = _b.iconDisabled;
    var iconColor = icon, borderColor = boxBorder, outlineColor = 'transparent', fontColor = defaultTheme.colors.blue80, backgroundColor = 'transparent';
    if (disabled) {
        iconColor = iconDisabled;
        backgroundColor = bgDisabled;
        borderColor = boxBorderDisabled;
        fontColor = defaultTheme.colors.black60;
    }
    if (inverse) {
        fontColor = defaultTheme.colors.black00;
    }
    if (focused) {
        outlineColor = focusBorder;
    }
    return {
        container: {
            marginTop: 'inc20',
            '&:first-of-type': {
                marginTop: 0
            }
        },
        // hides default input element
        input: {
            position: 'absolute',
            width: 0,
            height: 0,
            margin: 0,
            opacity: 0
        },
        label: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        radio: {
            position: 'relative',
            display: 'inline-block',
            cursor: disabled ? 'not-allowed' : 'pointer',
            width: [16, null, null, 20],
            height: [16, null, null, 20],
            borderStyle: 'solid',
            borderWidth: 2,
            borderRadius: 50,
            borderColor: borderColor,
            outlineStyle: 'solid',
            outlineWidth: 2,
            outlineOffset: 2,
            outlineColor: outlineColor,
            backgroundColor: backgroundColor
        },
        button: {
            display: checked ? 'block' : 'none',
            '&::after': {
                content: "''",
                position: 'absolute',
                top: [2, null, null, 3],
                left: [2, null, null, 3],
                backgroundColor: iconColor,
                borderRadius: 50,
                height: [8, null, null, 10],
                width: [8, null, null, 10]
            }
        },
        text: {
            color: fontColor,
            marginLeft: [16, null, null, 12]
        }
    };
};

var Radio = function (_a) {
    var name = _a.name, value = _a.value, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, _d = _a.checked, checked = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.customStyles, customStyles = _f === void 0 ? {} : _f, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g;
    var _h = useState(false), focused = _h[0], setFocused = _h[1];
    var styles = getRadioButtonStyles({ checked: checked, disabled: disabled, focused: focused, inverse: inverse });
    return (jsxs("div", __assign({ className: className, sx: __assign(__assign({}, styles.container), customStyles) }, { children: [jsx("input", { id: value, type: 'radio', name: name, value: value, checked: checked, sx: styles.input, disabled: disabled, onChange: onChange, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); } }, void 0),
            jsxs("label", __assign({ "aria-label": 'radio-button-label', htmlFor: value, sx: styles.label }, { children: [jsx("span", __assign({ "aria-label": 'radio-button-container', sx: styles.radio }, { children: jsx("span", { "aria-label": 'radio-button', sx: styles.button }, void 0) }), void 0),
                    jsx(TypographyScale, __assign({ variant: 'body3', inverse: inverse, sx: styles.text }, { children: children }), void 0)] }), void 0)] }), void 0));
};

var RadioGroup = function (_a) {
    var name = _a.name, _b = _a.id, id = _b === void 0 ? '' : _b, onChange = _a.onChange, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.inverse, inverse = _d === void 0 ? false : _d, _e = _a.customStyles, customStyles = _e === void 0 ? {} : _e, _f = _a.defaultChecked, defaultChecked = _f === void 0 ? '' : _f;
    var _g = useState(defaultChecked), selected = _g[0], setSelected = _g[1];
    useEffect(function () {
        setSelected(defaultChecked);
    }, [defaultChecked]);
    var handleSelection = function (_a) {
        var value = _a.target.value;
        setSelected(value);
        if (onChange) {
            onChange(value);
        }
    };
    var renderChildren = function (children) {
        var parentProps = {
            name: name,
            inverse: inverse,
            onChange: handleSelection
        };
        return React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                // safe guard if user passes children in a Fragment
                if (child.type === React.Fragment) {
                    return renderChildren(child.props.children);
                }
                return React.cloneElement(child, __assign(__assign({}, parentProps), { checked: child.props.value === selected }));
            }
            return child;
        });
    };
    return (jsx("div", __assign({ id: id, className: className, sx: __assign(__assign({}, radioGroupStyles), customStyles) }, { children: renderChildren(children) }), void 0));
};

var ComboBox = function (_a) {
    var label = _a.label, onSelect = _a.onSelect, onChange = _a.onChange, iconName = _a.iconName, inputName = _a.inputName, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.options, options = _c === void 0 ? [] : _c, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, _e = _a.inverse, inverse = _e === void 0 ? false : _e, _f = _a.height, height = _f === void 0 ? '80px' : _f, _g = _a.width, width = _g === void 0 ? '456px' : _g, _h = _a.noResults, noResults = _h === void 0 ? false : _h, _j = _a.isLoading, isLoading = _j === void 0 ? false : _j, _k = _a.wrapperStyles, wrapperStyles = _k === void 0 ? {} : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? 'left' : _l;
    var _m = useState(value), selection = _m[0], setSelection = _m[1];
    var _o = useState(isOpen), isDropdownOpen = _o[0], setIsDropdownOpen = _o[1];
    var wrapperRef = useRef(null);
    useEffect(function () {
        setIsDropdownOpen(isOpen);
    }, [isOpen]);
    useEffect(function () {
        setSelection(value);
    }, [value]);
    useOnClickOutside(wrapperRef, function () { return setIsDropdownOpen(false); });
    useTabEscape(wrapperRef, function () { return setIsDropdownOpen(false); });
    function handleSelect(value) {
        setSelection(value);
        onSelect(value);
        setIsDropdownOpen(!isDropdownOpen);
    }
    return (jsxs("div", __assign({ ref: wrapperRef, onClick: function () { return setIsDropdownOpen(true); }, sx: __assign({ position: 'relative', width: ['100%', null, null, width], height: height }, wrapperStyles) }, { children: [jsx(TextInput, { label: label, name: inputName, value: selection, inverse: inverse, onChange: onChange, iconName: iconName, iconPosition: iconPosition }, void 0),
            jsx(Dropdown$1, { options: options, noResults: noResults, isLoading: isLoading, selection: selection, open: isDropdownOpen, menuPlacement: 'bottom', onSelect: handleSelect }, void 0)] }), void 0));
};

var getCTASpacing = function (hasLinkCTA) {
    if (hasLinkCTA) {
        return {
            marginRight: ['inc00', null, 'inc50'],
            marginBottom: ['inc40', null, 'inc00']
        };
    }
};
var getMobileButtonStyle = function () {
    return {
        width: ['100%', null, 'auto'],
        textAlign: ['center', null, 'inherit']
    };
};

var CTALockup = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.buttonHref, buttonHref = _c === void 0 ? '' : _c, _d = _a.buttonText, buttonText = _d === void 0 ? '' : _d, _e = _a.onButtonClick, onButtonClick = _e === void 0 ? function () { } : _e, buttonTarget = _a.buttonTarget, _f = _a.buttonSize, buttonSize = _f === void 0 ? 'small' : _f, _g = _a.linkHref, linkHref = _g === void 0 ? '' : _g, _h = _a.linkText, linkText = _h === void 0 ? '' : _h, _j = _a.linkIconDisableExpand, linkIconDisableExpand = _j === void 0 ? false : _j, _k = _a.linkIcon, linkIcon = _k === void 0 ? 'chevron' : _k, _l = _a.onLinkClick, onLinkClick = _l === void 0 ? function () { } : _l, linkTarget = _a.linkTarget, _m = _a.inverse, inverse = _m === void 0 ? false : _m; _a.theme; var centerLocked = _a.centerLocked;
    var hasLinkCTA = !!linkText;
    var hasButtonText = !!buttonText;
    var getLockupContent = function (centered) {
        var buttonElement = (jsx(Button, __assign({ variant: 'primary', href: buttonHref, onClick: onButtonClick, inverse: inverse, target: buttonTarget, size: buttonSize, customWrapperStyles: __assign(__assign({}, getMobileButtonStyle()), getCTASpacing(hasLinkCTA)) }, { children: buttonText }), void 0));
        var ctaElement = (jsx(Link, __assign({ variant: ELinkVariant.SMALL, linkIcon: linkIcon, href: linkHref, linkIconDisableExpand: linkIconDisableExpand, onClick: onLinkClick, inverse: inverse, target: linkTarget }, { children: linkText }), void 0));
        if (centered) {
            return (jsxs(Fragment, { children: [hasButtonText && (jsx("div", __assign({ sx: {
                            width: ['100%', null, hasLinkCTA ? '50%' : '100%'],
                            display: [null, null, 'flex'],
                            justifyContent: [
                                null,
                                null,
                                hasLinkCTA ? 'flex-end' : 'center'
                            ]
                        } }, { children: buttonElement }), void 0)),
                    hasLinkCTA && (jsx("div", __assign({ sx: {
                            width: ['100%', null, hasButtonText ? '50%' : '100%'],
                            display: ['flex', null, null],
                            justifyContent: [
                                'center',
                                null,
                                hasButtonText ? 'flex-start' : 'center'
                            ]
                        } }, { children: ctaElement }), void 0))] }, void 0));
        }
        return (jsxs(Fragment, { children: [!!buttonText && buttonElement, !!hasLinkCTA && ctaElement] }, void 0));
    };
    var ctaLockupContent = getLockupContent(centerLocked);
    return (jsx("div", __assign({ className: className, sx: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: ['column', null, 'row']
        } }, { children: ctaLockupContent }), void 0));
};

var SectionIntro = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, title = _a.title, _c = _a.titleVariant, titleVariant = _c === void 0 ? 'heading2' : _c, _d = _a.titleColor, titleColor = _d === void 0 ? 'default' : _d, customElement = _a.customElement, _e = _a.text, text = _e === void 0 ? '' : _e, _f = _a.inverse, inverse = _f === void 0 ? false : _f, buttonText = _a.buttonText, linkText = _a.linkText, _g = _a.linkIconDisableExpand, linkIconDisableExpand = _g === void 0 ? false : _g, _h = _a.buttonSize, buttonSize = _h === void 0 ? 'large' : _h; _a.theme; var customStyles = _a.customStyles, props = __rest(_a, ["className", "title", "titleVariant", "titleColor", "customElement", "text", "inverse", "buttonText", "linkText", "linkIconDisableExpand", "buttonSize", "theme", "customStyles"]);
    return (jsxs("div", __assign({ className: className, sx: __assign({ display: 'grid', gridTemplateColumns: [
                'repeat(6, 1fr)',
                null,
                'repeat(8, 1fr)',
                'repeat(12, 1fr)'
            ], columnGap: 'inc40', textAlign: 'center' }, customStyles) }, { children: [jsx("div", __assign({ sx: { gridColumn: ['1 / span 6', null, '2 / span 6', '3 / span 8'] } }, { children: jsx(TypographyScale, __assign({ customElement: customElement ? customElement : undefined, variant: titleVariant, color: titleColor, inverse: inverse }, { children: title }), void 0) }), void 0),
            !!text && (jsx("div", __assign({ sx: {
                    gridColumn: ['1 / span 6', null, '2 / span 6', '4 / span 6'],
                    marginTop: ['inc30', null, 'inc40', 'inc60']
                } }, { children: jsx(TypographyScale, __assign({ color: 'secondary', inverse: inverse, variant: 'body1' }, { children: text }), void 0) }), void 0)),
            (buttonText || linkText) && (jsx("div", __assign({ sx: {
                    gridColumn: ['1 / span 6', null, '2 / span 6', '3 / span 8'],
                    marginTop: ['inc50', null, 'inc60', 'inc70']
                } }, { children: jsx(CTALockup, __assign({ centerLocked: true, linkIcon: 'arrow', buttonText: buttonText, linkText: linkText, linkIconDisableExpand: linkIconDisableExpand, inverse: inverse, buttonSize: buttonSize }, props, { sx: {
                        justifyContent: 'center'
                    } }), void 0) }), void 0))] }), void 0));
};

var ICONS = {
    INVERSE: {
        PLUS: 'https://webimages.mongodb.com/_com_assets/cms/ktei3afgrst841sdx-StatePlus.svg?auto=format%252Ccompress',
        MINUS: 'https://webimages.mongodb.com/_com_assets/cms/ktei3jh2ytadx4nj9-StateMinus.svg?auto=format%252Ccompress'
    },
    DEFAULT: {
        PLUS: 'https://webimages.mongodb.com/_com_assets/cms/kx0wvn02iwn4zu68z-plus.svg?auto=format%252Ccompress',
        MINUS: 'https://webimages.mongodb.com/_com_assets/cms/kx0wvr3ntqon8c7tp-minus.svg?auto=format%252Ccompress'
    }
};

var EColorType;
(function (EColorType) {
    EColorType[EColorType["background"] = 0] = "background";
    EColorType[EColorType["text"] = 1] = "text";
})(EColorType || (EColorType = {}));
/**
 * Returns a color for background or text, following few rules:
 * - Returns colorActive when a tab is selected, otherwise returns colorInactive
 * - When there isn't a color value defined, we use the token
 *
 * @param {EColorType} colorType color type
 * @param {boolean} isActive tab selection state
 * @param {boolean} inverse inverse color token
 * @param {string} colorActive (optional) color for a selected tab
 * @param {string} colorInactive (optional) color for an unselected tab
 * @return {string} a color for background or text
 */
var getColor$1 = function (colorType, isActive, inverse, colorActive, colorInactive) {
    if (isActive && !!colorActive) {
        return colorActive;
    }
    if (!isActive && !!colorInactive) {
        return colorInactive;
    }
    return getTokenColor(colorType, isActive, inverse);
};
var getTokenColor = function (colorType, active, inverse) {
    var themeProp = inverse ? 'inverse' : 'default';
    if (colorType === EColorType.background) {
        return defaultTheme.colors.tabs.tertiary[themeProp][active ? 'bgActive' : 'bgInverse'];
    }
    return defaultTheme.colors.tabs.tertiary[themeProp][active ? 'textActive' : 'textInactive'];
};

var Tab = function (_a) {
    var value = _a.value, bgInactive = _a.bgInactive, bgActive = _a.bgActive, colorInactive = _a.colorInactive, colorActive = _a.colorActive, borderRadius = _a.borderRadius, padding = _a.padding, active = _a.active, _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, onClick = _a.onClick;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    return (jsx("div", __assign({ sx: {
            WebkitUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none',
            fontFamily: selectedTheme.fonts.body,
            height: '40px',
            backgroundColor: getColor$1(EColorType.background, active, inverse, bgActive, bgInactive),
            padding: padding ||
                selectedTheme.space.inc20 + " " + selectedTheme.space.inc40,
            color: getColor$1(EColorType.text, active, inverse, colorActive, colorInactive),
            lineHeight: selectedTheme.lineHeights.inc20,
            borderRadius: borderRadius || selectedTheme.radii.circle,
            cursor: 'pointer',
            boxSizing: 'border-box',
            '&:hover': {
                boxShadow: "0 0 0 1px " + selectedTheme.colors.blue60,
                transition: '.1s' // Need a token for this
            }
        }, onClick: function (e) {
            e.stopPropagation();
            onClick(value);
        } }, { children: value }), void 0));
};

var Tabs = function (_a) {
    var items = _a.items, activeValue = _a.activeValue, _b = _a.className, className = _b === void 0 ? '' : _b, gap = _a.gap, onSelect = _a.onSelect, _c = _a.inverse, inverse = _c === void 0 ? false : _c, fontSize = _a.fontSize, bgActive = _a.bgActive, bgInactive = _a.bgInactive, borderRadius = _a.borderRadius, padding = _a.padding, colorActive = _a.colorActive, colorInactive = _a.colorInactive, _d = _a.theme, theme = _d === void 0 ? 'default' : _d;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var _e = useState(items[0]), selectedValue = _e[0], setSelectedValue = _e[1];
    useEffect(function () {
        activeValue && setSelectedValue(activeValue);
    }, [activeValue]);
    var isActive = function (value) { return value === selectedValue; };
    return (jsx("div", __assign({ "aria-label": 'tabs', className: className, sx: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: gap || selectedTheme.space.base,
            fontFamily: 'body',
            fontSize: fontSize || selectedTheme.fontSizes.inc20
        } }, { children: items.map(function (value, index) {
            var props = {
                value: value,
                active: isActive(value),
                onClick: function (value) {
                    setSelectedValue(value);
                    onSelect && onSelect(value);
                },
                inverse: inverse,
                bgActive: bgActive,
                bgInactive: bgInactive,
                borderRadius: borderRadius,
                padding: padding,
                colorActive: colorActive,
                colorInactive: colorInactive
            };
            return jsx(Tab, __assign({}, props), index);
        }) }), void 0));
};

var CodePanel = function (_a) {
    var _b = _a.snippets, snippets = _b === void 0 ? [{ code: '', language: 'JavaScript', alias: '' }] : _b, _c = _a.copyButton, copyButton = _c === void 0 ? true : _c, _d = _a.copyButtonPosition, copyButtonPosition = _d === void 0 ? 'bottom' : _d, _e = _a.lineNumbers, lineNumbers = _e === void 0 ? true : _e, _f = _a.lineWrapping, lineWrapping = _f === void 0 ? true : _f, _g = _a.height, height = _g === void 0 ? 'medium' : _g, _h = _a.theme, theme = _h === void 0 ? 'default' : _h;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var _j = snippets[0], code = _j.code, language = _j.language, alias = _j.alias;
    var _k = useState(language), currentLanguage = _k[0], setCurrentLanguage = _k[1];
    var _l = useState(code), currentCode = _l[0], setCurrentCode = _l[1];
    var _m = useState(alias), currentAlias = _m[0], setCurrentAlias = _m[1];
    useEffect(function () {
        setCurrentAlias(alias);
        setCurrentLanguage(language);
        setCurrentCode(code);
    }, [snippets]);
    var TAB_VALUES = snippets.map(function (_a) {
        var _b = _a.alias, alias = _b === void 0 ? '' : _b, _c = _a.language, language = _c === void 0 ? '' : _c;
        return alias || language;
    });
    var LANGUAGES = snippets.map(function (obj) { return obj.language; });
    var handleTabSelection = function (selectedValue) {
        var idx = LANGUAGES.indexOf(selectedValue);
        if (idx >= 0) {
            // selectedValue is CodeSnippet-supported language
            setCurrentLanguage(selectedValue);
            setCurrentCode(snippets[idx].code);
            setCurrentAlias(snippets[idx].alias);
        }
        else {
            // selectedValue is an alias
            var snippet = snippets.find(function (_a) {
                var _b = _a.alias, alias = _b === void 0 ? '' : _b;
                return selectedValue === alias;
            });
            if (!snippet)
                return;
            setCurrentLanguage(snippet.language);
            setCurrentCode(snippet.code);
            setCurrentAlias(selectedValue);
        }
    };
    return (jsxs("div", __assign({ "aria-label": 'code-panel-wrapper', sx: {
            display: 'flex',
            flexDirection: 'column'
        } }, { children: [jsx("div", __assign({ "aria-label": 'code-panel-tab-wrapper', sx: {
                    background: selectedTheme.colors.black90,
                    padding: selectedTheme.space.inc30 + " " + selectedTheme.space.inc40,
                    borderTopLeftRadius: selectedTheme.radii.inc60,
                    borderTopRightRadius: selectedTheme.radii.inc60,
                    borderBottom: "1px solid " + selectedTheme.colors.black70
                } }, { children: jsx(Tabs, { bgActive: selectedTheme.colors.tabs.tertiary.bgActive, bgInactive: selectedTheme.colors.black70, colorActive: selectedTheme.colors.black00, colorInactive: selectedTheme.colors.black00, items: TAB_VALUES, activeValue: currentAlias || currentLanguage, onSelect: handleTabSelection }, void 0) }), void 0),
            jsx(CodeSnippet, { height: height, borderRadiusTop: false, language: currentLanguage, code: currentCode, copyButton: copyButton, copyButtonPosition: copyButtonPosition, lineNumbers: lineNumbers, lineWrapping: lineWrapping }, void 0)] }), void 0));
};

var AccordionIcon = function (_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, _c = _a.height, height = _c === void 0 ? '' : _c, _d = _a.width, width = _d === void 0 ? '' : _d;
    return jsx("img", { src: src, sx: { height: height, width: width } }, void 0);
};
var Accordion = function (_a) {
    var _b, _c;
    var tabs = _a.tabs, _d = _a.headerVariant, headerVariant = _d === void 0 ? 'heading6' : _d, _e = _a.openFirstTab, openFirstTab = _e === void 0 ? true : _e, _f = _a.clickHandler, clickHandler = _f === void 0 ? function () { } : _f, _g = _a.embedCodePanels, embedCodePanels = _g === void 0 ? false : _g, _h = _a.theme, theme = _h === void 0 ? 'default' : _h, _j = _a.inverse, inverse = _j === void 0 ? true : _j, children = _a.children, customStyles = _a.customStyles;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var _k = useState(openFirstTab ? 0 : -1), currentTabIndex = _k[0], setCurrentTabIndex = _k[1];
    var contentRef = useRef(null);
    var _l = useState(openFirstTab ? ((_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + "px" : '0px'), contentHeight = _l[0], setContentHeight = _l[1];
    var handleTabSelection = function (event, index) {
        if (index === currentTabIndex) {
            setCurrentTabIndex(-1);
        }
        else {
            setCurrentTabIndex(index);
        }
        clickHandler(event, index);
    };
    useEffect(function () {
        var _a;
        setContentHeight(((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) + "px");
    }, [(_c = contentRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight, children]);
    return (jsx(Fragment, { children: tabs.map(function (tab, index) {
            var _a;
            var _b = tab.linkCta, linkCta = _b === void 0 ? { href: '', text: '', disableExpand: false } : _b;
            var activeTab = index === currentTabIndex;
            return (jsxs("div", __assign({ "aria-label": 'accordion-wrapper', onClick: function (e) {
                    e.stopPropagation();
                    handleTabSelection(e, index);
                }, sx: __assign({ maxWidth: '100%', padding: selectedTheme.space.inc50 + " 0", background: 'transparent', borderBottom: selectedTheme.borderWidths.inc10 + " solid " + selectedTheme.colors.black70, cursor: 'pointer' }, customStyles) }, { children: [jsxs("div", __assign({ "aria-label": 'accordion-tab-head', sx: {
                            display: 'flex',
                            WebkitUserSelect: 'none',
                            msUserSelect: 'none',
                            userSelect: 'none'
                        } }, { children: [jsx(TypographyScale, __assign({ inverse: inverse, variant: headerVariant, sx: {
                                    flex: '1',
                                    fontWeight: 500
                                } }, { children: tab.header }), void 0),
                            activeTab ? (jsx(AccordionIcon, { src: inverse ? ICONS.INVERSE.MINUS : ICONS.DEFAULT.MINUS, height: selectedTheme.sizes.inc20, width: selectedTheme.sizes.inc20 }, void 0)) : (jsx(AccordionIcon, { src: inverse ? ICONS.INVERSE.PLUS : ICONS.DEFAULT.PLUS, height: selectedTheme.sizes.inc20, width: selectedTheme.sizes.inc20 }, void 0))] }), void 0),
                    jsxs("div", __assign({ ref: contentRef, "aria-label": activeTab ? 'active-tab-body' : 'accordion-tab-body', sx: {
                            marginTop: selectedTheme.space.inc20,
                            paddingRight: selectedTheme.space.inc40,
                            height: activeTab ? '100%' : '0px',
                            minHeight: activeTab ? contentHeight : '0px',
                            transition: "min-height " + selectedTheme.motion.accordion + " ease",
                            overflow: 'hidden'
                        } }, { children: [jsx("div", __assign({ sx: {
                                    marginTop: selectedTheme.space.inc30,
                                    marginBottom: selectedTheme.space.inc50,
                                    marginRight: selectedTheme.space.inc20
                                } }, { children: jsx(TypographyScale, __assign({ color: 'secondary', inverse: inverse, variant: 'body3' }, { children: tab.description }), void 0) }), void 0),
                            linkCta.href && linkCta.text && (jsx(Link, __assign({ inverse: inverse, textContentMaxWidth: 'calc(100% - 85px)', linkIcon: 'chevron', theme: theme, href: linkCta.href, linkIconDisableExpand: linkCta.disableExpand === undefined
                                    ? false
                                    : linkCta.disableExpand, sx: {
                                    width: '100%'
                                }, stopPropagation: true }, { children: linkCta.text }), void 0)),
                            embedCodePanels && ((_a = tabs[currentTabIndex]) === null || _a === void 0 ? void 0 : _a.codeBlock) && (jsx("div", __assign({ onClick: function (e) { return e.stopPropagation(); }, sx: {
                                    marginTop: selectedTheme.space.inc30
                                } }, { children: jsx(CodePanel, __assign({}, tabs[currentTabIndex].codeBlock, { copyButton: false, lineNumbers: false, lineWrapping: true }), void 0) }), void 0)), children && React.Children.toArray(children)[currentTabIndex]] }), void 0)] }), index));
        }) }, void 0));
};

var hasItems = function (array) {
    return array !== undefined && array !== null && array.length !== 0;
};
function debounce(fn, ms) {
    var timer;
    var debouncedFunc = function (args) {
        return new Promise(function (resolve) {
            if (timer) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                resolve(fn(args));
            }, ms);
        });
    };
    var teardown = function () { return clearTimeout(timer); };
    return [debouncedFunc, teardown];
}

var getDateAndDuration = function (date, duration) {
    if (date && duration) {
        return date + " \u2022 " + duration;
    }
    if (date)
        return date;
    if (duration)
        return duration;
    return '';
};

var DateSection = function (_a) {
    var _b = _a.date, date = _b === void 0 ? '' : _b, _c = _a.duration, duration = _c === void 0 ? '' : _c;
    return (jsx(TypographyScale, __assign({ customStyles: { marginTop: ['inc50', null, null, 'inc60'] }, variant: 'body3' }, { children: getDateAndDuration(date, duration) }), void 0));
};

var LeadPageInfoSideBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.article, article = _c === void 0 ? { url: '' } : _c, date = _a.date, duration = _a.duration, speakersTitle = _a.speakersTitle, _d = _a.speakers, speakers = _d === void 0 ? [] : _d, languagesTitle = _a.languagesTitle, _e = _a.languages, languages = _e === void 0 ? [] : _e, tagsTitle = _a.tagsTitle, _f = _a.tags, tags = _f === void 0 ? [] : _f, shareButtonsTitle = _a.shareButtonsTitle, _g = _a.theme, theme = _g === void 0 ? 'default' : _g, customStyles = _a.customStyles, buttonTitle = _a.buttonTitle, buttonProps = _a.buttonProps, showHeaderButton = _a.showHeaderButton;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var headerProps = {
        showHeaderButton: showHeaderButton,
        buttonTitle: buttonTitle,
        buttonProps: buttonProps
    };
    return (jsxs("aside", __assign({ className: className, sx: __assign({ display: 'flex', flexDirection: 'column' }, customStyles) }, { children: [jsx(Header, __assign({}, headerProps), void 0),
            (date || duration) && jsx(DateSection, { date: date, duration: duration }, void 0),
            hasItems(speakers) && (jsx(SpeakersSection, { speakersTitle: speakersTitle || 'speakers', speakers: speakers }, void 0)),
            hasItems(languages) && (jsx(LanguagesSection, { languagesTitle: languagesTitle || 'languages', languages: languages }, void 0)),
            hasItems(tags) && (jsx(TagsSection, { tagsTitle: tagsTitle || 'view more', tags: tags }, void 0)),
            jsx(Eyebrow, __assign({ customElement: 'span', customStyles: {
                    marginTop: ['inc50', null, null, 'inc60'],
                    display: 'block'
                } }, { children: shareButtonsTitle || 'share this' }), void 0),
            jsx(ShareButtonsGroup, { theme: selectedTheme, article: article }, void 0)] }), void 0));
};

var Header = function (_a) {
    var _b = _a.buttonTitle, buttonTitle = _b === void 0 ? '' : _b, _c = _a.buttonProps, buttonProps = _c === void 0 ? {} : _c, _d = _a.showHeaderButton, showHeaderButton = _d === void 0 ? false : _d;
    return (jsxs(Fragment, { children: [showHeaderButton && (jsx(Button, __assign({ href: buttonProps && buttonProps.href, variant: 'primary', customStyles: {
                    width: '100%'
                }, onClick: buttonProps && buttonProps.onClick }, buttonProps, { children: buttonTitle }), void 0)),
            jsx(HorizontalRule, { customStyles: {
                    marginTop: ['inc50', null, null, 'inc60']
                } }, void 0)] }, void 0));
};

var LanguagesSection = function (_a) {
    var languagesTitle = _a.languagesTitle, _b = _a.languages, languages = _b === void 0 ? [] : _b;
    return (jsxs(Fragment, { children: [languagesTitle && (jsx(Eyebrow, __assign({ customElement: 'span', customStyles: {
                    marginTop: ['inc50', null, null, 'inc60'],
                    display: 'block'
                } }, { children: languagesTitle }), void 0)),
            jsx("div", __assign({ "aria-label": 'languages-container', sx: {
                    display: 'flex',
                    gap: 'inc10',
                    flexWrap: 'wrap',
                    marginTop: 'inc40'
                } }, { children: languages.map(function (language, index) {
                    var lastItem = index === languages.length - 1;
                    return (jsx(TypographyScale, __assign({ variant: 'body3', customElement: 'p', customStyles: { color: 'green80' } }, { children: "" + language + (lastItem ? '' : ',') }), language));
                }) }), void 0)] }, void 0));
};

var _a;
var ESocialShareIcons;
(function (ESocialShareIcons) {
    ESocialShareIcons["TWITTER_DEFAULT"] = "Twitter Default";
    ESocialShareIcons["TWITTER_INVERSE"] = "Twitter Inverse";
    ESocialShareIcons["LINKEDIN_DEFAULT"] = "LinkedIn Default";
    ESocialShareIcons["LINKEDIN_INVERSE"] = "LinkedIn Inverse";
    ESocialShareIcons["FACEBOOK_DEFAULT"] = "Facebook Default";
    ESocialShareIcons["FACEBOOK_INVERSE"] = "Facebook Inverse";
})(ESocialShareIcons || (ESocialShareIcons = {}));
var IconPaths = (_a = {},
    _a[ESocialShareIcons.TWITTER_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3glwqmuj32g2c5b-twitter-icon.svg?auto=format%252Ccompress',
    _a[ESocialShareIcons.TWITTER_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gqamik97awj25y-twitter-icon-inverse.svg?auto=format%252Ccompress',
    _a[ESocialShareIcons.LINKEDIN_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gk7f60aqudvzz7-linkedin-icon.svg?auto=format%252Ccompress',
    _a[ESocialShareIcons.LINKEDIN_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gpv4srls4oajgs-linkedin-icon-inverse.svg?auto=format%252Ccompress',
    _a[ESocialShareIcons.FACEBOOK_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gim7t28ihobrpf-facebook-icon.svg?auto=format%252Ccompress',
    _a[ESocialShareIcons.FACEBOOK_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gm784m1mmtfy9t-facebook-icon-inverse.svg?auto=format%252Ccompress',
    _a);

var ShareButtonsGroup = function (_a) {
    var article = _a.article; _a.theme; var _c = _a.inverse, inverse = _c === void 0 ? false : _c;
    var heading = article.heading, subheading = article.subheading, url = article.url;
    var mode = inverse ? 'INVERSE' : 'DEFAULT';
    return (jsxs("div", __assign({ "aria-label": 'share-buttons-container', sx: {
            display: 'flex',
            gap: 'inc30',
            marginTop: 'inc40',
            a: {
                width: ['32px', null, null, '24px']
            },
            img: {
                width: '100%'
            }
        } }, { children: [jsx("a", __assign({ target: '_blank', rel: 'noopener noreferrer', href: "https://twitter.com/intent/tweet?url=" + url + "&text=" + heading }, { children: jsx("img", { src: IconPaths[ESocialShareIcons["TWITTER_" + mode]], alt: 'twitter icon' }, void 0) }), void 0),
            jsx("a", __assign({ target: '_blank', rel: 'noopener noreferrer', href: "https://www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + heading + "&summary=" + subheading + "&source=MongoDB" }, { children: jsx("img", { src: IconPaths[ESocialShareIcons["LINKEDIN_" + mode]], alt: 'linkedin icon' }, void 0) }), void 0),
            jsx("a", __assign({ target: '_blank', rel: 'noopener noreferrer', href: "https://www.facebook.com/sharer.php?u=" + url }, { children: jsx("img", { src: IconPaths[ESocialShareIcons["FACEBOOK_" + mode]], alt: 'facebook icon' }, void 0) }), void 0)] }), void 0));
};

var SpeakersSection = function (_a) {
    var speakersTitle = _a.speakersTitle, _b = _a.speakers, speakers = _b === void 0 ? [] : _b;
    return (jsxs(Fragment, { children: [speakersTitle && (jsx(Eyebrow, __assign({ customElement: 'span', customStyles: {
                    marginTop: ['inc50', null, null, 'inc60'],
                    display: 'block'
                } }, { children: speakersTitle }), void 0)),
            jsx("div", __assign({ "aria-label": 'speakers-container', sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 'inc40',
                    gap: 'inc30'
                } }, { children: speakers.map(function (_a) {
                    var name = _a.name, title = _a.title, profileImage = _a.profileImage;
                    return (jsx(SpeakerLockup, { name: name, title: title, profileImage: profileImage }, name + "-" + title));
                }) }), void 0)] }, void 0));
};

var TagsSection = function (_a) {
    var tagsTitle = _a.tagsTitle, _b = _a.tags, tags = _b === void 0 ? [] : _b;
    return (jsxs(Fragment, { children: [tagsTitle && (jsx(Eyebrow, __assign({ customElement: 'span', customStyles: {
                    marginTop: ['inc50', null, null, 'inc60'],
                    display: 'block'
                } }, { children: tagsTitle }), void 0)),
            jsx("div", __assign({ "aria-label": 'tags-container', sx: {
                    display: 'flex',
                    gap: 'inc20',
                    flexWrap: 'wrap',
                    marginTop: 'inc40'
                } }, { children: tags.map(function (_a) {
                    var text = _a.text, href = _a.href, target = _a.target;
                    return (text && (jsx(Tag, __assign({ href: href, target: target }, { children: text }), text)));
                }) }), void 0)] }, void 0));
};

var getInitials = function (name) {
    var _a, _b;
    if (name === void 0) { name = ''; }
    var fullName = name.split(' ');
    var firstNameInitial = (_a = fullName.shift()) === null || _a === void 0 ? void 0 : _a.charAt(0);
    var lastNameInitial = (_b = fullName.pop()) === null || _b === void 0 ? void 0 : _b.charAt(0);
    if (firstNameInitial && lastNameInitial) {
        var initials = firstNameInitial + lastNameInitial;
        return initials.toUpperCase();
    }
    if (firstNameInitial) {
        return firstNameInitial.toUpperCase();
    }
    return name;
};
var getStyles$2 = function () {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: 'inc30'
        },
        profileImage: {
            borderRadius: '50%',
            width: ['40px', null, null, '64px'],
            height: ['40px', null, null, '64px']
        },
        avatarPlaceholder: {
            backgroundColor: 'blue80',
            borderRadius: '50%',
            width: ['40px', null, null, '64px'],
            height: ['40px', null, null, '64px'],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        typographyContainer: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '256px'
        }
    };
};

var SpeakerLockup = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.profileImage, profileImage = _c === void 0 ? {} : _c, name = _a.name, title = _a.title, customStyles = _a.customStyles;
    var hasProfileImage = !!profileImage && !!profileImage.src;
    var styles = getStyles$2();
    var renderAvatar = function () {
        if (hasProfileImage) {
            return (jsx("img", { sx: styles.profileImage, src: profileImage.src, alt: (profileImage === null || profileImage === void 0 ? void 0 : profileImage.alt) || '' }, void 0));
        }
        return (jsx("div", __assign({ sx: styles.avatarPlaceholder }, { children: jsx(TypographyScale, __assign({ inverse: true, customStyles: {
                    fontWeight: [400, null, null, 500],
                    fontSize: ['16px', null, null, '24px']
                } }, { children: getInitials(name) }), void 0) }), void 0));
    };
    return (jsxs("div", __assign({ "aria-label": 'speaker-lockup-container', className: className, sx: __assign(__assign({}, styles.container), customStyles) }, { children: [renderAvatar(), jsxs("div", __assign({ sx: styles.typographyContainer }, { children: [jsx(TypographyScale, __assign({ variant: 'body1', customStyles: { fontWeight: 500 } }, { children: name }), void 0),
                    jsx(TypographyScale, __assign({ variant: 'body3', color: 'secondary' }, { children: title }), void 0)] }), void 0)] }), void 0));
};

var ShareLink = function (_a) {
    var children = _a.children, href = _a.href, target = _a.target, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, label = _a.label;
    return (jsx("a", __assign({ "aria-label": label, sx: {
            height: [32, null, null, 24],
            marginLeft: 'elementXSmall',
            display: isOpen ? 'initial' : ['none', 'initial']
        }, href: href, target: target }, { children: children }), void 0));
};

//exported for testing only
var getDocHeight = function () {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
};
//exported for testing only
var calculateScrollDistance = function (setScroll) {
    var scrollTop = window.scrollY;
    var windowHeight = window.innerHeight;
    var docHeight = getDocHeight();
    var totalDocScrollLength = docHeight - windowHeight;
    var scrollPosition = Math.floor((scrollTop / totalDocScrollLength) * 100);
    setScroll(scrollPosition);
};
var listenToScrollEvent = function (setScroll) {
    requestAnimationFrame(function () {
        // Calculates the scroll distance
        calculateScrollDistance(setScroll);
    });
};

var useDebounce = function (fn, ms) {
    var _a = debounce(fn, ms), debouncedFun = _a[0], teardown = _a[1];
    useEffect(function () { return function () { return teardown(); }; }, []);
    return debouncedFun;
};

var FacebookIcon = function () {
    return (jsx("svg", __assign({ sx: {
            width: [32, null, null, 24],
            height: [32, null, null, 24]
        }, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: jsx("path", { d: 'M24 12.0724C24 5.40845 18.624 0 12 0C5.376 0 0 5.40845 0 12.0724C0 18.0966 4.392 23.0946 10.128 24V15.5614H7.08V12.0724H10.128V9.4165C10.128 6.38632 11.916 4.72032 14.664 4.72032C15.972 4.72032 17.352 4.96177 17.352 4.96177V7.93159H15.84C14.352 7.93159 13.884 8.86117 13.884 9.81489V12.0724H17.208L16.68 15.5614H13.884V24C19.608 23.0946 24 18.0966 24 12.0724Z', fill: '#001E2B' }, void 0) }), void 0));
};

var LinkedInIcon = function () {
    return (jsx("svg", __assign({ sx: {
            width: [32, null, null, 24],
            height: [32, null, null, 24]
        }, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.86487 6.17112C8.86487 6.91818 8.29604 7.52276 7.4065 7.52276C6.55162 7.52276 5.98279 6.91818 6.0004 6.17112C5.98279 5.38775 6.5516 4.80078 7.42354 4.80078C8.29603 4.80078 8.84781 5.38775 8.86487 6.17112ZM6.07192 17.2917V8.59053H8.77629V17.2917H6.07192ZM10.9446 11.3676C10.9446 10.2823 10.9088 9.35698 10.873 8.59177H13.222L13.3469 9.78387H13.4003C13.7562 9.23211 14.6457 8.39648 16.087 8.39648C17.8661 8.39648 19.2007 9.57098 19.2007 12.1323V17.2935H16.4963V12.4712C16.4963 11.3495 16.1052 10.5848 15.1265 10.5848C14.3789 10.5848 13.9344 11.1008 13.7568 11.5987C13.6852 11.7769 13.65 12.0256 13.65 12.2753V17.2935H10.9457V11.3676H10.9446Z', fill: '#001E2B' }, void 0) }), void 0));
};

var TwitterIcon = function () {
    return (jsx("svg", __assign({ sx: {
            width: [32, null, null, 24],
            height: [32, null, null, 24]
        }, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, { children: jsx("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.5041 7.85027C18.1017 7.77876 18.6714 7.62037 19.2008 7.38519C18.8048 7.97747 18.3037 8.49776 17.7259 8.91533C17.7321 9.04156 17.7345 9.16922 17.7345 9.29738C17.7345 13.201 14.763 17.7026 9.32929 17.7026C7.66091 17.7026 6.10822 17.213 4.80078 16.375C5.03165 16.4028 5.26683 16.4167 5.50585 16.4167C6.89008 16.4167 8.16392 15.944 9.17474 15.152C7.88218 15.128 6.79073 14.2737 6.41492 13.1002C6.59538 13.1347 6.78065 13.1534 6.9712 13.1534C7.24046 13.1534 7.50156 13.117 7.74923 13.0498C6.3986 12.7776 5.37962 11.5839 5.37962 10.1522V10.1152C5.77848 10.3365 6.23349 10.4695 6.71826 10.4848C5.92487 9.95494 5.4041 9.05068 5.4041 8.02595C5.4041 7.48454 5.54953 6.97721 5.80392 6.54092C7.2611 8.32832 9.43776 9.50472 11.8933 9.6276C11.8429 9.41113 11.8165 9.18555 11.8165 8.9542C11.8165 7.32279 13.1393 6 14.7707 6C15.6198 6 16.3882 6.35902 16.9272 6.93306C17.5996 6.80011 18.2327 6.55484 18.8029 6.21598C18.5826 6.9057 18.1142 7.48454 17.5041 7.85027Z', fill: '#001E2B' }, void 0) }), void 0));
};

var ShareBar = function (_a) {
    var title = _a.title, facebookUrl = _a.facebookUrl, linkedinUrl = _a.linkedinUrl, twitterUrl = _a.twitterUrl, isVisible = _a.isVisible;
    var _b = useState(0), scroll = _b[0], setScroll = _b[1];
    var debounceScrollEvent = useDebounce(function () { return listenToScrollEvent(setScroll); }, 15);
    useEffect(function () {
        document.addEventListener('scroll', debounceScrollEvent);
        return function () {
            document.removeEventListener('scroll', debounceScrollEvent);
        };
    }, []);
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var toggleIsOpen = useCallback(function () {
        setIsOpen(!isOpen);
    }, [isOpen]);
    var titleRef = useRef(null);
    var _d = useDimension(titleRef), width = _d.width, height = _d.height;
    var _e = useState(), padding = _e[0], setPadding = _e[1];
    useEffect(function () {
        var _a = defaultTheme.breakpoints, mobile = _a[0], tablet = _a[2];
        var isMobile = width <= parseInt(mobile);
        var isTablet = width > parseInt(mobile) && width < parseInt(tablet);
        var isMoreThanOneLine = height > parseInt(defaultTheme.lineHeights.bodyL);
        if (isMoreThanOneLine) {
            if (isMobile) {
                setPadding('inc20');
            }
            if (isTablet) {
                setPadding('inc30');
            }
        }
        else {
            setPadding(null);
        }
    }, [titleRef, width, height]);
    var getPaddingY = useCallback(function () {
        if (isOpen)
            return 'inc40';
        if (padding)
            return padding;
        return ['inc30', 'inc50', 'inc60'];
    }, [isOpen, padding]);
    return (jsxs("div", __assign({ sx: {
            width: '100%',
            display: isVisible ? 'flex' : 'none',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            position: 'fixed',
            boxShadow: 'level01',
            top: 0
        } }, { children: [jsxs("div", __assign({ sx: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingY: getPaddingY(),
                    paddingBottom: isOpen && 'inc40'
                } }, { children: [jsx("div", __assign({ sx: {
                            flex: 1,
                            textAlign: ['left', null, null, 'center'],
                            paddingLeft: 'elementMedium',
                            display: isOpen && 'none'
                        }, ref: titleRef }, { children: jsx(TypographyScale, __assign({ customStyles: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                '-webkit-line-clamp': '2',
                                '-webkit-box-orient': 'vertical'
                            } }, { children: title }), void 0) }), void 0),
                    jsxs("div", __assign({ sx: {
                            marginRight: 'elementLarge',
                            marginLeft: isOpen ? 'inc20' : 'elementLarge',
                            flex: isOpen ? 1 : 0,
                            display: 'flex',
                            position: isOpen && 'relative'
                        } }, { children: [jsx("button", __assign({ "aria-label": 'Share menu', onClick: toggleIsOpen, sx: {
                                    display: isOpen ? 'none' : ['initial', 'none'],
                                    border: 'none',
                                    bg: 'white',
                                    cursor: 'pointer'
                                } }, { children: jsx(SystemIcon, { name: ESystemIconNames.SHAREOPTION }, void 0) }), void 0),
                            (facebookUrl === null || facebookUrl === void 0 ? void 0 : facebookUrl.href) && (jsx(ShareLink, __assign({ label: 'Share on Facebook', isOpen: isOpen, href: facebookUrl.href, target: facebookUrl.target }, { children: jsx(FacebookIcon, {}, void 0) }), void 0)),
                            (linkedinUrl === null || linkedinUrl === void 0 ? void 0 : linkedinUrl.href) && (jsx(ShareLink, __assign({ label: 'Share on LinkedIn', isOpen: isOpen, href: linkedinUrl.href, target: linkedinUrl.target }, { children: jsx(LinkedInIcon, {}, void 0) }), void 0)),
                            (twitterUrl === null || twitterUrl === void 0 ? void 0 : twitterUrl.href) && (jsx(ShareLink, __assign({ label: 'Share on Twitter', isOpen: isOpen, href: twitterUrl.href, target: twitterUrl.target }, { children: jsx(TwitterIcon, {}, void 0) }), void 0)),
                            isOpen && (jsx("button", __assign({ "aria-label": 'Close menu', onClick: toggleIsOpen, sx: {
                                    marginLeft: 'elementMedium',
                                    border: 'none',
                                    bg: 'white',
                                    cursor: 'pointer',
                                    position: 'absolute',
                                    marginY: 'auto',
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)'
                                } }, { children: jsx(SystemIcon, { strokeWeight: 'medium', name: ESystemIconNames.CLOSE }, void 0) }), void 0))] }), void 0)] }), void 0),
            jsx("div", { sx: {
                    alignSelf: 'flex-start',
                    width: scroll + "%",
                    height: '4px',
                    bg: "background.selected"
                } }, void 0)] }), void 0));
};

var PromoImage = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.image, image = _c === void 0 ? {} : _c, _d = _a.postSubmissionState, postSubmissionState = _d === void 0 ? false : _d, _e = _a.iconName, iconName = _e === void 0 ? ESystemIconNames.PLAY : _e, _f = _a.iconStrokeWeight, iconStrokeWeight = _f === void 0 ? 'medium' : _f, buttonText = _a.buttonText, flyoutHash = _a.flyoutHash, _g = _a.onClickPlay, onClickPlay = _g === void 0 ? function () { } : _g, customStyles = _a.customStyles;
    var buttonWrapperCommonStyles = {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    return (jsxs("div", __assign({ onClick: postSubmissionState ? onClickPlay : function () { }, className: className, "aria-label": 'promo-image-wrapper', sx: __assign({ cursor: postSubmissionState ? 'pointer' : 'default', position: 'relative', width: '100%', borderRadius: ['none', null, 'inc50', 'inc70'], overflow: 'hidden' }, customStyles) }, { children: [jsx(SingleImage, { variant: ESingleImageVariant.VIDEO, src: image.src || '', altText: image.alt }, void 0),
            postSubmissionState ? (jsx(ButtonIcon, { onClick: onClickPlay, iconName: iconName, iconStrokeWeight: iconStrokeWeight, customWrapperStyles: __assign({}, buttonWrapperCommonStyles) }, void 0)) : (buttonText && (jsx(Button, __assign({ onClick: onClickPlay, hasIcon: true, iconName: iconName, iconStrokeWeight: iconStrokeWeight, href: flyoutHash ? flyoutHash : '', customWrapperStyles: __assign({}, buttonWrapperCommonStyles) }, { children: buttonText }), void 0)))] }), void 0));
};

var StyledList = {
    paddingLeft: 0,
    listStyle: [null, null, null, 'none'],
    display: ['block', 'block', 'block', 'inline-block']
};
var SecondaryLinksList = function (_a) {
    var children = _a.children;
    return jsx("li", __assign({ sx: StyledList }, { children: children }), void 0);
};

// Do we need this in sx since it uses props?
var SecondaryLinks = styled.ul(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  overflow-y: auto;\n  height: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: 0;\n  /* L1 */\n  > li {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    position: relative;\n\n    &:first-of-type {\n      min-height: 30px;\n      padding-top: ", ";\n    }\n    &:not(:last-child) {\n      border-bottom: solid #e7eeec 1px;\n    }\n  }\n"], ["\n  overflow-y: auto;\n  height: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: 0;\n  /* L1 */\n  > li {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    position: relative;\n\n    &:first-of-type {\n      min-height: 30px;\n      padding-top: ", ";\n    }\n    &:not(:last-child) {\n      border-bottom: solid #e7eeec 1px;\n    }\n  }\n"])), function (props) { return (props.isOpen ? '100vh' : '0'); }, defaultTheme.space.inc40, defaultTheme.space.inc40, defaultTheme.space.inc30, defaultTheme.space.inc30, defaultTheme.space.inc40);
var MainLinkStyles$1 = {
    borderBottom: 'solid #00ED64 2px',
    fontSize: 'inc30',
    fontWeight: 500,
    paddingLeft: 'inc50',
    paddingTop: 'inc30',
    paddingBottom: 'inc30'
};
var StylesFloraLink = {
    display: 'inline-block',
    paddingLeft: 'inc40',
    lineHeight: 'normal'
};
var StylesFloraLinkChevronRight = {
    display: 'flex',
    paddingLeft: 'inc40',
    lineHeight: 'normal',
    span: {
        color: 'default!important',
        fontSize: 'inc20',
        fontFamily: 'body',
        fontWeight: '300',
        '&:hover': {
            borderBottom: 'solid 2px transparent !important'
        }
    }
};
var plusOrMinusStylesForDropDowns = {
    position: 'absolute',
    right: '0'
};
var aLinkStyles$1 = {
    display: 'inline-block',
    alignItems: 'center',
    fontSize: 'inc20',
    fontFamily: 'euclid-circular-a',
    fontWeight: 300,
    '.all-link .textlink-default-text-class': {
        color: '#006cfa'
    },
    '&:hover': {
        color: 'text.selected',
        textDecoration: 'none'
    }
};
var chevronStylesForMainLink = {
    display: 'inline',
    position: 'absolute',
    right: 'inc40',
    stroke: 'icon.system.success'
};
var DropDownStyles = {
    position: 'relative'
};
var StylesDropDownWrapper$1 = {
    '.dropdown-titles': {
        display: 'inline-block',
        fontSize: 'inc40',
        marginBottom: 'inc40'
    },
    backgroundColor: '#fff',
    color: '#000'
};
var StylesDropDownMenuList = {
    listStyleType: 'none',
    whiteSpace: 'nowrap',
    paddingTop: 'inc30',
    paddingLeft: 0,
    // L2
    'li:not(:last-child)': {
        paddingBottom: 'inc30'
    }
};
// L2
var StylesSubLinks = {
    backgroundColor: '#f5f7fa',
    listStyleType: 'none',
    paddingTop: 'inc40',
    paddingBottom: 'inc40',
    marginLeft: '-inc40',
    marginRight: '-inc40',
    /* L3 */
    '> li': {
        paddingLeft: 'inc50',
        '&:not(:last-child)': {
            paddingBottom: 'inc50'
        }
    },
    ul: {
        listStyleType: 'none',
        paddingLeft: 'inc40',
        paddingTop: 'inc40',
        /* L4 */
        '> li:not(:last-child)': {
            paddingBottom: 'inc60'
        },
        '> li:last-child': {
            color: '#006cfa'
        }
    }
};
var templateObject_1$1;

var DropDownButton = function (_a) {
    var text = _a.text, dropDownItems = _a.dropDownItems;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var showMenu = function () {
        setIsOpen(!isOpen);
    };
    return (jsxs(Fragment, { children: [jsx("div", __assign({ sx: DropDownStyles }, { children: jsxs("div", __assign({ onClick: showMenu, sx: { fontFamily: 'euclid-circular-a' } }, { children: [text, jsx(SystemIcon, { sx: plusOrMinusStylesForDropDowns, name: isOpen ? ESystemIconNames.MINUS : ESystemIconNames.PLUS, size: 'small', color: 'success' }, void 0)] }), void 0) }), void 0),
            isOpen && jsx(DropDownMenu$1, { items: dropDownItems }, void 0)] }, void 0));
};
var SubNavLink$1 = function (_a) {
    var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems; _a.path; var all = _a.all;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var showMenu = function () {
        setIsOpen(!isOpen);
    };
    return (jsxs("li", { children: [jsx("span", __assign({ sx: {
                    display: 'inline'
                } }, { children: jsxs(Link, __assign({ sx: StylesFloraLink, onClick: showMenu }, { children: [name, jsx(SystemIcon, { sx: plusOrMinusStylesForDropDowns, name: isOpen ? ESystemIconNames.MINUS : ESystemIconNames.PLUS, size: 'small', color: 'success' }, void 0)] }), void 0) }), void 0),
            dropDownItems && (jsx(Fragment, { children: isOpen && (jsx(Fragment, { children: jsx(Fragment, { children: jsxs("ul", __assign({ sx: StylesSubLinks }, { children: [dropDownItems === null || dropDownItems === void 0 ? void 0 : dropDownItems.map(function (_a) {
                                    var name = _a.name, slug = _a.slug, l1Product = _a.l1Product, dropDownItems = _a.dropDownItems;
                                    return (jsx(Fragment, { children: l1Product ? (jsx("li", { children: jsx(MobileViewL1ProductLinks, { name: name, slug: slug, dropDownItems: dropDownItems }, void 0) }, name)) : (jsx("li", { children: jsxs("a", __assign({ href: slug, sx: __assign(__assign({}, aLinkStyles$1), { display: 'flex', alignItems: 'center' }) }, { children: [jsx(Link, __assign({ sx: StylesFloraLink, customLinkContentStyles: {
                                                            color: '#000'
                                                        } }, { children: name }), void 0),
                                                    jsx(SystemIcon, { sx: {
                                                            paddingLeft: 'inc10',
                                                            display: 'inline'
                                                        }, name: ESystemIconNames.CHEVRON_RIGHT, size: 'small' }, void 0)] }), name) }, name)) }, void 0));
                                }),
                                all && (jsx("li", { children: jsxs("a", __assign({ href: slug, sx: __assign(__assign({}, aLinkStyles$1), { display: 'flex', alignItems: 'center' }) }, { children: [jsx(Link, __assign({ className: 'all-link', sx: StylesFloraLink }, { children: all }), void 0),
                                            jsx(SystemIcon, { sx: {
                                                    paddingLeft: 'inc10',
                                                    display: 'inline'
                                                }, name: ESystemIconNames.CHEVRON_RIGHT, size: 'small' }, void 0)] }), name) }, all))] }), void 0) }, void 0) }, void 0)) }, void 0))] }, void 0));
};
var DropDownMenu$1 = function (_a) {
    var items = _a.items;
    return (
    // StylesDropDownMenuList
    jsx("div", __assign({ sx: StylesDropDownWrapper$1 }, { children: jsxs("ul", __assign({ sx: StylesDropDownMenuList }, { children: [items.map(function (_a) {
                    var name = _a.name, slug = _a.slug, all = _a.all, path = _a.path, dropDownItems = _a.dropDownItems;
                    return (jsx(Fragment, { children: jsx(SubNavLink$1, { name: name, slug: slug, all: all, path: path, dropDownItems: dropDownItems }, void 0) }, void 0));
                }),
                jsx("li", { children: jsx("a", __assign({ href: 'topics', sx: aLinkStyles$1 }, { children: jsx(Link, __assign({ sx: StylesFloraLink }, { children: "All Topics" }), void 0) }), void 0) }, 'all topics')] }), void 0) }), void 0));
};
var MobileViewL1ProductLinks = function (_a) {
    var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems;
    var _b = useState(false), isOpenL1 = _b[0], setIsOpenL1 = _b[1];
    var onClickShowL1Menu = function () {
        setIsOpenL1(!isOpenL1);
    };
    return (jsxs(Fragment, { children: [jsxs("div", __assign({ sx: { display: 'flex', alignItems: 'center' } }, { children: [jsxs("a", __assign({ href: slug, sx: __assign(__assign({}, aLinkStyles$1), { display: 'flex', alignItems: 'center' }) }, { children: [jsx(Link, __assign({ sx: StylesFloraLinkChevronRight }, { children: name }), void 0),
                            jsx(SystemIcon, { sx: {
                                    paddingLeft: 'inc10',
                                    display: 'inline'
                                }, name: ESystemIconNames.CHEVRON_RIGHT, size: 'small' }, void 0)] }), name),
                    jsxs("span", __assign({ onClick: onClickShowL1Menu }, { children: [!isOpenL1 && (jsx(SystemIcon, { sx: plusOrMinusStylesForDropDowns, name: ESystemIconNames.PLUS, size: 'small', color: 'success' }, void 0)),
                            isOpenL1 && (jsx(SystemIcon, { sx: plusOrMinusStylesForDropDowns, name: ESystemIconNames.MINUS, size: 'small', color: 'success' }, void 0))] }), void 0)] }), void 0),
            dropDownItems && isOpenL1 && (jsx("ul", { children: dropDownItems.map(function (_a) {
                    var name = _a.name;
                    return (jsx("li", __assign({ sx: { marginLeft: 'inc40' } }, { children: jsx("a", __assign({ href: slug, sx: aLinkStyles$1 }, { children: name }), name) }), name));
                }) }, void 0))] }, void 0));
};
var MobileView = function (_a) {
    var navLinks = _a.navLinks, title = _a.title;
    var _b = useState(false), mobileMenuIsOpen = _b[0], setMobileMenuIsOpen = _b[1];
    var openMobileMenu = function () {
        setMobileMenuIsOpen(!mobileMenuIsOpen);
    };
    return (jsxs("div", __assign({ sx: {
            boxSizing: 'border-box',
            background: '#fff',
            backgroundColor: 'white',
            display: ['block', 'block', 'block', 'none'],
            overflowY: 'auto',
            width: '100%',
            zIndex: '10'
        } }, { children: [jsxs("div", __assign({ sx: { display: 'grid', gridTemplateColumns: '240px 1fr' } }, { children: [jsxs(Link, __assign({ sx: MainLinkStyles$1, onClick: openMobileMenu, customLinkContentStyles: {
                            color: '#000!important',
                            fontSize: '18px!important',
                            '&:hover': {
                                borderBottom: '2px solid transparent!important'
                            }
                        } }, { children: [title, !mobileMenuIsOpen && (jsx(SystemIcon, { sx: chevronStylesForMainLink, className: 'chevron-icon', name: ESystemIconNames.CHEVRON_DOWN, size: 'small' }, void 0)),
                            mobileMenuIsOpen && (jsx(SystemIcon, { sx: chevronStylesForMainLink, className: 'chevron-icon', name: ESystemIconNames.CHEVRON_UP, size: 'small', strokeWeight: 'large' }, void 0))] }), void 0),
                    jsx("div", { sx: {
                            height: '68px',
                            width: '100%',
                            borderBottom: 'solid 2px #00684A'
                        } }, void 0)] }), void 0),
            jsx(SecondaryLinks, __assign({ isOpen: mobileMenuIsOpen }, { children: navLinks.map(function (_a) {
                    var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems, target = _a.target;
                    return (jsx(SecondaryLinksList, { children: (dropDownItems === null || dropDownItems === void 0 ? void 0 : dropDownItems.length) ? (jsx(DropDownButton, { text: name, dropDownItems: dropDownItems }, void 0)) : (jsx(Fragment, { children: jsx("div", __assign({ sx: DropDownStyles }, { children: jsx(Link, __assign({ sx: __assign(__assign({}, StylesFloraLink), { paddingLeft: 0 }), target: target, href: slug, customLinkContentStyles: {
                                        color: '#000',
                                        fontSize: 'inc20',
                                        fontFamily: 'body',
                                        fontWeight: '300',
                                        '&:hover': {
                                            borderBottom: '2px solid transparent !important'
                                        }
                                    } }, { children: name }), void 0) }), name) }, void 0)) }, name));
                }) }), void 0)] }), void 0));
};

var aLinkStyles = {
    display: 'inline',
    alignItems: 'center',
    fontSize: 'inc20',
    fontFamily: 'euclid-circular-a',
    fontWeight: 300,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    textDecoration: 'none',
    color: '#fff',
    '&:hover': {
        color: 'text.selected'
    }
};
var DropDownMenuList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  white-space: nowrap;\n  @media only screen and (min-width: ", ") {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    a:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n\n  li {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    position: relative;\n    a:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  list-style-type: none;\n  padding: 0;\n  white-space: nowrap;\n  @media only screen and (min-width: ", ") {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    a:not(:last-child) {\n      margin-bottom: ", ";\n    }\n  }\n\n  li {\n    padding-top: ", ";\n    padding-bottom: ", ";\n    position: relative;\n    a:hover {\n      color: ", ";\n    }\n  }\n"])), defaultTheme.sizes.breakpoint.large, defaultTheme.space.inc40, defaultTheme.space.inc30, defaultTheme.space.inc30, defaultTheme.colors.green40);
var SubLinks = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 32px 0 16px;\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin-top: ", ";\n\n    > li {\n      position: relative;\n\n      &:last-child {\n        display: none;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    display: grid;\n    grid-column-gap: ", ";\n    grid-template-columns: repeat(3, 1fr);\n  }\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 32px 0 16px;\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin-top: ", ";\n\n    > li {\n      position: relative;\n\n      &:last-child {\n        display: none;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    display: grid;\n    grid-column-gap: ", ";\n    grid-template-columns: repeat(3, 1fr);\n  }\n"])), defaultTheme.space.inc30, defaultTheme.sizes.breakpoint.large, defaultTheme.space.inc50);
var SubNavLink = function (_a) {
    var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems, path = _a.path, all = _a.all;
    return (jsxs("li", { children: [slug ? (jsx("a", __assign({ href: slug, className: 'dropdown-titles', sx: aLinkStyles }, { children: name }), name)) : (jsx(TypographyScale, __assign({ inverse: true, variant: 'body1' }, { children: name }), void 0)),
            dropDownItems && (jsxs(Fragment, { children: [jsx(SubLinks, { children: dropDownItems === null || dropDownItems === void 0 ? void 0 : dropDownItems.map(function (_a) {
                            var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems, l1Product = _a.l1Product;
                            return (jsxs("li", { children: [jsx("a", __assign({ href: slug, sx: aLinkStyles }, { children: l1Product ? jsx("strong", { children: name }, void 0) : name }), name),
                                    dropDownItems && (jsx("ul", { children: dropDownItems === null || dropDownItems === void 0 ? void 0 : dropDownItems.map(function (_a) {
                                            var name = _a.name, slug = _a.slug;
                                            return (jsx("li", { children: jsx("a", __assign({ href: slug, sx: aLinkStyles }, { children: name }), name) }, name));
                                        }) }, void 0))] }, name));
                        }) }, void 0),
                    all && (jsx(Link, __assign({ href: path, inverse: true, linkIcon: 'chevron', linkIconDisableExpand: true }, { children: all }), void 0))] }, void 0)),
            name.includes('Expertise Levels') && (jsx(Button, __assign({ href: 'topics', sx: {
                    marginTop: '25px',
                    '&:hover': {
                        color: 'initial!important'
                    }
                }, variant: 'primary' }, { children: "All Topics" }), void 0))] }, name));
};
var StylesDropDownWrapper = {
    '.dropdown-titles': {
        display: 'inline-block',
        fontSize: 'inc40',
        marginBottom: 'inc40'
    },
    boxShadow: [null, null, null, defaultTheme.shadows.level01],
    borderBottomRightRadius: [null, null, null, defaultTheme.radii.inc50],
    borderBottomLeftRadius: [null, null, null, defaultTheme.radii.inc50],
    backgroundColor: ['#fff', '#fff', '#fff', defaultTheme.colors.blue80],
    color: ['#000', '#000', '#000', defaultTheme.colors.text.inverse],
    left: [null, null, null, 0],
    marginTop: [null, null, null, defaultTheme.space.elementXSmall],
    position: ['initial', 'initial', 'initial', 'absolute'],
    paddingTop: [null, null, null, defaultTheme.space.inc70],
    paddingBottom: [null, null, null, defaultTheme.space.inc70],
    paddingRight: [null, null, null, defaultTheme.space.inc90],
    paddingLeft: ['inc50', 'inc50', 'inc50', defaultTheme.space.inc90],
    zIndex: [null, null, null, 2]
};
var DropDownMenu = function (_a) {
    var items = _a.items;
    return (jsx("div", __assign({ sx: StylesDropDownWrapper }, { children: jsx(DropDownMenuList, { children: items.map(function (_a) {
                var name = _a.name, slug = _a.slug, all = _a.all, path = _a.path, dropDownItems = _a.dropDownItems;
                return (jsx(React.Fragment, { children: jsx(SubNavLink, { name: name, slug: slug, all: all, path: path, dropDownItems: dropDownItems }, void 0) }, name + "-" + slug));
            }) }, void 0) }), void 0));
};
var templateObject_1, templateObject_2;

var StyledSecondaryNavContainer = {
    display: 'block',
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingX: 'inc70',
    paddingTop: 'elementXSmall',
    paddingBottom: 'elementXSmall',
    position: 'relative',
    maxWidth: defaultTheme.sizes.maxWidthDesktop
};
var linkWrapperStyles = {
    position: 'relative',
    padding: 0
};
var StyledSecondaryLinks = {
    padding: 0,
    margin: 0,
    overflow: 'visible',
    'li:not(:last-child)': {
        marginRight: defaultTheme.space.inc40
    }
};
var MainLinkStyles = function (isActive) { return ({
    float: 'left',
    marginRight: 'inc90',
    fontSize: 'inc30',
    fontWeight: 500,
    borderBottom: "" + (isActive ? "2px solid " + defaultTheme.colors.green40 : 'none')
}); };
var LinkStyles = function () { return ({
    display: 'inline-block'
}); };

var DesktopView = function (_a) {
    var activePath = _a.activePath, navLinks = _a.navLinks, title = _a.title;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var showMenu = function () {
        setIsOpen(!isOpen);
    };
    return (jsx("div", __assign({ sx: {
            display: ['none', null, null, 'block'],
            borderBottom: "1px solid " + defaultTheme.colors.black30
        } }, { children: jsxs("nav", __assign({ sx: StyledSecondaryNavContainer }, { children: [jsx("div", __assign({ sx: linkWrapperStyles }, { children: jsx(Link, __assign({ href: '/careers', sx: MainLinkStyles(activePath === '/'), customLinkContentStyles: {
                            fontSize: ['16px', null, null, null, '20px'],
                            color: defaultTheme.colors.text.default,
                            borderBottom: "2px solid transparent",
                            ':hover': {
                                borderBottom: "2px solid " + defaultTheme.colors.green40
                            }
                        } }, { children: title }), void 0) }), void 0),
                jsx("ul", __assign({ sx: StyledSecondaryLinks }, { children: navLinks.map(function (_a) {
                        var name = _a.name, slug = _a.slug, dropDownItems = _a.dropDownItems, target = _a.target;
                        return (jsx(SecondaryLinksList, { children: (dropDownItems === null || dropDownItems === void 0 ? void 0 : dropDownItems.length) ? (jsxs(Fragment, { children: [jsx("div", __assign({ sx: linkWrapperStyles }, { children: jsxs(Link, __assign({ sx: LinkStyles(), onClick: showMenu, target: target, customLinkContentStyles: {
                                                borderBottom: "" + (activePath === slug
                                                    ? "2px solid " + defaultTheme.colors.green40
                                                    : '2px solid transparent'),
                                                color: defaultTheme.colors.text.default,
                                                fontSize: [
                                                    null,
                                                    null,
                                                    defaultTheme.fontSizes.inc20,
                                                    defaultTheme.fontSizes.inc10,
                                                    defaultTheme.fontSizes.inc20
                                                ],
                                                fontFamily: defaultTheme.fonts.body,
                                                fontWeight: '300',
                                                '&:hover': {
                                                    borderBottom: "2px solid " + defaultTheme.colors.green40
                                                }
                                            } }, { children: [name, jsx(SystemIcon, { sx: {
                                                        paddingLeft: 'inc20',
                                                        display: 'inline'
                                                    }, name: isOpen
                                                        ? ESystemIconNames.CHEVRON_UP
                                                        : ESystemIconNames.CHEVRON_DOWN, size: 'small', strokeWeight: 'large' }, void 0)] }), void 0) }), void 0),
                                    isOpen && jsx(DropDownMenu, { items: dropDownItems }, void 0)] }, void 0)) : (jsx(Fragment, { children: jsx("div", __assign({ sx: linkWrapperStyles }, { children: jsx(Link, __assign({ className: 'top-level-link', href: slug, sx: LinkStyles(), target: target, customLinkContentStyles: {
                                            borderBottom: "" + (activePath === slug
                                                ? "2px solid " + defaultTheme.colors.green40
                                                : '2px solid transparent'),
                                            color: defaultTheme.colors.text.default,
                                            fontSize: [
                                                null,
                                                null,
                                                defaultTheme.fontSizes.inc20,
                                                defaultTheme.fontSizes.inc10,
                                                defaultTheme.fontSizes.inc20
                                            ],
                                            fontFamily: defaultTheme.fonts.body,
                                            fontWeight: '300',
                                            '&:hover': {
                                                borderBottom: "2px solid " + defaultTheme.colors.green40
                                            }
                                        } }, { children: name }), void 0) }), void 0) }, void 0)) }, name));
                    }) }), void 0)] }), void 0) }), void 0));
};

var secondaryNavData$1 = [
    {
        name: 'Topics',
        slug: '',
        dropDownItems: [
            {
                name: 'Languages',
                slug: '',
                all: 'All Languages',
                path: '#',
                dropDownItems: [
                    { name: 'Javascript', slug: '#' },
                    { name: 'C#', slug: '#' },
                    { name: 'Python', slug: '#' },
                    { name: 'Kotlin', slug: '#' },
                    { name: 'Java', slug: '#' },
                    { name: 'PHP', slug: '#' }
                ]
            },
            {
                name: 'Technologies',
                slug: '',
                all: 'All Technologies',
                path: '#',
                dropDownItems: [
                    { name: 'Docker', slug: '#' },
                    { name: 'Azure', slug: '#' },
                    { name: 'AWS', slug: '#' },
                    { name: 'Kubernetes', slug: '#' },
                    { name: 'Nesxtjs', slug: '#' },
                    { name: 'Nodejs', slug: '#' },
                    { name: 'Unity', slug: '#' }
                ]
            },
            {
                name: 'Products',
                slug: '',
                all: 'All Products',
                path: '#',
                dropDownItems: [
                    { name: 'Atlas', slug: '#' },
                    { name: 'Atlas Search', slug: '#' },
                    { name: 'Compass', slug: '#' },
                    { name: 'Aggregation', slug: '#' },
                    { name: 'MongoDB', slug: '#' },
                    { name: 'Encryption', slug: '#' },
                    { name: 'Realm', slug: '#' }
                ]
            },
            {
                name: 'Expertise Levels',
                slug: '',
                all: '',
                path: '/#',
                dropDownItems: [
                    { name: 'Introductory', slug: '#' },
                    { name: 'Expert', slug: '#' }
                ]
            }
        ]
    },
    { name: 'Documentation', slug: 'https://www.mongodb.com/docs/' },
    { name: 'Articles', slug: '/articles' },
    { name: 'Tutorials', slug: '/tutorials' },
    { name: 'Quickstarts', slug: '/quickstarts' },
    { name: 'Code Examples', slug: '/code-examples' },
    {
        name: 'Podcasts',
        slug: 'https://podcasts.mongodb.com/public/115/The-MongoDB-Podcast-b02cf624'
    },
    { name: 'Videos', slug: '/videos' }
];

var secondaryNavData = [
    { name: 'Teams', slug: '/careers/teams', target: '_self' },
    {
        name: 'Students & Graduates',
        slug: '/careers/departments/campus',
        target: '_self'
    },
    {
        name: 'Diversity & Inclusion',
        slug: '/careers/inclusion',
        target: '_self'
    },
    { name: 'Culture Blog', slug: '/blog/channel/culture', target: '_blank' }
];

var ETemplateTypes;
(function (ETemplateTypes) {
    ETemplateTypes["CAREERS"] = "Careers";
    ETemplateTypes["DEVELOPER_CENTER"] = "DeveloperCenter";
})(ETemplateTypes || (ETemplateTypes = {}));

var getNavLinks = function (template) {
    switch (template) {
        case ETemplateTypes.CAREERS:
            return secondaryNavData;
        case ETemplateTypes.DEVELOPER_CENTER:
            return secondaryNavData$1;
        default:
            return secondaryNavData;
    }
};
var SecondaryNav = function (_a) {
    var _b = _a.linkTemplate, linkTemplate = _b === void 0 ? ETemplateTypes.CAREERS : _b, _c = _a.navLinks, navLinks = _c === void 0 ? getNavLinks(linkTemplate) : _c, _d = _a.title, title = _d === void 0 ? 'MongoDB Careers' : _d;
    var _e = useState(), activePath = _e[0], setActivePath = _e[1];
    useEffect(function () {
        setActivePath(window.location.pathname);
    }, []);
    return (jsxs("div", __assign({ style: {
            position: 'sticky',
            top: '0',
            backgroundColor: '#fff',
            zIndex: 11,
            overflowX: 'clip',
            overflowY: 'visible'
        } }, { children: [jsx(MobileView, __assign({}, { navLinks: navLinks, title: title }), void 0),
            jsx(DesktopView, __assign({}, { activePath: activePath, navLinks: navLinks, title: title }), void 0)] }), void 0));
};

var getStyles$1 = function (formCustomStyles) { return ({
    form: __assign({ display: 'flex', width: '100%', 
        //need to add token for maxWidth
        maxWidth: '456px', flexDirection: 'column', gap: ['inc40', null, null, '40px'] }, formCustomStyles)
}); };

var getFormFields = function (formData) {
    return Object.keys(formData).map(function (name) { return formData[name]; });
};
var getFormRecord = function (formData, key) {
    return getFormFields(formData).reduce(function (prev, cur) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[cur.name] = cur[key], _a)));
    }, {});
};
var getFormValues = function (formData) {
    return getFormRecord(formData, 'value');
};
var updateFieldValues = function (name, newFieldValues) {
    return function (formData) {
        var _a;
        return __assign(__assign({}, formData), (_a = {}, _a[name] = __assign(__assign({}, formData[name]), newFieldValues), _a));
    };
};
var updateAllFields = function (formData) {
    return function (callback) {
        var keys = Object.keys(formData);
        return keys.reduce(function (prev, key) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = __assign(__assign({}, formData[key]), callback(formData[key])), _a)));
        }, {});
    };
};

var validate = function (value, validators) {
    if (validators && validators.length) {
        var validateErrors = validators.map(function (validator) { return validator(value); });
        return validateErrors.filter(Boolean);
    }
};
var appendAsteriskIfRequired = function (label, validators) {
    var isRequired = validators === null || validators === void 0 ? void 0 : validators.find(function (validator) {
        var _a;
        return (_a = validator.rule) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('required');
    });
    return isRequired && typeof label === 'string' ? label + "*" : label;
};

var FormContextActions = {
    setSubmitFlag: function (shouldSubmit) { return function (state) { return (__assign(__assign({}, state), { shouldSubmit: shouldSubmit })); }; },
    setChangeFlag: function (shouldChange) { return function (state) { return (__assign(__assign({}, state), { shouldChange: shouldChange })); }; },
    validateAllFields: function () { return function (state) { return (__assign(__assign({}, state), { formData: updateAllFields(state.formData)(function (_a) {
            var value = _a.value, validators = _a.validators, name = _a.name;
            return ({
                name: name,
                errors: validate(value || '', validators),
                isValidated: true
            });
        }), shouldSubmit: true })); }; },
    fieldRegister: function (name, field) { return function (state) { return (__assign(__assign({}, state), { formData: updateFieldValues(name, __assign(__assign({}, field), { errors: [], isValidated: false }))(state.formData) })); }; },
    fieldHandleChange: function (name, value) { return function (state) { return (__assign(__assign({}, state), { shouldChange: true, formData: updateFieldValues(name, {
            value: value,
            isValidated: false
        })(state.formData) })); }; },
    fieldHandleValidate: function (name, errors) { return function (state) { return (__assign(__assign({}, state), { formData: updateFieldValues(name, {
            errors: errors,
            isValidated: true
        })(state.formData) })); }; }
};

var FormStateContext = React.createContext({});
var FormUpdaterContext = React.createContext({});
var useFormState = function () {
    return React.useContext(FormStateContext);
};
var useFormUpdater = function () {
    return React.useContext(FormUpdaterContext);
};
var useFormActions = function () {
    var setFormState = useFormUpdater();
    return React.useMemo(function () { return ({
        submit: function () { return setFormState(FormContextActions.setSubmitFlag(true)); }
    }); }, [setFormState]);
};
var useFormFieldActions = function (name) {
    var setFormState = useFormUpdater();
    return React.useMemo(function () { return ({
        change: function (value) {
            return setFormState(FormContextActions.fieldHandleChange(name, value));
        },
        validate: function (errors) {
            return setFormState(FormContextActions.fieldHandleValidate(name, errors));
        },
        register: function (field) {
            return setFormState(FormContextActions.fieldRegister(name, field));
        }
    }); }, [setFormState]);
};

var INITIAL_STATE = {
    inverse: false,
    shouldChange: false,
    shouldSubmit: false,
    formData: {}
};
var FormProvider = function (_a) {
    var onChange = _a.onChange, onSubmit = _a.onSubmit, onValidate = _a.onValidate, children = _a.children, initialState = _a.initialState;
    var _b = React.useState(__assign(__assign({}, INITIAL_STATE), initialState)), formState = _b[0], setFormState = _b[1];
    var shouldSubmit = formState.shouldSubmit, shouldChange = formState.shouldChange, formData = formState.formData;
    var isInvalid = React.useMemo(function () { return getFormFields(formData).some(function (_a) {
        var errors = _a.errors;
        return errors === null || errors === void 0 ? void 0 : errors.length;
    }); }, [formData]);
    var isValidated = React.useMemo(function () { return getFormFields(formData).every(function (_a) {
        var isValidated = _a.isValidated;
        return isValidated;
    }); }, [formData]);
    React.useEffect(function () {
        if (shouldSubmit) {
            setFormState(FormContextActions.setSubmitFlag(false));
            if (!isInvalid && isValidated) {
                onSubmit(getFormValues(formData));
            }
            else if (!isValidated) {
                setFormState(FormContextActions.validateAllFields());
            }
            else if (isValidated) {
                onValidate && onValidate(getFormFields(formData));
            }
        }
    }, [shouldSubmit, isInvalid, isValidated, onSubmit, formData]);
    React.useEffect(function () {
        if (shouldChange) {
            onChange(getFormValues(formData));
            setFormState(FormContextActions.setChangeFlag(false));
        }
    }, [shouldChange, onChange]);
    return (React.createElement(FormStateContext.Provider, { value: formState },
        React.createElement(FormUpdaterContext.Provider, { value: setFormState }, children)));
};

var ForwardFormWithContext = function (_a, ref) {
    var id = _a.id, name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, customStyles = _a.customStyles, children = _a.children, _c = _a.method, method = _c === void 0 ? 'post' : _c;
    var styles = getStyles$1(customStyles);
    var submit = useFormActions().submit;
    var handleFormSubmit = function (event) {
        event.preventDefault();
        event.stopPropagation();
        submit();
    };
    return (jsx("form", __assign({ ref: ref, id: id, name: name, method: method, onSubmit: handleFormSubmit, className: className, sx: styles.form }, { children: children }), void 0));
};
var FormWithContext = forwardRef(ForwardFormWithContext);
var ForwardFormGeneric = function (_a, ref) {
    var _b = _a.onSubmit, onSubmit = _b === void 0 ? function (_values) { return null; } : _b, _c = _a.onChange, onChange = _c === void 0 ? function (_values) { return null; } : _c, onValidate = _a.onValidate, inverse = _a.inverse, props = __rest(_a, ["onSubmit", "onChange", "onValidate", "inverse"]);
    return (jsx(FormProvider, __assign({ initialState: { inverse: inverse }, onSubmit: onSubmit, onChange: onChange, onValidate: onValidate }, { children: jsx(FormWithContext, __assign({ ref: ref }, props), void 0) }), void 0));
};
var FormGeneric = forwardRef(ForwardFormGeneric);

var CheckboxWrapper = function (_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var handleToggle = function (value) {
        var event = { target: { value: value } };
        onChange(event);
    };
    return jsx(Checkbox, __assign({}, props, { onToggle: handleToggle }), void 0);
};

var SelectWrapper = function (_a) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    var handleSelect = function (value) {
        var event = { target: { value: value } };
        onChange(event);
    };
    return jsx(Select, __assign({}, props, { onSelect: handleSelect }), void 0);
};

var NO_DELAY = undefined;
var DEFAULT_DELAY = 800;
var CHECKBOX_DELAY = 500;
var ComponentProps = {
    'text-input': {
        element: TextInput,
        delayTime: DEFAULT_DELAY
    },
    'text-area': {
        element: TextArea,
        delayTime: DEFAULT_DELAY
    },
    select: {
        element: SelectWrapper,
        delayTime: NO_DELAY
    },
    checkbox: {
        element: CheckboxWrapper,
        delayTime: CHECKBOX_DELAY
    }
};
var MemoizedField = function (_a) {
    var validators = _a.validators, _b = _a.component, component = _b === void 0 ? 'text-input' : _b, _c = _a.fieldData, fieldData = _c === void 0 ? {} : _c, hidden = _a.hidden, props = __rest(_a, ["validators", "component", "fieldData", "hidden"]);
    var validateTimeout = useRef();
    var errors = fieldData.errors;
    var _d = useMemo(function () { return ComponentProps[component]; }, [component]), element = _d.element, delayTime = _d.delayTime;
    var formFieldActions = useFormFieldActions(props.name);
    var handleChange = function (event) {
        var errors = validate(event.target.value, validators);
        handleValidate(errors, delayTime);
        formFieldActions.change(event.target.value);
        if (props.onChange) {
            props.onChange(event);
        }
    };
    var triggerValidate = function (errors) {
        formFieldActions.validate(errors);
        if (props.onValidate) {
            props.onValidate(errors);
        }
    };
    var handleValidate = function (errors, delay) {
        if (delay) {
            if (validateTimeout.current) {
                clearTimeout(validateTimeout.current);
            }
            validateTimeout.current = setTimeout(function () {
                triggerValidate(errors);
            }, delay);
            return;
        }
        triggerValidate(errors);
    };
    useEffect(function () {
        formFieldActions.register({
            name: props.name,
            validators: validators
        });
    }, []);
    var renderComponent = function () {
        return React.createElement(element, __assign(__assign({}, props), { onChange: handleChange, inverse: props.inverse, invalid: Boolean(errors === null || errors === void 0 ? void 0 : errors.length), label: appendAsteriskIfRequired(props.label, validators), errors: fieldData.errors }));
    };
    var renderErrors = function () {
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return (jsx("div", __assign({ sx: { display: 'flex', flexDirection: 'column' } }, { children: errors.map(function (error) { return (jsx(HelperText, { color: component === 'checkbox' ? 'secondary' : 'default', inverse: props.inverse, text: error }, error)); }) }), void 0));
        }
        return null;
    };
    return (jsxs("div", __assign({ sx: { display: hidden ? 'none' : 'block' } }, { children: [renderComponent(), renderErrors()] }), void 0));
};
var Field = function (props) {
    var _a = useFormState(), inverse = _a.inverse, formData = _a.formData;
    var iconName = props.iconName;
    var fieldData = useMemo(function () { return formData[props.name] || {}; }, [formData[props.name]]);
    return useMemo(function () { return jsx(MemoizedField, __assign({}, props, { inverse: inverse, fieldData: fieldData }), void 0); }, [fieldData, inverse, iconName]);
};

var Article = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inverse, inverse = _c === void 0 ? false : _c, heading = _a.heading, subheading = _a.subheading, content = _a.content, verticalSpacingProps = _a.verticalSpacingProps;
    return (jsx(VerticalSectionSpacing, __assign({ top: 'large', bottom: 'large' }, verticalSpacingProps, { children: jsxs("article", __assign({ className: className, sx: {
                maxWidth: '816px',
                wordBreak: 'break-word'
            } }, { children: [heading && (jsx(TypographyScale, __assign({ variant: 'heading2', customStyles: {
                        fontFamily: 'body',
                        fontSize: ['inc50', null, null, 'inc80'],
                        lineHeight: ['inc30', null, null, 'inc50'],
                        marginBottom: ['inc40', null, 'inc50', 'inc60']
                    }, inverse: inverse }, { children: heading }), void 0)),
                subheading && (jsx(TypographyScale, __assign({ variant: 'heading3', customStyles: {
                        fontFamily: 'body',
                        fontSize: ['inc30', null, null, 'inc50'],
                        lineHeight: ['inc20', null, null, 'inc30'],
                        marginBottom: ['inc40', null, 'inc50', 'inc60']
                    }, inverse: inverse }, { children: subheading }), void 0)),
                content && (jsx(TypographyScale, __assign({ variant: 'body1', customStyles: {
                        color: inverse ? 'black00' : 'green80',
                        marginBottom: ['inc70', 'inc80', null]
                    } }, { children: content }), void 0))] }), void 0) }), void 0));
};

var EAsideVariant;
(function (EAsideVariant) {
    EAsideVariant["ERROR"] = "error";
    EAsideVariant["TIP"] = "tip";
    EAsideVariant["DEEP_DIVE"] = "deep dive";
    EAsideVariant["NEXT_STEPS"] = "next steps";
})(EAsideVariant || (EAsideVariant = {}));

var getBackgroundColor$1 = function (variant) {
    switch (variant) {
        case EAsideVariant.ERROR:
            return 'red10';
        case EAsideVariant.TIP:
            return 'purple10';
        case EAsideVariant.DEEP_DIVE:
            return 'blue10';
        case EAsideVariant.NEXT_STEPS:
            return 'black15';
    }
};
var getTextColor = function (variant) {
    switch (variant) {
        case EAsideVariant.ERROR:
            return 'red80';
        case EAsideVariant.TIP:
            return 'purple80';
        case EAsideVariant.DEEP_DIVE:
            return 'blue70';
        case EAsideVariant.NEXT_STEPS:
            return 'blue80';
    }
};
var getAccentColor = function (variant) {
    switch (variant) {
        case EAsideVariant.ERROR:
            return 'red30';
        case EAsideVariant.TIP:
            return 'purple60';
        case EAsideVariant.DEEP_DIVE:
            return 'blue60';
        case EAsideVariant.NEXT_STEPS:
            return 'blue80';
    }
};
var getIconName = function (variant) {
    switch (variant) {
        case EAsideVariant.ERROR:
            return ESystemIconNames.CIRCLE_ALERT;
        case EAsideVariant.TIP:
            return ESystemIconNames.LIGHT_BULB;
        case EAsideVariant.DEEP_DIVE:
            return ESystemIconNames.ACADEMIC_CAP;
        case EAsideVariant.NEXT_STEPS:
            return ESystemIconNames.MEGAPHONE;
    }
};

var Aside = function (_a) {
    var variant = _a.variant, _b = _a.text, text = _b === void 0 ? '' : _b, customStyles = _a.customStyles;
    var header = variant[0].toUpperCase() + variant.substring(1);
    return (jsxs("div", __assign({ className: 'aside-container', sx: __assign({ borderRadius: '2px 16px 16px 2px', backgroundColor: 'background.body', filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))', borderLeftColor: getAccentColor(variant), borderLeftWidth: '3px', borderLeftStyle: 'solid', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }, customStyles) }, { children: [jsx("div", __assign({ sx: {
                    position: 'absolute',
                    top: '-16px',
                    left: '-16px',
                    width: '32px',
                    height: '32px',
                    background: 'black00',
                    borderRadius: 'circle',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                } }, { children: jsx(SystemIcon, { name: getIconName(variant), color: variant === EAsideVariant.ERROR ? 'error' : undefined, size: 'medium' }, void 0) }), void 0),
            jsx("div", __assign({ sx: {
                    backgroundColor: getBackgroundColor$1(variant),
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 24px',
                    borderRadius: '2px 16px 0px 0px'
                } }, { children: jsx(TypographyScale, __assign({ variant: 'body1', customStyles: {
                        color: getTextColor(variant)
                    } }, { children: header }), void 0) }), void 0),
            jsx("div", __assign({ sx: {
                    padding: '16px 24px',
                    display: 'flex',
                    alignItems: 'center'
                } }, { children: jsx(TypographyScale, __assign({ variant: 'body2' }, { children: text }), void 0) }), void 0)] }), void 0));
};

var defaultIconConfig = {
    name: 'mdb_backup',
    size: 'medium',
    alt: 'MDB Backup'
};
var defaultImageConfig$2 = {
    src: 'https://webimages.mongodb.com/_com_assets/cms/kpn3bw5aefoqlwbcy-04textsearch.png?auto=format%252Ccompress',
    variant: ESingleImageVariant.LETTERBOX
};
var cardWidthBreakpoints$1 = {
    large: 540,
    medium: 434,
    small: 328
};

var getCardPadding = function (width, theme, background) {
    if (background === void 0) { background = true; }
    var large = cardWidthBreakpoints$1.large, small = cardWidthBreakpoints$1.small;
    if (width >= large)
        return background ? theme.space.cards.paddingXL : "0";
    if (width >= small && width < large)
        return background
            ? theme.space.cards.paddingS + " " + theme.space.cards.paddingM
            : "0";
    if (width < small)
        return background
            ? theme.space.cards.paddingS + " " + theme.space.cards.paddingXXS
            : "0";
};
var getBackgroundStyles$1 = function (background, inverse) {
    if (background) {
        return inverse ? 'card.inverse.bg' : 'card.default.bg';
    }
    return 'transparent';
};
var getBorderStyles$1 = function (background, inverse) {
    return {
        borderStyle: 'solid',
        borderWidth: background ? '1px' : '0',
        borderColor: inverse ? 'card.inverse.border' : 'card.default.border',
        borderRadius: ['cardResponsive', 'cardResponsive', 'cardResponsive', 'card']
    };
};
var getTypographyVariant = function (size, type, largeTitle) {
    var isHeading = type === 'heading';
    var TypographyVariant = {
        small: 'body3',
        large: 'body1'
    };
    // To meet SEO requirements, small and large headings will both be <h3>'s with appropriate styles
    var variant = isHeading || largeTitle
        ? 'heading3'
        : TypographyVariant[size];
    return variant;
};
var getImageryElement = function (props, inverse) {
    var _a = props.imageryType, imageryType = _a === void 0 ? 'icon' : _a, _b = props.iconConfig, iconConfig = _b === void 0 ? defaultIconConfig : _b, _c = props.imageConfig, imageConfig = _c === void 0 ? defaultImageConfig$2 : _c;
    var imgStyles = {
        width: '100%'
    };
    var ImageryElement = {
        icon: (jsx(BrandedIcon, { name: iconConfig.name || defaultIconConfig.name, size: iconConfig.size || 'medium', alt: iconConfig.alt, inverse: inverse }, void 0)),
        image: (jsx("div", __assign({ sx: imgStyles }, { children: jsx(SingleImage, { lazyLoad: imageConfig.lazyLoad, src: imageConfig.src || defaultImageConfig$2.src, altText: imageConfig.altText, variant: imageConfig.variant || defaultImageConfig$2.variant }, void 0) }), void 0))
    };
    return ImageryElement[imageryType];
};
var getCardHeaderWidthVariantStyles = function (width, theme, pillText, horizontalCard) {
    var medium = cardWidthBreakpoints$1.medium;
    var largeCard = width >= medium;
    var hasMarginBottom = largeCard || !pillText;
    return {
        cardHeaderStyles: {
            marginBottom: hasMarginBottom && !horizontalCard ? 'inc40' : 0
        },
        pillStyles: { margin: theme.space.inc30 + " 0" }
    };
};

var CardContent = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, _d = _a.alignment, alignment = _d === void 0 ? 'center' : _d, text = _a.text, _e = _a.typographySize, typographySize = _e === void 0 ? 'small' : _e, _f = _a.listItems, listItems = _f === void 0 ? [] : _f, _g = _a.listGlyph, listGlyph = _g === void 0 ? 'circle' : _g, customContentStyles = _a.customContentStyles;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var hasItems = listItems.length !== 0;
    return (jsxs(Fragment, { children: [jsx(TypographyScale, __assign({ "aria-label": 'text-content', customElement: 'p', customStyles: __assign({ marginBottom: hasItems ? 0 : selectedTheme.space.inc40, textAlign: alignment }, customContentStyles), color: 'secondary', variant: getTypographyVariant(typographySize, 'body', false), inverse: inverse }, { children: text }), void 0),
            hasItems && (jsx(List, { textSize: typographySize, items: listItems, glyph: listGlyph, inverse: inverse }, void 0))] }, void 0));
};

var CardFooter = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.cta, cta = _c === void 0 ? {} : _c, _d = _a.disableAnchor, disableAnchor = _d === void 0 ? false : _d;
    var _e = cta.type, type = _e === void 0 ? 'link-arrow' : _e, text = cta.text, _f = cta.config, config = _f === void 0 ? {} : _f, _g = cta.disableExpand, disableExpand = _g === void 0 ? false : _g;
    var arrowOnly = type === 'arrow';
    var showCTA = text || arrowOnly;
    var CTAElement = {
        button: (jsx(Button, __assign({ inverse: inverse, variant: config.variant || 'primary', href: config.href, target: config.target, onClick: config.onClick, customWrapperStyles: __assign(__assign({}, getMobileButtonStyle()), { order: '3' }), disableAnchor: disableAnchor }, { children: text }), void 0)),
        'link-arrow': (jsx(Link, __assign({ variant: ELinkVariant.SMALL, linkIcon: 'arrow', inverse: inverse, href: config.href, target: config.target, onClick: config.onClick, linkIconDisableExpand: disableExpand, customStyles: { order: '3' }, disableAnchor: disableAnchor }, { children: text }), void 0)),
        'link-chevron': (jsx(Link, __assign({ variant: ELinkVariant.SMALL, linkIcon: 'chevron', inverse: inverse, href: config.href, target: config.target, onClick: config.onClick, linkIconDisableExpand: disableExpand, customStyles: { order: '3' }, disableAnchor: disableAnchor }, { children: text }), void 0)),
        arrow: (jsx(Link, { variant: ELinkVariant.SMALL, linkIcon: 'arrow', arrowOnly: true, inverse: inverse, href: config.href, target: config.target, onClick: config.onClick, customStyles: { order: '3' }, disableAnchor: disableAnchor }, void 0))
    };
    return (showCTA && CTAElement[type]) || null;
};

var CardHeader = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, pillText = _a.pillText, _d = _a.pillVariant, pillVariant = _d === void 0 ? 'identifier' : _d, _e = _a.imageryType, imageryType = _e === void 0 ? 'none' : _e, horizontalCard = _a.horizontalCard, iconConfig = _a.iconConfig, imageConfig = _a.imageConfig, _f = _a.cardWidth, cardWidth = _f === void 0 ? 0 : _f, customStyles = _a.customStyles;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var hasImagery = !!imageryType && imageryType !== 'none';
    var imageryProps = {
        imageryType: imageryType,
        iconConfig: iconConfig,
        imageConfig: imageConfig
    };
    var ImageryElement = getImageryElement(imageryProps, inverse);
    var _g = getCardHeaderWidthVariantStyles(cardWidth, selectedTheme, pillText, horizontalCard), cardHeaderStyles = _g.cardHeaderStyles, pillStyles = _g.pillStyles;
    return (jsxs("div", __assign({ "aria-label": 'card-header', sx: __assign(__assign({ order: horizontalCard ? 2 : 0, width: horizontalCard ? '50%' : '100%', height: horizontalCard ? '100%' : null, display: 'inherit', flexDirection: 'inherit', flexWrap: 'inherit', alignItems: 'inherit' }, cardHeaderStyles), customStyles) }, { children: [hasImagery && ImageryElement, pillText && !horizontalCard && (jsx(Pill, { sx: __assign({}, pillStyles), variant: pillVariant, text: pillText, inverse: inverse }, void 0))] }), void 0));
};

var CardTitles = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, _d = _a.alignment, alignment = _d === void 0 ? 'center' : _d, _e = _a.typographySize, typographySize = _e === void 0 ? 'small' : _e, _f = _a.largeTitle, largeTitle = _f === void 0 ? false : _f, titleMinHeight = _a.titleMinHeight, title = _a.title, useTitleRef = _a.useTitleRef, subtitle = _a.subtitle, caption = _a.caption, customVariant = _a.customVariant, customTitleStyles = _a.customTitleStyles, flashCard = _a.flashCard;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var titleRef = useRef(null);
    var hasCaption = caption && caption !== '';
    var hasSubtitle = subtitle && subtitle !== '';
    var defaultVariant = getTypographyVariant(typographySize, 'heading', largeTitle);
    var displayedVariant = customVariant ? customVariant : defaultVariant;
    useEffect(function () {
        useTitleRef && useTitleRef(titleRef);
    });
    return (jsxs(Fragment, { children: [hasCaption && (jsx(TypographyScale, __assign({ customStyles: {
                    marginBottom: selectedTheme.space.inc40,
                    textAlign: alignment,
                    color: inverse ? 'card.inverse.textSub' : 'card.default.textSub',
                    letterSpacing: '3px',
                    fontWeight: 600,
                    opacity: 0.8
                }, variant: 'mono3', inverse: inverse }, { children: caption }), void 0)),
            jsx("div", __assign({ ref: titleRef, sx: __assign({ height: 'fit-content', marginBottom: selectedTheme.space.inc40 }, customTitleStyles) }, { children: jsx(TypographyScale, __assign({ flashCard: flashCard, largeTitle: largeTitle, customStyles: {
                        minHeight: [null, null, null, titleMinHeight],
                        textAlign: alignment,
                        fontWeight: '500'
                    }, variant: displayedVariant, inverse: inverse }, { children: title }), void 0) }), void 0),
            hasSubtitle && (jsx(TypographyScale, __assign({ customStyles: {
                    marginBottom: selectedTheme.space.inc40,
                    textAlign: alignment,
                    fontWeight: '500',
                    color: inverse ? 'card.inverse.textSub' : 'card.default.textSub'
                }, variant: 'body4', inverse: inverse }, { children: subtitle }), void 0))] }, void 0));
};

var FlashCard = function (_a) {
    var _b, _c, _d;
    var _e = _a.className, className = _e === void 0 ? '' : _e, customWrapperStyles = _a.customWrapperStyles, customContentWrapperStyles = _a.customContentWrapperStyles, customLinkStyles = _a.customLinkStyles, customHeaderStyles = _a.customHeaderStyles, customVariant = _a.customVariant, customTitleStyles = _a.customTitleStyles, customContentStyles = _a.customContentStyles, _f = _a.inverse, inverse = _f === void 0 ? false : _f, _g = _a.theme, theme = _g === void 0 ? 'default' : _g, _h = _a.background, background = _h === void 0 ? true : _h, _j = _a.divider, divider = _j === void 0 ? false : _j, pillText = _a.pillText, pillVariant = _a.pillVariant, _k = _a.alignment, alignment = _k === void 0 ? 'center' : _k, title = _a.title, _l = _a.typographySize, typographySize = _l === void 0 ? 'small' : _l, largeTitle = _a.largeTitle, horizontalLayout = _a.horizontalLayout, subtitle = _a.subtitle, caption = _a.caption, text = _a.text, _m = _a.listItems, listItems = _m === void 0 ? [] : _m, footerTags = _a.footerTags, _o = _a.listGlyph, listGlyph = _o === void 0 ? 'circle' : _o, _p = _a.imageryType, imageryType = _p === void 0 ? 'none' : _p, _q = _a.iconConfig, iconConfig = _q === void 0 ? defaultIconConfig : _q, _r = _a.imageConfig, imageConfig = _r === void 0 ? defaultImageConfig$2 : _r, titleMinHeight = _a.titleMinHeight, _s = _a.flashCard, flashCard = _s === void 0 ? false : _s, _t = _a.useTitleRef, useTitleRef = _t === void 0 ? function () { } : _t, _u = _a.cta, cta = _u === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _u, _v = _a.trackClick, trackClick = _v === void 0 ? true : _v, trackCategory = _a.trackCategory;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var centerAlign = alignment === 'center';
    var hasCTA = cta.type !== 'none';
    var isLink = hasCTA && cta.type !== 'button';
    var isClickable = isLink && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
    var hasContent = !!text || listItems.length !== 0;
    var hasTitles = !!title || !!subtitle || !!caption;
    var hasFooterTags = footerTags && (footerTags === null || footerTags === void 0 ? void 0 : footerTags.length) > 0;
    var ref = useRef(null);
    var width = useDimension(ref).width;
    var medium = cardWidthBreakpoints$1.medium;
    var largeCard = width >= medium;
    var horizontalCard = horizontalLayout && largeCard;
    var headerProps = {
        inverse: inverse,
        alignment: alignment,
        pillText: pillText,
        pillVariant: pillVariant,
        title: title,
        typographySize: typographySize,
        subtitle: subtitle,
        caption: caption,
        horizontalCard: horizontalCard,
        imageryType: imageryType,
        iconConfig: iconConfig,
        imageConfig: imageConfig,
        cardWidth: width,
        customStyles: customHeaderStyles
    };
    var titleProps = {
        titleMinHeight: titleMinHeight,
        inverse: inverse,
        theme: theme,
        alignment: alignment,
        typographySize: typographySize,
        largeTitle: largeTitle,
        title: title,
        subtitle: subtitle,
        caption: caption,
        useTitleRef: useTitleRef,
        customVariant: customVariant,
        customTitleStyles: customTitleStyles,
        flashCard: flashCard
    };
    var contentProps = {
        inverse: inverse,
        alignment: alignment,
        text: text,
        typographySize: typographySize,
        listItems: listItems,
        listGlyph: listGlyph,
        customContentStyles: customContentStyles
    };
    var footerProps = {
        inverse: inverse,
        cta: cta,
        disableAnchor: isClickable
    };
    var TagName = isClickable ? 'a' : 'div';
    return (jsxs("div", __assign({ ref: ref, sx: __assign({}, customWrapperStyles) }, { children: [jsxs(TagName, __assign({ href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined, target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined, "data-track": isClickable && trackClick ? trackClick.toString() : '', "data-track-category": isClickable && (trackCategory === '' ? undefined : trackCategory), className: className, sx: __assign(__assign({ color: 'inherit', textDecoration: 'none', '&:hover': {
                        textDecoration: 'none'
                    }, position: 'relative', display: 'flex', flexDirection: horizontalCard ? 'row' : 'column', flexWrap: horizontalCard ? 'nowrap' : 'wrap', minHeight: '100%', width: '100%', alignItems: horizontalCard
                        ? 'center'
                        : centerAlign
                            ? 'center'
                            : 'start', padding: getCardPadding(width, selectedTheme, background), boxShadow: background ? 'level01' : 'none', backgroundColor: getBackgroundStyles$1(background, inverse) }, getBorderStyles$1(background, inverse)), customLinkStyles) }, { children: [jsx(CardHeader, __assign({}, headerProps), void 0),
                    jsxs("div", __assign({ sx: __assign({ order: 1, height: '100%', width: horizontalCard ? '50%' : '100%', alignItems: centerAlign ? 'center' : 'start', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }, customContentWrapperStyles) }, { children: [jsxs("div", __assign({ sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: centerAlign ? 'center' : 'start',
                                    maxWidth: horizontalCard ? null : [null, null, null, null, '100%']
                                } }, { children: [hasTitles && jsx(CardTitles, __assign({}, titleProps), void 0),
                                    hasContent && jsx(CardContent, __assign({}, contentProps), void 0)] }), void 0),
                            (hasCTA || hasFooterTags) && (jsx("div", __assign({ sx: {
                                    order: '3',
                                    display: 'flex',
                                    alignContent: 'end',
                                    flexWrap: 'wrap',
                                    flexGrow: '1'
                                } }, { children: jsxs("div", __assign({ sx: { display: 'flex', flexDirection: 'column' } }, { children: [hasCTA && (jsx("span", { children: jsx(CardFooter, __assign({}, footerProps), void 0) }, void 0)),
                                        hasFooterTags && (jsx("div", __assign({ sx: {
                                                display: 'flex',
                                                marginTop: hasCTA ? selectedTheme.space.inc40 : 0,
                                                marginBottom: -selectedTheme.space.inc20,
                                                flexWrap: 'wrap',
                                                '& > *': {
                                                    marginBottom: selectedTheme.space.inc20,
                                                    marginRight: selectedTheme.space.inc20
                                                }
                                            } }, { children: footerTags === null || footerTags === void 0 ? void 0 : footerTags.map(function (tag) { return (createElement(Tag, __assign({}, tag.tagProps, { key: tag.label }), tag.label)); }) }), void 0))] }), void 0) }), void 0))] }), void 0)] }), void 0),
            divider && !background && (jsx(HorizontalRule, { spacing: 'none', inverse: inverse }, void 0))] }), void 0));
};

var Card = function (_a) {
    var className = _a.className, _b = _a.direction, direction = _b === void 0 ? 'row' : _b, customCardWrapperStyles = _a.customCardWrapperStyles, children = _a.children;
    return (jsx(Panel, __assign({ className: className, sx: __assign({ display: 'flex', flexDirection: direction, justifyContent: 'space-between', borderColor: 'card.default.border', bg: 'card.default.bg', boxShadow: 'level01' }, customCardWrapperStyles) }, { children: children }), void 0));
};

var defaultImageConfig$1 = {
    src: 'https://webimages.mongodb.com/_com_assets/cms/ktir2qw25e1dt5hyb-payment_terminal.png?auto=format%252Ccompress',
    variant: ESingleImageVariant.SQUARE,
    bleed: true
};

var getPadding$1 = function (width, theme) {
    var tokens = getSelectedToken(theme);
    var breakpoint = tokens.sizing.breakpoint;
    var spacing = tokens.spacing;
    var cards = spacing.cards;
    if (width >= breakpoint.small && width < breakpoint.medium) {
        return spacing.inc70 + "px " + cards.paddingS + "px";
    }
    return spacing.inc60 + "px " + cards.paddingXXS + "px";
};
var StackedCard = function (_a) {
    var className = _a.className, title = _a.title, subtitle = _a.subtitle, _b = _a.imageConfig, imageConfig = _b === void 0 ? defaultImageConfig$1 : _b, _c = _a.alignment, alignment = _c === void 0 ? 'center' : _c, width = _a.width, _d = _a.cta, cta = _d === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _d, _e = _a.theme, theme = _e === void 0 ? 'default' : _e, customCardWrapperStyles = _a.customCardWrapperStyles;
    var hasCTA = cta.type !== 'none';
    var padding = getPadding$1(width, theme);
    return (jsxs(Card, __assign({ className: className, direction: 'column', sx: __assign({ padding: padding, alignItems: 'center', textAlign: 'center' }, customCardWrapperStyles) }, { children: [jsx("div", __assign({ sx: { maxWidth: '292px', width: '100%' } }, { children: jsx(SingleImage, __assign({}, imageConfig), void 0) }), void 0),
            jsxs("div", __assign({ sx: {
                    textAlign: alignment
                } }, { children: [jsx(TypographyScale, __assign({ variant: 'heading5', customStyles: { marginTop: 'inc40', fontWeight: '500' } }, { children: title }), void 0),
                    jsx(TypographyScale, __assign({ variant: 'body3', color: 'secondary', sx: {
                            display: 'flex',
                            marginTop: 'inc40',
                            justifyContent: 'center'
                        } }, { children: subtitle }), void 0)] }), void 0),
            hasCTA && (jsx("div", __assign({ sx: { marginTop: 'inc40', width: '100%' } }, { children: jsx(CardFooter, { cta: cta }, void 0) }), void 0))] }), void 0));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getPadding = function (width, token) {
    var breakpoint = token.sizing.breakpoint;
    var spacing = token.spacing;
    var cards = token.spacing.cards;
    if (width >= breakpoint.medium && width < breakpoint.large) {
        return spacing.inc50 + "px " + cards.paddingXL + "px";
    }
    return spacing.inc130 + "px " + cards.paddingXXL + "px";
};
var DefaultCard = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, title = _a.title, subtitle = _a.subtitle, _c = _a.imageConfig, imageConfig = _c === void 0 ? defaultImageConfig$1 : _c, _d = _a.alignment, alignment = _d === void 0 ? 'center' : _d, width = _a.width, _e = _a.cta, cta = _e === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _e, _f = _a.theme, theme = _f === void 0 ? 'default' : _f, customCardWrapperStyles = _a.customCardWrapperStyles;
    var token = getSelectedToken(theme);
    var padding = getPadding(width, token);
    var imgSize = width < token.sizing.breakpoint.large ? 280 : 448;
    var bleedSize = (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.bleed) ? 64 : 0;
    var hasCTA = cta.type !== 'none';
    return (jsxs(Card, __assign({ sx: __assign({}, customCardWrapperStyles), className: className }, { children: [jsxs("div", __assign({ sx: {
                    padding: padding,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 'inc40',
                    flexGrow: 1,
                    alignItems: alignment === 'left' ? 'flex-start' : 'center',
                    textAlign: alignment
                } }, { children: [jsx(TypographyScale, __assign({ variant: 'heading5', customStyles: { fontWeight: '500' } }, { children: title }), void 0),
                    jsx(TypographyScale, __assign({ color: 'secondary', variant: 'body3' }, { children: subtitle }), void 0),
                    hasCTA && jsx(CardFooter, { cta: cta }, void 0)] }), void 0),
            jsx("div", __assign({ sx: {
                    maxHeight: imgSize + bleedSize + "px",
                    maxWidth: imgSize + "px",
                    width: '100%',
                    marginTop: -bleedSize + "px",
                    marginRight: 'inc80',
                    div: {
                        display: 'flex',
                        height: '100%',
                        borderBottomRightRadius: 'inc50'
                    }
                } }, { children: jsx(SingleImage, __assign({}, imageConfig), void 0) }), void 0)] }), void 0));
};

var getCardLayout = function (width) {
    return width < sizing$1.breakpoint.medium ? StackedCard : DefaultCard;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getSelectedToken = function (theme) {
    if (theme === void 0) { theme = 'default'; }
    return theme === 'legacy' ? legacyTokens : defaultTokens;
};
var FeaturedCard = function (props) {
    var _a, _b, _c;
    var cta = props.cta, _d = props.trackClick, trackClick = _d === void 0 ? true : _d, _e = props.trackCategory, trackCategory = _e === void 0 ? '' : _e;
    var hasCTA = (cta === null || cta === void 0 ? void 0 : cta.type) !== 'none';
    var isLink = hasCTA && (cta === null || cta === void 0 ? void 0 : cta.type) !== 'button';
    var isClickable = isLink && !['', '#'].includes(((_a = cta === null || cta === void 0 ? void 0 : cta.config) === null || _a === void 0 ? void 0 : _a.href) || '');
    var ref = useRef(null);
    var width = useDimension(ref).width;
    var CardLayout = getCardLayout(width);
    var TagName = isClickable ? 'a' : 'div';
    return (jsx("div", __assign({ sx: __assign({ width: '100%' }, props.customWrapperStyles), ref: ref }, { children: jsx(TagName, __assign({ href: isClickable ? (_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href : undefined, target: isClickable ? (_c = cta === null || cta === void 0 ? void 0 : cta.config) === null || _c === void 0 ? void 0 : _c.target : undefined, "data-track": isClickable && trackClick ? trackClick.toString() : '', "data-track-category": isClickable && (trackCategory === '' ? undefined : trackCategory), sx: {
                color: 'inherit',
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'none'
                },
                width: '100%',
                height: '100%'
            } }, { children: jsx(CardLayout, __assign({}, props, { width: width }), void 0) }), void 0) }), void 0));
};

var defaultImageConfig = {
    src: 'https://webimages.mongodb.com/_com_assets/cms/kufhp8s27alno4hjr-Cluster%20Chart.png?auto=format%252Ccompress',
    variant: ESingleImageVariant.NO_RATIO
};
var defaultListConfig = {
    items: [
        'Take the difficulty out of data.',
        'Fit any workload with a single, flexible API and architecture.',
        'Automate repetitive (but vital) tasks.'
    ]
};
var cardWidthBreakpoints = {
    large: 927,
    medium: 622,
    small: 462,
    xsmall: 320
};

var widthToCardSize = function (width) {
    var large = cardWidthBreakpoints.large, medium = cardWidthBreakpoints.medium, small = cardWidthBreakpoints.small, xsmall = cardWidthBreakpoints.xsmall;
    if (width >= large)
        return 'large';
    if (width >= medium)
        return 'medium';
    if (width >= small)
        return 'small';
    if (width >= xsmall)
        return 'xsmall';
    return 'xxsmall';
};
var getFlexWrap = function (width) {
    var cardWidth = widthToCardSize(width);
    return cardWidth === 'xsmall' || cardWidth === 'xxsmall' ? 'wrap' : 'nowrap';
};
var getContentWrapperMaxWidth = function (width, hasImage) {
    var commonMaxWidth = hasImage ? '50%' : '100%';
    var ContentWrapperMaxWidth = {
        large: commonMaxWidth,
        medium: commonMaxWidth,
        small: commonMaxWidth,
        xsmall: '100%',
        xxsmall: '100%'
    };
    var cardSize = widthToCardSize(width);
    return ContentWrapperMaxWidth[cardSize];
};
var getImageWrapperResponsiveStyles = function (width, imageWidth) {
    // the marginRight calc will handle how much of the image will be cut off based on card width
    var ImageWrapperStyles = {
        large: {
            maxWidth: '734px',
            marginRight: -(imageWidth / 3)
        },
        medium: {
            maxWidth: '600px',
            marginRight: -(imageWidth / 2)
        },
        small: {
            maxWidth: '600px',
            marginRight: -(imageWidth / 3) * 2
        },
        xsmall: {
            minWidth: '300%',
            marginRight: -(imageWidth / 4)
        },
        xxsmall: {
            minWidth: '300%',
            marginRight: -(imageWidth / 4)
        }
    };
    var cardSize = widthToCardSize(width);
    return ImageWrapperStyles[cardSize];
};
var getListWrapperResponsiveStyles = function (width) {
    var ListWrapperStyles = {
        large: {
            width: '50%',
            borderLeft: "1px solid " + defaultTheme.colors.black30,
            paddingLeft: 'inc90'
        },
        medium: {
            width: '50%',
            borderLeft: "1px solid " + defaultTheme.colors.black30,
            paddingLeft: 'inc50'
        },
        small: {
            width: '50%',
            paddingLeft: 'inc50',
            borderLeft: "1px solid " + defaultTheme.colors.black30
        },
        xsmall: { width: '100%', paddingLeft: undefined },
        xxsmall: { width: '100%', paddingLeft: undefined }
    };
    var cardSize = widthToCardSize(width);
    return ListWrapperStyles[cardSize];
};
var getBackgroundStyles = function (background, inverse) {
    if (background) {
        return inverse ? 'card.inverse.bg' : 'card.default.bg';
    }
    return 'transparent';
};
var getBorderStyles = function (background, inverse) {
    return {
        borderStyle: 'solid',
        borderWidth: background ? '1px' : '0',
        borderColor: inverse ? 'card.inverse.border' : 'card.default.border',
        borderRadius: 'card'
    };
};

var MainContent = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? false : _b, _c = _a.theme, theme = _c === void 0 ? 'default' : _c, title = _a.title, eyebrow = _a.eyebrow, description = _a.description, _d = _a.iconConfig, iconConfig = _d === void 0 ? {} : _d, _e = _a.hasImage, hasImage = _e === void 0 ? false : _e, _f = _a.cardWidth, cardWidth = _f === void 0 ? cardWidthBreakpoints.large : _f, _g = _a.cta, cta = _g === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _g;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var hasCTA = cta.type !== 'none';
    return (jsxs("div", __assign({ "aria-label": 'content-container', sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: ['inc100', null, null, 'inc110'],
            maxWidth: getContentWrapperMaxWidth(cardWidth, hasImage)
        } }, { children: [iconConfig.name && (jsx(BrandedIcon, { name: iconConfig.name, size: iconConfig.size || 'medium', inverse: inverse }, void 0)),
            jsxs("div", __assign({ sx: {
                    display: 'flex',
                    flexGrow: 1,
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 'colGapMedium'
                } }, { children: [jsxs("div", __assign({ sx: {
                            display: 'inherit',
                            flexDirection: 'inherit',
                            gap: 'colGapMedium'
                        } }, { children: [jsx(TypographyScale, __assign({ variant: 'mono3', sx: { textTransform: 'uppercase' }, inverse: inverse, customElement: 'h5' }, { children: jsx(Mark, __assign({ inverse: inverse }, { children: eyebrow }), void 0) }), void 0),
                            jsx(TypographyScale, __assign({ sx: { wordBreak: 'break-word' }, variant: 'heading5', inverse: inverse }, { children: title }), void 0),
                            jsx(TypographyScale, __assign({ sx: { wordBreak: 'break-word' }, variant: 'body1', color: 'secondary', inverse: inverse }, { children: description }), void 0)] }), void 0),
                    hasCTA && (jsx(CardFooter, { inverse: inverse, cta: cta, theme: selectedTheme, disableAnchor: true }, void 0))] }), void 0)] }), void 0));
};

var MasonryCard = function (_a) {
    var _b, _c, _d;
    var _e = _a.variant, variant = _e === void 0 ? 'default' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, customWrapperStyles = _a.customWrapperStyles, _g = _a.inverse, inverse = _g === void 0 ? false : _g; _a.theme; var _j = _a.background, background = _j === void 0 ? true : _j, title = _a.title, eyebrow = _a.eyebrow, description = _a.description, _k = _a.iconConfig, iconConfig = _k === void 0 ? { name: '' } : _k, _l = _a.imageConfig, imageConfig = _l === void 0 ? {} : _l, _m = _a.listConfig, listConfig = _m === void 0 ? {} : _m, _o = _a.cta, cta = _o === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _o;
    var hasImage = !!imageConfig.src;
    var hasCTA = cta.type !== 'none';
    var isLink = hasCTA && cta.type !== 'button';
    var isClickable = isLink && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
    var isListVariant = variant === 'list';
    var cardWrapperRef = useRef(null);
    var imageWrapperRef = useRef(null);
    var cardWidth = useDimension(cardWrapperRef).width;
    var imageWidth = useDimension(imageWrapperRef).width;
    var mainContentProps = {
        inverse: inverse,
        title: title,
        eyebrow: eyebrow,
        description: description,
        iconConfig: iconConfig,
        cta: cta,
        cardWidth: cardWidth,
        hasImage: hasImage
    };
    var TagName = isClickable ? 'a' : 'div';
    return (jsx("div", __assign({ ref: cardWrapperRef, sx: __assign({}, customWrapperStyles) }, { children: jsxs(TagName, __assign({ href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined, target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined, className: className, sx: __assign({ color: 'inherit', textDecoration: 'none', '&:hover': {
                    textDecoration: 'none'
                }, display: 'flex', justifyContent: 'space-between', width: '100%', height: '100%', overflow: 'hidden', gap: ['inc40', 'inc40', 'inc50', 'inc50'], alignContent: 'space-between', boxShadow: background ? 'level01' : 'none', padding: [
                    'cards.paddingXXS',
                    'cards.paddingXS',
                    'cards.paddingS',
                    'cards.paddingM',
                    'cards.paddingL'
                ], backgroundColor: getBackgroundStyles(background, inverse), flexWrap: getFlexWrap(cardWidth) }, getBorderStyles(background, inverse)) }, { children: [jsx(MainContent, __assign({}, mainContentProps), void 0),
                !isListVariant && imageConfig.src && (jsx("div", __assign({ "aria-label": 'image-container', sx: { width: '50%', display: 'flex' } }, { children: jsx("div", __assign({ ref: imageWrapperRef, sx: __assign({ display: 'flex', flexGrow: 1, flexDirection: 'column', justifyContent: 'center' }, getImageWrapperResponsiveStyles(cardWidth, imageWidth)) }, { children: jsx(SingleImage, { lazyLoad: imageConfig.lazyLoad, src: imageConfig.src, altText: imageConfig.altText, variant: imageConfig.variant || defaultImageConfig.variant }, void 0) }), void 0) }), void 0)),
                isListVariant && (jsx("div", __assign({ "data-testid": 'list-wrapper', sx: __assign({ display: 'flex', justifyContent: 'center', alignItems: 'center' }, getListWrapperResponsiveStyles(cardWidth)) }, { children: jsx(List, { inverse: inverse, items: listConfig.items || defaultListConfig.items }, void 0) }), void 0))] }), void 0) }), void 0));
};

var getBorderColor = function (inverse) {
    return inverse
        ? defaultTheme.colors.card.inverse.borderLighter
        : defaultTheme.colors.card.inverse.border;
};
var getBgColor = function (inverse) {
    return inverse ? defaultTheme.colors.card.inverse.bg : defaultTheme.colors.card.default.bg;
};
var getPaddingBottom = function (ctaType) {
    if (ctaType === 'none' || ctaType === undefined)
        return '32px';
    return '12px';
};
var addMarginTop = function (showBrandedIcon, selectedTheme) {
    if (!showBrandedIcon)
        return '0';
    return [
        selectedTheme['space'].inc60,
        selectedTheme['space'].inc60,
        selectedTheme['space'].inc60,
        selectedTheme['space'].inc80
    ];
};

var ScrollyStoryCard = function (_a) {
    var _b, _c, _d;
    var _e = _a.className, className = _e === void 0 ? '' : _e, _f = _a.theme, theme = _f === void 0 ? 'default' : _f, _g = _a.inverse, inverse = _g === void 0 ? false : _g, _h = _a.variant, variant = _h === void 0 ? 'body1' : _h, title = _a.title, _j = _a.showBrandedIcon, showBrandedIcon = _j === void 0 ? true : _j, _k = _a.brandedIconName, brandedIconName = _k === void 0 ? 'mdb_backup' : _k, _l = _a.cta, cta = _l === void 0 ? {
        type: 'none',
        text: '',
        config: {}
    } : _l;
    var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
    var hasCTA = cta.type !== 'none';
    var isClickable = hasCTA && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
    var footerProps = {
        inverse: inverse,
        cta: cta
    };
    var TagName = isClickable ? 'a' : 'div';
    return (jsx(Panel, __assign({ gridColumn: ['span 3', 'span 3', 'span 2', 'span 2'], className: className, borderColor: getBorderColor(inverse), bgColor: getBgColor(inverse), sx: { position: 'relative', height: '100%' } }, { children: jsxs(TagName, __assign({ href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined, target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined, sx: {
                color: 'inherit',
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'none'
                },
                paddingTop: 'inc50',
                paddingLeft: ['inc40', null, null, 'inc50'],
                paddingRight: ['inc40', null, null, 'inc50'],
                paddingBottom: getPaddingBottom(cta.type),
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                flexDirection: 'column',
                flexWrap: 'wrap',
                height: '100%',
                wordBreak: 'break-word',
                boxSizing: 'border-box'
            } }, { children: [showBrandedIcon && (jsx(BrandedIcon, { "data-testid": 'branded-icon', inverse: inverse, name: brandedIconName, size: 'small' }, void 0)),
                jsxs("div", __assign({ sx: {
                        marginTop: addMarginTop(showBrandedIcon, selectedTheme),
                        display: 'flex',
                        flexDirection: 'column'
                    } }, { children: [title && (jsx(TypographyScale, __assign({ "aria-label": 'text-content', inverse: inverse, variant: variant }, { children: title }), void 0)),
                        hasCTA && jsx(CardFooter, __assign({}, footerProps, { disableAnchor: true }), void 0)] }), void 0)] }), void 0) }), void 0));
};

var exampleLinks = [
    {
        href: '#',
        text: 'Current releases & packages'
    },
    {
        href: '#',
        text: 'Documentation'
    }
];
var MenuButton = function (_a) {
    var _b = _a.children, children = _b === void 0 ? 'More Options' : _b, _c = _a.links, links = _c === void 0 ? exampleLinks : _c, onClick = _a.onClick, customStyles = _a.customStyles;
    var wrapperRef = useRef(null);
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var toggleIsOpen = function () {
        setIsOpen(!isOpen);
    };
    var handleEscapeKey = function (key) {
        if (key === KEYS.Escape)
            setIsOpen(false);
    };
    useOnClickOutside(wrapperRef, function () { return setIsOpen(false); });
    return (jsxs("div", __assign({ ref: wrapperRef, sx: {
            position: 'relative'
        }, onKeyDown: function (e) {
            handleEscapeKey(e.key);
        } }, { children: [jsx(Link, __assign({ linkIcon: ESystemIconNames.MEATBALLS, onClick: toggleIsOpen }, { children: children }), void 0),
            jsx("div", __assign({ "aria-label": 'menu-panel', sx: __assign({ display: isOpen ? 'flex' : 'none', top: 0, left: 0, width: ['327px', null, null, '336px'], position: 'absolute', opacity: 1, zIndex: 9 }, customStyles) }, { children: jsxs(Panel, __assign({ boxShadow: 'level03', sx: {
                        width: '100%',
                        position: 'relative',
                        borderRadius: 'inc30'
                    } }, { children: [jsx("button", __assign({ onClick: toggleIsOpen, sx: {
                                display: ['flex', null, null, 'none'],
                                border: 'none',
                                bg: 'panels.default.bg',
                                position: 'absolute',
                                top: 28,
                                right: 28,
                                cursor: 'pointer'
                            } }, { children: jsx(SystemIcon, { strokeWeight: 'medium', name: ESystemIconNames.CLOSE }, void 0) }), void 0),
                        jsx("div", __assign({ sx: {
                                paddingTop: 'inc50',
                                paddingRight: 'inc50',
                                paddingBottom: 'inc40',
                                paddingLeft: 'inc50'
                            } }, { children: links.map(function (_a) {
                                var href = _a.href, text = _a.text, target = _a.target;
                                return (jsx("div", __assign({ sx: { paddingBottom: 8 } }, { children: jsx(Link, __assign({ href: href, target: target, onClick: onClick && (function () { return onClick({ href: href, text: text, target: target }); }) }, { children: text }), void 0) }), text));
                            }) }), void 0)] }), void 0) }), void 0)] }), void 0));
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var getSelectedTheme = function (theme) {
    if (theme === void 0) { theme = 'default'; }
    return theme === 'default' ? defaultTheme : legacyTheme;
};
var findSelectedItem = function (_a) {
    var currentUrl = _a.currentUrl, items = _a.items;
    var selectedItem = null;
    var find = function (item, index, subItemIndex) {
        if (item.url === currentUrl) {
            selectedItem = {
                index: index,
                title: item.title,
                url: item.url,
                subItemIndex: subItemIndex
            };
            return true;
        }
        return false;
    };
    items.some(function (item, index) {
        var _a;
        var result = find(item, index);
        if (!result) {
            return (((_a = item.subItems) === null || _a === void 0 ? void 0 : _a.some(function (subItem, subItemIndex) {
                return find(subItem, index, subItemIndex);
            })) || false);
        }
        return result;
    });
    return selectedItem;
};

var NavItem = function (_a) {
    var index = _a.index, item = _a.item, _b = _a.theme, theme = _b === void 0 ? 'default' : _b, inverse = _a.inverse, subItem = _a.subItem, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c, active = _a.active, redirect = _a.redirect, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d;
    var colors = getSelectedTheme(theme).colors;
    var url = item.url, title = item.title, icon = item.icon, faux = item.faux, target = item.target;
    var getBorderColor = function () {
        if (inverse) {
            return active ? colors.black00 : colors.green70;
        }
        return active ? colors.green60 : colors.black20;
    };
    var getColor = function () {
        if (inverse) {
            return active ? 'default' : subItem ? 'secondary' : 'selected';
        }
        return active ? 'default' : subItem ? 'neutral' : 'mark';
    };
    var handleClick = function (e) {
        if (faux)
            e.preventDefault();
        e.stopPropagation();
        onClick({ item: item, index: index });
    };
    var isLink = url && redirect;
    var Element = isLink ? 'a' : 'button';
    var targetProps = __assign(__assign({}, (isLink ? { target: target } : {})), (isLink && target === '_blank' ? { rel: 'noopener noreferrer' } : {}));
    return (jsxs(Element, __assign({ "data-testid": item.title, tabIndex: tabIndex, sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 'inc30',
            borderLeftWidth: ['4px', null, '2px'],
            borderLeftStyle: 'solid',
            borderLeftColor: ['transparent', null, getBorderColor()],
            paddingTop: 'inc30',
            paddingBottom: 'inc30',
            paddingLeft: [
                subItem ? 'inc70' : 'inc40',
                null,
                null,
                subItem ? 'inc90' : 'inc60'
            ],
            paddingRight: ['inc40', null, null, 'inc60'],
            textDecoration: 'none',
            textAlign: 'left',
            width: '100%',
            background: inverse ? colors.blue80 : colors.black00,
            '&:hover': {
                cursor: 'pointer',
                textDecoration: 'none'
            },
            '&:focus-visible': {
                outline: '-webkit-focus-ring-color auto 1px'
            }
        }, href: isLink ? url : undefined, onClick: handleClick }, targetProps, { children: [jsx(TypographyScale, __assign({ inverse: inverse, color: getColor(), variant: 'body3', customStyles: {
                    fontWeight: active ? '700' : '400'
                } }, { children: title }), void 0), icon && icon] }), void 0));
};

var Collapse = function (_a) {
    var open = _a.open, children = _a.children;
    var _b = useState('0'), maxHeight = _b[0], setMaxHeight = _b[1];
    useEffect(function () {
        setMaxHeight(open ? '100vh' : '0');
    }, [open]);
    return (jsx("div", __assign({ sx: {
            overflow: 'hidden',
            maxHeight: maxHeight,
            transition: 'max-height 0.5s ease'
        } }, { children: children }), void 0));
};

var SubItems = function (_a) {
    var theme = _a.theme, items = _a.items, parentIndex = _a.parentIndex, selectedItem = _a.selectedItem, redirect = _a.redirect, inverse = _a.inverse, _b = _a.onClickItem, onClickItem = _b === void 0 ? function () { } : _b;
    var open = parentIndex === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index);
    return (React.createElement(Collapse, { open: open }, items.map(function (item, index) { return (React.createElement(NavItem, __assign({ key: index }, {
        tabIndex: open ? 0 : -1,
        index: parentIndex,
        theme: theme,
        subItem: true,
        redirect: redirect,
        active: index === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.subItemIndex),
        inverse: inverse,
        item: item,
        onClick: function (item) { return onClickItem(__assign(__assign({}, item), { subItemIndex: index })); }
    }))); })));
};

var Content = function (_a) {
    var items = _a.items, theme = _a.theme, selectedItem = _a.selectedItem, inverse = _a.inverse, redirect = _a.redirect, _b = _a.onClickItem, onClickItem = _b === void 0 ? function () { } : _b;
    return (React.createElement("div", { "data-testid": 'nav-content' }, items.map(function (item, index) { return (React.createElement("div", { key: index },
        React.createElement(NavItem, __assign({}, {
            active: index === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index) &&
                selectedItem.subItemIndex === undefined,
            theme: theme,
            redirect: redirect,
            index: index,
            inverse: inverse,
            item: item,
            onClick: onClickItem
        })),
        (item === null || item === void 0 ? void 0 : item.subItems) && (React.createElement(SubItems, __assign({}, {
            theme: theme,
            parentIndex: index,
            items: item.subItems,
            onClickItem: onClickItem,
            selectedItem: selectedItem,
            inverse: inverse,
            redirect: redirect
        }))))); })));
};

var DefaultLayout = function (props) { return React.createElement(Content, __assign({}, props)); };

var Dropdown = function (_a) {
    var inverse = _a.inverse, selectedItem = _a.selectedItem, _b = _a.theme, theme = _b === void 0 ? 'default' : _b, children = _a.children;
    if (!selectedItem)
        return null;
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = getSelectedTheme(theme), colors = _d.colors, space = _d.space, lineHeights = _d.lineHeights;
    useEffect(function () {
        if (selectedItem.url) {
            setOpen(false);
        }
    }, [selectedItem]);
    return (jsxs(Fragment, { children: [jsxs("div", __assign({ "data-testid": 'nav-dropdown', sx: {
                    borderLeft: "4px solid " + colors.green40,
                    padding: 'section20',
                    '&:hover': {
                        cursor: 'pointer'
                    },
                    background: "" + (inverse ? colors.green80 : colors.black00),
                    borderBottom: "1px solid " + (inverse ? colors.green70 : colors.black20),
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, onClick: function () { return setOpen(!open); } }, { children: [jsx(TypographyScale, __assign({ inverse: inverse, color: 'default', variant: 'body3' }, { children: selectedItem.title }), void 0),
                    jsx(SystemIcon, { inverse: inverse, color: 'default', name: open ? ESystemIconNames.CHEVRON_UP : ESystemIconNames.CHEVRON_DOWN }, void 0)] }), void 0),
            open && (jsx("div", __assign({ sx: {
                    position: 'absolute',
                    top: "calc(" + space.section20 + " * 2 + " + lineHeights.headingXSResponsive + " + 1px)",
                    width: '100%'
                } }, { children: children }), void 0))] }, void 0));
};

var MobileLayout = function (props) {
    var inverse = props.inverse, selectedItem = props.selectedItem;
    return (React.createElement(Dropdown, __assign({}, { inverse: inverse, selectedItem: selectedItem }),
        React.createElement(Content, __assign({}, props))));
};

var SideNav = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'default' : _b, inverse = _a.inverse, items = _a.items, currentUrl = _a.currentUrl, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, _d = _a.redirect, redirect = _d === void 0 ? true : _d, isMobile = _a.isMobile;
    var item = findSelectedItem({ currentUrl: currentUrl, items: items });
    var _e = useState(item), selectedItem = _e[0], setSelectedItem = _e[1];
    var onClickItem = function (_a) {
        var item = _a.item, index = _a.index, subItemIndex = _a.subItemIndex;
        var title = item.title, url = item.url;
        setSelectedItem({
            index: index,
            title: title,
            url: url,
            subItemIndex: subItemIndex
        });
        onClick({ title: title, url: url });
    };
    useEffect(function () {
        var item = findSelectedItem({ currentUrl: currentUrl, items: items });
        if (item)
            setSelectedItem(item);
    }, [currentUrl]);
    getSelectedTheme(theme);
    var Layout = isMobile ? MobileLayout : DefaultLayout;
    return (jsx("nav", __assign({ sx: {
            display: 'flex',
            flexDirection: 'column',
            boxShadow: ['level01', null, 'none'],
            position: 'sticky',
            top: [0, null, '56px', '88px']
        } }, { children: jsx(Layout, __assign({}, { items: items, inverse: inverse, redirect: redirect, selectedItem: selectedItem, onClickItem: onClickItem }), void 0) }), void 0));
};

[
    {
        title: 'Atlas',
        url: '/atlas',
        subItems: [
            {
                title: 'Database',
                url: '/atlas/database'
            },
            {
                title: 'Data Lake',
                url: '/atlas/data-lake',
                icon: (jsx("div", __assign({ sx: {
                        fill: 'blue60',
                        stroke: 'blue60',
                        display: 'flex',
                        alignItems: 'center'
                    } }, { children: jsx(SystemIcon, { name: ESystemIconNames.EXTERNAL, inheritColor: true }, void 0) }), void 0)),
                target: '_blank'
            },
            {
                title: 'Charts',
                url: '/products/charts'
            }
        ]
    },
    {
        title: 'Enterprise Advanced',
        url: '/products/mongodb-enterprise-advanced',
        subItems: [
            {
                title: 'Enterprise Server',
                url: '/try/download/enterprise'
            },
            {
                title: 'Ops Manager',
                url: '/products/ops-manager'
            }
        ]
    },
    {
        title: 'Realm',
        url: '/realm',
        subItems: [
            {
                title: 'Edge-to-Cloud Sync',
                url: '/realm/mobile/sync'
            },
            {
                title: 'Functions, APIs, and more',
                url: '/realm/appdev'
            }
        ]
    },
    {
        title: 'Community Edition',
        url: '/try/download/community',
        subItems: [
            {
                title: 'Community Server',
                url: '/try/download/community'
            },
            {
                title: 'Cloud Manager',
                url: '/cloud/cloud-manager'
            }
        ]
    },
    {
        title: 'Tools',
        subItems: [
            {
                title: 'Compass',
                url: '/products/compass'
            },
            {
                title: 'VS Code Plugin',
                url: '/products/vs-code'
            }
        ]
    }
];

var getPages = function (_a) {
    var currentPage = _a.currentPage, last = _a.pages, maxPages = _a.maxPages, isMobile = _a.isMobile;
    var range = Array();
    var responsiveMaxPages = isMobile ? 4 : maxPages;
    if (!responsiveMaxPages || responsiveMaxPages === last) {
        return __spreadArray([], Array(last)).map(function (_, index) { return index + 1; });
    }
    var limit = function (side) {
        var firstOrLast = currentPage === 1 || currentPage === last;
        var pages = firstOrLast ? responsiveMaxPages : responsiveMaxPages - 2;
        var even = pages % 2 === 0;
        var range = pages / 2;
        if (even) {
            return side === 'left' ? currentPage - range : currentPage + range;
        }
        return side === 'left'
            ? currentPage - Math.floor(range)
            : currentPage + Math.ceil(range);
    };
    var pageInsideTheLimit = function (page) {
        return page === 1 ||
            page === last ||
            (page >= limit('left') &&
                page <= limit('right') &&
                range.length < responsiveMaxPages - 1);
    };
    for (var page = 1; page <= last; page++) {
        if (pageInsideTheLimit(page)) {
            range.push(page);
        }
    }
    var steps = Array();
    for (var index = 0; index < range.length; index++) {
        var prev = range[index - 1];
        var value = range[index];
        if (prev && prev !== value - 1) {
            steps.push('...');
        }
        steps.push(value);
    }
    return steps;
};
var getColor = function (_a) {
    var active = _a.active, inverse = _a.inverse;
    if (inverse) {
        return active ? 'blue80' : 'black00';
    }
    return active ? 'black00' : 'blue80';
};
var getBackgroundColor = function (_a) {
    var active = _a.active, inverse = _a.inverse, dots = _a.dots;
    if (dots) {
        return active ? 'green40' : inverse ? 'green60' : 'blue10';
    }
    return inverse && active ? 'black00' : active ? 'blue80' : 'transparent';
};

var Dots = function (_a) {
    var currentPage = _a.currentPage, pages = _a.pages, inverse = _a.inverse, _b = _a.onChangePage, onChangePage = _b === void 0 ? function () { } : _b;
    var _c = useState(currentPage), page = _c[0], setPage = _c[1];
    useEffect(function () {
        setPage(currentPage);
    }, [currentPage]);
    var handleOnClick = function (selectedPage) {
        setPage(selectedPage);
        onChangePage(selectedPage);
    };
    return (jsx("div", __assign({ "data-testid": 'dots-container', sx: {
            bg: inverse ? 'black10' : 'green80',
            borderRadius: 'inc40',
            padding: defaultTheme.space.section00 + " 12px",
            display: 'inline-flex',
            alignItems: 'center'
        } }, { children: __spreadArray([], Array(pages)).map(function (_, index) {
            var active = page - 1 === index;
            return (jsx("div", { "aria-label": "page " + (index + 1), onClick: function () { return !active && handleOnClick(index + 1); }, sx: {
                    backgroundColor: getBackgroundColor({
                        active: active,
                        inverse: inverse,
                        dots: true
                    }),
                    borderRadius: '4px',
                    width: active ? '26px' : '8px',
                    height: '8px',
                    marginLeft: index === 0 ? 0 : '6px'
                } }, index));
        }) }), void 0));
};

var Arrow = function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? 'left' : _b, inverse = _a.inverse, customStyles = _a.customStyles, isMobile = _a.isMobile, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    var drawSpecs = {
        left: {
            desktop: 'M1.15003 14.2929C0.75951 14.6834 0.75951 15.3166 1.15003 15.7071L7.51399 22.0711C7.90452 22.4616 8.53768 22.4616 8.92821 22.0711C9.31873 21.6805 9.31873 21.0474 8.92821 20.6568L3.27135 15L8.92821 9.34314C9.31873 8.95261 9.31873 8.31945 8.92821 7.92892C8.53768 7.5384 7.90452 7.5384 7.51399 7.92892L1.15003 14.2929ZM49 14L1.85714 14L1.85714 16L49 16L49 14Z',
            mobile: 'M0.864323 14.2929C0.473797 14.6834 0.473797 15.3166 0.864323 15.7071L7.22828 22.0711C7.61881 22.4616 8.25197 22.4616 8.6425 22.0711C9.03302 21.6805 9.03302 21.0474 8.6425 20.6568L2.98564 15L8.6425 9.34314C9.03302 8.95262 9.03302 8.31945 8.6425 7.92893C8.25197 7.5384 7.61881 7.5384 7.22828 7.92893L0.864323 14.2929ZM33 14L1.57143 14L1.57143 16L33 16L33 14Z'
        },
        right: {
            desktop: 'M47.85 15.7071C48.2405 15.3166 48.2405 14.6834 47.85 14.2929L41.486 7.92894C41.0955 7.53842 40.4623 7.53841 40.0718 7.92894C39.6813 8.31946 39.6813 8.95263 40.0718 9.34315L45.7286 15L40.0718 20.6569C39.6813 21.0474 39.6813 21.6806 40.0718 22.0711C40.4623 22.4616 41.0955 22.4616 41.486 22.0711L47.85 15.7071ZM-1.3005e-07 16L47.1429 16L47.1429 14L1.3005e-07 14L-1.3005e-07 16',
            mobile: 'M32.1357 15.7071C32.5262 15.3166 32.5262 14.6834 32.1357 14.2929L25.7717 7.92894C25.3812 7.53841 24.748 7.53841 24.3575 7.92894C23.967 8.31946 23.967 8.95263 24.3575 9.34315L30.0144 15L24.3575 20.6569C23.967 21.0474 23.967 21.6805 24.3575 22.0711C24.748 22.4616 25.3812 22.4616 25.7717 22.0711L32.1357 15.7071ZM-8.66998e-08 16L31.4286 16L31.4286 14L8.66998e-08 14L-8.66998e-08 16Z'
        }
    };
    var sizes = defaultTheme.sizes, colors = defaultTheme.colors;
    var width = isMobile ? sizes.inc30 : sizes.inc50;
    return (jsx("svg", __assign({ "aria-label": direction + " arrow", width: width, viewBox: "0 0 " + width + " 30", height: '30', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', sx: __assign({ '&:hover': {
                cursor: 'pointer'
            } }, customStyles), onClick: onClick }, { children: jsx("path", { d: drawSpecs[direction][isMobile ? 'mobile' : 'desktop'], fill: inverse ? colors.green40 : colors.green60 }, void 0) }), void 0));
};

var Default = function (_a) {
    var inverse = _a.inverse, currentPage = _a.currentPage, pages = _a.pages, maxPages = _a.maxPages, isMobile = _a.isMobile, _b = _a.onChangePage, onChangePage = _b === void 0 ? function () { } : _b;
    var _c = useState(currentPage), page = _c[0], setPage = _c[1];
    var handleOnClick = function (selectedPage) {
        if (selectedPage <= 0 ||
            selectedPage > pages ||
            typeof selectedPage === 'string') {
            return;
        }
        setPage(selectedPage);
        onChangePage(selectedPage);
    };
    return (jsxs("div", __assign({ sx: { display: 'flex', flexDirection: 'row', alignItems: 'center' } }, { children: [jsx(Arrow, { inverse: inverse, customStyles: { marginRight: ['inc40', null, 'inc70'] }, onClick: function () { return handleOnClick(page - 1); } }, void 0),
            jsx("div", __assign({ sx: { display: 'flex', flexDirection: 'row', alignItems: 'baseline' } }, { children: getPages({ currentPage: page, pages: pages, maxPages: maxPages, isMobile: isMobile }).map(function (value, index) {
                    var active = page === value;
                    return (jsx("div", __assign({ "aria-label": "page " + value, onClick: function () { return handleOnClick(value); }, sx: {
                            width: 'inc30',
                            height: 'inc30',
                            lineHeight: 'inc30',
                            textAlign: 'center',
                            bg: getBackgroundColor({ active: active, inverse: inverse }),
                            borderRadius: 'circle',
                            marginLeft: value === 0 ? '0' : 'inc20',
                            '&:hover': {
                                cursor: typeof value === 'number' ? 'pointer' : 'default'
                            }
                        } }, { children: jsx(TypographyScale, __assign({ variant: 'body3', customStyles: {
                                color: getColor({ active: active, inverse: inverse })
                            } }, { children: value }), void 0) }), index));
                }) }), void 0),
            jsx(Arrow, __assign({}, { inverse: inverse, direction: 'right' }, { customStyles: { marginLeft: ['inc40', null, 'inc70'] }, onClick: function () { return handleOnClick(page + 1); } }), void 0)] }), void 0));
};

var Pagination = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, inverse = _a.inverse, currentPage = _a.currentPage, pages = _a.pages, maxPages = _a.maxPages, isMobile = _a.isMobile, _c = _a.onChangePage, onChangePage = _c === void 0 ? function () { } : _c;
    var Layout = type === 'default' ? Default : Dots;
    return (React.createElement(Layout, __assign({}, {
        inverse: inverse,
        currentPage: currentPage,
        pages: pages,
        onChangePage: onChangePage,
        maxPages: maxPages,
        isMobile: isMobile
    })));
};

var AUTO_DISMISS_DELAY = 3000;

var getStyles = function (styleState, theme) {
    var postSubmissionState = styleState.postSubmissionState;
    return {
        wrapper: {
            width: ['100%', null, null, 584],
            height: 'fit-content',
            minHeight: '100vh',
            backgroundColor: theme.colors.background.containerInverse,
            padding: [
                'inc40',
                null,
                null,
                theme.space.inc70 + " " + theme.space.inc90
            ],
            paddingBottom: 'calc(env(safe-area-inset-bottom) + 96px)',
            display: 'flex',
            flexDirection: 'column'
        },
        closeButtonContainer: {
            marginLeft: 'auto',
            marginBottom: 'inc80'
        },
        contentContainer: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: 'auto'
        },
        titleContainer: {
            textAlign: 'center',
            marginBottom: postSubmissionState
                ? ['inc30', null, null, 'inc50']
                : 'inc60'
        },
        subtitle: {
            marginBottom: ['inc60', null, null, 'inc80']
        },
        descriptionContainer: {
            textAlign: 'center'
        },
        postSubmissionButtonContainer: {
            marginTop: ['inc60', null, null, 'inc80']
        }
    };
};

var Flyout = function (_a) {
    var children = _a.children, flyoutLink = _a.flyoutLink, open = _a.open, handleState = _a.handleState;
    if (!flyoutLink) {
        return jsx(Fragment, { children: children }, void 0);
    }
    var handleFlyout = function (e) {
        e.preventDefault();
        handleState(true);
    };
    useEffect(function () {
        if (flyoutLink) {
            document.querySelectorAll("a[href=\"#" + flyoutLink + "\"]").forEach(function (link) {
                link.addEventListener('click', handleFlyout);
            });
            return function () {
                document
                    .querySelectorAll("a[href=\"#" + flyoutLink + "\"]")
                    .forEach(function (link) {
                    link.removeEventListener('click', handleFlyout);
                });
            };
        }
    }, [flyoutLink]);
    return (jsx("div", __assign({ "data-testid": "form-panel-" + (open ? 'open' : 'close'), sx: { position: 'absolute', top: 0, left: 0, zIndex: '1000000' } }, { children: jsx("div", __assign({ sx: {
                position: 'fixed',
                width: '100%'
            } }, { children: jsx("div", __assign({ sx: {
                    position: 'absolute',
                    transition: "right " + defaultTheme.motion.inc10 + " ease",
                    right: open ? '0' : '-100%',
                    top: 0,
                    maxWidth: ['100%', null, '375px', '584px'],
                    width: '100vw',
                    height: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden'
                } }, { children: children }), void 0) }), void 0) }), void 0));
};

var FormPanel = function (_a) {
    var _b = _a.inverse, inverse = _b === void 0 ? true : _b, _c = _a.postSubmissionState, postSubmissionState = _c === void 0 ? false : _c, children = _a.children, onClose = _a.onClose, onPostSubmissionButtonClick = _a.onPostSubmissionButtonClick, postSubmissionTitle = _a.postSubmissionTitle, postSubmissionDescription = _a.postSubmissionDescription, postSubmissionButtonText = _a.postSubmissionButtonText, title = _a.title, subtitle = _a.subtitle, flyoutLink = _a.flyoutLink, _d = _a.open, open = _d === void 0 ? false : _d, _e = _a.dismissPanelOnPostSubmissionClick, dismissPanelOnPostSubmissionClick = _e === void 0 ? false : _e, _f = _a.autoDismissPanel, autoDismissPanel = _f === void 0 ? false : _f, _g = _a.bodyOverride, bodyOverride = _g === void 0 ? false : _g, _h = _a.dismissPanelImmediately, dismissPanelImmediately = _h === void 0 ? false : _h;
    var styles = getStyles({ postSubmissionState: postSubmissionState }, defaultTheme);
    var ref = useRef(null);
    var _j = useState(open), flyoutState = _j[0], setFlyoutState = _j[1];
    useOnClickOutside(ref, function () { return setFlyoutState(false); });
    var escapeHandler = useCallback(function (event) {
        if (event.key === 'Escape') {
            setFlyoutState(false);
        }
    }, []);
    useEffect(function () {
        document.addEventListener('keydown', escapeHandler);
        return function () {
            document.removeEventListener('keydown', escapeHandler);
        };
    }, []);
    useEffect(function () {
        if (flyoutState && bodyOverride) {
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.minHeight = '100vh';
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.body.style.position = 'unset';
            document.body.style.width = 'unset';
            document.body.style.minHeight = 'unset';
            document.body.style.overflow = 'initial';
        };
    }, [flyoutState]);
    useEffect(function () {
        if (autoDismissPanel) {
            var timeId_1 = setTimeout(function () {
                setFlyoutState(false);
                if (onClose)
                    onClose(true);
            }, AUTO_DISMISS_DELAY);
            return function () {
                clearTimeout(timeId_1);
            };
        }
    }, [autoDismissPanel]);
    useEffect(function () {
        if (dismissPanelImmediately) {
            setFlyoutState(false);
            if (onClose)
                onClose(true);
        }
    }, [dismissPanelImmediately]);
    var renderTitle = useCallback(function (titleText) {
        if (titleText) {
            return (jsx("div", __assign({ "aria-label": 'panel-title', sx: styles.titleContainer }, { children: jsx(TypographyScale, __assign({ variant: 'heading4', inverse: inverse, customStyles: { fontWeight: 'normal' }, customElement: 'span' }, { children: titleText }), void 0) }), void 0));
        }
        return null;
    }, [inverse, styles.titleContainer]);
    var renderSubtitle = function (subtitle) {
        if (subtitle) {
            return (jsx(TypographyScale, __assign({ sx: styles.subtitle, variant: 'body2', inverse: inverse }, { children: subtitle }), void 0));
        }
        return null;
    };
    var renderPanelContent = function () {
        if (postSubmissionState) {
            return (jsxs(Fragment, { children: [renderTitle(postSubmissionTitle), postSubmissionDescription && (jsx("div", __assign({ "aria-label": 'post-submission-description', sx: styles.descriptionContainer }, { children: jsx(TypographyScale, __assign({ variant: 'body1', inverse: inverse }, { children: postSubmissionDescription }), void 0) }), void 0)),
                    !!onPostSubmissionButtonClick && postSubmissionButtonText && (jsx("div", __assign({ "aria-label": 'post-submission-button', sx: styles.postSubmissionButtonContainer }, { children: jsx(Button, __assign({ onClick: function () {
                                onPostSubmissionButtonClick();
                                if (dismissPanelOnPostSubmissionClick) {
                                    !!onClose && onClose(true);
                                    setFlyoutState(false);
                                }
                            }, inverse: inverse, size: 'large' }, { children: postSubmissionButtonText }), void 0) }), void 0))] }, void 0));
        }
        if (dismissPanelImmediately) {
            return jsx(Fragment, { children: children }, void 0);
        }
        return (jsxs(Fragment, { children: [renderTitle(title), renderSubtitle(subtitle), children] }, void 0));
    };
    return (jsx(Flyout, __assign({}, {
        flyoutLink: flyoutLink,
        open: flyoutState,
        handleState: function (state) { return setFlyoutState(state); }
    }, { children: jsxs("div", __assign({ ref: ref, sx: styles.wrapper }, { children: [jsx("span", __assign({ sx: styles.closeButtonContainer }, { children: jsx(ButtonIcon, { iconName: ESystemIconNames.CLOSE, onClick: function () {
                            setFlyoutState(false);
                            !!onClose && onClose(true);
                        }, inverse: inverse, variant: 'outline', size: 'large', keepMobileOutline: true }, void 0) }), void 0),
                jsx("div", __assign({ sx: styles.contentContainer }, { children: renderPanelContent() }), void 0)] }), void 0) }), void 0));
};

var isRequired = function (message) {
    var required = function (value) {
        return !value || value === '' ? message || 'This field is required' : '';
    };
    required.rule = 'required';
    return required;
};
var hasMinimumLength = function (minimumLength, message) {
    var error = message || "This field must have at least " + minimumLength + " characters.";
    return function hasMinimumLength(value) {
        return value.trim().length < minimumLength ? error : '';
    };
};
var doesNotContainEmail = function (email, message) {
    var error = message || 'This field cannot contain your email address.';
    var splitEmail = email.split('@');
    return function doesNotContainEmail(value) {
        return email && splitEmail && value.includes(splitEmail[0]) ? error : '';
    };
};
var containsEmail = function (message) {
    var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+([.][a-zA-Z0-9-]{2,})+$/;
    return function containsEmail(value) {
        return value.match(emailRegex)
            ? ''
            : message || 'Please include a valid domain in the email address.';
    };
};

var passwordRequirementsDefault = {
    title: 'Your password must:',
    list: [
        'Contain at least 8 characters.',
        'Contain unique characters, numbers, or symbols.',
        ' Not contain your email address.'
    ]
};
var termsDefault = (jsxs(Fragment$1, { children: ["I agree to the", ' ', jsx("a", __assign({ sx: {
                textDecoration: 'none',
                color: 'text.default',
                fontWeight: 'bold'
            }, href: 'https://www.mongodb.com/legal/privacy-policy' }, { children: "Terms & Conditions" }), void 0), ' ', "and", ' ', jsx("a", __assign({ sx: {
                textDecoration: 'none',
                color: 'text.default',
                fontWeight: 'bold'
            }, href: 'https://cloud.mongodb.com/links/terms-of-service' }, { children: "Privacy Policy" }), void 0)] }, void 0));
var formDefaultProps = {
    passwordRequirements: passwordRequirementsDefault,
    accountSignInLink: 'https://account.mongodb.com/account/login',
    accountSignInText: 'Sign in',
    accountText: 'Already have an account? ',
    googleSSOText: 'Sign up with Google',
    separatorText: 'or',
    submitButtonText: 'Create your Atlas account',
    terms: termsDefault,
    customLabels: {
        firstName: 'First Name',
        lastName: 'Last Name',
        company: 'Company',
        email: 'Email',
        password: 'Password'
    },
    customErrorMessages: {
        required: 'This field is required',
        minLength: 'This field must have at least 8 characters.',
        noEmail: 'This field cannot contain your email address.',
        validEmail: 'Please include a valid domain in the email address.'
    }
};

var SSOButton = function (_a) {
    var _b = _a.text, text = _b === void 0 ? 'Sign up with Google' : _b, target = _a.target, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick, href = _a.href, customStyles = _a.customStyles;
    return (jsxs(Button, __assign({ target: target, disabled: disabled, customStyles: __assign({ backgroundColor: 'black00', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }, customStyles), customWrapperStyles: {
            width: '100%'
        }, onClick: onClick, href: href }, { children: [!!icon && (jsx(ThirdPartyLogo, { alt: 'SSO provider logo', variant: icon, imageWidth: '16px' }, void 0)), text] }), void 0));
};

var SignUpForm = function (_a) {
    var _b;
    var 
    /* deprecated props, for backwards compatibility */
    _c = _a.googleSSOText, 
    /* deprecated props, for backwards compatibility */
    googleSSOText = _c === void 0 ? formDefaultProps.googleSSOText : _c, googleSSOHref = _a.googleSSOHref, googleSSOOnClick = _a.googleSSOOnClick, 
    /* enabled props */
    formId = _a.formId, formName = _a.formName, onSubmit = _a.onSubmit, isSubmitting = _a.isSubmitting, _d = _a.passwordRequirements, passwordRequirements = _d === void 0 ? formDefaultProps.passwordRequirements : _d, _e = _a.accountSignInLink, accountSignInLink = _e === void 0 ? formDefaultProps.accountSignInLink : _e, _f = _a.accountSignInText, accountSignInText = _f === void 0 ? formDefaultProps.accountSignInText : _f, _g = _a.accountText, accountText = _g === void 0 ? formDefaultProps.accountText : _g, _h = _a.sso, sso = _h === void 0 ? [
        {
            text: googleSSOText,
            href: googleSSOHref,
            onClick: googleSSOOnClick,
            icon: EThirdPartyLogoVariant.GOOGLE_ICON
        }
    ] : _h, _j = _a.separatorText, separatorText = _j === void 0 ? formDefaultProps.separatorText : _j, _k = _a.submitButtonText, submitButtonText = _k === void 0 ? formDefaultProps.submitButtonText : _k, _l = _a.terms, terms = _l === void 0 ? formDefaultProps.terms : _l, _m = _a.customLabels, customLabels = _m === void 0 ? formDefaultProps.customLabels : _m, _o = _a.customErrorMessages, customErrorMessages = _o === void 0 ? formDefaultProps.customErrorMessages : _o;
    var _p = useState(''), email = _p[0], setEmail = _p[1];
    var _q = useState(false), passwordShow = _q[0], setPasswordShow = _q[1];
    var onClickPasswordIcon = useCallback(function (passwordFlag) {
        setPasswordShow(!passwordFlag);
    }, [setPasswordShow]);
    var passwordIcon = passwordShow
        ? ESystemIconNames.PASSWORD_HIDE
        : ESystemIconNames.PASSWORD_VIEW;
    var _r = useState(false), passwordHintVisibility = _r[0], setPasswordHintVisibility = _r[1];
    var onValidatePasswordField = useCallback(function (errors) {
        if (errors === void 0) { errors = []; }
        errors.length > 0
            ? setPasswordHintVisibility(true)
            : setPasswordHintVisibility(false);
    }, [setPasswordHintVisibility]);
    var onValidatePasswordForm = useCallback(function (formData) {
        formData.every(function (_a) {
            var isValidated = _a.isValidated;
            return isValidated;
        }) > 0
            ? setPasswordHintVisibility(true)
            : setPasswordHintVisibility(false);
    }, [setPasswordHintVisibility]);
    return (jsxs(FormGeneric, __assign({ id: formId, name: formName, onSubmit: onSubmit, onChange: function (form) {
            setEmail(form.email || '');
        }, onValidate: onValidatePasswordForm, customStyles: {
            gridColumn: ['1/ span 6', null, null, '2/span 4'],
            margin: 'auto'
        } }, { children: [jsx(Field, { component: 'text-input', validators: [isRequired(customErrorMessages.required)], name: 'firstName', label: customLabels['firstName'] || 'First Name', autoFocus: true }, void 0),
            jsx(Field, { component: 'text-input', validators: [isRequired(customErrorMessages.required)], name: 'lastName', label: customLabels['lastName'] || 'Last Name' }, void 0),
            jsx(Field, { component: 'text-input', name: 'company', label: customLabels['company'] || 'Company' }, void 0),
            jsx(Field, { component: 'text-input', validators: [
                    isRequired(customErrorMessages.required),
                    containsEmail(customErrorMessages.validEmail)
                ], name: 'email', label: customLabels['email'] || 'Email', type: 'email' }, void 0),
            jsx(Field, { component: 'text-input', validators: [
                    isRequired(customErrorMessages.required),
                    hasMinimumLength(8, customErrorMessages.minLength),
                    doesNotContainEmail(email, customErrorMessages.noEmail)
                ], name: 'password', label: customLabels['password'] || 'Password', type: passwordShow ? 'text' : 'password', iconPosition: 'right', iconName: passwordIcon, onIconClick: function () { return onClickPasswordIcon(passwordShow); }, onValidate: onValidatePasswordField }, void 0),
            passwordHintVisibility && (jsxs(Panel, __assign({ borderRadius: 'inc30', borderColor: 'black20', bgColor: 'black00', sx: {
                    padding: '24px'
                } }, { children: [(passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.title) && (jsx(TypographyScale, __assign({ variant: 'body4', customStyles: {
                            fontWeight: 500
                        } }, { children: passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.title }), void 0)),
                    (passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.list) && (jsx("ul", __assign({ sx: { paddingX: 'inc30' } }, { children: (_b = passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.list) === null || _b === void 0 ? void 0 : _b.map(function (requirement, index) { return (jsx("li", __assign({ sx: { listStyleType: 'disc' } }, { children: jsx(TypographyScale, __assign({ variant: 'body4', customStyles: {
                                    lineHeight: '24px'
                                } }, { children: requirement }), void 0) }), "requirement-" + index)); }) }), void 0))] }), void 0)),
            jsx(Field, { component: 'checkbox', validators: [isRequired(customErrorMessages.required)], name: 'terms', label: terms }, void 0),
            jsxs("div", __assign({ sx: { display: 'flex', flexDirection: 'column' } }, { children: [jsx(Button, __assign({ type: 'submit', customStyles: {
                            width: '100%',
                            justifyContent: 'center'
                        }, disabled: isSubmitting }, { children: submitButtonText }), void 0),
                    jsx(TypographyScale, __assign({ variant: 'body4', customStyles: {
                            display: 'block',
                            textAlign: 'center',
                            marginTop: 'inc30',
                            marginBottom: 'inc30'
                        } }, { children: separatorText }), void 0),
                    sso.length > 0
                        ? sso.map(function (sso) { return (jsx("div", __assign({ sx: { marginBottom: 'inc30', width: '100%' } }, { children: jsx(SSOButton, { onClick: sso.onClick, href: sso.href, text: sso.text, icon: sso.icon, disabled: isSubmitting }, void 0) }), sso.href)); })
                        : undefined,
                    jsxs(TypographyScale, __assign({ variant: 'body4', customStyles: {
                            display: 'block',
                            textAlign: 'center',
                            marginTop: ['inc50', 'inc60']
                        } }, { children: [accountText, ' ', jsx("a", __assign({ sx: {
                                    textDecoration: 'none',
                                    color: 'text.default',
                                    fontWeight: 'bold'
                                }, href: accountSignInLink }, { children: accountSignInText }), void 0)] }), void 0)] }), void 0)] }), void 0));
};

var SignUpCard = function (_a) {
    var onSubmit = _a.onSubmit, isSubmitting = _a.isSubmitting, _b = _a.title, title = _b === void 0 ? 'Sign Up' : _b, _c = _a.description, description = _c === void 0 ? 'See what Atlas is capable of for free' : _c, atlasError = _a.atlasError, props = __rest(_a, ["onSubmit", "isSubmitting", "title", "description", "atlasError"]);
    var BASE_GRID_COLUMN = '2/span 4';
    return (jsxs(Panel, __assign({ borderRadius: 'inc70', borderColor: 'black20', bgColor: 'black00', boxShadow: 'level01', sx: {
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: 'inc40',
            padding: ['24px', null, '40px', '64px 0px'],
            width: '100%',
            maxWidth: '700px',
            margin: ['auto', null, null, '0']
        } }, { children: [title && (jsx(TypographyScale, __assign({ variant: 'heading4', customStyles: {
                    gridColumn: BASE_GRID_COLUMN,
                    textAlign: 'center',
                    fontWeight: 400
                } }, { children: title }), void 0)),
            description && (jsx(TypographyScale, __assign({ variant: 'body2', customStyles: {
                    gridColumn: BASE_GRID_COLUMN,
                    fontWeight: 400,
                    color: 'green80',
                    display: 'block',
                    textAlign: 'center',
                    paddingBottom: '40px',
                    paddingTop: '16px'
                } }, { children: description }), void 0)),
            atlasError && (jsx("div", __assign({ sx: {
                    gridColumn: ['1/ span 6', null, null, '2/span 4'],
                    width: '100%',
                    //need to add token for maxWidth
                    maxWidth: '456px',
                    marginBottom: 'inc60',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                } }, { children: jsx(Aside, { variant: EAsideVariant.ERROR, text: atlasError }, void 0) }), void 0)),
            jsx(SignUpForm, __assign({ onSubmit: onSubmit, isSubmitting: isSubmitting }, props), void 0)] }), void 0));
};

export { ARROW_DIRECTION, Accordion, Article, Aside, BrandedIcon, Button, ButtonIcon, CTALockup, Checkbox, CodePanel, CodeSnippet, ComboBox, EBrandedIcons, ELanguageModeMap, ELinkVariant, ELogoVariant, ESingleImageVariant, ESystemIconNames, ETemplateTypes, EThirdPartyLogoVariant, Eyebrow, FeaturedCard, Field, FlashCard, FormGeneric, FormPanel, Globals, GridLayout, HorizontalRule, LeadPageInfoSideBar, Lightbox, Link, List, ListItem, ListV2, LogoPaths, MDBLogo, Mark, MasonryCard, MenuButton, Pagination, Panel, Pill, PromoImage, Radio, RadioGroup, SSOButton, ScrollyStoryCard, SecondaryNav, SectionIntro, Select, ShareBar, SideNav, SignUpCard, SingleImage, SpeakerLockup, SystemIcon, Tag, TextArea, TextInput, ThirdPartyLogo, Tooltip, TypographyScale, VerticalSectionSpacing };
